import * as i0 from '@angular/core';
import { InjectionToken, Optional, Injectable, Inject, RendererFactory2, NgModule, Component, Input, Directive, Renderer2, ViewChild, ViewChildren, EventEmitter, Output, ContentChildren, ViewEncapsulation, ElementRef, HostBinding, HostListener, Self, ChangeDetectorRef, ApplicationRef, Pipe, ChangeDetectionStrategy, ContentChild, forwardRef, Host, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { BehaviorSubject, Subject, merge, of, fromEvent, defer } from 'rxjs';
import { filter, map, startWith, switchMap, takeUntil, delay, take, skip, debounceTime } from 'rxjs/operators';
import { style, animation, group, query, animate, trigger, transition, useAnimation, state } from '@angular/animations';
import { A11yModule, LiveAnnouncer } from '@angular/cdk/a11y';
import { Overlay, OverlayContainer, CdkConnectedOverlay, CdkOverlayOrigin, OverlayModule, OverlayPositionBuilder, ScrollDispatcher } from '@angular/cdk/overlay';
import { NgControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { ComponentPortal } from '@angular/cdk/portal';

/**
 * Segmentos Itaú
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/overlay';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@angular/cdk/a11y';
import * as ɵngcc6 from '@angular/cdk/platform';
import * as ɵngcc7 from '@angular/cdk/scrolling';

const _c0 = ["*"];
const _c1 = ["bodyRef"];
const _c2 = ["contentRef"];
function VoxelAccordionComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "voxel-icon");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.accordionIcon, " ");
} }
function VoxelAccordionComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1, ",");
    ɵngcc0.ɵɵelementEnd();
} }
function VoxelAccordionComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.description, " ");
} }
const _c3 = function (a0) { return { "voxel-accordion__trigger--expanded": a0 }; };
const _c4 = function (a0, a1) { return { "voxel-accordion__title--icon": a0, "voxel-accordion__title--description": a1 }; };
const _c5 = function (a0) { return { "voxel-accordion__content--hide": a0 }; };
const _c6 = [[["voxel-accordion"]]];
const _c7 = ["voxel-accordion"];
function VoxelAlertComponent_div_0_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function VoxelAlertComponent_div_0_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.clickOnCloseButton(); });
    ɵngcc0.ɵɵelementStart(1, "voxel-icon", 5);
    ɵngcc0.ɵɵtext(2, "fechar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r1.btnA11yLabel);
} }
function VoxelAlertComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "voxel-icon", 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵprojection(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, VoxelAlertComponent_div_0_button_5_Template, 3, 1, "button", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("voxel-alert voxel-alert--", ctx_r0.type ? ctx_r0.type : "default", "");
    ɵngcc0.ɵɵclassProp("voxel-alert--light", ctx_r0.light)("voxel-alert--dismissible", ctx_r0.dismissible)("voxel-alert--closing", ctx_r0.closing)("voxel-alert--mobile-only", ctx_r0.mobileStyle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-live", ctx_r0.ariaLive)("role", ctx_r0.ariaRole);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.dismissible);
} }
const _c8 = ["panel"];
function VoxelAutocompleteComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1, 2);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-height", ctx_r0.visibleOptions * 3, "rem");
    ɵngcc0.ɵɵclassProp("voxel-autocomplete-options--top-positioned", ctx_r0.panelPosition === "top");
    ɵngcc0.ɵɵproperty("id", ctx_r0.panelId);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.ariaLabel)("aria-labelledby", !ctx_r0.ariaLabel && ctx_r0.input.labelId ? ctx_r0.input.labelId : null);
} }
const _c9 = [[["voxel-option"]]];
const _c10 = ["voxel-option"];
function VoxelBadgeComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.accessibleValue + ctx_r0.a11yLabel);
} }
function VoxelBreadcrumbComponent_li_2_voxel_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 8);
    ɵngcc0.ɵɵtext(1, " seta_esquerda ");
    ɵngcc0.ɵɵelementEnd();
} }
function VoxelBreadcrumbComponent_li_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function VoxelBreadcrumbComponent_li_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c11 = function (a0) { return { $implicit: a0 }; };
function VoxelBreadcrumbComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 5);
    ɵngcc0.ɵɵtemplate(1, VoxelBreadcrumbComponent_li_2_voxel_icon_1_Template, 2, 0, "voxel-icon", 6);
    ɵngcc0.ɵɵtemplate(2, VoxelBreadcrumbComponent_li_2_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(3, VoxelBreadcrumbComponent_li_2_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const isFirst_r6 = ctx.first;
    const isLast_r7 = ctx.last;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(4);
    const _r3 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !isFirst_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(5, _c11, item_r5));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", !isLast_r7 ? "" : _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(7, _c11, item_r5));
} }
const _c12 = function (a0) { return [a0]; };
function VoxelBreadcrumbComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(2, _c12, item_r12.route));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r12.label);
} }
function VoxelBreadcrumbComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r13.label);
} }
const _c13 = function (a0, a1, a2) { return { "voxel-loading-circle__svg--small": a0, "voxel-loading-circle__svg--medium": a1, "voxel-loading-circle__svg--large": a2 }; };
function VoxelLoadingCircleComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 3);
    ɵngcc0.ɵɵelementStart(3, "title");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "circle", 4);
    ɵngcc0.ɵɵelement(6, "circle", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("voxel-loading-circle--inverse", ctx_r0.inverse)("voxel-loading-circle--transparent", ctx_r0.transparent)("voxel-loading-circle--secondary", ctx_r0.secondary);
    ɵngcc0.ɵɵattribute("id", ctx_r0.loadingCircleId)("aria-live", ctx_r0.ariaPolite && !ctx_r0.ariaRole ? "polite" : null)("role", ctx_r0.ariaRole && !ctx_r0.ariaPolite ? "status" : null)("aria-hidden", ctx_r0.ariaHidden);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(13, _c13, ctx_r0.size === "small", ctx_r0.size === "medium", ctx_r0.size === "large"));
    ɵngcc0.ɵɵattribute("viewBox", ctx_r0.viewBox);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.loadingTitle);
} }
const _c14 = ["voxelButton", ""];
function VoxelButtonComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "voxel-loading-circle", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("secondary", ctx_r0.buttonStyle === "secondary")("inverse", ctx_r0._highContrast || ctx_r0.buttonStyle === "secondary" ? false : true);
} }
const _c15 = ["*", [["voxel-icon"]]];
const _c16 = ["*", "voxel-icon"];
function VoxelChipsComponent_legend_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "legend", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
const _c17 = function (a0) { return { "voxel-chips--withIcon": a0 }; };
function VoxelChipsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "input", 7);
    ɵngcc0.ɵɵlistener("change", function VoxelChipsComponent_div_3_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.changeOptions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵelementStart(4, "voxel-icon", 9);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "label", 10);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpureFunction1(11, _c17, option_r2.icon));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", option_r2.id)("type", ctx_r1.type === "filter" ? "checkbox" : "radio")("value", option_r2.value)("disabled", option_r2.disabled || ctx_r1.disabled)("name", option_r2.name)("checked", option_r2.selected);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(option_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", option_r2.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r2.label, " ");
} }
const _c18 = ["datepickerButton"];
const _c19 = ["origin"];
const _c20 = ["tableDays"];
const _c21 = ["calendarFull"];
function VoxelDatepickerComponent_ng_template_6_th_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th");
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const week_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("title", week_r11.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(week_r11.abbreviation);
} }
function VoxelDatepickerComponent_ng_template_6_tr_33_td_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29);
    ɵngcc0.ɵɵlistener("click", function VoxelDatepickerComponent_ng_template_6_tr_33_td_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const dayWeek_r16 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.selectDate(dayWeek_r16); })("focus", function VoxelDatepickerComponent_ng_template_6_tr_33_td_1_button_1_Template_button_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(4); return ctx_r22.dayFocus(ctx_r22.oudElementFocus, $event.target); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    const dayWeek_r16 = ctx_r23.$implicit;
    const col_r17 = ctx_r23.index;
    const row_r14 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("voxel-datepicker__day voxel-datepicker__day-", dayWeek_r16, "");
    ɵngcc0.ɵɵclassProp("voxel-datepicker__day--currentDate", ctx_r18.isCurrentDate(dayWeek_r16, ctx_r18.month, ctx_r18.year))("voxel-datepicker__day--selected", ctx_r18.value === ctx_r18.convertToDate(dayWeek_r16))("voxel-datepicker__day--focus", ctx_r18.dateFocus === ctx_r18.convertToDate(dayWeek_r16))("voxel-datepicker__day--enable", !ctx_r18.disabledDay(dayWeek_r16));
    ɵngcc0.ɵɵproperty("disabled", ctx_r18.disabledDay(dayWeek_r16));
    ɵngcc0.ɵɵattribute("aria-label", ctx_r18.ariaLabelDay(dayWeek_r16, ctx_r18.value === ctx_r18.convertToDate(dayWeek_r16)))("aria-current", ctx_r18.isCurrentDate(dayWeek_r16, ctx_r18.month, ctx_r18.year) ? "date" : null)("data-row", row_r14)("data-col", col_r17)("tabindex", !ctx_r18.isMobile ? "-1" : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(dayWeek_r16);
} }
function VoxelDatepickerComponent_ng_template_6_tr_33_td_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtemplate(1, VoxelDatepickerComponent_ng_template_6_tr_33_td_1_button_1_Template, 3, 18, "button", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dayWeek_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", dayWeek_r16);
} }
function VoxelDatepickerComponent_ng_template_6_tr_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, VoxelDatepickerComponent_ng_template_6_tr_33_td_1_Template, 2, 1, "td", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const week_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", week_r13);
} }
function VoxelDatepickerComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dialog", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6, 7);
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "button", 10, 11);
    ɵngcc0.ɵɵlistener("click", function VoxelDatepickerComponent_ng_template_6_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r26); const _r4 = ɵngcc0.ɵɵreference(6); const ctx_r25 = ɵngcc0.ɵɵnextContext(); ctx_r25.prevMonth(_r4); return ctx_r25.tabIndexDay(); });
    ɵngcc0.ɵɵelementStart(7, "voxel-icon");
    ɵngcc0.ɵɵtext(8, "seta_esquerda");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "p", 12);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "button", 13, 14);
    ɵngcc0.ɵɵlistener("click", function VoxelDatepickerComponent_ng_template_6_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r26); const _r5 = ɵngcc0.ɵɵreference(12); const ctx_r27 = ɵngcc0.ɵɵnextContext(); ctx_r27.nextMonth(_r5); return ctx_r27.tabIndexDay(); });
    ɵngcc0.ɵɵelementStart(13, "voxel-icon");
    ɵngcc0.ɵɵtext(14, "seta_direita");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 15);
    ɵngcc0.ɵɵelementStart(16, "button", 16, 17);
    ɵngcc0.ɵɵlistener("click", function VoxelDatepickerComponent_ng_template_6_Template_button_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r26); const _r6 = ɵngcc0.ɵɵreference(17); const ctx_r28 = ɵngcc0.ɵɵnextContext(); ctx_r28.prevYear(_r6); return ctx_r28.tabIndexDay(); });
    ɵngcc0.ɵɵelementStart(18, "voxel-icon");
    ɵngcc0.ɵɵtext(19, "seta_esquerda");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "p", 18);
    ɵngcc0.ɵɵtext(21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "button", 19, 20);
    ɵngcc0.ɵɵlistener("click", function VoxelDatepickerComponent_ng_template_6_Template_button_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r26); const _r7 = ɵngcc0.ɵɵreference(23); const ctx_r29 = ɵngcc0.ɵɵnextContext(); ctx_r29.nextYear(_r7); return ctx_r29.tabIndexDay(); });
    ɵngcc0.ɵɵelementStart(24, "voxel-icon");
    ɵngcc0.ɵɵtext(25, "seta_direita");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "div", 21);
    ɵngcc0.ɵɵelementStart(27, "table", 22, 23);
    ɵngcc0.ɵɵlistener("keydown", function VoxelDatepickerComponent_ng_template_6_Template_table_keydown_27_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.handleKeydown($event); });
    ɵngcc0.ɵɵelementStart(29, "thead", 24);
    ɵngcc0.ɵɵelementStart(30, "tr");
    ɵngcc0.ɵɵtemplate(31, VoxelDatepickerComponent_ng_template_6_th_31_Template, 3, 2, "th", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "tbody", 26);
    ɵngcc0.ɵɵtemplate(33, VoxelDatepickerComponent_ng_template_6_tr_33_Template, 2, 1, "tr", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "button", 27);
    ɵngcc0.ɵɵlistener("click", function VoxelDatepickerComponent_ng_template_6_Template_button_click_34_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.close(); });
    ɵngcc0.ɵɵtext(35, " fechar ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabledMonth(ctx_r2.month, ctx_r2.year)[0]);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.calendarConfig.prevMonth);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.isMobile ? ctx_r2.calendarConfig.monthNames[ctx_r2.month] : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.calendarConfig.monthNames[ctx_r2.month], " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabledMonth(ctx_r2.month, ctx_r2.year)[1]);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.calendarConfig.nextMonth);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabledYear(ctx_r2.year)[0]);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.calendarConfig.prevYear);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.isMobile ? ctx_r2.year : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.year, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabledYear(ctx_r2.year)[1]);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.calendarConfig.nextYear);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.calendarConfig.weekNames);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.calendar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.calendarConfig.close);
} }
function VoxelDialogComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "section", 1, 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3, 4);
    ɵngcc0.ɵɵprojection(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(5, 1);
    ɵngcc0.ɵɵelement(6, "div", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.dialogId);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r0.dialogAriaLabelledby)("aria-describedby", ctx_r0.dialogAriaDescribedby)("lang", ctx_r0.dialogLang)("aria-modal", ctx_r0.ariaModal);
} }
const _c22 = ["*", [["", "voxelDialogFooter", ""]]];
const _c23 = ["*", "[voxelDialogFooter]"];
const _c24 = function (a0) { return { "voxel-expense-chart--light": a0 }; };
const _c25 = function (a0) { return { chartPosition: a0 }; };
const _c26 = function (a0, a1) { return { value: a0, params: a1 }; };
const _c27 = [[["", "voxelHeaderBackButton", ""]], [["", "voxelHeaderTitle", ""]], [["", "voxelHeaderActionButton", ""]], [["", "voxelHeaderStepper", ""]]];
const _c28 = ["[voxelHeaderBackButton]", "[voxelHeaderTitle]", "[voxelHeaderActionButton]", "[voxelHeaderStepper]"];
function VoxelFormFieldComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errorMsgId", ctx_r1.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.msgErr, " ");
} }
function VoxelFormFieldComponent_ng_template_12_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hintFieldId", ctx_r4.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.description, " ");
} }
function VoxelFormFieldComponent_ng_template_12_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("hintFieldId", ctx_r7.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.description, " ");
} }
function VoxelFormFieldComponent_ng_template_12_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VoxelFormFieldComponent_ng_template_12_ng_template_1_span_0_Template, 2, 2, "span", 13);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.description);
} }
function VoxelFormFieldComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VoxelFormFieldComponent_ng_template_12_span_0_Template, 2, 2, "span", 10);
    ɵngcc0.ɵɵtemplate(1, VoxelFormFieldComponent_ng_template_12_ng_template_1_Template, 1, 1, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r5 = ɵngcc0.ɵɵreference(2);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.field.nativeElement.type === "textarea" && ctx_r3.description && ctx_r3.field.nativeElement.maxLength - ctx_r3.field.value.toString().length <= ctx_r3.a11yPoliteThresold)("ngIfElse", _r5);
} }
const _c29 = [[["", "voxelPrefix", ""]], "*", [["voxel-icon"], ["voxel-datepicker"], ["", "voxelSuffix", ""]]];
const _c30 = ["[voxelPrefix]", "*", "voxel-icon, voxel-datepicker, [voxelSuffix]"];
function VoxelFormSelectionComponent_voxel_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.input.iconClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.input.icon, " ");
} }
const _c31 = [[["input"]], "*", [["voxel-form-status"]]];
const _c32 = ["input", "*", "voxel-form-status"];
const _c33 = [[["legend"]], [["voxel-form-selection"]], [["voxel-form-status"]]];
const _c34 = ["legend", "voxel-form-selection", "voxel-form-status"];
const _c35 = ["content"];
function VoxelLearnMoreComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function VoxelLearnMoreComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.toggleCollapse(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-expanded", !ctx_r1.collapse)("aria-controls", ctx_r1.contentId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.collapse ? ctx_r1.readMoreLabel : ctx_r1.readLessLabel, "\n");
} }
function VoxelLikertComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function VoxelLikertComponent_button_4_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const option_r11 = restoredCtx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.emitValue(option_r11); })("focus", function VoxelLikertComponent_button_4_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onFocus(); })("blur", function VoxelLikertComponent_button_4_Template_button_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onBlur(); });
    ɵngcc0.ɵɵelementContainer(1, 10);
    ɵngcc0.ɵɵelementStart(2, "span", 11);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r11 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(6);
    const _r3 = ɵngcc0.ɵɵreference(8);
    const _r5 = ɵngcc0.ɵɵreference(10);
    const _r7 = ɵngcc0.ɵɵreference(12);
    const _r9 = ɵngcc0.ɵɵreference(14);
    ɵngcc0.ɵɵclassProp("voxel-likert__button--selected", (ctx_r0.value == null ? null : ctx_r0.value.key) === (option_r11 == null ? null : option_r11.key));
    ɵngcc0.ɵɵproperty("id", ctx_r0.id + "-" + option_r11.key);
    ɵngcc0.ɵɵattribute("aria-checked", option_r11 === ctx_r0.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", option_r11.key === "bad" ? _r1 : option_r11.key === "dislike" ? _r3 : option_r11.key === "neutral" ? _r5 : option_r11.key === "like" ? _r7 : _r9);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r11.value, " ");
} }
function VoxelLikertComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 12);
} }
function VoxelLikertComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} }
function VoxelLikertComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 14);
} }
function VoxelLikertComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 15);
} }
function VoxelLikertComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 16);
} }
const _c36 = [[["voxel-icon"], ["img"]], "*", [["voxel-list-descr"]]];
const _c37 = ["voxel-icon, img", "*", "voxel-list-descr"];
const _c38 = ["*", [["voxel-list-descr"]], [["voxel-icon"]]];
const _c39 = ["*", "voxel-list-descr", "voxel-icon"];
const _c40 = [[["voxel-list-descr"]], [["voxel-list-text"]]];
const _c41 = ["voxel-list-descr", "voxel-list-text"];
const _c42 = [[["voxel-list-text"]], [["voxel-list-descr"]], [["voxel-list-text-detail"], ["voxel-list-number"]], [["voxel-list-detail"]]];
const _c43 = ["voxel-list-text", "voxel-list-descr", "voxel-list-text-detail, voxel-list-number", "voxel-list-detail"];
const _c44 = [[["voxel-list-text"]], [["voxel-list-text-detail"]], [["voxel-list-descr"]], [["voxel-list-detail"]]];
const _c45 = ["voxel-list-text", "voxel-list-text-detail", "voxel-list-descr", "voxel-list-detail"];
const _c46 = [[["voxel-form-selection"], ["input", "type", "checkbox", "voxelSwitch", ""]]];
const _c47 = ["voxel-form-selection, input[type='checkbox'][voxelSwitch]"];
function VoxelListComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 2);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r0.listId);
} }
function VoxelListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r1.listId);
} }
const _c48 = [[["li", "voxelListSimple", ""], ["li", "voxel-list-simple", ""], ["li", "voxelListAction", ""], ["li", "voxel-list-action", ""], ["li", "voxelListInfo", ""], ["li", "voxel-list-info", ""], ["li", "voxelListColumn", ""], ["li", "voxel-list-column", ""], ["li", "voxelListRow", ""], ["li", "voxel-list-row", ""], ["li", "voxelListSwitch", ""], ["li", "voxel-list-switch", ""]], [["dl", "voxelListDefinition", ""], ["dl", "voxel-list-definition", ""]]];
const _c49 = ["\n    li[voxelListSimple],\n    li[voxel-list-simple],\n    li[voxelListAction],\n    li[voxel-list-action],\n    li[voxelListInfo],\n    li[voxel-list-info],\n    li[voxelListColumn],\n    li[voxel-list-column],\n    li[voxelListRow],\n    li[voxel-list-row],\n    li[voxelListSwitch],\n    li[voxel-list-switch]", "\n    dl[voxelListDefinition],\n    dl[voxel-list-definition]"];
function VoxelModalComponent_ng_template_0_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function VoxelModalComponent_ng_template_0_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.modalIsOpen = false; });
    ɵngcc0.ɵɵelementStart(1, "voxel-icon");
    ɵngcc0.ɵɵtext(2, "fechar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r2.modalId + "-button-close");
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.modalCloseLabel);
} }
function VoxelModalComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "section", 1, 2);
    ɵngcc0.ɵɵtemplate(2, VoxelModalComponent_ng_template_0_button_2_Template, 3, 2, "button", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4, 5);
    ɵngcc0.ɵɵprojection(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(6, 1);
    ɵngcc0.ɵɵelement(7, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.modalId);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r0.modalAriaLabelledby)("aria-describedby", ctx_r0.modalAriaDescribedby)("lang", ctx_r0.modalLang)("aria-modal", ctx_r0.ariaModal);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canClose);
} }
const _c50 = ["*", [["", "voxelModalFooter", ""]]];
const _c51 = ["*", "[voxelModalFooter]"];
const _c52 = ["select"];
function VoxelSelectComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5, 6);
    ɵngcc0.ɵɵlistener("keydown", function VoxelSelectComponent_ng_template_7_Template_div_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.handleKeydown($event); });
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-height", !ctx_r2.isMobile ? ctx_r2.visibleOptions * 3 : "", "rem");
    ɵngcc0.ɵɵproperty("id", ctx_r2.panelId);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r2.labelId)("aria-hidden", !ctx_r2.panelOpen);
} }
const _c53 = function (a0) { return { "voxel-select--disabled": a0 }; };
const _c54 = function (a1, a2) { return { "voxel-select__icon": true, "voxel-select__icon--disabled": a1, "voxel-select__icon--open": a2 }; };
const _c55 = ["tabsBg"];
const _c56 = ["tabListContent"];
const _c57 = ["buttonTabs"];
const _c58 = function (a0) { return { "voxel-tab-list__navigation--disabled": a0 }; };
function VoxelTabsComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function VoxelTabsComponent_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.changeTab(false); });
    ɵngcc0.ɵɵelementStart(1, "voxel-icon", 9);
    ɵngcc0.ɵɵtext(2, "seta_esquerda");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c58, ctx_r1.scrollPosition === 0));
} }
function VoxelTabsComponent_button_6_voxel_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(tab_r7.icon);
} }
function VoxelTabsComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10, 11);
    ɵngcc0.ɵɵlistener("focus", function VoxelTabsComponent_button_6_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const _r9 = ɵngcc0.ɵɵreference(1); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.scrollIntoView(_r9); })("keydown", function VoxelTabsComponent_button_6_Template_button_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onKeyDown($event); })("click", function VoxelTabsComponent_button_6_Template_button_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const tab_r7 = restoredCtx.$implicit; const index_r8 = restoredCtx.index; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.clickTab($event, tab_r7, index_r8); });
    ɵngcc0.ɵɵtemplate(2, VoxelTabsComponent_button_6_voxel_icon_2_Template, 2, 1, "voxel-icon", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("voxel-tab--checked", ctx_r3.current === index_r8 + 1)("voxel-tab--on-dark", ctx_r3.dark);
    ɵngcc0.ɵɵproperty("id", ctx_r3.tabId + "-" + (index_r8 + 1));
    ɵngcc0.ɵɵattribute("aria-selected", ctx_r3.current === index_r8 + 1)("aria-controls", ctx_r3.current === index_r8 + 1 ? tab_r7.panelId : "")("disabled", tab_r7.disabled || null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", tab_r7.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tab_r7.name, " ");
} }
function VoxelTabsComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵlistener("click", function VoxelTabsComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.changeTab(true); });
    ɵngcc0.ɵɵelementStart(1, "voxel-icon", 9);
    ɵngcc0.ɵɵtext(2, "seta_direita");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c58, ctx_r4.scrollPosition >= 100));
} }
function VoxelTooltipComponent_voxel_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.tooltipIcon, " ");
} }
const _c59 = function (a0) { return { "transform": a0 }; };
const _c60 = ["messageRef"];
var SegmentTypes;
(function (SegmentTypes) {
    SegmentTypes["Credicard"] = "credicard";
    SegmentTypes["Empresas"] = "empresas";
    SegmentTypes["Hipercard"] = "hipercard";
    SegmentTypes["Investment_Service"] = "investment_service";
    SegmentTypes["Ion"] = "ion";
    SegmentTypes["Itau_BBA"] = "itau_bba";
    SegmentTypes["Itaucard"] = "itaucard";
    SegmentTypes["Iti"] = "iti";
    SegmentTypes["Magalu"] = "magalu";
    SegmentTypes["Person_Antigo"] = "personnalite";
    SegmentTypes["Personal_Bank"] = "personal_bank";
    SegmentTypes["Personnalite"] = "personnalite";
    SegmentTypes["Person_Beta"] = "person_beta";
    SegmentTypes["Private"] = "private";
    SegmentTypes["Uniclass"] = "uniclass";
    SegmentTypes["Varejo"] = "varejo";
})(SegmentTypes || (SegmentTypes = {}));
var LegacySegmentTypes;
(function (LegacySegmentTypes) {
    LegacySegmentTypes["credicard"] = "parceiro-credicard";
    LegacySegmentTypes["empresas"] = "empresas";
    LegacySegmentTypes["hipercard"] = "parceiro-hipercard";
    LegacySegmentTypes["investment_service"] = "varejo";
    LegacySegmentTypes["ion"] = "varejo";
    LegacySegmentTypes["itau_bba"] = "itau-bba";
    LegacySegmentTypes["itaucard"] = "parceiro-itaucard";
    LegacySegmentTypes["iti"] = "varejo";
    LegacySegmentTypes["magalu"] = "parceiro-magazine-luiza";
    LegacySegmentTypes["person_antigo"] = "personnalite";
    LegacySegmentTypes["personal_bank"] = "personal-bank";
    LegacySegmentTypes["personnalite"] = "personnalite";
    LegacySegmentTypes["person_beta"] = "personnalite";
    LegacySegmentTypes["private"] = "private";
    LegacySegmentTypes["uniclass"] = "uniclass";
    LegacySegmentTypes["varejo"] = "varejo";
})(LegacySegmentTypes || (LegacySegmentTypes = {}));
/**
 * @internal
 * Token de Injeção de Dependência que contêm o valor do {@link SegmentTypes} padrão.
 */
const SegmentTypeDefault = new InjectionToken('SegmentTypeDefault');
/**
 * @internal
 * Token de Injeção de Dependência que permite configuração opcional do valor do {@link SegmentTypes} SegmentTypeDefault.
 */
const SegmentTypeConfig = new InjectionToken('SegmentTypeConfig');
/**
 * @internal
 * Factory function para criar o valor do SegmentTypeDefault
 */
const segmentTypeDefaultFactory = (segment) => segment || SegmentTypes.Varejo;
/**
 * @internal
 * Provider do valor do SegmentTypeDefault
 */
const SegmentTypeDefaultProvider = {
    provide: SegmentTypeDefault,
    useFactory: segmentTypeDefaultFactory,
    deps: [[new Optional(), SegmentTypeConfig]],
};

class VoxelSegmentService {
    /**
     * @internal
     */
    constructor(defaultSegment, document, rendererFactory) {
        this.defaultSegment = defaultSegment;
        this.document = document;
        this.rendererFactory = rendererFactory;
        this._segment = new BehaviorSubject(LegacySegmentTypes[this.defaultSegment]);
        /**
         * Observable de Segmento
         */
        this.segment = this._segment.asObservable();
        this.renderer = this.rendererFactory.createRenderer(null, null);
        this.changeSegment(defaultSegment);
    }
    /**
     * Envia novo valor de Segmento para os subscribers e para o root
     *
     * @param value Novo valor de Segmento
     * @returns void
     */
    changeSegment(value) {
        this._segment.next(LegacySegmentTypes[value]);
        this.renderer.removeClass(this.document.documentElement, this._currentSegment);
        this.renderer.addClass(this.document.documentElement, `voxel-theme-${value}`);
        this._currentSegment = `voxel-theme-${value}`;
    }
}
VoxelSegmentService.ɵfac = function VoxelSegmentService_Factory(t) { return new (t || VoxelSegmentService)(ɵngcc0.ɵɵinject(SegmentTypeDefault), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2)); };
VoxelSegmentService.ɵprov = i0.ɵɵdefineInjectable({ factory: function VoxelSegmentService_Factory() { return new VoxelSegmentService(i0.ɵɵinject(SegmentTypeDefault), i0.ɵɵinject(i2.DOCUMENT), i0.ɵɵinject(i0.RendererFactory2)); }, token: VoxelSegmentService, providedIn: "root" });
VoxelSegmentService.ctorParameters = () => [
    { type: SegmentTypes, decorators: [{ type: Inject, args: [SegmentTypeDefault,] }] },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: RendererFactory2 }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSegmentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SegmentTypes, decorators: [{
                type: Inject,
                args: [SegmentTypeDefault]
            }] }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.RendererFactory2 }]; }, null); })();

class VoxelSegmentModule {
}
VoxelSegmentModule.ɵfac = function VoxelSegmentModule_Factory(t) { return new (t || VoxelSegmentModule)(); };
VoxelSegmentModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelSegmentModule });
VoxelSegmentModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [SegmentTypeDefaultProvider] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSegmentModule, [{
        type: NgModule,
        args: [{
                providers: [SegmentTypeDefaultProvider]
            }]
    }], null, null); })();

/**
 * Módulo para configurações globais do Voxel.
 * A importação desse módulo é obrigatória e deve ser feita no módulo raiz da aplicação, utilizando o método `.forRoot()`
 */
class VoxelConfigModule {
    // eslint-disable-next-line @typescript-eslint/no-empty-function,  @typescript-eslint/no-unused-vars
    constructor(_voxelSegmentService) { }
    /**
     * Método estático para gerar as configurações de módulo conforme parâmetros recebidos
     *
     * @param config Configuração desejada para o projeto
     */
    static forRoot(config) {
        return {
            ngModule: VoxelConfigModule,
            providers: [
                {
                    provide: SegmentTypeConfig,
                    useValue: config.segment,
                },
            ],
        };
    }
}
VoxelConfigModule.ɵfac = function VoxelConfigModule_Factory(t) { return new (t || VoxelConfigModule)(ɵngcc0.ɵɵinject(VoxelSegmentService)); };
VoxelConfigModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelConfigModule });
VoxelConfigModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [SegmentTypeDefaultProvider] });
VoxelConfigModule.ctorParameters = () => [
    { type: VoxelSegmentService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelConfigModule, [{
        type: NgModule,
        args: [{
                providers: [SegmentTypeDefaultProvider]
            }]
    }], function () { return [{ type: VoxelSegmentService }]; }, null); })();

/**
 * Componente de ícone usado em elementos de interface, disponibilizado nos tamanhos pequeno "S", médio "M" e grande "L"
 *
 * *Icon component used in interface elements, available as small "S", medium "M" and large "L".*
 *
 * **Module:**
 *
 * `import { VoxelIconModule } from '@voxel/components';`
 *
 * <example-url>../../demo/#/portfolio/icon?componentOnly=true</example-url>
 *
 * @example
 * <voxel-icon>
 *    nome_do_ícone
 * </voxel-icon>
 *
 * @example Leitor de tela habilitado
 * <voxel-icon
 *  a11yHidden="false"
 *  a11yLabel="Descrição do ícone">
 *    nome_do_ícone
 * </voxel-icon>
 *
 * @example Ícone com alteração de tamanho
 * <voxel-icon
 *  size="S">
 *    nome_do_ícone
 * </voxel-icon>
 *
 */
class VoxelIconComponent {
    constructor() {
        /**
         * Tamanho do ícone
         *
         * *Icon size*
         */
        this.size = 'M';
        /**
         * Desabilitar Leitor de Tela para o ícone
         *
         * *Disable screen reader for the icon*
         */
        this.a11yHidden = true;
    }
}
VoxelIconComponent.ɵfac = function VoxelIconComponent_Factory(t) { return new (t || VoxelIconComponent)(); };
VoxelIconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelIconComponent, selectors: [["voxel-icon"]], inputs: { size: "size", a11yHidden: "a11yHidden", a11yLabel: "a11yLabel" }, ngContentSelectors: _c0, decls: 4, vars: 7, consts: [["role", "img", 1, "voxel-icon"], ["aria-hidden", "true"]], template: function VoxelIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵpipe(2, "lowercase");
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.a11yHidden)("aria-label", ctx.a11yLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("voxel-icon__", ɵngcc0.ɵɵpipeBind1(2, 5, ctx.size), "");
    } }, pipes: [ɵngcc1.LowerCasePipe], styles: [".voxel-icon[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_medium);-webkit-font-feature-settings:\"liga\",\"dlig\";font-feature-settings:\"liga\",\"dlig\";font-size:inherit;-webkit-font-smoothing:antialiased;-webkit-font-variant-ligatures:discretionary-ligatures;font-variant-ligatures:discretionary-ligatures;letter-spacing:0;line-height:inherit;margin:auto;text-rendering:optimizeLegibility}.voxel-icon__s[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_small)}.voxel-icon__m[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_medium)}.voxel-icon__l[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_large)}"] });
/**
 * @internal
 */
VoxelIconComponent.selector = 'voxel-icon';
VoxelIconComponent.propDecorators = {
    size: [{ type: Input }],
    a11yHidden: [{ type: Input }],
    a11yLabel: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelIconComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-icon',
                template: "<div\n  class=\"voxel-icon\"\n  role=\"img\"\n  [attr.aria-hidden]=\"a11yHidden\"\n  [attr.aria-label]=\"a11yLabel\"\n>\n  <span\n    aria-hidden=\"true\"\n    class=\"voxel-icon__{{ size | lowercase }}\"\n  >\n    <ng-content></ng-content>\n  </span>\n</div>\n",
                styles: [".voxel-icon{font:var(--ids_textStyle_icon_medium);-webkit-font-feature-settings:\"liga\",\"dlig\";font-feature-settings:\"liga\",\"dlig\";font-size:inherit;-webkit-font-smoothing:antialiased;-webkit-font-variant-ligatures:discretionary-ligatures;font-variant-ligatures:discretionary-ligatures;letter-spacing:0;line-height:inherit;margin:auto;text-rendering:optimizeLegibility}.voxel-icon__s{font:var(--ids_textStyle_icon_small)}.voxel-icon__m{font:var(--ids_textStyle_icon_medium)}.voxel-icon__l{font:var(--ids_textStyle_icon_large)}\n"]
            }]
    }], function () { return []; }, { size: [{
            type: Input
        }], a11yHidden: [{
            type: Input
        }], a11yLabel: [{
            type: Input
        }] }); })();

class VoxelIconModule {
}
VoxelIconModule.ɵfac = function VoxelIconModule_Factory(t) { return new (t || VoxelIconModule)(); };
VoxelIconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelIconModule });
VoxelIconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelIconModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelIconComponent],
                exports: [VoxelIconComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelIconModule, { declarations: function () { return [VoxelIconComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelIconComponent]; } }); })();

const currencies = () => {
    const currenciesMap = new Map();
    currenciesMap.set('ARS', {
        prefix: '$ ',
        singular: 'peso argentino',
        plural: 'pesos argentinos',
    });
    currenciesMap.set('BRL', { prefix: 'R$ ', singular: 'real', plural: 'reais' });
    currenciesMap.set('CLP', { prefix: '$ ', singular: 'peso chileno', plural: 'pesos chilenos' });
    currenciesMap.set('COP', {
        prefix: '$ ',
        singular: 'peso colombiano',
        plural: 'pesos colombianos',
    });
    currenciesMap.set('EUR', { prefix: '€ ', singular: 'euro', plural: 'euros' });
    currenciesMap.set('GBP', {
        prefix: '£ ',
        singular: 'libra esterlina',
        plural: 'libras esterlinas',
    });
    currenciesMap.set('PYG', {
        prefix: '₲ ',
        singular: 'guarani paraguaio',
        plural: 'guaranis paraguaios',
    });
    currenciesMap.set('USD', { prefix: '$ ', singular: 'dólar', plural: 'dólares' });
    currenciesMap.set('UYU', { prefix: '$ ', singular: 'peso uruguaio', plural: 'pesos uruguaios' });
    return currenciesMap;
};
const currencyPrefix = (currencyType = 'BRL') => {
    var _a, _b;
    const allCurrencies = currencies();
    return (_b = (_a = allCurrencies.get(currencyType)) === null || _a === void 0 ? void 0 : _a.prefix) !== null && _b !== void 0 ? _b : 'R$ ';
};

const accessibleCurrencyReading = (value, currencyType = 'BRL') => {
    var _a;
    const allCurrencies = currencies();
    const isFloat = value % 1 !== 0;
    const currency = (_a = allCurrencies.get(currencyType)) !== null && _a !== void 0 ? _a : { singular: 'real', plural: 'reais' };
    if (isFloat) {
        const numberParts = value.toFixed(2).split('.');
        const integerPart = numberParts[0];
        const floatPart = numberParts[1];
        return `${integerPart} ${integerPart === '1' ? currency.singular : currency.plural} e ${floatPart} centavos`;
    }
    return `${value} ${value === 1 ? currency.singular : currency.plural}`;
};

// Este é um polyfill para element.focus({preventScroll: true});
// Atualmente necessário para Safari e versões antigas do Edge.
// https://caniuse.com/#feat=mdn-api_htmlelement_focus_preventscroll_option
// https://bugs.webkit.org/show_bug.cgi?id=178583
// Solução original em: https://github.com/calvellido/focus-options-polyfill
let supportsPreventScrollCached = null;
const supportsPreventScroll = () => {
    if (supportsPreventScrollCached == null) {
        supportsPreventScrollCached = false;
        try {
            const focusElem = document.createElement('div');
            focusElem.focus({
                get preventScroll() {
                    supportsPreventScrollCached = true;
                    return true;
                },
            });
        }
        catch (e) {
            // Ignore
        }
    }
    return supportsPreventScrollCached;
};
const ɵ0$6 = supportsPreventScroll;
const getScrollableElements = (element) => {
    let parent = element.parentNode;
    const scrollableElements = [];
    const rootScrollingElement = document.scrollingElement || document.documentElement;
    while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
            scrollableElements.push({
                element: parent,
                scrollTop: parent.scrollTop,
                scrollLeft: parent.scrollLeft,
            });
        }
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) {
        scrollableElements.push({
            element: rootScrollingElement,
            scrollTop: rootScrollingElement.scrollTop,
            scrollLeft: rootScrollingElement.scrollLeft,
        });
    }
    return scrollableElements;
};
const ɵ1$2 = getScrollableElements;
const restoreScrollPosition = (scrollableElements) => {
    for (const { element, scrollTop, scrollLeft } of scrollableElements) {
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
};
const ɵ2$2 = restoreScrollPosition;
const focusWithoutScrolling = (element) => {
    if (supportsPreventScroll()) {
        element.focus({ preventScroll: true });
        return;
    }
    const scrollableElements = getScrollableElements(element);
    element.focus();
    restoreScrollPosition(scrollableElements);
};

// Nós armazenamos uma lista global de elementos que no mommento estão
// transicionando, através de um conjunto de propriedades CSS que estão em
// transição para o elemento. Isso é melhor do que um simples contador de
// transições, por causa de alguns bugs dos navegadores, por exemplo o Chrome as
// vezes dispara os eventos "transitionend" e "transitioncancel" juntos, ao
// invés de um de cada vez. Então nós precisamos rastrear o que está transicionando
// no momento e ignorar esses eventos duplicados.
const transitionsByElement = new Map();
// Uma lista de callbacks para chamar quando não houver elementos transicionando
const transitionCallbacks = new Set();
const setupGlobalEvents = () => {
    if (typeof window === 'undefined') {
        return;
    }
    const onTransitionStart = (event) => {
        // adiciona a propriedade da lista de propriedade de transição
        const target = event.target;
        let transitions = transitionsByElement.get(target);
        if (!transitions) {
            transitions = new Set();
            transitionsByElement.set(target, transitions);
            // o event "transitioncancel" deve ser registrado no próprio elemento ao
            // invés de um evento global. Isso nos permite controlar quando o nó é
            // removido do documento enquanto está transicionando. Neste caso,
            // o evento de cancelamento não teria para onde ir, então precisamos lidar
            // com isso diretamente
            target.addEventListener('transitioncancel', onTransitionEnd);
        }
        transitions.add(event.propertyName);
    };
    const onTransitionEnd = (e) => {
        // remove a propriedade da lista de propriedade de transição
        const target = e.target;
        const properties = transitionsByElement.get(target);
        if (!properties) {
            return;
        }
        properties.delete(e.propertyName);
        // se vazio, remove evento de "transitioncancel" e remove o elemento da
        // lista de transitioning elements.
        if (properties.size === 0) {
            target.removeEventListener('transitioncancel', onTransitionEnd);
            transitionsByElement.delete(target);
        }
        // se nenhum elemento está em transição, chama todos os callbacks na fila.
        if (transitionsByElement.size === 0) {
            for (const cb of transitionCallbacks) {
                cb();
            }
            transitionCallbacks.clear();
        }
    };
    document.body.addEventListener('transitionrun', onTransitionStart);
    document.body.addEventListener('transitionend', onTransitionEnd);
};
const ɵ0$5 = setupGlobalEvents;
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') {
        setupGlobalEvents();
    }
    else {
        document.addEventListener('DOMContentLoaded', setupGlobalEvents);
    }
}
const runAfterTransition = (fn) => {
    // Aguarda 1 quadro para ver se uma animação inicia (transition on mount).
    requestAnimationFrame(() => {
        // Se nenhuma transição está rodando, chama a função, se não adiciona-a a
        // uma lista de callbacks para rodar no final da animação
        if (transitionsByElement.size === 0) {
            fn();
            return;
        }
        transitionCallbacks.add(fn);
    });
};

/**
 * Este é um método de inferir cliques virtuais.
 *
 * Teclados, tecnologias assistivas e element.click() produzem um evento
 * de clique "virtual". Todo navegador, menos o IE11, definem apenas o valor
 * zero de `detail` para eventos de clique que são "virtuais", já o IE11 usa um
 * valor zero para todos os eventos de cliques. Para o IE11 nós
 * confiamos na peculiaridade de produzir eventos de clique que são do tipo
 * PointerEvent, e quando é clique virual, falta o atributo pointerType.
 */
const isVirtualClick = (event) => {
    // no Firefox quando mozInputSource é igual foi 1 clique com mouse, se for 6
    // foi um clique com teclado e se for 0 foi com o JAWS/NVDA ligado.
    if (event.mozInputSource === 0 && event.isTrusted) {
        return true;
    }
    return event.detail === 0 && !event.pointerType;
};

const getOs = () => {
    var _a, _b, _c;
    // o iPad 13 vem descrito como Mac OS no seu sistema operacional, porém é
    // possível diferenciar pelos pontos de toque na tela
    const isIPad = navigator.userAgent.includes('Mac OS') && navigator.maxTouchPoints > 1;
    if (((_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform) === 'Windows' ||
        navigator.userAgent.includes('Windows NT')) {
        return 'Windows';
    }
    if (((_b = navigator.userAgentData) === null || _b === void 0 ? void 0 : _b.platform) === 'Android' || navigator.userAgent.includes('Android')) {
        return 'Android';
    }
    if (navigator.platform === 'iPhone' || navigator.userAgent.includes('iPhone') || isIPad) {
        return 'IOS';
    }
    if (((_c = navigator.userAgentData) === null || _c === void 0 ? void 0 : _c.platform) === 'macOS' ||
        navigator.userAgent.includes('Mac OS') ||
        navigator.platform === 'MacIntel') {
        return 'MacOS';
    }
    return 'Windows';
};
const ɵ0$4 = getOs;
const getIsMobile = () => {
    var _a;
    const os = getOs();
    if (((_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.mobile) || os === 'Android' || os === 'IOS') {
        return true;
    }
    return false;
};
const ɵ1$1 = getIsMobile;
const getUserAgent = () => {
    var _a, _b, _c, _d;
    // A única informação que difere o Chrome do Safari no IOS é a descrição CriOS
    // https://chromium.googlesource.com/chromium/src.git/+/HEAD/docs/ios/user_agent.md
    const isIphoneChrome = navigator.userAgent.includes('CriOS');
    // Contando que existe apenas Chrome e Safari no iPhone, excluindo Chrome,
    // sobra Safari
    const isIphoneSafari = !isIphoneChrome && navigator.platform === 'iPhone';
    const isMacSafari = navigator.vendor === 'Apple Computer, Inc' &&
        (navigator.platform === 'MacIntel' || navigator.userAgent.includes('Macintosh'));
    if ((_b = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.brands) === null || _b === void 0 ? void 0 : _b.some(({ brand }) => brand === 'Microsoft Edge')) {
        return 'Edge';
    }
    if (isIphoneChrome ||
        ((_d = (_c = navigator.userAgentData) === null || _c === void 0 ? void 0 : _c.brands) === null || _d === void 0 ? void 0 : _d.some(({ brand }) => brand === 'Google Chrome'))) {
        return 'Chrome';
    }
    if (navigator.userAgent.includes('Firefox/')) {
        return 'Firefox';
    }
    if (isIphoneSafari || isMacSafari) {
        return 'Safari';
    }
    return 'Internet Explorer';
};
const ɵ2$1 = getUserAgent;
/**
 * todas as informações da plataforma estão disponíveis no objeto Platform
 */
const platform = {
    get isMobile() {
        return getIsMobile();
    },
    get os() {
        return getOs();
    },
    get userAgent() {
        return getUserAgent();
    },
};

let currentModality = 'pointer';
const changeHandlers = new Set();
let hasSetupGlobalListeners = false;
let hasEventBeforeFocus = false;
let hasBlurredWindowRecently = false;
const triggerChangeHandlers = (modality, e) => {
    for (const handler of changeHandlers) {
        handler(modality, e);
    }
};
const ɵ0$3 = triggerChangeHandlers;
/**
 * Função para determinar se o KeyboardEvent não está modificado e poderia fazer
 * foco de teclado visível
 */
const isValidKey = (e) => 
// os botões control e shift disparam quando a navegação volta para o tab com
// teclado
!(e.metaKey ||
    (platform.os !== 'MacOS' && e.altKey) ||
    e.ctrlKey ||
    e.key === 'Control' ||
    e.key === 'Shift' ||
    e.key === 'Meta');
const ɵ1 = isValidKey;
const handleKeyboardEvent = (e) => {
    hasEventBeforeFocus = true;
    if (isValidKey(e)) {
        currentModality = 'keyboard';
        triggerChangeHandlers('keyboard', e);
    }
};
const ɵ2 = handleKeyboardEvent;
const handlePointerEvent = (e) => {
    currentModality = 'pointer';
    if (e.type === 'mousedown' || e.type === 'pointerdown') {
        hasEventBeforeFocus = true;
        triggerChangeHandlers('pointer', e);
    }
};
const ɵ3 = handlePointerEvent;
const handleClickEvent = (e) => {
    if (isVirtualClick(e)) {
        hasEventBeforeFocus = true;
        currentModality = 'virtual';
    }
};
const ɵ4 = handleClickEvent;
const handleFocusEvent = (e) => {
    // O Firefox lança dois eventos de foco extra quando o usuário clica pela
    // primeira vez em um iframe: primeiro no window e depois no documento. Nós
    // ignoramos esses eventos para não fazer o foco do teclado aparecer.
    if (e.target === window || e.target === document) {
        return;
    }
    // Se um evento de foco ocorrer sem ser após um evento de teclado ou de
    // cursor, muda para modalidade "virtual". Isso occore, por exemplo, quando
    // navegar para um formulário com os botões do teclado do iOS
    if (!hasEventBeforeFocus && !hasBlurredWindowRecently) {
        currentModality = 'virtual';
        triggerChangeHandlers('virtual', e);
    }
    hasEventBeforeFocus = false;
    hasBlurredWindowRecently = false;
};
const ɵ5 = handleFocusEvent;
const handleWindowBlur = () => {
    // Quando o window é desfocado, reseta o estado. Isso é necessário quando
    // tabulado para fora do window.
    hasEventBeforeFocus = false;
    hasBlurredWindowRecently = true;
};
const ɵ6 = handleWindowBlur;
/**
 * escuta eventos globais para ter controle quando o foco do teclado deve ser
 * visível.
 */
const setupGlobalFocusEvents = () => {
    if (typeof window === 'undefined' || hasSetupGlobalListeners) {
        return;
    }
    // Para que os eventos de foco disparados manualmente não afetem a modalidade
    // de interação é necessário sobrescrever o método HTMLElement.prototype.focus.
    const focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function () {
        hasEventBeforeFocus = true;
        // @ts-expect-error sobrescrita de evento
        // eslint-disable-next-line prefer-rest-params
        focus.apply(this, arguments);
    };
    document.addEventListener('keydown', handleKeyboardEvent, true);
    document.addEventListener('keyup', handleKeyboardEvent, true);
    document.addEventListener('click', handleClickEvent, true);
    // Registra os eventos de foco no window para garantir que será chamado antes
    // dos outros no documento.
    window.addEventListener('focus', handleFocusEvent, true);
    window.addEventListener('blur', handleWindowBlur, false);
    if (typeof PointerEvent !== 'undefined') {
        document.addEventListener('pointerdown', handlePointerEvent, true);
        document.addEventListener('pointermove', handlePointerEvent, true);
        document.addEventListener('pointerup', handlePointerEvent, true);
    }
    else {
        document.addEventListener('mousedown', handlePointerEvent, true);
        document.addEventListener('mousemove', handlePointerEvent, true);
        document.addEventListener('mouseup', handlePointerEvent, true);
    }
    hasSetupGlobalListeners = true;
};
if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') {
        setupGlobalFocusEvents();
    }
    else {
        document.addEventListener('DOMContentLoaded', setupGlobalFocusEvents);
    }
}
/**
 * Foco virtual ou com teclado são visíveis
 */
const isFocusVisible = () => currentModality !== 'pointer';
const getInteractionModality = () => currentModality;
const setInteractionModality = (modality) => {
    currentModality = modality;
    triggerChangeHandlers(modality, undefined);
};

/**
 * Uma função utilitária que foca um elemento enquanto evita efeitos colaterais
 * indesejados do tipo rolagem de página e problemas de leitores de tela com
 * transições CSS
 */
const focusSafely = (element) => {
    // Se o usuário está interagindo com um cursor virtual (leitor de tela), então
    // espera até depois de qualquer transição de animação que esteja ocorrendo
    // na página para mudar o foco. Isso evita problemas com VoiceOver no iOS
    // fazendo com que a página role ao mover o foco se o elemento estiver
    // saindo da tela.
    if (getInteractionModality() === 'virtual') {
        const lastFocusedElement = document.activeElement;
        runAfterTransition(() => {
            // Se o foco não moveu e o elemento ainda está no documento, foca-o.
            if (document.activeElement === lastFocusedElement && document.contains(element)) {
                focusWithoutScrolling(element);
            }
        });
        return;
    }
    focusWithoutScrolling(element);
};

const hasDefaultAttribute = (element, attribute) => element.getAttribute(`data-setted-${attribute}`) !== 'true';
const ɵ0$2 = hasDefaultAttribute;
/**
 * Este método tem a função de colocar um atributo em um elemento HTML e além
 * disso já deixar marcado com [data-setted-{ATRIBUTO}] para quando for preciso
 * remover
 */
const setAttribute = (element, attribute, value = 'true') => {
    if (element.hasAttribute(attribute)) {
        return;
    }
    element.setAttribute(attribute, value);
    element.setAttribute(`data-setted-${attribute}`, 'true');
};
/**
 * Este método tem a função de remover os atributos HTML que foram adicionados
 * pelo "setAttribute"
 */
const removeSettedAttribute = (element, attribute) => {
    if (!hasDefaultAttribute(element, attribute)) {
        element.removeAttribute(`data-setted-${attribute}`);
        element.removeAttribute(attribute);
    }
};

const toggleMobileFocusTrap = ({ element = document.querySelector('.cdk-overlay-container'), add = true, }) => {
    // o focustrap com aria-hidden não é necessário para desktop e causa efeitos
    // colaterais no NVDA na leitura do botão de origem quando fecha o modal.
    if (!element) {
        return;
    }
    const elExceptionList = Array.from(document.querySelectorAll('.cdk-live-announcer-element'));
    const exec = (currentElement) => {
        var _a, _b;
        const siblingEls = Array.from((_b = (_a = currentElement.parentElement) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
        const elementsToHide = siblingEls.filter((siblingEl) => siblingEl !== currentElement &&
            !elExceptionList.some((el) => el.isEqualNode(siblingEl)) &&
            siblingEl.tagName !== 'SCRIPT' &&
            siblingEl.tagName !== 'STYLE' &&
            siblingEl.tagName !== 'LINK' &&
            siblingEl.tagName !== 'HEAD');
        elementsToHide.forEach((elementToHide) => {
            if (add) {
                setAttribute(elementToHide, 'aria-hidden', 'true');
                return;
            }
            removeSettedAttribute(elementToHide, 'aria-hidden');
        });
        if (currentElement.parentElement) {
            exec(currentElement.parentElement);
        }
    };
    exec(element);
};

const startDialogFocus = (dialogElement) => {
    const startFocusOnRoot = () => {
        if (!dialogElement.hasAttribute('tabindex')) {
            dialogElement.setAttribute('tabindex', '-1');
        }
        // apenas o VoiceOver não faz a leitura se fizer o foco imediatamente
        if (platform.os === 'IOS') {
            focusSafely(dialogElement);
            return;
        }
        dialogElement.focus();
    };
    if (platform.os === 'Android') {
        startFocusOnRoot();
        return;
    }
    const selector = 'a, button, input, [tabindex], h2, p';
    const firstElement = dialogElement.querySelector(selector);
    if (!firstElement) {
        startFocusOnRoot();
        return;
    }
    if (firstElement.tagName === 'H2' || firstElement.tagName === 'P') {
        firstElement.setAttribute('tabindex', '-1');
    }
    if (!firstElement.contains(document.activeElement)) {
        // Com VoiceOver se o foco do botão que abriu o modal é retirado imediamente
        // a leitura do modal não é feita corretamente. Essa técnica cria um outro
        // problema menor que repete a leitura do botão que abriu e é interronpida
        // pela da caixa de diálogo.
        // Em alguns NVDA o foco virtual não segue o nativo, então essa técnica é
        // aplicada para o Windows também.
        if (platform.os === 'IOS' || platform.os === 'Windows') {
            focusSafely(firstElement);
            return;
        }
        firstElement.focus();
    }
};

const removeTabindex = (element) => {
    setTimeout(() => {
        removeSettedAttribute(element, 'tabindex');
    }, 100);
};
const ɵ0$1 = removeTabindex;
/**
 * Foca elementos mesmo não interagívies
 */
const focus = (element) => {
    setAttribute(element, 'tabindex', '0');
    element.focus();
    removeTabindex(element);
};
/**
 * @internal
 */
const setVoiceOverFocus = (element) => {
    const focusInterval = 10;
    const focusTotalRepetitions = 10;
    element.setAttribute('tabindex', '0');
    element.blur();
    let focusRepetitions = 0;
    const interval = setInterval(() => {
        element.focus();
        focusRepetitions++;
        if (focusRepetitions >= focusTotalRepetitions) {
            clearInterval(interval);
        }
    }, focusInterval);
};

const DURATION_VALUE = 200;
const SELECTOR = '[data-voxel-animation="wrapper"]';
const CONTENT_SELECTOR = '[data-voxel-animation="content"]';
const DURATION = `${DURATION_VALUE}ms`;
const CONTENT_DURATION = `${DURATION_VALUE / 2}ms`;
const EASING = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
const transform_initial = 'translate(0)';
const opacity_initial = 1;
const opacity = 0;
const STYLE_INITIAL = style({ transform: transform_initial, opacity: opacity_initial });
const NEW_STYLE = style({ transform: '{{ transform }}', opacity });
const transitionIn = animation(group([
    query(SELECTOR, [
        NEW_STYLE,
        group([
            animate(`${DURATION} ${EASING}`, style({ transform: transform_initial })),
            animate(DURATION, style({ opacity: opacity_initial })),
        ]),
    ]),
    query(CONTENT_SELECTOR, [
        NEW_STYLE,
        group([
            animate(`${CONTENT_DURATION} ${CONTENT_DURATION} ${EASING}`, style({ transform: transform_initial })),
            animate(`${CONTENT_DURATION} ${CONTENT_DURATION}`, style({ opacity: opacity_initial })),
        ]),
    ]),
]));
const transitionOut = animation(group([
    query(SELECTOR, [
        STYLE_INITIAL,
        group([
            animate(`${DURATION} ${EASING}`, style({ transform: '{{ transform }}' })),
            animate(DURATION, style({ opacity })),
        ]),
    ]),
    query(CONTENT_SELECTOR, [
        STYLE_INITIAL,
        group([
            animate(`${CONTENT_DURATION} ${EASING}`, style({ transform: '{{ transform }}' })),
            animate(CONTENT_DURATION, style({ opacity })),
        ]),
    ]),
]));
const TRANSFORM_FROM_TOP = 'translateY(-100%)';
const TRANSFORM_FROM_BOTTOM = 'translateY(100%)';
const TRANSFORM_FROM_LEFT = 'translateX(-100%)';
const TRANSFORM_FROM_RIGHT = 'translateX(100%)';
const IN_OUT_ANIMATION_FROM_TOP = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_TOP } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_TOP } })),
]);
const IN_OUT_ANIMATION_FROM_BOTTOM = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_BOTTOM } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_BOTTOM } })),
]);
const IN_OUT_ANIMATION_FROM_LEFT = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_LEFT } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_LEFT } })),
]);
const IN_OUT_ANIMATION_FROM_RIGHT = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_RIGHT } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_RIGHT } })),
]);

/**
 * Força um valor (normalmente uma string) para boolean.
 * Normalmente utilizado para converter valores recebidos de
 *
 * @Inputs dos componentes para boolean.
 *
 * @internal
 */
const enforceBoolean = (value) => value != null && `${value}` !== 'false';
/**
 * função que verifica se o parâmetro passado é um número e devolve um booleano
 *
 * @internal
 */
const isNumber = (value) => !isNaN(parseFloat(value)) && !isNaN(Number(value));
/**
 * recebe um valor 'any' e força que o retorno seja um número
 *
 * @internal
 */
const enforceNumber = (value, defaultValue = 0) => isNumber(value) ? Number(value) : defaultValue;
/**
 * Algoritmo para verificar se os valores sao iguais
 * Polyfill para a função: https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 *
 * @internal
 */
const objectIs = (x, y) => {
    if (x === y) {
        // Passos 1-5, 7-10
        // Passos 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
    }
    // Passo 6.a: NaN == NaN
    return x !== x && y !== y;
};
const getBackgroundColor = (element) => {
    var _a;
    const bgColor = window.getComputedStyle(element, null).getPropertyValue('background-color');
    if (bgColor === 'rgba(0, 0, 0, 0)' && ((_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.tagName)) {
        return getBackgroundColor(element.parentNode);
    }
    return bgColor;
};
/**
 * Remove acentos e caracteres especiais de um texto
 *
 * @internal
 */
const normalizeText = (text) => text
    .normalize('NFKD')
    .replace(/[\u0080-\uF8FF]/g, '')
    .toLocaleLowerCase();

/**
 * @internal
 */
const noop = (...args) => args;
const ɵ0 = noop;
/**
 * @internal
 */
const FormAcessorMixin = (base) => {
    class FormAcessor extends base {
        constructor(...args) {
            super(...args);
            this.formState = new Subject();
            this._disabled = false;
            this._focused = false;
            this._active = false;
            this._updateFirstOnBlur = false;
            this.formAcessorChanged = noop;
            this.formAcessorTouched = noop;
            this._destroy = new Subject();
            if (this.ngControl) {
                this.ngControl.valueAccessor = this;
            }
            this.errorState = this.formState.pipe(filter(() => Boolean(this.ngControl)), map(() => Boolean((this.ngControl.touched || this.ngControl.dirty) &&
                this.ngControl.invalid &&
                (!this.updateFirstOnBlur || (this.updateFirstOnBlur && this.ngControl.touched)))));
        }
        /**
         * @internal
         */
        ngOnDestroy() {
            this._destroy.complete();
            this.formState.complete();
        }
        /**
         * Valor do componente
         *
         * *Value of the component*
         */
        set value(newValue) {
            if (newValue !== this._value) {
                this._value = newValue;
                this.formAcessorChanged(newValue);
            }
        }
        get value() {
            return this._value;
        }
        /**
         * Desabilita a edição do campo
         *
         * *Disables the field editing*
         */
        set disabled(disabled) {
            this._disabled = enforceBoolean(disabled);
        }
        get disabled() {
            return this._disabled;
        }
        set focused(focused) {
            this._focused = focused;
        }
        get focused() {
            return this._focused;
        }
        set active(active) {
            this._active = active;
        }
        get active() {
            return this._active;
        }
        set updateFirstOnBlur(updateFirstOnBlur) {
            this._updateFirstOnBlur = updateFirstOnBlur;
        }
        get updateFirstOnBlur() {
            return this._updateFirstOnBlur;
        }
        formAcessorHandleChange() {
            // TODO: Implementar uma melhor forma de validar as mudanças asyncronas
            setTimeout(() => {
                this.formState.next();
            }, 0);
        }
        formAcessorHandleFocus() {
            this.focused = true;
            this.formState.next();
        }
        formAcessorHandleBlur() {
            this.focused = false;
            this.active = false;
            this.formAcessorTouched();
            this.formState.next();
        }
        writeValue(newValue) {
            if (newValue !== this._value) {
                this._value = newValue;
                this.elementRef.nativeElement.value = newValue;
                this.formAcessorTouched();
            }
        }
        registerOnChange(fn) {
            this.formAcessorChanged = (value) => {
                if (this.focused) {
                    this.active = true;
                }
                fn(value);
                this.formState.next();
            };
        }
        registerOnTouched(fn) {
            this.formAcessorTouched = fn;
        }
        setDisabledState(isDisabled) {
            this._disabled = isDisabled;
            this.formState.next();
        }
    }
    FormAcessor.decorators = [
        { type: Directive }
    ];
    FormAcessor.ctorParameters = () => [
        { type: Array }
    ];
    FormAcessor.propDecorators = {
        value: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return FormAcessor;
};

const verifyIsScrollable = (element) => element.scrollHeight > element.offsetHeight;

/**
 * garantir que regiões com rolagem sejam acessadas por teclado
 * https://dequeuniversity.com/rules/axe/3.5/scrollable-region-focusable
 */
const a11yScrollableRegion = (element) => {
    if (platform.isMobile || !element) {
        return;
    }
    const isScrollable = verifyIsScrollable(element);
    if (!isScrollable) {
        return;
    }
    element.setAttribute('tabindex', '0');
};

/**
 * Classe para ser extendida por modais e caixa de diálogo, possui o decorator
 * Directive para evitar erros de falta de módulo ao usar o decorator Component
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class VoxelModalBaseComponent {
    constructor(overlay, overlayContainer, _renderer) {
        this.overlay = overlay;
        this.overlayContainer = overlayContainer;
        this._renderer = _renderer;
        /**
         * Define como o modal/dialog se comporta com rolagem da página. Valores possíveis: "block" | "reposition" | "noop" | "close".
         *
         * *Set the behavior of the modal/dialog on page scroll. Possible values: "block" | "reposition" | "noop" | "close".*
         */
        this.scrollStrategy = 'block';
        this._forceAriaLabelledby = false;
    }
    /**
     * Garante que no Windows irá usar o atributo aria-labelledby enviado. Evite seu uso pois irá causar
     * repetições de leitura no NVDA.
     */
    set forceAriaLabelledby(open) {
        if (!open && this._forceAriaLabelledby) {
            this.detach();
        }
        this._forceAriaLabelledby = enforceBoolean(open);
    }
    get forceAriaLabelledby() {
        return this._forceAriaLabelledby;
    }
    /** @internal */
    get canClose() {
        return Boolean(this.outputClose.observers.length);
    }
    /** @internal */
    get classes() {
        const classes = [this.className];
        if (this.inputClass) {
            classes.push(this.inputClass);
        }
        return classes;
    }
    /** @internal */
    get ariaModal() {
        // no VoiceOver do iOS quando usado o aria-modal="true", quebra a navegação
        // após o fechamento do modal, também impede o controle do foco na abertura,
        // que para uma leitura correta no iOS, precisa ter um certo atraso
        if (platform.os === 'IOS') {
            return;
        }
        return 'true';
    }
    ngOnDestroy() {
        toggleMobileFocusTrap({ add: false });
    }
    /** @internal */
    attach() {
        this.setOverlayPosition();
        this.outputOpen.emit({ source: this });
        this.setOverlayZIndex();
        toggleMobileFocusTrap({});
        this.focus();
        setTimeout(() => {
            this.setTabIndexContent();
        });
    }
    /** @internal */
    detach() {
        toggleMobileFocusTrap({ add: false });
        this.removeOverlayZIndex();
        this.inputOrigin.elementRef.nativeElement.focus();
        this.outputClose.emit({ source: this });
    }
    removeOverlayZIndex() {
        const panel = this.overlayContainer.getContainerElement();
        if (this.zIndex) {
            this._renderer.removeStyle(panel, 'z-index');
        }
    }
    /** @internal */
    setOverlayPosition() {
        const positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();
        this.overlayDir.overlayRef.updatePositionStrategy(positionStrategy);
    }
    /** @internal */
    focus() {
        if (this.contentRef) {
            startDialogFocus(this.contentRef.nativeElement);
            return;
        }
        let tryCount = 0;
        // verifica até o conteúdo estar carregado, raramente é necessário
        /* istanbul ignore next */
        const timeout = setInterval(() => {
            tryCount += 1;
            if (tryCount >= 1000) {
                clearInterval(timeout);
            }
            if (!this.contentRef) {
                return;
            }
            clearInterval(timeout);
            startDialogFocus(this.contentRef.nativeElement);
        }, 1);
    }
    /**
     * se o do modal/dialog possuir rolagem, deve ter o tabindex no primeiro elemento
     *
     * @internal
     */
    setTabIndexContent() {
        if (this.contentRef) {
            a11yScrollableRegion(this.bodyRef.nativeElement);
            return;
        }
        /* istanbul ignore next */
        let tryCount = 0;
        // verifica até o conteúdo estar carregado, raramente é necessário
        /* istanbul ignore next */
        const timeout = setInterval(() => {
            tryCount += 1;
            if (tryCount >= 1000) {
                clearInterval(timeout);
            }
            if (!this.contentRef) {
                return;
            }
            clearInterval(timeout);
            a11yScrollableRegion(this.bodyRef.nativeElement);
        });
    }
    setOverlayZIndex() {
        const panel = this.overlayContainer.getContainerElement();
        if (this.zIndex) {
            this._renderer.setStyle(panel, 'z-index', this.zIndex);
        }
    }
}
VoxelModalBaseComponent.ɵfac = function VoxelModalBaseComponent_Factory(t) { return new (t || VoxelModalBaseComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.OverlayContainer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VoxelModalBaseComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelModalBaseComponent, selectors: [["do-not-use-voxel-modal-base"]], viewQuery: function VoxelModalBaseComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 5);
        ɵngcc0.ɵɵviewQuery(_c2, 5);
        ɵngcc0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayDir = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bodyRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentChildrenRef = _t);
    } }, inputs: { scrollStrategy: "scrollStrategy", forceAriaLabelledby: "forceAriaLabelledby", zIndex: "zIndex" } });
VoxelModalBaseComponent.ctorParameters = () => [
    { type: Overlay },
    { type: OverlayContainer },
    { type: Renderer2 }
];
VoxelModalBaseComponent.propDecorators = {
    scrollStrategy: [{ type: Input }],
    forceAriaLabelledby: [{ type: Input }],
    zIndex: [{ type: Input }],
    overlayDir: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }],
    bodyRef: [{ type: ViewChild, args: ['bodyRef',] }],
    contentRef: [{ type: ViewChild, args: ['contentRef',] }],
    contentChildrenRef: [{ type: ViewChildren, args: ['contentRef',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelModalBaseComponent, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: 'do-not-use-voxel-modal-base'
            }]
    }], function () { return [{ type: ɵngcc2.Overlay }, { type: ɵngcc2.OverlayContainer }, { type: ɵngcc0.Renderer2 }]; }, { scrollStrategy: [{
            type: Input
        }], forceAriaLabelledby: [{
            type: Input
        }], zIndex: [{
            type: Input
        }], overlayDir: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }], bodyRef: [{
            type: ViewChild,
            args: ['bodyRef']
        }], contentRef: [{
            type: ViewChild,
            args: ['contentRef']
        }], contentChildrenRef: [{
            type: ViewChildren,
            args: ['contentRef']
        }] }); })();

class VoxelOverlayOriginDirective extends CdkOverlayOrigin {
}
VoxelOverlayOriginDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelOverlayOriginDirective_BaseFactory; return function VoxelOverlayOriginDirective_Factory(t) { return (ɵVoxelOverlayOriginDirective_BaseFactory || (ɵVoxelOverlayOriginDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelOverlayOriginDirective)))(t || VoxelOverlayOriginDirective); }; }();
VoxelOverlayOriginDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelOverlayOriginDirective, selectors: [["", "voxelOverlayOrigin", ""]], exportAs: ["voxelOverlayOrigin"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelOverlayOriginDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelOverlayOrigin]',
                exportAs: 'voxelOverlayOrigin'
            }]
    }], null, null); })();

class VoxelOverlayModalModule {
}
VoxelOverlayModalModule.ɵfac = function VoxelOverlayModalModule_Factory(t) { return new (t || VoxelOverlayModalModule)(); };
VoxelOverlayModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelOverlayModalModule });
VoxelOverlayModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[A11yModule, CommonModule, OverlayModule], OverlayModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelOverlayModalModule, [{
        type: NgModule,
        args: [{
                imports: [A11yModule, CommonModule, OverlayModule],
                declarations: [VoxelOverlayOriginDirective, VoxelModalBaseComponent],
                exports: [VoxelOverlayOriginDirective, VoxelModalBaseComponent, OverlayModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelOverlayModalModule, { declarations: function () { return [VoxelOverlayOriginDirective, VoxelModalBaseComponent]; }, imports: function () { return [A11yModule, CommonModule, OverlayModule]; }, exports: function () { return [VoxelOverlayOriginDirective, VoxelModalBaseComponent, OverlayModule]; } }); })();

/**
 * @internal
 */
let NEXT_ID$o = 0;
/**
 * Lista de tópicos que podem ser expandidos ou contraidos
 *
 * *List of topics that can be expanded or collapsed*
 *
 * **Module:**
 *
 * `import { VoxelAccordionModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/accordion?componentOnly=true</example-url>
 *
 * @example Simples
 * <voxel-accordion
 *   accordionTitle="accordion"
 * >
 *   content
 * </voxel-accordion>
 *
 * @example Ícone
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *     accordionIcon="inovacao_outline"
 *   >
 *     content1
 *   </voxel-accordion>
 *
 * @example Descrição
 *   <voxel-accordion
 *     accordionTitle="accordion2"
 *     description="descrição teste"
 *   >
 *     content2
 *   </voxel-accordion>
 *
 * @example  Descrição e ícone
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *     accordionIcon="inovacao_outline"
 *     description="descrição teste"
 *   >
 *     content3
 *   </voxel-accordion>
 *
 * @example Agrupado
 * <voxel-accordion-group>
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *   >
 *     content1
 *   </voxel-accordion>
 *   <voxel-accordion
 *     accordionTitle="accordion2"
 *   >
 *     content2
 *   </voxel-accordion>
 * </voxel-accordion-group>
 *
 *  * @example Agrupado com descrição e ícone
 * <voxel-accordion-group>
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *     accordionIcon="inovacao_outline"
 *     description="descrição teste"
 *   >
 *     content1
 *   </voxel-accordion>
 *   <voxel-accordion
 *     accordionTitle="accordion2"
 *     accordionIcon="inovacao_outline"
 *     description="descrição teste2"
 *   >
 *     content2
 *   </voxel-accordion>
 * </voxel-accordion-group>
 */
class VoxelAccordionComponent {
    constructor() {
        /**
         * @internal
         */
        this._isOpened = false;
        /**
         * Id do componente de accordion
         *
         * *Accordion id*
         */
        this.accordionId = `voxel-accordion-${NEXT_ID$o++}`;
        /**
         * Nível de cabeçalho do accordion (Evitar)
         *
         * *Accordion heading level (Avoid)*
         */
        this.accordionAriaLevel = null;
        /**
         * Emite eventos de clique no accordion
         *
         * *Click event emitter on Accordion*
         */
        this.accordionClick = new EventEmitter();
    }
    /**
     * Estado do componente
     * Fechado (default) = false
     * Aberto = true
     *
     * *Component status*
     * *Closed (default) = false*
     * *Opened = true*
     */
    set isOpened(isOpened) {
        this._isOpened = enforceBoolean(isOpened);
    }
    get isOpened() {
        return this._isOpened;
    }
    /**
     * @internal
     */
    createEmit(_event) {
        return {
            _event,
            id: this.accordionId,
        };
    }
    /**
     * @internal
     */
    toggleCollapse(_event) {
        this.accordionClick.emit(this.createEmit(_event));
        this._isOpened = !this._isOpened;
    }
}
VoxelAccordionComponent.ɵfac = function VoxelAccordionComponent_Factory(t) { return new (t || VoxelAccordionComponent)(); };
VoxelAccordionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelAccordionComponent, selectors: [["voxel-accordion"]], inputs: { accordionId: "accordionId", accordionAriaLevel: "accordionAriaLevel", isOpened: "isOpened", accordionTitle: "accordionTitle", accordionIcon: "accordionIcon", description: "description" }, outputs: { accordionClick: "accordionClick" }, ngContentSelectors: _c0, decls: 14, vars: 21, consts: [[1, "voxel-accordion"], [1, "voxel-accordion__trigger", 3, "ngClass", "click"], [1, "voxel-accordion__main"], ["class", "voxel-accordion__icon-start", 4, "ngIf"], [1, "voxel-accordion__title", 3, "ngClass"], ["class", "voxel-accordion__interval", 4, "ngIf"], ["class", "voxel-accordion__description", 4, "ngIf"], [1, "voxel-accordion__icon"], [1, "voxel-accordion__content", 3, "id", "ngClass"], [1, "voxel-accordion__icon-start"], [1, "voxel-accordion__interval"], [1, "voxel-accordion__description"]], template: function VoxelAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "button", 1);
        ɵngcc0.ɵɵlistener("click", function VoxelAccordionComponent_Template_button_click_2_listener($event) { return ctx.toggleCollapse($event); });
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, VoxelAccordionComponent_div_4_Template, 3, 1, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵtemplate(7, VoxelAccordionComponent_span_7_Template, 2, 0, "span", 5);
        ɵngcc0.ɵɵtemplate(8, VoxelAccordionComponent_span_8_Template, 2, 1, "span", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "voxel-icon");
        ɵngcc0.ɵɵtext(11, "seta_baixo");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵprojection(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("role", ctx.accordionAriaLevel !== null ? "heading" : null)("aria-level", ctx.accordionAriaLevel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c3, ctx.isOpened));
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpened)("id", ctx.accordionId)("aria-controls", "content-" + ctx.accordionId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accordionIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(16, _c4, ctx.accordionIcon, ctx.description));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.accordionTitle, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.description);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.description);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("id", "content-" + ctx.accordionId)("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c5, !ctx.isOpened));
        ɵngcc0.ɵɵattribute("aria-hidden", !ctx.isOpened);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, VoxelIconComponent], styles: [".voxel-accordion[_ngcontent-%COMP%]{background:var(--ids_color_bg_base);border-bottom:solid var(--ids_size_border_small) var(--ids_color_border_medium)}.voxel-accordion__title[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);line-height:var(--ids_size_general_24x);min-height:var(--ids_size_general_24x);padding:var(--ids_size_general_12x) 0 var(--ids_size_general_12x) var(--ids_size_general_16x);text-align:left}.voxel-accordion__title--icon[_ngcontent-%COMP%]{padding-left:0}.voxel-accordion__title--description[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-bottom:var(--ids_size_general_8x);padding-top:var(--ids_size_general_8x)}.voxel-accordion__interval[_ngcontent-%COMP%]{border:0;height:var(--ids_size_general_1x);margin:-.0625rem;overflow:hidden;padding:0;position:absolute;width:var(--ids_size_general_1x)}.voxel-accordion__content[_ngcontent-%COMP%]{-webkit-animation:fadeIn .5s;animation:fadeIn .5s;font:var(--ids_textStyle_label_medium_regular);margin-bottom:var(--ids_size_general_24x);max-height:auto;overflow:hidden;padding:0 var(--ids_size_general_16x) 0 var(--ids_size_general_16x);-webkit-transition:margin .5s,max-height .3s;transition:margin .5s,max-height .3s}.voxel-accordion__content--hide[_ngcontent-%COMP%]{-webkit-animation:fadeOut .5s;animation:fadeOut .5s;margin-bottom:0;max-height:0;overflow:hidden;visibility:hidden}.voxel-accordion__icon[_ngcontent-%COMP%]{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_primary_base);-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.voxel-accordion__icon-start[_ngcontent-%COMP%]{-ms-flex-item-align:start;align-self:flex-start;color:var(--ids_color_action_primary_base);padding:var(--ids_size_general_12x)}.voxel-accordion__trigger[_ngcontent-%COMP%]{background-color:var(--ids_color_bg_base);border:0;color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:var(--ids_size_general_48x);overflow:hidden;padding-right:var(--ids_size_general_12x);width:100%}.voxel-accordion__trigger[_ngcontent-%COMP%]:hover{cursor:pointer}.voxel-accordion__trigger--expanded[_ngcontent-%COMP%]{overflow:hidden}.voxel-accordion__trigger--expanded[_ngcontent-%COMP%]   .voxel-accordion__icon[_ngcontent-%COMP%]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.voxel-accordion__description[_ngcontent-%COMP%]{color:var(--ids_color_text_body_02);font:var(--ids_textStyle_label_small_regular);padding-bottom:var(--ids_size_general_8x)}.voxel-accordion__main[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}"] });
VoxelAccordionComponent.propDecorators = {
    accordionId: [{ type: Input }],
    accordionTitle: [{ type: Input }],
    accordionAriaLevel: [{ type: Input }],
    isOpened: [{ type: Input }],
    accordionIcon: [{ type: Input }],
    description: [{ type: Input }],
    accordionClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAccordionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-accordion',
                template: "<div class=\"voxel-accordion\">\n  <div\n    [attr.role]=\"accordionAriaLevel !== null ? 'heading' : null\"\n    [attr.aria-level]=\"accordionAriaLevel\"\n  >\n    <button\n      [attr.aria-expanded]=\"isOpened\"\n      class=\"voxel-accordion__trigger\"\n      [ngClass]=\"{'voxel-accordion__trigger--expanded': isOpened}\"\n      [attr.id]=\"accordionId\"\n      [attr.aria-controls]=\"'content-' + accordionId\"\n      (click)=\"toggleCollapse($event)\"\n    >\n    <div class=\"voxel-accordion__main\">\n      <div *ngIf=\"accordionIcon\" class=\"voxel-accordion__icon-start\">\n        <voxel-icon> {{ accordionIcon }} </voxel-icon>\n      </div>\n        <span\n          class=\"voxel-accordion__title\"\n          [ngClass]=\"{\n            'voxel-accordion__title--icon': accordionIcon,\n            'voxel-accordion__title--description': description\n          }\"\n        >\n          {{ accordionTitle }}\n          <span *ngIf=\"description\" class=\"voxel-accordion__interval\">,</span>\n          <span *ngIf=\"description\" class=\"voxel-accordion__description\">\n            {{ description }}\n          </span>\n        </span>\n      </div>\n      <div class=\"voxel-accordion__icon\">\n        <voxel-icon>seta_baixo</voxel-icon>\n      </div>\n    </button>\n  </div>\n  <div\n    [id]=\"'content-' + accordionId\"\n    class=\"voxel-accordion__content\"\n    [ngClass]=\"{\n      'voxel-accordion__content--hide': !isOpened\n    }\"\n    [attr.aria-hidden]=\"!isOpened\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                styles: [".voxel-accordion{background:var(--ids_color_bg_base);border-bottom:solid var(--ids_size_border_small) var(--ids_color_border_medium)}.voxel-accordion__title{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);line-height:var(--ids_size_general_24x);min-height:var(--ids_size_general_24x);padding:var(--ids_size_general_12x) 0 var(--ids_size_general_12x) var(--ids_size_general_16x);text-align:left}.voxel-accordion__title--icon{padding-left:0}.voxel-accordion__title--description{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-bottom:var(--ids_size_general_8x);padding-top:var(--ids_size_general_8x)}.voxel-accordion__interval{border:0;height:var(--ids_size_general_1x);margin:-.0625rem;overflow:hidden;padding:0;position:absolute;width:var(--ids_size_general_1x)}.voxel-accordion__content{-webkit-animation:fadeIn .5s;animation:fadeIn .5s;font:var(--ids_textStyle_label_medium_regular);margin-bottom:var(--ids_size_general_24x);max-height:auto;overflow:hidden;padding:0 var(--ids_size_general_16x) 0 var(--ids_size_general_16x);-webkit-transition:margin .5s,max-height .3s;transition:margin .5s,max-height .3s}.voxel-accordion__content--hide{-webkit-animation:fadeOut .5s;animation:fadeOut .5s;margin-bottom:0;max-height:0;overflow:hidden;visibility:hidden}.voxel-accordion__icon{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_primary_base);-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.voxel-accordion__icon-start{-ms-flex-item-align:start;align-self:flex-start;color:var(--ids_color_action_primary_base);padding:var(--ids_size_general_12x)}.voxel-accordion__trigger{background-color:var(--ids_color_bg_base);border:0;color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:var(--ids_size_general_48x);overflow:hidden;padding-right:var(--ids_size_general_12x);width:100%}.voxel-accordion__trigger:hover{cursor:pointer}.voxel-accordion__trigger--expanded{overflow:hidden}.voxel-accordion__trigger--expanded .voxel-accordion__icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.voxel-accordion__description{color:var(--ids_color_text_body_02);font:var(--ids_textStyle_label_small_regular);padding-bottom:var(--ids_size_general_8x)}.voxel-accordion__main{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}\n"]
            }]
    }], function () { return []; }, { accordionId: [{
            type: Input
        }], accordionAriaLevel: [{
            type: Input
        }], accordionClick: [{
            type: Output
        }], isOpened: [{
            type: Input
        }], accordionTitle: [{
            type: Input
        }], accordionIcon: [{
            type: Input
        }], description: [{
            type: Input
        }] }); })();

/** @internal */
class VoxelAccordionGroupComponent {
    constructor() {
        /** @internal */
        this._destroy = new Subject();
        /**
         * Atributo booleano para definir se o accordion group permitirá um único accordion expandir
         * Valor default: true
         *
         * *Boolean value to define if the accordion group will permit only one accordion to expand*
         * *Default value: true*
         */
        this.expandOne = true;
    }
    /** @internal */
    ngAfterContentInit() {
        this.accordionList.changes
            .pipe(startWith(null), switchMap(() => merge(...this.accordionList.map((item) => item.accordionClick))), takeUntil(this._destroy))
            .subscribe((accordionEvent) => {
            if (accordionEvent.id) {
                this.accordionList.forEach((accordion) => {
                    if (accordion.accordionId !== accordionEvent.id && this.expandOne) {
                        accordion.isOpened = false;
                    }
                });
            }
        });
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
}
VoxelAccordionGroupComponent.ɵfac = function VoxelAccordionGroupComponent_Factory(t) { return new (t || VoxelAccordionGroupComponent)(); };
VoxelAccordionGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelAccordionGroupComponent, selectors: [["voxel-accordion-group"]], contentQueries: function VoxelAccordionGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelAccordionComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.accordionList = _t);
    } }, inputs: { expandOne: "expandOne" }, ngContentSelectors: _c7, decls: 1, vars: 0, template: function VoxelAccordionGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
VoxelAccordionGroupComponent.propDecorators = {
    accordionList: [{ type: ContentChildren, args: [VoxelAccordionComponent, { descendants: true },] }],
    expandOne: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAccordionGroupComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-accordion-group',
                template: "<ng-content select=\"voxel-accordion\"></ng-content>"
            }]
    }], function () { return []; }, { expandOne: [{
            type: Input
        }], accordionList: [{
            type: ContentChildren,
            args: [VoxelAccordionComponent, { descendants: true }]
        }] }); })();

class VoxelAccordionModule {
}
VoxelAccordionModule.ɵfac = function VoxelAccordionModule_Factory(t) { return new (t || VoxelAccordionModule)(); };
VoxelAccordionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelAccordionModule });
VoxelAccordionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAccordionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelAccordionComponent, VoxelAccordionGroupComponent],
                exports: [VoxelAccordionComponent, VoxelAccordionGroupComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelAccordionModule, { declarations: function () { return [VoxelAccordionComponent, VoxelAccordionGroupComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelAccordionComponent, VoxelAccordionGroupComponent]; } }); })();

/**
 * Alerts são cards de conteúdo que notificam os usuários sobre um produto disponível, ofertas, serviços e/ou
 * trazem avisos referentes à conta. Podem também conter ações contextuais que guiam o usuário a outras telas e/ou serviços.
 *
 * *Alerts are content cards that notify users about an available product, offers, services and / or bring notices*
 * *regarding the account. They can also contain contextual actions that guide the user to other screens and / or services.*
 *
 * **Module:**
 *
 * `import { VoxelAlertModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/alert?componentOnly=true</example-url>
 *
 */
class VoxelAlertComponent {
    constructor() {
        /** @internal */
        this._dismissible = false;
        /** @internal */
        this._light = false;
        /** @internal */
        this._mobileStyle = false;
        /** @internal */
        this.display = true;
        /** @internal */
        this.closing = false;
        /**
         * Ícone (aparecerá ao lado esquerdo da mensagem)
         *
         * *Icon (will appear to the left of the message)*
         */
        this.icon = 'inovacao_outline';
        /**
         * Label de acessibilidade para o botão fechar, pode ser customizada, visando outros idiomas
         *
         * *Accessibility label for the close button, can be customized for other languages*
         */
        this.btnA11yLabel = 'Fechar';
        /**
         * Evento emitido ao fechar o alert
         *
         * *Event emitter on alert close*
         */
        this.close = new EventEmitter();
    }
    /**
     * Define se será possível ou não fechar o alert através do botão "X"
     *
     * *Defines whether it will be possible or not to close the alert through the "X" button*
     */
    set dismissible(value) {
        this._dismissible = enforceBoolean(value);
    }
    get dismissible() {
        return this._dismissible;
    }
    /**
     * Define se o componente terá o visual light
     *
     * *Defines whether the component will have light visual*
     */
    set light(value) {
        this._light = enforceBoolean(value);
    }
    get light() {
        return this._light;
    }
    /**
     * Força o estilo do alert ficar como mobile
     *
     * *Force to keep mobile style*
     */
    set mobileStyle(value) {
        this._mobileStyle = enforceBoolean(value);
    }
    get mobileStyle() {
        return this._mobileStyle;
    }
    /** @internal */
    clickOnCloseButton() {
        this.closing = true;
        of(1)
            .pipe(delay(200))
            .subscribe(() => {
            this.display = false;
            this.close.emit();
        });
    }
}
VoxelAlertComponent.ɵfac = function VoxelAlertComponent_Factory(t) { return new (t || VoxelAlertComponent)(); };
VoxelAlertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelAlertComponent, selectors: [["voxel-alert"]], inputs: { icon: "icon", btnA11yLabel: "btnA11yLabel", dismissible: "dismissible", light: "light", mobileStyle: "mobileStyle", type: "type", ariaLive: "ariaLive", ariaRole: "ariaRole" }, outputs: { close: "close" }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [[3, "class", "voxel-alert--light", "voxel-alert--dismissible", "voxel-alert--closing", "voxel-alert--mobile-only", 4, "ngIf"], [1, "voxel-alert__icon"], [1, "voxel-alert__message"], ["class", "voxel-alert__close-button", 3, "click", 4, "ngIf"], [1, "voxel-alert__close-button", 3, "click"], ["size", "S", 1, "voxel-alert__close"]], template: function VoxelAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, VoxelAlertComponent_div_0_Template, 6, 15, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.display);
    } }, directives: [ɵngcc1.NgIf, VoxelIconComponent], styles: ["[_nghost-%COMP%]{display:block}.voxel-alert[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:var(--ids_size_border_small) solid transparent;border-radius:var(--ids_size_cornerRadius_tags_01);display:-webkit-box;display:-ms-flexbox;display:flex;min-height:var(--ids_size_general_64x);-webkit-transition:all ease .5s;transition:all ease .5s}.voxel-alert__icon[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_48x)}.voxel-alert__message[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark);font:var(--ids_textStyle_body_01_regular);padding:var(--ids_size_general_12x) var(--ids_size_general_24x) var(--ids_size_general_12x) 0;width:100%}.voxel-alert__close-button[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:start;align-self:flex-start;background-color:transparent;border:none;color:var(--ids_color_contrast_onDark);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:var(--ids_size_general_48x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:.4375rem var(--ids_size_general_6x) 0 0;min-width:var(--ids_size_general_48x)}.voxel-alert__close[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-alert--offer[_ngcontent-%COMP%]{background:var(--ids_color_feedback_information)}.voxel-alert--success[_ngcontent-%COMP%]{background:var(--ids_color_feedback_success)}.voxel-alert--warning[_ngcontent-%COMP%]{background-color:var(--ids_color_feedback_alert)}.voxel-alert--warning[_ngcontent-%COMP%]   .voxel-alert__icon[_ngcontent-%COMP%], .voxel-alert--warning[_ngcontent-%COMP%]   .voxel-alert__message[_ngcontent-%COMP%], .voxel-alert--warning[_ngcontent-%COMP%]   .voxel-alert__close[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01)}.voxel-alert--error[_ngcontent-%COMP%]{background-color:#781b8e}.voxel-alert--critical[_ngcontent-%COMP%]{background-color:var(--ids_color_feedback_error)}.voxel-alert--default[_ngcontent-%COMP%]{border-color:var(--ids_color_action_neutral_variant);border-style:solid}.voxel-alert--default[_ngcontent-%COMP%]   .voxel-alert__icon[_ngcontent-%COMP%], .voxel-alert--default[_ngcontent-%COMP%]   .voxel-alert__message[_ngcontent-%COMP%], .voxel-alert--default[_ngcontent-%COMP%]   .voxel-alert__close[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01)}.voxel-alert--light.voxel-alert--offer[_ngcontent-%COMP%]{background-color:var(--ids_color_feedback_information_soft);border-color:var(--ids_color_feedback_information)}.voxel-alert--light.voxel-alert--success[_ngcontent-%COMP%]{background-color:var(--ids_color_feedback_success_soft);border-color:var(--ids_color_feedback_success)}.voxel-alert--light.voxel-alert--warning[_ngcontent-%COMP%]{background-color:var(--ids_color_feedback_alert_soft);border-color:var(--ids_color_feedback_alert)}.voxel-alert--light.voxel-alert--error[_ngcontent-%COMP%]{background-color:rgba(120,27,142,.1);border-color:#781b8e}.voxel-alert--light.voxel-alert--critical[_ngcontent-%COMP%]{background-color:var(--ids_color_feedback_error_soft);border-color:var(--ids_color_feedback_error)}.voxel-alert--light[_ngcontent-%COMP%]   .voxel-alert__message[_ngcontent-%COMP%], .voxel-alert--light[_ngcontent-%COMP%]   .voxel-alert__icon[_ngcontent-%COMP%], .voxel-alert--light[_ngcontent-%COMP%]   .voxel-alert__close[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01)}.voxel-alert--closing[_ngcontent-%COMP%]{opacity:0;-webkit-transform:scale(0);transform:scale(0)}.voxel-alert--dismissible[_ngcontent-%COMP%]   .voxel-alert__message[_ngcontent-%COMP%]{padding-right:0}@media (min-width: 64rem){.voxel-alert[_ngcontent-%COMP%]:not(.voxel-alert--mobile-only)   .voxel-alert__message[_ngcontent-%COMP%]{padding:var(--ids_size_general_20x) var(--ids_size_general_32x) var(--ids_size_general_20x) 0}}@media (min-width: 64rem){.voxel-alert__message[_ngcontent-%COMP%]{padding:var(--ids_size_general_20x) var(--ids_size_general_24x) var(--ids_size_general_20x) 0}.voxel-alert__close-button[_ngcontent-%COMP%]{margin:.5625rem var(--ids_size_general_10x) 0 0}}"] });
VoxelAlertComponent.propDecorators = {
    type: [{ type: Input }],
    dismissible: [{ type: Input }],
    light: [{ type: Input }],
    icon: [{ type: Input }],
    btnA11yLabel: [{ type: Input }],
    ariaLive: [{ type: Input }],
    ariaRole: [{ type: Input }],
    mobileStyle: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAlertComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-alert',
                template: "<div\n  *ngIf=\"display\"\n  class=\"voxel-alert voxel-alert--{{ type ? type : 'default' }}\"\n  [class.voxel-alert--light]=\"light\"\n  [class.voxel-alert--dismissible]=\"dismissible\"\n  [class.voxel-alert--closing]=\"closing\"\n  [class.voxel-alert--mobile-only]=\"mobileStyle\"\n>\n  <voxel-icon class=\"voxel-alert__icon\">{{ icon }}</voxel-icon>\n  <div\n    [attr.aria-live]=\"ariaLive\"\n    [attr.role]=\"ariaRole\"\n    class=\"voxel-alert__message\"\n  >\n    <ng-content></ng-content>\n  </div>\n  <button\n    [attr.aria-label]=\"btnA11yLabel\"\n    class=\"voxel-alert__close-button\"\n    *ngIf=\"dismissible\"\n    (click)=\"clickOnCloseButton()\"\n  >\n    <voxel-icon class=\"voxel-alert__close\" size=\"S\">fechar</voxel-icon>\n  </button>\n</div>\n",
                styles: [":host{display:block}.voxel-alert{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:var(--ids_size_border_small) solid transparent;border-radius:var(--ids_size_cornerRadius_tags_01);display:-webkit-box;display:-ms-flexbox;display:flex;min-height:var(--ids_size_general_64x);-webkit-transition:all ease .5s;transition:all ease .5s}.voxel-alert__icon{color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_48x)}.voxel-alert__message{color:var(--ids_color_contrast_onDark);font:var(--ids_textStyle_body_01_regular);padding:var(--ids_size_general_12x) var(--ids_size_general_24x) var(--ids_size_general_12x) 0;width:100%}.voxel-alert__close-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:start;align-self:flex-start;background-color:transparent;border:none;color:var(--ids_color_contrast_onDark);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:var(--ids_size_general_48x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:.4375rem var(--ids_size_general_6x) 0 0;min-width:var(--ids_size_general_48x)}.voxel-alert__close{color:var(--ids_color_contrast_onDark)}.voxel-alert--offer{background:var(--ids_color_feedback_information)}.voxel-alert--success{background:var(--ids_color_feedback_success)}.voxel-alert--warning{background-color:var(--ids_color_feedback_alert)}.voxel-alert--warning .voxel-alert__icon,.voxel-alert--warning .voxel-alert__message,.voxel-alert--warning .voxel-alert__close{color:var(--ids_color_text_body_01)}.voxel-alert--error{background-color:#781b8e}.voxel-alert--critical{background-color:var(--ids_color_feedback_error)}.voxel-alert--default{border-color:var(--ids_color_action_neutral_variant);border-style:solid}.voxel-alert--default .voxel-alert__icon,.voxel-alert--default .voxel-alert__message,.voxel-alert--default .voxel-alert__close{color:var(--ids_color_text_body_01)}.voxel-alert--light.voxel-alert--offer{background-color:var(--ids_color_feedback_information_soft);border-color:var(--ids_color_feedback_information)}.voxel-alert--light.voxel-alert--success{background-color:var(--ids_color_feedback_success_soft);border-color:var(--ids_color_feedback_success)}.voxel-alert--light.voxel-alert--warning{background-color:var(--ids_color_feedback_alert_soft);border-color:var(--ids_color_feedback_alert)}.voxel-alert--light.voxel-alert--error{background-color:rgba(120,27,142,.1);border-color:#781b8e}.voxel-alert--light.voxel-alert--critical{background-color:var(--ids_color_feedback_error_soft);border-color:var(--ids_color_feedback_error)}.voxel-alert--light .voxel-alert__message,.voxel-alert--light .voxel-alert__icon,.voxel-alert--light .voxel-alert__close{color:var(--ids_color_text_body_01)}.voxel-alert--closing{opacity:0;-webkit-transform:scale(0);transform:scale(0)}.voxel-alert--dismissible .voxel-alert__message{padding-right:0}@media (min-width: 64rem){.voxel-alert:not(.voxel-alert--mobile-only) .voxel-alert__message{padding:var(--ids_size_general_20x) var(--ids_size_general_32x) var(--ids_size_general_20x) 0}}@media (min-width: 64rem){.voxel-alert__message{padding:var(--ids_size_general_20x) var(--ids_size_general_24x) var(--ids_size_general_20x) 0}.voxel-alert__close-button{margin:.5625rem var(--ids_size_general_10x) 0 0}}\n"]
            }]
    }], function () { return []; }, { icon: [{
            type: Input
        }], btnA11yLabel: [{
            type: Input
        }], close: [{
            type: Output
        }], dismissible: [{
            type: Input
        }], light: [{
            type: Input
        }], mobileStyle: [{
            type: Input
        }], type: [{
            type: Input
        }], ariaLive: [{
            type: Input
        }], ariaRole: [{
            type: Input
        }] }); })();

class VoxelAlertModule {
}
VoxelAlertModule.ɵfac = function VoxelAlertModule_Factory(t) { return new (t || VoxelAlertModule)(); };
VoxelAlertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelAlertModule });
VoxelAlertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAlertModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelAlertComponent],
                exports: [VoxelAlertComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelAlertModule, { declarations: function () { return [VoxelAlertComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelAlertComponent]; } }); })();

/**
 * Dados dos eventos da option
 *
 * *Option event data*
 */
class IVoxelOptionEvent {
    /** @internal */
    constructor(option, close) {
        this.option = option;
        this.close = close;
    }
}
/**
 * @internal
 */
let NEXT_ID$n = 0;
/**
 *  @internal
 *  Componente base para select.
 *
 * *Base component to select.*
 */
class VoxelOptionComponent {
    /** @internal */
    constructor(element) {
        this.element = element;
        /** @internal */
        this._destroy = new Subject();
        this._showing = true;
        /**
         *  Identificação única da opção.
         *
         * *Unique option identification.*
         */
        this.optionId = `voxel-option-${NEXT_ID$n++}`;
        this._disabled = false;
        this._selected = false;
        /**
         * Evento disparado quando ouver mudança na opção.
         *
         * *Event fired when you hear a change in option.*
         */
        this.change = new EventEmitter();
        /** @internal */
        this.role = 'option';
    }
    /** @internal */
    get showing() {
        return this._showing;
    }
    set showing(value) {
        this._showing = value;
    }
    /**
     *  Valor da opção no momento do evento.
     *
     * *Option value at the time of the event.*
     */
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }
    /**
     * Indica se a opção ficara desabilitato.
     *
     * *Indicates whether the option will be disabled.*
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    /**
     * Indica se a opção esta selecionada.
     *
     * *Indicates whether the option is selected.*
     */
    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = enforceBoolean(value);
    }
    /** @internal */
    get classes() {
        return {
            'voxel-option': true,
            'voxel-option--selected': this.selected,
            'voxel-option--disabled': this.disabled,
            'voxel-option--hide': !this.showing,
        };
    }
    /** @internal */
    get tabIndex() {
        return this.disabled ? '-1' : '0';
    }
    /** @internal */
    get id() {
        return this.optionId;
    }
    /** @internal */
    get ariaSelected() {
        return this.selected;
    }
    /** @internal */
    get ariaDisabled() {
        return this.disabled;
    }
    /** @internal */
    onClick() {
        this.select(true);
    }
    /** @internal */
    get optionLabel() {
        return (this.element.nativeElement.textContent || '').trim();
    }
    /** @internal */
    show() {
        this.showing = true;
    }
    /** @internal */
    hide() {
        this.showing = false;
    }
    /** @internal */
    select(close = false) {
        if (this.disabled) {
            return;
        }
        this._selected = true;
        this._emitOptionChangeEvent(close);
    }
    /** @internal */
    deselect(emitValue = false) {
        this._selected = false;
        if (emitValue) {
            this._emitOptionChangeEvent();
        }
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
    /** @internal */
    _emitOptionChangeEvent(_close) {
        this.change.emit(new IVoxelOptionEvent(this, _close));
    }
}
VoxelOptionComponent.ɵfac = function VoxelOptionComponent_Factory(t) { return new (t || VoxelOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelOptionComponent, selectors: [["voxel-option"]], hostVars: 7, hostBindings: function VoxelOptionComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function VoxelOptionComponent_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role)("tabindex", ctx.tabIndex)("id", ctx.id)("aria-selected", ctx.ariaSelected)("aria-disabled", ctx.ariaDisabled);
        ɵngcc0.ɵɵclassMap(ctx.classes);
    } }, inputs: { optionId: "optionId", value: "value", disabled: "disabled", selected: "selected" }, outputs: { change: "change" }, ngContentSelectors: _c0, decls: 2, vars: 0, consts: [[1, "voxel-option__text"]], template: function VoxelOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".voxel-option{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_bg_base);color:var(--ids_color_text_body_01);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);padding:0 var(--ids_size_general_24x)}.voxel-option:hover:not(.voxel-option--selected){background-color:var(--ids_color_bg_variant_01)}.voxel-option--selected{background-color:var(--ids_color_bg_variant_01);border-left:var(--ids_size_border_large) solid var(--ids_color_action_primary_base);padding-left:var(--ids_size_general_20x)}.voxel-option--disabled{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-option--hide{display:none}.voxel-option__text{font:var(--ids_textStyle_body_01_regular);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n"], encapsulation: 2 });
VoxelOptionComponent.ctorParameters = () => [
    { type: ElementRef }
];
VoxelOptionComponent.propDecorators = {
    optionId: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    selected: [{ type: Input }],
    change: [{ type: Output }],
    classes: [{ type: HostBinding, args: ['class',] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    id: [{ type: HostBinding, args: ['attr.id',] }],
    ariaSelected: [{ type: HostBinding, args: ['attr.aria-selected',] }],
    ariaDisabled: [{ type: HostBinding, args: ['attr.aria-disabled',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelOptionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-option',
                template: "<span class=\"voxel-option__text\">\n  <ng-content></ng-content>\n</span>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-option{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_bg_base);color:var(--ids_color_text_body_01);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);padding:0 var(--ids_size_general_24x)}.voxel-option:hover:not(.voxel-option--selected){background-color:var(--ids_color_bg_variant_01)}.voxel-option--selected{background-color:var(--ids_color_bg_variant_01);border-left:var(--ids_size_border_large) solid var(--ids_color_action_primary_base);padding-left:var(--ids_size_general_20x)}.voxel-option--disabled{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-option--hide{display:none}.voxel-option__text{font:var(--ids_textStyle_body_01_regular);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { optionId: [{
            type: Input
        }], change: [{
            type: Output
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], id: [{
            type: HostBinding,
            args: ['attr.id']
        }], ariaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], ariaDisabled: [{
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], 
    /** @internal */
    onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class VoxelOptionModule {
}
VoxelOptionModule.ɵfac = function VoxelOptionModule_Factory(t) { return new (t || VoxelOptionModule)(); };
VoxelOptionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelOptionModule });
VoxelOptionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelOptionModule, [{
        type: NgModule,
        args: [{
                declarations: [VoxelOptionComponent],
                exports: [VoxelOptionComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelOptionModule, { declarations: [VoxelOptionComponent], exports: [VoxelOptionComponent] }); })();

/**
 * @internal
 */
class VoxelFieldBase {
    constructor(ngControl, elementRef, errorState) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.errorState = errorState;
    }
}
/**
 * @internal
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class VoxelFieldMixinBase extends FormAcessorMixin(VoxelFieldBase) {
    constructor(ngControl, elementRef) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this._controlAriaInvalid = null;
        this.controlDescribedBy = null;
        this.ariaLabelledby = null;
    }
    get controlAriaInvalid() {
        return this._controlAriaInvalid;
    }
    set controlAriaInvalid(value) {
        this._controlAriaInvalid = value;
    }
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    a11yHandler(described, describedId) {
        this.controlDescribedBy = described ? null : describedId;
    }
    onErrorStatusChange(hasDescription, describedById, state) {
        this.controlDescribedBy = null;
        this.controlAriaInvalid = null;
        if (hasDescription) {
            this.controlDescribedBy = describedById;
        }
        if (state) {
            this.controlDescribedBy = describedById;
            this.controlAriaInvalid = state;
        }
    }
}
VoxelFieldMixinBase.ɵfac = function VoxelFieldMixinBase_Factory(t) { return new (t || VoxelFieldMixinBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelFieldMixinBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelFieldMixinBase, selectors: [["do-not-use-voxel-field-mixin-base"]], hostVars: 3, hostBindings: function VoxelFieldMixinBase_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.controlDescribedBy)("aria-labelledby", ctx.ariaLabelledby)("aria-invalid", ctx.controlAriaInvalid);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelFieldMixinBase.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef }
];
VoxelFieldMixinBase.propDecorators = {
    controlDescribedBy: [{ type: HostBinding, args: ['attr.aria-describedby',] }],
    ariaLabelledby: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    controlAriaInvalid: [{ type: HostBinding, args: ['attr.aria-invalid',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFieldMixinBase, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: 'do-not-use-voxel-field-mixin-base'
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { controlDescribedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }], ariaLabelledby: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], controlAriaInvalid: [{
            type: HostBinding,
            args: ['attr.aria-invalid']
        }] }); })();

let NEXT_ID$m = 0;
class VoxelAutocompleteDirective extends CdkOverlayOrigin {
    constructor(ngControl, voxelInput, renderer, elementRef) {
        super(elementRef);
        this.ngControl = ngControl;
        this.voxelInput = voxelInput;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this._viewModelChange = new BehaviorSubject(this.controlValue);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-empty-function, @typescript-eslint/no-empty-function
        this._onChange = (_) => { };
        // eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
        this._onTouched = () => { };
        this._containerPadding = 24;
        this.panelOpen = false;
        this._value = '';
        this.class = 'voxel-autocomplete-input';
        this.autocomplete = 'off';
        this.role = 'combobox';
        this.ariaAutocomplete = 'list';
        this._ariaControlledId = null;
        this._ariaActivedescendant = null;
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
        if (this.voxelInput) {
            this.labelId = `voxel-autocomplete-label-${NEXT_ID$m++}`;
            this.voxelInput.labelId = this.labelId;
        }
    }
    get inputEvent() {
        return fromEvent(this.elementRef.nativeElement, 'input');
    }
    get keydownEvent() {
        return fromEvent(this.elementRef.nativeElement, 'keydown');
    }
    get clickEvent() {
        return fromEvent(this.elementRef.nativeElement, 'click');
    }
    get viewModelChangeEvent() {
        return this._viewModelChange.asObservable();
    }
    get viewValue() {
        return this.elementRef.nativeElement.value;
    }
    get width() {
        return this.elementRef.nativeElement.offsetWidth + this._containerPadding;
    }
    get controlValue() {
        return this._value;
    }
    set controlValue(value) {
        this._value = value;
    }
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    get disabled() {
        return (this._disabled ||
            (this.ngControl ? (this.ngControl.disabled && !this.controlValue) || null : null));
    }
    set readonly(value) {
        this._readonly = enforceBoolean(value);
    }
    get readonly() {
        return (this._readonly ||
            (this.ngControl ? (this.ngControl.disabled && !!this.controlValue) || null : null));
    }
    get value() {
        return this.controlValue;
    }
    get ariaExpanded() {
        return this.panelOpen;
    }
    get ariaControls() {
        return this._ariaControlledId;
    }
    set ariaControls(value) {
        this._ariaControlledId = value;
    }
    get ariaActiveDescendant() {
        if (this.panelOpen) {
            return this._ariaActivedescendant;
        }
        return null;
    }
    set ariaActiveDescendant(value) {
        this._ariaActivedescendant = value;
    }
    onBlur() {
        this._onTouched();
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    writeValue(value) {
        this.controlValue = value;
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
        this._viewModelChange.next(this.controlValue);
    }
    setControlValue(viewValue, value) {
        const shouldEmitChange = this.controlValue !== value;
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', viewValue);
        this.controlValue = value;
        if (shouldEmitChange) {
            this._onChange(this.controlValue);
        }
    }
    resetControlValue() {
        this.controlValue = '';
        this._onChange(this.controlValue);
    }
    focus() {
        this.elementRef.nativeElement.focus();
    }
}
VoxelAutocompleteDirective.ɵfac = function VoxelAutocompleteDirective_Factory(t) { return new (t || VoxelAutocompleteDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(VoxelFieldMixinBase, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelAutocompleteDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelAutocompleteDirective, selectors: [["", "voxelAutocomplete", ""]], hostVars: 12, hostBindings: function VoxelAutocompleteDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function VoxelAutocompleteDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("autocomplete", ctx.autocomplete)("disabled", ctx.disabled)("readonly", ctx.readonly);
        ɵngcc0.ɵɵattribute("role", ctx.role)("aria-autocomplete", ctx.ariaAutocomplete)("value", ctx.value)("aria-expanded", ctx.ariaExpanded)("aria-controls", ctx.ariaControls)("aria-owns", ctx.ariaControls)("aria-activedescendant", ctx.ariaActiveDescendant);
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { disabled: "disabled", readonly: "readonly" }, exportAs: ["voxelAutocomplete"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelAutocompleteDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: VoxelFieldMixinBase, decorators: [{ type: Self }, { type: Optional }] },
    { type: Renderer2 },
    { type: ElementRef }
];
VoxelAutocompleteDirective.propDecorators = {
    disabled: [{ type: Input, args: ['disabled',] }, { type: HostBinding, args: ['disabled',] }],
    readonly: [{ type: Input, args: ['readonly',] }, { type: HostBinding, args: ['readonly',] }],
    class: [{ type: HostBinding, args: ['class',] }],
    autocomplete: [{ type: HostBinding, args: ['autocomplete',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    value: [{ type: HostBinding, args: ['attr.value',] }],
    ariaAutocomplete: [{ type: HostBinding, args: ['attr.aria-autocomplete',] }],
    ariaExpanded: [{ type: HostBinding, args: ['attr.aria-expanded',] }],
    ariaControls: [{ type: HostBinding, args: ['attr.aria-controls',] }, { type: HostBinding, args: ['attr.aria-owns',] }],
    ariaActiveDescendant: [{ type: HostBinding, args: ['attr.aria-activedescendant',] }],
    onBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAutocompleteDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelAutocomplete]',
                exportAs: 'voxelAutocomplete'
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: VoxelFieldMixinBase, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { class: [{
            type: HostBinding,
            args: ['class']
        }], autocomplete: [{
            type: HostBinding,
            args: ['autocomplete']
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], ariaAutocomplete: [{
            type: HostBinding,
            args: ['attr.aria-autocomplete']
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }, {
            type: HostBinding,
            args: ['disabled']
        }], readonly: [{
            type: Input,
            args: ['readonly']
        }, {
            type: HostBinding,
            args: ['readonly']
        }], value: [{
            type: HostBinding,
            args: ['attr.value']
        }], ariaExpanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], ariaControls: [{
            type: HostBinding,
            args: ['attr.aria-controls']
        }, {
            type: HostBinding,
            args: ['attr.aria-owns']
        }], ariaActiveDescendant: [{
            type: HostBinding,
            args: ['attr.aria-activedescendant']
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

let NEXT_ID$l = 0;
/**
 * O autocomplete aprimora a caixa de texto adicionando um painel com as opções disponíveis para seleção.
 * Permitindo realizar filtros para facilitar a seleção. Semelhante ao componente select, é necessário
 * informar uma opção dentre uma das opções disponíveis na lista.
 *
 *
 * *Autocomplete enhances the text box by adding a panel with available options for selection.*
 * *Allowing to perform filters to facilitate the selection. Similar to the select component, it*
 * *is necessary to inform an option from one of the options available in the list.*
 *
 * **Module:**
 * `import { VoxelAutocompleteModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/autocomplete?componentOnly=true</example-url>
 */
class VoxelAutocompleteComponent {
    constructor(_cdr, _appRef) {
        this._cdr = _cdr;
        this._appRef = _appRef;
        this._destroy = new Subject();
        this.panelId = `voxel-autocomplete-options-${NEXT_ID$l++}`;
        this.panelPosition = 'bottom';
        this.positions = [];
        this._position = 'auto';
        /**
         *  Define a quantidade de option no visível scroll.
         *  visibleOptions = 6; (default)
         *
         * *Sets the amount of option in the visible scroll.*
         * *visibleOptions = 6; (default)*
         */
        this.visibleOptions = 6;
        /**
         * Define o modo de filtragem das opções:
         *
         * Startswith: Filtra todas as opções que começarem com o valor digitado;
         *
         * Includes: Filtra todas as opções que contenham o texto digitado em qualquer posição;
         *
         * *Sets the filtering mode for the options.*
         * *Startswith: Filters all options that start with the entered value;*
         * *Includes: Filters all options that contain typed text in any position;*
         */
        this.filterMode = 'startsWith';
        /**
         * Define uma função de callback para filtrar as opções. A função é chamada uma vez para cada opção disponível,
         * toda vez que o evento input do componente input vinculado, é disparado.
         *
         * *Defines a callback function to filter the options. The function is called once for each available option,*
         * *every time the input event of the linked input component is fired.*
         *
         * Exemplo:
         * filterFn = (option: VoxelOptionComponent) => option.optionLabel.includes(myFilterValue);
         */
        this.customFilter = null;
        this._compareWith = objectIs;
        /**
         * Evento emitido toda vez que a lista de opções é aberta.
         *
         * *Event emitted every time options list is opened*
         */
        this.opened = new EventEmitter();
        /**
         * Evento emitido toda vez que a lista de opções é fechada.
         *
         * *Event emitted every time options list is closed*
         */
        this.closed = new EventEmitter();
        /**
         * Evento emitido sempre que uma nova opção é ativada. Ou seja,
         * a opção está selecionada na lista de opções, porém seu valor ainda não foi atribuído ao input.
         *
         * *Event emitted whenever a new option is activated. That is, the option is selected in the list*
         * *of options, but its value has not yet been assigned to the input.*
         */
        this.optionActivated = new EventEmitter();
        /**
         * Evento emitido ao selecionar uma nova opção, no momento em que seu valor é atribuído ao input.
         *
         * *Event emitted when selecting a new option, at the moment when its value is assigned to the input.*
         */
        this.optionSelected = new EventEmitter();
    }
    get panelOpen() {
        if (this._panelOpen) {
            this.panelWidth = this.input.width;
        }
        return this._panelOpen;
    }
    set panelOpen(value) {
        this._panelOpen = value;
        this.input.panelOpen = value;
        if (this._panelOpen) {
            this.opened.emit();
            return;
        }
        this.closed.emit();
    }
    get optionsArray() {
        return this.options.toArray();
    }
    get visibleOptionsArray() {
        return this.optionsArray.filter((option) => !option.disabled && option.showing);
    }
    /**
     * Define a posição de abertura da lista de opções
     *
     * Possíveis valores:
     *
     * 'top' | 'bottom' | 'auto' = 'auto'
     *
     * *Defines the opening position of the options list*
     */
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
        this.defineOpeningPosition();
    }
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * *Function to compare the option values with the selected values.*
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: any, c2: any): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectControlValueAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    set compareWith(fn) {
        this._compareWith = fn;
    }
    ngAfterContentInit() {
        if (!this.input) {
            throw new Error(`\
É necessário informar um input para o componente Voxel Autocomplete.
Exemplo:
<voxel-autocomplete [input]="myInput"></voxel-autocomplete>`);
        }
        this.input.ariaControls = this.panelId;
        this.listenToOptionsChanges();
        this.listenToPositionChanges();
        this.listenToViewModelChanges();
        this.listenToClickEvent();
        this.listenToInputEvent();
        this.listenToKeydownEvent();
    }
    ngOnDestroy() {
        this._destroy.complete();
    }
    detach(shouldFocusOnInput = true) {
        this.panelOpen = false;
        if (shouldFocusOnInput) {
            this.input.focus();
        }
        if (this.lastSelectedOption && !this.input.controlValue) {
            this.resetSelection();
        }
    }
    defineOpeningPosition() {
        const bottom = {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        };
        const top = {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
        };
        this.positions = [];
        const setPosition = {
            top: () => this.positions.push(top),
            bottom: () => this.positions.push(bottom),
            auto: () => (this.positions = []),
        };
        setPosition[this.position]();
    }
    listenToOptionsChanges() {
        this.options.changes
            .pipe(takeUntil(this._destroy), startWith(this.options), switchMap(() => merge(...this.options.map((option) => option.change))))
            .subscribe((optionEvent) => {
            this.setSelectedOption(optionEvent);
        });
    }
    listenToPositionChanges() {
        this.cdkOverlay.positionChange.pipe(takeUntil(this._destroy)).subscribe((change) => {
            const openingPosition = change.connectionPair.originY === 'bottom' ? 'bottom' : 'top';
            if (openingPosition === this.panelPosition) {
                return;
            }
            this.panelPosition = openingPosition;
            this._cdr.detectChanges();
        });
    }
    listenToViewModelChanges() {
        this.input.viewModelChangeEvent.pipe(takeUntil(this._destroy)).subscribe((controlValue) => {
            if (controlValue) {
                this.resolveInitialSelection();
                return;
            }
            if (this.lastSelectedOption) {
                this.setValue(null);
            }
        });
    }
    listenToClickEvent() {
        this.input.clickEvent.pipe(takeUntil(this._destroy)).subscribe(() => {
            if (this.input.readonly) {
                return;
            }
            this.panelOpen = true;
        });
    }
    listenToInputEvent() {
        this.input.inputEvent.pipe(takeUntil(this._destroy)).subscribe(() => {
            const shouldResetValue = this.input.controlValue !== '';
            if (shouldResetValue) {
                this.resetValue();
            }
            if (this.lastSelectedOption) {
                this.resetSelection();
            }
            this.optionsArray.map((option) => {
                const filter = this.customFilter
                    ? this.customFilter(option)
                    : this.filterMode === 'startsWith'
                        ? normalizeText(option.optionLabel).startsWith(normalizeText(this.input.viewValue))
                        : normalizeText(option.optionLabel).includes(normalizeText(this.input.viewValue));
                return filter ? option.show() : option.hide();
            });
            if (this.position === 'auto' && this.panelOpen) {
                // Tick para aguardar as opções serem atualizadas na lista de opções, para então
                // atualizar a posição
                this._appRef.tick();
                this.cdkOverlay.overlayRef.updatePosition();
            }
        });
    }
    listenToKeydownEvent() {
        this.input.keydownEvent.pipe(takeUntil(this._destroy)).subscribe((event) => {
            if (this.input.readonly) {
                return;
            }
            this.handleKeydown(event);
        });
    }
    resolveInitialSelection() {
        Promise.resolve().then(() => {
            if (this.input.controlValue) {
                const selectedOption = this.optionsArray.find((option) => !option.disabled && this.compareWith(option.value, this.input.controlValue));
                if (selectedOption) {
                    selectedOption.select(true);
                    return;
                }
                this.setValue(null);
            }
        });
    }
    setSelectedOption(optionEvent) {
        const selectedOption = optionEvent.option;
        const selectAndCloseOptions = optionEvent.close || false;
        const shouldEmitActivatedEvent = selectedOption !== this.lastSelectedOption;
        this.deselectOptions(selectedOption, selectAndCloseOptions);
        selectedOption.show();
        this.lastSelectedOption = selectedOption;
        this.input.ariaActiveDescendant = selectedOption.id;
        if (shouldEmitActivatedEvent) {
            this.emitActivatedEvent(selectedOption);
        }
        if (selectAndCloseOptions) {
            const shouldEmitSelectedEvent = selectedOption.optionLabel !== this.input.viewValue;
            this.setValue(selectedOption, shouldEmitSelectedEvent);
            if (this.panelOpen) {
                this.detach();
            }
            return;
        }
        if (!this.panel) {
            this.cdkOverlay.positionChange
                .pipe(take(1))
                .subscribe(() => this.scrollIntoView(selectedOption));
            return;
        }
        this.scrollIntoView(selectedOption);
    }
    deselectOptions(selectedOption, hideOption) {
        this.optionsArray.forEach((option) => {
            if (!this.compareWith(option.value, selectedOption.value)) {
                option.deselect();
                if (hideOption) {
                    option.hide();
                }
            }
        });
    }
    setValue(selectedOption, shouldEmitSelectedEvent = true) {
        const viewValue = selectedOption ? selectedOption.optionLabel : '';
        const value = selectedOption ? selectedOption.value : '';
        this.input.setControlValue(viewValue, value);
        if (!selectedOption) {
            this.resetSelection(true);
        }
        if (shouldEmitSelectedEvent) {
            this.emitSelectedEvent(selectedOption);
        }
    }
    resetSelection(unhideOptions = false) {
        this.lastSelectedOption = null;
        this.input.ariaActiveDescendant = null;
        this.optionsArray.forEach((option) => {
            option.deselect();
            if (unhideOptions) {
                option.show();
            }
        });
        this.emitActivatedEvent(null);
    }
    resetValue() {
        this.input.resetControlValue();
        this.emitSelectedEvent(null);
    }
    handleKeydown(event) {
        const shouldNotOpen = event.code === 'Enter' ||
            event.code === 'ArrowLeft' ||
            event.code === 'ArrowRight' ||
            event.code === 'Escape' ||
            event.code === 'Backspace' ||
            event.code === 'Tab' ||
            event.key === 'Alt' ||
            event.key === 'Shift' ||
            event.key === 'Control' ||
            event.key === 'Meta';
        const lastOption = this.lastSelectedOption;
        const selectedOptionIdx = lastOption
            ? this.visibleOptionsArray.findIndex((opt) => opt.id === lastOption.id)
            : -1;
        if (!this.panelOpen && !shouldNotOpen) {
            this.panelOpen = true;
        }
        if ((event.code === 'ArrowUp' || event.code === 'ArrowDown') && event.altKey) {
            return;
        }
        if (event.code === 'ArrowUp') {
            event.preventDefault();
            if (this.visibleOptionsArray.length === 0) {
                return;
            }
            this.visibleOptionsArray[selectedOptionIdx === 0 || selectedOptionIdx === -1
                ? this.visibleOptionsArray.length - 1
                : selectedOptionIdx - 1].select();
            return;
        }
        if (event.code === 'ArrowDown') {
            event.preventDefault();
            if (this.visibleOptionsArray.length === 0) {
                return;
            }
            this.visibleOptionsArray[selectedOptionIdx === this.visibleOptionsArray.length - 1 ? 0 : selectedOptionIdx + 1].select();
            return;
        }
        if ((event.code === 'Enter' || event.code === 'NumpadEnter') && this.panelOpen) {
            event.preventDefault();
            if (lastOption) {
                lastOption.select(true);
                return;
            }
            if (this.visibleOptionsArray.length === 1) {
                this.visibleOptionsArray[0].select(true);
                return;
            }
            this.detach();
            return;
        }
        if (event.code === 'Escape') {
            event.preventDefault();
            if (this.panelOpen) {
                this.detach();
                return;
            }
            if (lastOption) {
                this.setValue(null);
            }
            return;
        }
        if (event.code === 'Tab' && this.panelOpen) {
            if (lastOption) {
                lastOption.select(true);
                return;
            }
            this.detach(false);
        }
    }
    scrollIntoView(selectedOption) {
        const panelEl = this.panel.nativeElement;
        const optionEl = selectedOption.element.nativeElement;
        const scrollPosition = optionEl.offsetTop - panelEl.scrollTop;
        if (scrollPosition >= panelEl.offsetHeight) {
            optionEl.scrollIntoView(false);
            return;
        }
        /* istanbul ignore next */
        if (scrollPosition < 0) {
            optionEl.scrollIntoView();
        }
    }
    emitActivatedEvent(option) {
        this.optionActivated.emit({
            activatedOption: option ? option : null,
            activatedOptionLabel: option ? option.optionLabel : '',
            activatedOptionValue: option ? option.value : '',
        });
    }
    emitSelectedEvent(option) {
        this.optionSelected.emit({
            selectedOption: option ? option : null,
            selectedOptionLabel: option ? option.optionLabel : '',
            selectedOptionValue: option ? option.value : '',
        });
    }
}
VoxelAutocompleteComponent.ɵfac = function VoxelAutocompleteComponent_Factory(t) { return new (t || VoxelAutocompleteComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ApplicationRef)); };
VoxelAutocompleteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelAutocompleteComponent, selectors: [["voxel-autocomplete"]], contentQueries: function VoxelAutocompleteComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelOptionComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, viewQuery: function VoxelAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 5);
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cdkOverlay = _t.first);
    } }, inputs: { visibleOptions: "visibleOptions", filterMode: "filterMode", customFilter: "customFilter", position: "position", compareWith: "compareWith", input: "input", ariaLabel: ["aria-label", "ariaLabel"] }, outputs: { opened: "opened", closed: "closed", optionActivated: "optionActivated", optionSelected: "optionSelected" }, ngContentSelectors: _c10, decls: 1, vars: 4, consts: [["cdkConnectedOverlay", "", "cdkConnectedOverlayHasBackdrop", "", "cdkConnectedOverlayBackdropClass", "cdk-overlay-transparent-backdrop", 3, "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayWidth", "backdropClick"], ["role", "listbox", 1, "voxel-autocomplete-options", 3, "id"], ["panel", ""]], template: function VoxelAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c9);
        ɵngcc0.ɵɵtemplate(0, VoxelAutocompleteComponent_ng_template_0_Template, 3, 7, "ng-template", 0);
        ɵngcc0.ɵɵlistener("backdropClick", function VoxelAutocompleteComponent_Template_ng_template_backdropClick_0_listener() { return ctx.detach(false); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayOrigin", ctx.input)("cdkConnectedOverlayOpen", ctx.panelOpen)("cdkConnectedOverlayPositions", ctx.positions)("cdkConnectedOverlayWidth", ctx.panelWidth);
    } }, directives: [ɵngcc2.CdkConnectedOverlay], styles: [".voxel-autocomplete-input{overflow:hidden;padding-right:var(--ids_spacing_8x);text-overflow:ellipsis;white-space:nowrap}.voxel-autocomplete-input:not(:disabled,:-moz-read-only){cursor:pointer}.voxel-autocomplete-input:not(:disabled,:read-only){cursor:pointer}.voxel-autocomplete-options{background-color:var(--ids_color_bg_base);border-radius:0 0 var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01);-webkit-box-shadow:0 0 .125rem 0 rgba(86,80,76,.16),0 .125rem .5rem 0 rgba(86,80,76,.16);box-shadow:0 0 .125rem rgba(86,80,76,.16),0 .125rem .5rem rgba(86,80,76,.16);margin-top:var(--ids_size_general_10x);overflow-y:auto;width:100%}.voxel-autocomplete-options--top-positioned{border-radius:var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01) 0 0;margin:0;margin-bottom:var(--ids_size_general_22x)}\n"], encapsulation: 2 });
VoxelAutocompleteComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ApplicationRef }
];
VoxelAutocompleteComponent.propDecorators = {
    input: [{ type: Input }],
    position: [{ type: Input }],
    visibleOptions: [{ type: Input }],
    filterMode: [{ type: Input }],
    customFilter: [{ type: Input }],
    ariaLabel: [{ type: Input, args: ['aria-label',] }],
    compareWith: [{ type: Input }],
    opened: [{ type: Output }],
    closed: [{ type: Output }],
    optionActivated: [{ type: Output }],
    optionSelected: [{ type: Output }],
    options: [{ type: ContentChildren, args: [VoxelOptionComponent, { descendants: true },] }],
    panel: [{ type: ViewChild, args: ['panel',] }],
    cdkOverlay: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-autocomplete',
                template: "<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"input\"\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayWidth]=\"panelWidth\"\n  (backdropClick)=\"detach(false)\"\n>\n  <div\n    #panel\n    role=\"listbox\"\n    [id]=\"panelId\"\n    class=\"voxel-autocomplete-options\"\n    [class.voxel-autocomplete-options--top-positioned]=\"panelPosition === 'top'\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-labelledby]=\"!ariaLabel && input.labelId ? input.labelId: null\"\n    [style.maxHeight.rem]=\"visibleOptions * 3\"\n  >\n    <ng-content select=\"voxel-option\"></ng-content>\n  </div>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-autocomplete-input{overflow:hidden;padding-right:var(--ids_spacing_8x);text-overflow:ellipsis;white-space:nowrap}.voxel-autocomplete-input:not(:disabled,:-moz-read-only){cursor:pointer}.voxel-autocomplete-input:not(:disabled,:read-only){cursor:pointer}.voxel-autocomplete-options{background-color:var(--ids_color_bg_base);border-radius:0 0 var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01);-webkit-box-shadow:0 0 .125rem 0 rgba(86,80,76,.16),0 .125rem .5rem 0 rgba(86,80,76,.16);box-shadow:0 0 .125rem rgba(86,80,76,.16),0 .125rem .5rem rgba(86,80,76,.16);margin-top:var(--ids_size_general_10x);overflow-y:auto;width:100%}.voxel-autocomplete-options--top-positioned{border-radius:var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01) 0 0;margin:0;margin-bottom:var(--ids_size_general_22x)}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ApplicationRef }]; }, { visibleOptions: [{
            type: Input
        }], filterMode: [{
            type: Input
        }], customFilter: [{
            type: Input
        }], opened: [{
            type: Output
        }], closed: [{
            type: Output
        }], optionActivated: [{
            type: Output
        }], optionSelected: [{
            type: Output
        }], position: [{
            type: Input
        }], compareWith: [{
            type: Input
        }], input: [{
            type: Input
        }], ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }], options: [{
            type: ContentChildren,
            args: [VoxelOptionComponent, { descendants: true }]
        }], panel: [{
            type: ViewChild,
            args: ['panel']
        }], cdkOverlay: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }] }); })();

class VoxelAutocompleteModule {
}
VoxelAutocompleteModule.ɵfac = function VoxelAutocompleteModule_Factory(t) { return new (t || VoxelAutocompleteModule)(); };
VoxelAutocompleteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelAutocompleteModule });
VoxelAutocompleteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[OverlayModule, VoxelOptionModule], VoxelOptionModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAutocompleteModule, [{
        type: NgModule,
        args: [{
                imports: [OverlayModule, VoxelOptionModule],
                declarations: [VoxelAutocompleteComponent, VoxelAutocompleteDirective],
                exports: [VoxelAutocompleteComponent, VoxelAutocompleteDirective, VoxelOptionModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelAutocompleteModule, { declarations: function () { return [VoxelAutocompleteComponent, VoxelAutocompleteDirective]; }, imports: function () { return [OverlayModule, VoxelOptionModule]; }, exports: function () { return [VoxelAutocompleteComponent, VoxelAutocompleteDirective, VoxelOptionModule]; } }); })();

/**
 * O badge é um componente usado para representar informações dinâmicas.
 * Pode ser exibido em elementos como ícones ou cards para notificar que existem
 * solicitações pendentes.
 *
 * *Badge is used to represent dynamic information.
 * Can be displayed on elements like icons or cards to notify that there are
 * pending requests*
 *
 * **Module:**
 *
 * `import { VoxelBadgeModule } from '@voxel/components';`
 *
 *  <example-url>../../demo/index.html#/portfolio/badge?componentOnly=true</example-url>
 *
 */
class VoxelBadgeComponent {
    constructor() {
        /**
         * @internal
         */
        this._value = 0;
        /**
         * @internal
         */
        this._max = 99;
        /**
         * @internal
         */
        this._accessibleValue = '';
        /**
         * @internal
         */
        this._highContrast = false;
        /**
         * Variável utilizada para tornar dinâmico o conteúdo à frente do valor
         *
         * *Variable used to make content ahead of value dynamic*
         */
        this.maxSymbol = '+';
    }
    /**
     *
     * Retorna o valor acessível do badge
     *
     * @readonly
     * @type {string}
     * @memberof VoxelBadgeComponent
     */
    get accessibleValue() {
        return this._accessibleValue;
    }
    /**
     * Define se o badge é de alto contraste
     *
     * *Sets whether the badge is high contrast*
     */
    set highContrast(value) {
        this._highContrast = enforceBoolean(value);
    }
    get highContrast() {
        return this._highContrast;
    }
    /**
     * Valor máximo a ser exibido
     *
     * *Maximum value to display*
     */
    set max(value) {
        this._max = enforceNumber(value);
    }
    get max() {
        return this._max;
    }
    /**
     * Valor do badge a ser exibido
     *
     * *Badge value to display*
     */
    set value(value) {
        this._value = value;
    }
    get value() {
        return this._value;
    }
    /**
     * @internal
     */
    convertBadge(value) {
        const valueNumber = Math.abs(enforceNumber(value));
        this._accessibleValue = `${valueNumber} `;
        if (valueNumber > this.max) {
            this._accessibleValue = `mais de ${this.max} `;
            return `${this.max}${this.maxSymbol}`;
        }
        return valueNumber.toString();
    }
    ngOnChanges() {
        this.value = this.convertBadge(this.value);
    }
}
VoxelBadgeComponent.ɵfac = function VoxelBadgeComponent_Factory(t) { return new (t || VoxelBadgeComponent)(); };
VoxelBadgeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelBadgeComponent, selectors: [["voxel-badge"], ["", "voxelBadge", ""]], inputs: { maxSymbol: "maxSymbol", highContrast: "highContrast", max: "max", value: "value", a11yLabel: "a11yLabel" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 6, consts: [[1, "voxel-badge"], ["class", "hidden-aria-label", 4, "ngIf"], [1, "hidden-aria-label"]], template: function VoxelBadgeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "span");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, VoxelBadgeComponent_span_3_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-badge--high-contrast", ctx.highContrast);
        ɵngcc0.ɵɵattribute("data-max", ctx.max);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.a11yLabel ? true : false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.a11yLabel);
    } }, directives: [ɵngcc1.NgIf], styles: [".voxel-badge[_ngcontent-%COMP%]{background-color:var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_layout_01);-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--ids_color_contrast_onDark);display:inline-block;font:var(--ids_textStyle_body_01_regular);min-height:var(--ids_size_general_24x);min-width:var(--ids_size_general_24x);padding:0 var(--ids_size_general_8x);position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-badge--high-contrast[_ngcontent-%COMP%]{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_secondary_base)}.voxel-badge[_ngcontent-%COMP%]   .hidden-aria-label[_ngcontent-%COMP%]{display:block;height:1.5625rem;left:0;-webkit-line-clamp:2;opacity:0;overflow:hidden;position:absolute;text-overflow:ellipsis;top:0;width:2.1875rem}"] });
VoxelBadgeComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    highContrast: [{ type: Input }],
    max: [{ type: Input }],
    maxSymbol: [{ type: Input }],
    value: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelBadgeComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-badge, [voxelBadge]',
                template: "<span\n  class=\"voxel-badge\"\n  [class.voxel-badge--high-contrast]=\"highContrast\"\n  [attr.data-max]=\"max\"\n>\n  <span [attr.aria-hidden]=\"a11yLabel ? true : false\">{{ value }}</span>\n  <span *ngIf=\"a11yLabel\" class=\"hidden-aria-label\">{{ accessibleValue + a11yLabel }}</span>\n</span>\n",
                styles: [".voxel-badge{background-color:var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_layout_01);-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--ids_color_contrast_onDark);display:inline-block;font:var(--ids_textStyle_body_01_regular);min-height:var(--ids_size_general_24x);min-width:var(--ids_size_general_24x);padding:0 var(--ids_size_general_8x);position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-badge--high-contrast{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_secondary_base)}.voxel-badge .hidden-aria-label{display:block;height:1.5625rem;left:0;-webkit-line-clamp:2;opacity:0;overflow:hidden;position:absolute;text-overflow:ellipsis;top:0;width:2.1875rem}\n"]
            }]
    }], function () { return []; }, { maxSymbol: [{
            type: Input
        }], highContrast: [{
            type: Input
        }], max: [{
            type: Input
        }], value: [{
            type: Input
        }], a11yLabel: [{
            type: Input
        }] }); })();

class VoxelBadgeModule {
}
VoxelBadgeModule.ɵfac = function VoxelBadgeModule_Factory(t) { return new (t || VoxelBadgeModule)(); };
VoxelBadgeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelBadgeModule });
VoxelBadgeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelBadgeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelBadgeComponent],
                exports: [VoxelBadgeComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelBadgeModule, { declarations: function () { return [VoxelBadgeComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelBadgeComponent]; } }); })();

/**
 * É uma navegação secundária dentro do aplicativo. O breadcrumbs oferece
 * aos usuários do aplicativo a opção, na forma de links internos,
 * de retornar rapidamente à página principal ou a outro nível do aplicativo.
 *
 *
 * *It is a secondary navigation within the application.*
 * *Breadcrumbs offers users of the application the option,*
 * *in the form of internal links, to quickly return to the*
 * *main page or to another level of the application.*
 *
 * **Module:**
 * `import { VoxelBreadcrumbModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/components/breadcrumb?componentOnly=true</example-url>
 *
 * @example Breadcrumb
 * <voxel-breadcrumb
 *     [breadcrumb]="[
 *        {label: 'home', route:''},
 *        {label: 'visão geral', route:'/portifolio'},
 *        {label: 'breadcrumb', route:'/portifolio/breadcrumb'}]"
 * ></voxel-breadcrumb>
 *
 */
class VoxelBreadcrumbComponent {
}
VoxelBreadcrumbComponent.ɵfac = function VoxelBreadcrumbComponent_Factory(t) { return new (t || VoxelBreadcrumbComponent)(); };
VoxelBreadcrumbComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelBreadcrumbComponent, selectors: [["voxel-breadcrumb"]], inputs: { breadcrumb: "breadcrumb", type: "type" }, decls: 7, vars: 2, consts: [["aria-label", "breadcrumb", 3, "ngClass"], [1, "breadcrumb"], ["class", "breadcrumb__item", 4, "ngFor", "ngForOf"], ["link", ""], ["text", ""], [1, "breadcrumb__item"], ["class", "breadcrumb__arrow-right", "aria-hidden", "true", "size", "S", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-hidden", "true", "size", "S", 1, "breadcrumb__arrow-right"], [1, "breadcrumb__link", 3, "routerLink"], ["aria-current", "page", 1, "breadcrumb__label"]], template: function VoxelBreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵtemplate(2, VoxelBreadcrumbComponent_li_2_Template, 4, 9, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, VoxelBreadcrumbComponent_ng_template_3_Template, 2, 4, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, VoxelBreadcrumbComponent_ng_template_5_Template, 2, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.type ? "breadcrumb--" + ctx.type : "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.breadcrumb);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, VoxelIconComponent, ɵngcc4.RouterLinkWithHref], styles: [".breadcrumb[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__link[_ngcontent-%COMP%]{color:var(--ids_color_action_secondary_base);cursor:pointer;font:var(--ids_textStyle_body_01_regular);text-decoration:underline}.breadcrumb__link[_ngcontent-%COMP%]:hover, .breadcrumb__link[_ngcontent-%COMP%]:focus{color:var(--ids_color_action_secondary_variant);font:var(--ids_textStyle_body_01_bold)}.breadcrumb__label[_ngcontent-%COMP%]{display:none}.breadcrumb__arrow-right[_ngcontent-%COMP%]{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_disabled_variant);margin:0 var(--ids_size_general_8x)}.breadcrumb__item[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__item[_ngcontent-%COMP%]:not(:nth-last-child(2)){display:none}.breadcrumb--light[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.breadcrumb--light[_ngcontent-%COMP%]   .breadcrumb__link[_ngcontent-%COMP%], .breadcrumb--light[_ngcontent-%COMP%]   .breadcrumb__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.breadcrumb--light[_ngcontent-%COMP%]   .breadcrumb__arrow-right[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.breadcrumb--dark[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01)}.breadcrumb--dark[_ngcontent-%COMP%]   .breadcrumb__link[_ngcontent-%COMP%], .breadcrumb--dark[_ngcontent-%COMP%]   .breadcrumb__label[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01)}.breadcrumb--dark[_ngcontent-%COMP%]   .breadcrumb__arrow-right[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01)}.breadcrumb--light[_ngcontent-%COMP%]   .breadcrumb__link[_ngcontent-%COMP%]:hover, .breadcrumb--light[_ngcontent-%COMP%]   .breadcrumb__link[_ngcontent-%COMP%]:focus, .breadcrumb--dark[_ngcontent-%COMP%]   .breadcrumb__link[_ngcontent-%COMP%]:hover, .breadcrumb--dark[_ngcontent-%COMP%]   .breadcrumb__link[_ngcontent-%COMP%]:focus{color:inherit}@media only screen and (min-width: 600px){.breadcrumb__item[_ngcontent-%COMP%]:not(:nth-last-child(2)){display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__item[_ngcontent-%COMP%]:last-child   .breadcrumb__link[_ngcontent-%COMP%]{display:none}.breadcrumb__label[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__arrow-right[_ngcontent-%COMP%]{-webkit-transform:scaleX(-1);transform:scaleX(-1)}}"] });
VoxelBreadcrumbComponent.propDecorators = {
    breadcrumb: [{ type: Input }],
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelBreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-breadcrumb',
                template: "<nav  aria-label=\"breadcrumb\" [ngClass]=\"type? 'breadcrumb--'+type : ''\">\n  <ul class=\"breadcrumb\">\n    <li\n      class=\"breadcrumb__item\"\n      *ngFor=\"let item of breadcrumb; first as isFirst; last as isLast; index as i\"\n    >\n      <voxel-icon\n        class=\"breadcrumb__arrow-right\"\n        aria-hidden=\"true\"\n        *ngIf=\"!isFirst\"\n        size=\"S\"\n      >\n        seta_esquerda\n      </voxel-icon>\n      <ng-container *ngTemplateOutlet=\"link; context: {$implicit:item}\"> </ng-container>\n      <ng-container\n        *ngTemplateOutlet=\"!isLast ? '': $any(text); context: {$implicit:item}\"\n      ></ng-container>\n    </li>\n  </ul>\n</nav>\n<ng-template #link let-item>\n  <a class=\"breadcrumb__link\" [routerLink]=\"[item.route]\">{{ item.label }}</a>\n</ng-template>\n<ng-template #text let-item>\n  <p class=\"breadcrumb__label\" aria-current=\"page\">{{ item.label }}</p>\n</ng-template>",
                styles: [".breadcrumb{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__link{color:var(--ids_color_action_secondary_base);cursor:pointer;font:var(--ids_textStyle_body_01_regular);text-decoration:underline}.breadcrumb__link:hover,.breadcrumb__link:focus{color:var(--ids_color_action_secondary_variant);font:var(--ids_textStyle_body_01_bold)}.breadcrumb__label{display:none}.breadcrumb__arrow-right{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_disabled_variant);margin:0 var(--ids_size_general_8x)}.breadcrumb__item{display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__item:not(:nth-last-child(2)){display:none}.breadcrumb--light{color:var(--ids_color_contrast_onDark)}.breadcrumb--light .breadcrumb__link,.breadcrumb--light .breadcrumb__label{color:var(--ids_color_contrast_onDark)}.breadcrumb--light .breadcrumb__arrow-right{color:var(--ids_color_contrast_onDark)}.breadcrumb--dark{color:var(--ids_color_text_body_01)}.breadcrumb--dark .breadcrumb__link,.breadcrumb--dark .breadcrumb__label{color:var(--ids_color_text_body_01)}.breadcrumb--dark .breadcrumb__arrow-right{color:var(--ids_color_text_body_01)}.breadcrumb--light .breadcrumb__link:hover,.breadcrumb--light .breadcrumb__link:focus,.breadcrumb--dark .breadcrumb__link:hover,.breadcrumb--dark .breadcrumb__link:focus{color:inherit}@media only screen and (min-width: 600px){.breadcrumb__item:not(:nth-last-child(2)){display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__item:last-child .breadcrumb__link{display:none}.breadcrumb__label{display:-webkit-box;display:-ms-flexbox;display:flex}.breadcrumb__arrow-right{-webkit-transform:scaleX(-1);transform:scaleX(-1)}}\n"]
            }]
    }], null, { breadcrumb: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class VoxelBreadcrumbModule {
}
VoxelBreadcrumbModule.ɵfac = function VoxelBreadcrumbModule_Factory(t) { return new (t || VoxelBreadcrumbModule)(); };
VoxelBreadcrumbModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelBreadcrumbModule });
VoxelBreadcrumbModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, RouterModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelBreadcrumbModule, [{
        type: NgModule,
        args: [{
                declarations: [VoxelBreadcrumbComponent],
                imports: [CommonModule, RouterModule, VoxelIconModule],
                exports: [VoxelBreadcrumbComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelBreadcrumbModule, { declarations: function () { return [VoxelBreadcrumbComponent]; }, imports: function () { return [CommonModule, RouterModule, VoxelIconModule]; }, exports: function () { return [VoxelBreadcrumbComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID$k = 0;
/**
 * @internal
 */
const loadSize = { small: '0 0 72 72', medium: '0 0 69 69', large: '0 0 66 66' };
/**
 * O loading circular indica ao usuário o status de um processo que está sendo realizado,
 * exclusivo para o carregamento interno de uma sessão específica dentro da página.
 *
 * *The circular loading indicates to the user the status of a process that is being carried out,
 * exclusive for the internal loading of a specific session within the page.*
 *
 * **Module:**
 *
 * `import { VoxelLoadingCircleModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/loadingcircle?componentOnly=true</example-url>
 *
 * @example Normal.
 * <voxel-loading-circle>
 * </voxel-loading-circle>
 *
 * @example Tamanho (small).
 * <voxel-loading-circle
 *            [hideLoading]="false"
 *            loadingTitle="exemploTitle"
 *            size="small"
 * >
 * </voxel-loading-circle>
 *
 * @example Tamanho (medium).
 * <voxel-loading-circle
 *             [hideLoading]="false"
 *             loadingTitle="exemploTitle"
 *             size="medium"
 * >
 * </voxel-loading-circle>
 *
 * @example Tamanho (large).
 * <voxel-loading-circle
 *              [hideLoading]="false"
 *              loadingTitle="exemploTitle"
 *              size="large"
 * >
 * </voxel-loading-circle>
 *
 * @example Exibindo loading-circle.
 * <voxel-loading-circle
 *               [hideLoading]="false"
 *               loadingTitle="exemploTitle"
 * >
 * </voxel-loading-circle>
 *
 * @example Ocultando loading-circle.
 * <voxel-loading-circle
 *                [hideLoading]="true"
 *                loadingTitle="exemploTitle"
 * >
 * </voxel-loading-circle>
 *
 * @example Alterando mensagem de carregamento.
 * <voxel-loading-circle
 *                 [hideLoading]="false"
 *                 loadingTitle="Carregando o serviço da lista de usuário"
 * >
 * </voxel-loading-circle>
 *
 * @example Adicionando aria-live.
 * <voxel-loading-circle
 *                  [hideLoading]="false"
 *                  [ariaPolite]="true"
 *                  loadingTitle="exemploTitle"
 * >
 * </voxel-loading-circle>
 *
 * @example Adicionando role.
 * <voxel-loading-circle
 *                   [hideLoading]="false"
 *                   [ariaRole]="true"
 *                   loadingTitle="exemploTitle"
 * >
 * </voxel-loading-circle>
 *
 * @example inverse: inverte as cores do tema.
 * <voxel-loading-circle
 *                    [hideLoading]="false"
 *                    inverse="true"
 *                    loadingTitle="exemploTitle"
 * >
 * </voxel-loading-circle>
 *
 * @example transparent: deixa o fundo interno do loader transparente.
 * <voxel-loading-circle
 *                     [hideLoading]="false"
 *                     trasparent="true"
 *                     loadingTitle="exemploTitle"
 * >
 * </voxel-loading-circle>
 */
class VoxelLoadingCircleComponent {
    constructor() {
        /**
         * @internal
         */
        this._hideLoading = false;
        /**
         * Id do componente voxel-loading-circle
         *
         * *Voxel-loading-circle component id*
         */
        this.loadingCircleId = `voxel-loading-circle-${NEXT_ID$k++}`;
        this._inverse = false;
        /**
         * Tamanho do loading.
         *
         * size = 'small'
         *
         * size (default) = 'medium'
         *
         * size = 'large'
         *
         * *Loading size*
         *
         * *size = 'small'*
         *
         * *size (default) = 'medium'*
         *
         * *size = 'large'*
         */
        this.size = 'medium';
        /**
         * Mensagem de loading.
         *
         * loadingTitle (default) = 'Carregando.'
         *
         * *Loading message*
         *
         * *loadingTitle (default) = 'Carregando.'*
         */
        this.loadingTitle = 'Carregando.';
        /**
         * Define se terá aria-live polite ou não
         *
         * *Define if it will have aria-live polite or not*
         */
        this.ariaPolite = false;
        /**
         * Define se terá aria-hidden ou não
         *
         * *Define if it will have aria-hidden or not*
         */
        this.ariaHidden = false;
        /**
         * Define se terá role ou não
         *
         * *Define if it will have a role or not*
         */
        this.ariaRole = false;
        /**
         * Alterna a exibição do fundo interno do loader se verdadeiro.
         *
         * transparent (default) = false
         *
         * transparent = true
         *
         * *Change the loader inner background if true*
         *
         * *transparent (default) = false*
         *
         * *transparent = true*
         */
        this.transparent = false;
        this._secondary = false;
    }
    /**
     * Inverte as cores do componente para se adaptar ao fundo do segmento selecionado.
     *
     * inverse (default) = false
     *
     * inverse = true
     *
     * *Change the component color to show with segment colors background*
     *
     * *inverse (defautl) = false*
     *
     * *inverse = true*
     */
    set inverse(value) {
        this._inverse = enforceBoolean(value);
    }
    get inverse() {
        return this._inverse;
    }
    /**
     * Alterna a cor do loading para secundário
     *
     * *Toggles loading color to secondary*
     */
    set secondary(value) {
        this._secondary = enforceBoolean(value);
    }
    get secondary() {
        return this._secondary;
    }
    /**
     * Define se o loading-circle estará visivel ou não
     *
     * hideLoading (default) = false
     *
     * hideLoading = true
     *
     * *Define if loading-circle is visible or not*
     *
     * *hideLoading (default) = false*
     *
     * *hideLoading = true*
     */
    set hideLoading(hideLoading) {
        this._hideLoading = enforceBoolean(hideLoading);
    }
    get hideLoading() {
        return this._hideLoading;
    }
    get viewBox() {
        return loadSize[this.size];
    }
}
VoxelLoadingCircleComponent.ɵfac = function VoxelLoadingCircleComponent_Factory(t) { return new (t || VoxelLoadingCircleComponent)(); };
VoxelLoadingCircleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelLoadingCircleComponent, selectors: [["voxel-loading-circle"]], inputs: { loadingCircleId: "loadingCircleId", size: "size", loadingTitle: "loadingTitle", ariaPolite: "ariaPolite", ariaHidden: "ariaHidden", ariaRole: "ariaRole", transparent: "transparent", inverse: "inverse", secondary: "secondary", hideLoading: "hideLoading" }, decls: 1, vars: 1, consts: [["class", "voxel-loading-circle", 3, "voxel-loading-circle--inverse", "voxel-loading-circle--transparent", "voxel-loading-circle--secondary", 4, "ngIf"], [1, "voxel-loading-circle"], [1, "voxel-loading-circle__container"], ["role", "img", "xmlns", "https://www.w3.org/2000/svg", "preserveAspectRatio", "xMidYMid meet", 1, "voxel-loading-circle__svg", 3, "ngClass"], ["cx", "50%", "cy", "50%", "r", "30", 1, "voxel-loading-circle__internal"], ["cx", "50%", "cy", "50%", "r", "30", 1, "voxel-loading-circle__external"]], template: function VoxelLoadingCircleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, VoxelLoadingCircleComponent_div_0_Template, 7, 17, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideLoading);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], styles: [".voxel-loading-circle[_ngcontent-%COMP%]{stroke:var(--ids_color_action_primary_base)}.voxel-loading-circle--secondary[_ngcontent-%COMP%]:not(.voxel-loading-circle--inverse){stroke:var(--ids_color_action_secondary_base)}.voxel-loading-circle--inverse[_ngcontent-%COMP%]{stroke:var(--ids_color_contrast_onDark)}.voxel-loading-circle__container[_ngcontent-%COMP%]{display:inline-block;margin:0 auto;width:100%}.voxel-loading-circle__internal[_ngcontent-%COMP%]{fill:transparent;stroke-linecap:round;stroke-opacity:.16}.voxel-loading-circle__external[_ngcontent-%COMP%]{-webkit-animation:.5s linear infinite both loading-circle-external,1.5s linear infinite both loading-circle-animation;animation:.5s linear infinite both loading-circle-external,1.5s linear infinite both loading-circle-animation;fill:transparent;stroke-dasharray:300;stroke-linecap:round;stroke-opacity:1;-webkit-transform-origin:50% 50%;transform-origin:50% 50%}.voxel-loading-circle__svg--small[_ngcontent-%COMP%]{height:var(--ids_size_general_16x);width:var(--ids_size_general_16x)}.voxel-loading-circle__svg--small[_ngcontent-%COMP%]   .voxel-loading-circle__internal[_ngcontent-%COMP%], .voxel-loading-circle__svg--small[_ngcontent-%COMP%]   .voxel-loading-circle__external[_ngcontent-%COMP%]{stroke-width:var(--ids_size_general_12x)}.voxel-loading-circle__svg--medium[_ngcontent-%COMP%]{height:var(--ids_size_general_32x);width:var(--ids_size_general_32x)}.voxel-loading-circle__svg--medium[_ngcontent-%COMP%]   .voxel-loading-circle__internal[_ngcontent-%COMP%], .voxel-loading-circle__svg--medium[_ngcontent-%COMP%]   .voxel-loading-circle__external[_ngcontent-%COMP%]{stroke-width:var(--ids_size_general_8x)}.voxel-loading-circle__svg--large[_ngcontent-%COMP%]{height:var(--ids_size_general_64x);width:var(--ids_size_general_64x)}.voxel-loading-circle__svg--large[_ngcontent-%COMP%]   .voxel-loading-circle__internal[_ngcontent-%COMP%], .voxel-loading-circle__svg--large[_ngcontent-%COMP%]   .voxel-loading-circle__external[_ngcontent-%COMP%]{stroke-width:var(--ids_size_general_5x)}@-webkit-keyframes loading-circle-animation{0%,25%{stroke-dashoffset:265}25%,50%{stroke-dashoffset:200}50%,75%{stroke-dashoffset:200}75%,to{stroke-dashoffset:270}}@keyframes loading-circle-animation{0%,25%{stroke-dashoffset:265}25%,50%{stroke-dashoffset:200}50%,75%{stroke-dashoffset:200}75%,to{stroke-dashoffset:270}}@-webkit-keyframes loading-circle-external{0%{-webkit-transform:rotateZ(0deg);transform:rotate(0)}80%,to{-webkit-animation-delay:.3s;animation-delay:.3s}to{-webkit-transform:rotateZ(360deg);transform:rotate(360deg)}}@keyframes loading-circle-external{0%{-webkit-transform:rotateZ(0deg);transform:rotate(0)}80%,to{-webkit-animation-delay:.3s;animation-delay:.3s}to{-webkit-transform:rotateZ(360deg);transform:rotate(360deg)}}"] });
VoxelLoadingCircleComponent.propDecorators = {
    loadingCircleId: [{ type: Input }],
    inverse: [{ type: Input }],
    size: [{ type: Input }],
    loadingTitle: [{ type: Input }],
    ariaPolite: [{ type: Input }],
    ariaHidden: [{ type: Input }],
    ariaRole: [{ type: Input }],
    transparent: [{ type: Input }],
    secondary: [{ type: Input }],
    hideLoading: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLoadingCircleComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-loading-circle',
                template: "<div\n  *ngIf=\"!hideLoading\"\n  class=\"voxel-loading-circle\"\n  [attr.id]=\"loadingCircleId\"\n  [class.voxel-loading-circle--inverse]=\"inverse\"\n  [class.voxel-loading-circle--transparent]=\"transparent\"\n  [class.voxel-loading-circle--secondary]=\"secondary\"\n  [attr.aria-live]=\"ariaPolite && !ariaRole ? 'polite' : null\"\n  [attr.role]=\"ariaRole && !ariaPolite ? 'status' : null\"\n  [attr.aria-hidden]=\"ariaHidden\"\n>\n  <div\n    class=\"voxel-loading-circle__container\"\n  >\n    <svg\n      class=\"voxel-loading-circle__svg\"\n      [ngClass]=\"{\n        'voxel-loading-circle__svg--small': size === 'small',\n        'voxel-loading-circle__svg--medium': size === 'medium',\n        'voxel-loading-circle__svg--large': size === 'large'\n      }\"\n      role=\"img\"\n      [attr.viewBox]=\"viewBox\"\n      xmlns=\"https://www.w3.org/2000/svg\"\n      preserveAspectRatio=\"xMidYMid meet\"\n    >\n      <title>{{loadingTitle}}</title>\n      <circle\n        cx=\"50%\"\n        cy=\"50%\"\n        r=\"30\"\n        class=\"voxel-loading-circle__internal\"\n      >\n      </circle>\n      <circle\n        class=\"voxel-loading-circle__external\"\n        cx=\"50%\"\n        cy=\"50%\"\n        r=\"30\"\n      >\n      </circle>\n    </svg>\n  </div>\n</div>\n",
                styles: [".voxel-loading-circle{stroke:var(--ids_color_action_primary_base)}.voxel-loading-circle--secondary:not(.voxel-loading-circle--inverse){stroke:var(--ids_color_action_secondary_base)}.voxel-loading-circle--inverse{stroke:var(--ids_color_contrast_onDark)}.voxel-loading-circle__container{display:inline-block;margin:0 auto;width:100%}.voxel-loading-circle__internal{fill:transparent;stroke-linecap:round;stroke-opacity:.16}.voxel-loading-circle__external{-webkit-animation:.5s linear infinite both loading-circle-external,1.5s linear infinite both loading-circle-animation;animation:.5s linear infinite both loading-circle-external,1.5s linear infinite both loading-circle-animation;fill:transparent;stroke-dasharray:300;stroke-linecap:round;stroke-opacity:1;-webkit-transform-origin:50% 50%;transform-origin:50% 50%}.voxel-loading-circle__svg--small{height:var(--ids_size_general_16x);width:var(--ids_size_general_16x)}.voxel-loading-circle__svg--small .voxel-loading-circle__internal,.voxel-loading-circle__svg--small .voxel-loading-circle__external{stroke-width:var(--ids_size_general_12x)}.voxel-loading-circle__svg--medium{height:var(--ids_size_general_32x);width:var(--ids_size_general_32x)}.voxel-loading-circle__svg--medium .voxel-loading-circle__internal,.voxel-loading-circle__svg--medium .voxel-loading-circle__external{stroke-width:var(--ids_size_general_8x)}.voxel-loading-circle__svg--large{height:var(--ids_size_general_64x);width:var(--ids_size_general_64x)}.voxel-loading-circle__svg--large .voxel-loading-circle__internal,.voxel-loading-circle__svg--large .voxel-loading-circle__external{stroke-width:var(--ids_size_general_5x)}@-webkit-keyframes loading-circle-animation{0%,25%{stroke-dashoffset:265}25%,50%{stroke-dashoffset:200}50%,75%{stroke-dashoffset:200}75%,to{stroke-dashoffset:270}}@keyframes loading-circle-animation{0%,25%{stroke-dashoffset:265}25%,50%{stroke-dashoffset:200}50%,75%{stroke-dashoffset:200}75%,to{stroke-dashoffset:270}}@-webkit-keyframes loading-circle-external{0%{-webkit-transform:rotateZ(0deg);transform:rotate(0)}80%,to{-webkit-animation-delay:.3s;animation-delay:.3s}to{-webkit-transform:rotateZ(360deg);transform:rotate(360deg)}}@keyframes loading-circle-external{0%{-webkit-transform:rotateZ(0deg);transform:rotate(0)}80%,to{-webkit-animation-delay:.3s;animation-delay:.3s}to{-webkit-transform:rotateZ(360deg);transform:rotate(360deg)}}\n"]
            }]
    }], function () { return []; }, { loadingCircleId: [{
            type: Input
        }], size: [{
            type: Input
        }], loadingTitle: [{
            type: Input
        }], ariaPolite: [{
            type: Input
        }], ariaHidden: [{
            type: Input
        }], ariaRole: [{
            type: Input
        }], transparent: [{
            type: Input
        }], inverse: [{
            type: Input
        }], secondary: [{
            type: Input
        }], hideLoading: [{
            type: Input
        }] }); })();

class VoxelLoadingCircleModule {
}
VoxelLoadingCircleModule.ɵfac = function VoxelLoadingCircleModule_Factory(t) { return new (t || VoxelLoadingCircleModule)(); };
VoxelLoadingCircleModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelLoadingCircleModule });
VoxelLoadingCircleModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLoadingCircleModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelLoadingCircleComponent],
                exports: [VoxelLoadingCircleComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelLoadingCircleModule, { declarations: function () { return [VoxelLoadingCircleComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelLoadingCircleComponent]; } }); })();

/**
 * Executa uma ação específica que deve ser claramente expressa por sua literal.
 * Aqui trataremos dos botões primários e secundários
 * (os botões de navegação e de ação são tratados no item "Barra de navegação" e os de "Ir para").
 *
 * *Executes a specific action that must be clearly expressed by its literal.*
 * *Here we'll deal with primary and secondary buttons*
 * *(the navigation and action buttons are treated in the "Barra de navegação" and "Ir para" items).*
 *
 * **Module:**
 *
 * `import { VoxelButtonModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/button?componentOnly=true</example-url>
 *
 * @example Normal
 * <button
 *   id='button1'
 *   voxelButton
 * >
 *  button
 *  </button>
 *
 * @example Desabilitado
 * <button
 *   id='button1'
 *   voxelButton
 *   disabled
 * >
 *  button
 *  </button>
 *
 * @example Secundário
 * <button
 *   id='button1'
 *   voxelButton
 *   buttonStyle='secondary'
 *  >
 *  button
 *  </button>
 *
 * @example Contextual
 * <button
 *   id='button1'
 *   voxelButtonContextual
 * >
 *  button
 *  </button>
 *
 * @example Action
 * <button
 *   id='button1'
 *   voxelButtonAction
 * >
 *  button
 *  </button>
 *
 * @example High-Contrast
 * <button
 *   id='button1'
 *   voxelButton
 *   highContrast
 * >
 *  button
 *  </button>
 *
 * @example Com Icone
 * <button
 *   id='button1'
 *   voxelButton
 * >
 *  button
 *  <voxel-icon>inovacao_outline</voxel-icon>
 *  </button>
 */
class VoxelButtonComponent {
    /**
     * @internal
     */
    constructor(elementRef, la) {
        this.elementRef = elementRef;
        this.la = la;
        this._buttonLoad = false;
        /**
         * Define a posição do icone
         *
         * *Sets the position of the icon*
         */
        this.iconPosition = 'right';
        /**
         * @internal
         */
        this._voxelButton = true;
        /**
         * @internal
         */
        this._voxelButtonContextual = false;
        /**
         * @internal
         */
        this._voxelButtonAction = false;
        /**
         * @internal
         */
        this._highContrast = false;
    }
    /**
     * Define se o botão é contextual
     *
     * *Defines whether the button is contextual*
     */
    set voxelButtonContextual(value) {
        this._voxelButtonContextual = enforceBoolean(value);
    }
    /**
     * Define se o botão é de ação
     *
     * *Defines whether the button is action*
     */
    set voxelButtonAction(value) {
        this._voxelButtonAction = enforceBoolean(value);
    }
    /**
     * Define se o botão é de alto contraste
     *
     * *Sets whether the button is high contrast*
     */
    set highContrast(value) {
        this._highContrast = enforceBoolean(value);
    }
    /**
     * Define se é um botão de load
     *
     * *Set whether it's a load button*
     */
    set buttonLoad(value) {
        const isLoading = enforceBoolean(value);
        const isInitialValue = this._buttonLoad === isLoading;
        this._buttonLoad = enforceBoolean(value);
        if (isInitialValue) {
            return;
        }
        setTimeout(() => {
            if (isLoading && this.ariaLabelValue) {
                this.la.announce(this.ariaLabelValue, 1000);
                return;
            }
            this.la.announce(this.elementRef.nativeElement.textContent.trim(), 1000);
        });
    }
    /**
     * @internal
     */
    get secondary() {
        return this.buttonStyle === 'secondary';
    }
    /**
     * @internal
     */
    get dark() {
        return this.buttonStyle === 'dark';
    }
    /**
     * @internal
     */
    get light() {
        return this.buttonStyle === 'light';
    }
    get ariaLabelValue() {
        var _a;
        return this._buttonLoad ? 'carregando' : (_a = this.ariaLabel) !== null && _a !== void 0 ? _a : null;
    }
}
VoxelButtonComponent.ɵfac = function VoxelButtonComponent_Factory(t) { return new (t || VoxelButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LiveAnnouncer)); };
VoxelButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelButtonComponent, selectors: [["button", "voxelButton", ""], ["button", "voxelButtonContextual", ""], ["button", "voxelButtonAction", ""], ["a", "voxelButton", ""], ["a", "voxelButtonContextual", ""], ["a", "voxelButtonAction", ""]], hostVars: 15, hostBindings: function VoxelButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabelValue);
        ɵngcc0.ɵɵclassProp("voxel-button", ctx._voxelButton)("voxel-button-contextual", ctx._voxelButtonContextual)("voxel-button-action", ctx._voxelButtonAction)("voxel-button--high-contrast", ctx._highContrast)("voxel-button--secondary", ctx.secondary)("voxel-button-contextual--dark", ctx.dark)("voxel-button-contextual--light", ctx.light);
    } }, inputs: { iconPosition: "iconPosition", voxelButtonContextual: "voxelButtonContextual", voxelButtonAction: "voxelButtonAction", highContrast: "highContrast", buttonLoad: "buttonLoad", buttonStyle: "buttonStyle", ariaLabel: ["aria-label", "ariaLabel"] }, attrs: _c14, ngContentSelectors: _c16, decls: 4, vars: 5, consts: [[1, "voxel-button-wrapper"], ["class", "voxel-button-loading", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "voxel-button-loading"], ["size", "small", "loadingTitle", "", 3, "secondary", "inverse"]], template: function VoxelButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c15);
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, VoxelButtonComponent_div_3_Template, 2, 2, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-button-wrapper--icon-left", ctx.iconPosition === "left")("voxel-button-wrapper--load", ctx._buttonLoad);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx._buttonLoad);
    } }, directives: [ɵngcc1.NgIf, VoxelLoadingCircleComponent], styles: [".voxel-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--ids_color_action_primary_base);border:none;border-radius:var(--ids_size_cornerRadius_tags_01);color:var(--ids_color_contrast_onDark);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_label_medium_bold);height:var(--ids_size_general_48x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1;padding:var(--ids_size_general_8x) var(--ids_size_general_16x);position:relative}.voxel-button:disabled{background:var(--ids_color_action_disabled_base);border:none;color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-button:hover:not(:disabled){background:var(--ids_color_action_primary_variant)}.voxel-button .voxel-icon>span{font-size:1rem}@media (min-width: 64rem){.voxel-button{font:var(--ids_textStyle_section_01);font-weight:700;padding:var(--ids_size_general_6x) var(--ids_size_general_24x) var(--ids_size_general_8x)}.voxel-button .voxel-icon>span{font-size:1.5rem}}.voxel-button--secondary{background:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_base)}.voxel-button--secondary:disabled{background:var(--ids_color_bg_variant_01)}.voxel-button--secondary:hover:not(:disabled){background:var(--ids_color_action_secondary_base_soft)}.voxel-button--high-contrast{background:var(--ids_color_contrast_onDark);border:none;color:var(--ids_color_action_primary_base)}.voxel-button--high-contrast:hover:not(:disabled){background:var(--ids_color_contrast_onDark);color:var(--ids_color_action_neutral_variant)}.voxel-button-contextual{background:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_tags_01);color:var(--ids_color_action_secondary_base);font:var(--ids_textStyle_label_small_bold);height:var(--ids_size_general_32x);line-height:1;padding:var(--ids_size_general_6x) var(--ids_size_general_24x) var(--ids_size_general_8x)}.voxel-button-contextual:disabled{background:var(--ids_color_bg_variant_01);border:none;color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-button-contextual:hover:not(:disabled){background:var(--ids_color_action_secondary_base_soft)}.voxel-button-contextual--dark{background:transparent;border-color:var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onLight)}.voxel-button-contextual--dark:disabled{background:var(--ids_color_contrast_onLight_soft);color:var(--ids_color_contrast_onLight_medium)}.voxel-button-contextual--dark:hover:not(:disabled){background:var(--ids_color_contrast_onLight_soft)}.voxel-button-contextual--light{background:transparent;border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-button-contextual--light:disabled{background:var(--ids_color_contrast_onDark_soft);color:var(--ids_color_contrast_onDark_medium)}.voxel-button-contextual--light:hover:not(:disabled){background:var(--ids_color_contrast_onDark_soft)}.voxel-button-action{background:transparent;border:none;color:var(--ids_color_action_secondary_base);font:var(--ids_textStyle_label_medium_bold);height:1.625rem;padding:var(--ids_size_general_8x) 0}.voxel-button-action:disabled{background:transparent;color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-button-action:hover:not(:disabled){background:transparent;color:var(--ids_color_action_secondary_variant)}.voxel-button-action .voxel-icon>span{font-size:1rem}.voxel-button-wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1}.voxel-button-wrapper>voxel-icon{margin-left:var(--ids_size_general_8x)}.voxel-button-wrapper--icon-left{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.voxel-button-wrapper--icon-left voxel-icon{margin-left:0;margin-right:var(--ids_size_general_8x)}.voxel-button-wrapper--load{visibility:hidden}.voxel-button-loading{max-width:auto;position:absolute}\n"], encapsulation: 2 });
VoxelButtonComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: LiveAnnouncer }
];
VoxelButtonComponent.propDecorators = {
    voxelButtonContextual: [{ type: Input }],
    voxelButtonAction: [{ type: Input }],
    highContrast: [{ type: Input }],
    buttonLoad: [{ type: Input }],
    iconPosition: [{ type: Input }],
    buttonStyle: [{ type: Input }],
    secondary: [{ type: HostBinding, args: ['class.voxel-button--secondary',] }],
    dark: [{ type: HostBinding, args: ['class.voxel-button-contextual--dark',] }],
    light: [{ type: HostBinding, args: ['class.voxel-button-contextual--light',] }],
    _voxelButton: [{ type: HostBinding, args: ['class.voxel-button',] }],
    _voxelButtonContextual: [{ type: HostBinding, args: ['class.voxel-button-contextual',] }],
    _voxelButtonAction: [{ type: HostBinding, args: ['class.voxel-button-action',] }],
    _highContrast: [{ type: HostBinding, args: ['class.voxel-button--high-contrast',] }],
    ariaLabel: [{ type: Input, args: ['aria-label',] }],
    ariaLabelValue: [{ type: HostBinding, args: ['attr.aria-label',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelButtonComponent, [{
        type: Component,
        args: [{
                // eslint-disable-next-line @angular-eslint/component-selector
                selector: `
    button[voxelButton], button[voxelButtonContextual], button[voxelButtonAction],
    a[voxelButton], a[voxelButtonContextual], a[voxelButtonAction]
  `,
                template: "<span\n  class=\"voxel-button-wrapper\"\n  [class.voxel-button-wrapper--icon-left]=\"iconPosition === 'left'\"\n  [class.voxel-button-wrapper--load]=\"_buttonLoad\"\n>\n  <ng-content></ng-content>\n  <ng-content select=\"voxel-icon\"></ng-content>\n</span>\n\n<div class=\"voxel-button-loading\" *ngIf=\"_buttonLoad\" aria-hidden=\"true\">\n  <voxel-loading-circle\n    size=\"small\"\n    [secondary]=\"buttonStyle === 'secondary'\"\n    [inverse]=\"_highContrast || buttonStyle === 'secondary' ? false : true\"\n    loadingTitle=\"\"\n  >\n  </voxel-loading-circle>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--ids_color_action_primary_base);border:none;border-radius:var(--ids_size_cornerRadius_tags_01);color:var(--ids_color_contrast_onDark);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_label_medium_bold);height:var(--ids_size_general_48x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1;padding:var(--ids_size_general_8x) var(--ids_size_general_16x);position:relative}.voxel-button:disabled{background:var(--ids_color_action_disabled_base);border:none;color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-button:hover:not(:disabled){background:var(--ids_color_action_primary_variant)}.voxel-button .voxel-icon>span{font-size:1rem}@media (min-width: 64rem){.voxel-button{font:var(--ids_textStyle_section_01);font-weight:700;padding:var(--ids_size_general_6x) var(--ids_size_general_24x) var(--ids_size_general_8x)}.voxel-button .voxel-icon>span{font-size:1.5rem}}.voxel-button--secondary{background:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_base)}.voxel-button--secondary:disabled{background:var(--ids_color_bg_variant_01)}.voxel-button--secondary:hover:not(:disabled){background:var(--ids_color_action_secondary_base_soft)}.voxel-button--high-contrast{background:var(--ids_color_contrast_onDark);border:none;color:var(--ids_color_action_primary_base)}.voxel-button--high-contrast:hover:not(:disabled){background:var(--ids_color_contrast_onDark);color:var(--ids_color_action_neutral_variant)}.voxel-button-contextual{background:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_tags_01);color:var(--ids_color_action_secondary_base);font:var(--ids_textStyle_label_small_bold);height:var(--ids_size_general_32x);line-height:1;padding:var(--ids_size_general_6x) var(--ids_size_general_24x) var(--ids_size_general_8x)}.voxel-button-contextual:disabled{background:var(--ids_color_bg_variant_01);border:none;color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-button-contextual:hover:not(:disabled){background:var(--ids_color_action_secondary_base_soft)}.voxel-button-contextual--dark{background:transparent;border-color:var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onLight)}.voxel-button-contextual--dark:disabled{background:var(--ids_color_contrast_onLight_soft);color:var(--ids_color_contrast_onLight_medium)}.voxel-button-contextual--dark:hover:not(:disabled){background:var(--ids_color_contrast_onLight_soft)}.voxel-button-contextual--light{background:transparent;border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-button-contextual--light:disabled{background:var(--ids_color_contrast_onDark_soft);color:var(--ids_color_contrast_onDark_medium)}.voxel-button-contextual--light:hover:not(:disabled){background:var(--ids_color_contrast_onDark_soft)}.voxel-button-action{background:transparent;border:none;color:var(--ids_color_action_secondary_base);font:var(--ids_textStyle_label_medium_bold);height:1.625rem;padding:var(--ids_size_general_8x) 0}.voxel-button-action:disabled{background:transparent;color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-button-action:hover:not(:disabled){background:transparent;color:var(--ids_color_action_secondary_variant)}.voxel-button-action .voxel-icon>span{font-size:1rem}.voxel-button-wrapper{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1}.voxel-button-wrapper>voxel-icon{margin-left:var(--ids_size_general_8x)}.voxel-button-wrapper--icon-left{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.voxel-button-wrapper--icon-left voxel-icon{margin-left:0;margin-right:var(--ids_size_general_8x)}.voxel-button-wrapper--load{visibility:hidden}.voxel-button-loading{max-width:auto;position:absolute}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc5.LiveAnnouncer }]; }, { iconPosition: [{
            type: Input
        }], _voxelButton: [{
            type: HostBinding,
            args: ['class.voxel-button']
        }], _voxelButtonContextual: [{
            type: HostBinding,
            args: ['class.voxel-button-contextual']
        }], _voxelButtonAction: [{
            type: HostBinding,
            args: ['class.voxel-button-action']
        }], _highContrast: [{
            type: HostBinding,
            args: ['class.voxel-button--high-contrast']
        }], voxelButtonContextual: [{
            type: Input
        }], voxelButtonAction: [{
            type: Input
        }], highContrast: [{
            type: Input
        }], buttonLoad: [{
            type: Input
        }], secondary: [{
            type: HostBinding,
            args: ['class.voxel-button--secondary']
        }], dark: [{
            type: HostBinding,
            args: ['class.voxel-button-contextual--dark']
        }], light: [{
            type: HostBinding,
            args: ['class.voxel-button-contextual--light']
        }], ariaLabelValue: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], buttonStyle: [{
            type: Input
        }], ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }] }); })();

class VoxelButtonModule {
}
VoxelButtonModule.ɵfac = function VoxelButtonModule_Factory(t) { return new (t || VoxelButtonModule)(); };
VoxelButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelButtonModule });
VoxelButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelLoadingCircleModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelLoadingCircleModule],
                declarations: [VoxelButtonComponent],
                exports: [VoxelButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelButtonModule, { declarations: function () { return [VoxelButtonComponent]; }, imports: function () { return [CommonModule, VoxelLoadingCircleModule]; }, exports: function () { return [VoxelButtonComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID$j = 1;
/**
 * @internal
 */
// Desabilitado esse lint pois obriga a classe a ter o sufixo do selector da diretiva
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class VoxelFormSelectionBase {
    constructor(ngControl, elementRef) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.state = '';
        this.labelId = `voxel-form-selection-label-${NEXT_ID$j}`;
        /**
         * @internal
         */
        this._isFocused = false;
        this._rtlDirection = false;
        this._ariaHiddenLabel = false;
        /**
         * @internal
         */
        this.controlId = `voxel-${this.selectorType}-${NEXT_ID$j++}`;
        /**
         * @internal
         */
        this.inputClasses = `voxel-form-selection__input--${this.selectorType}`;
    }
    /** @internal */
    get rtlDirection() {
        return this._rtlDirection;
    }
    /** @internal */
    get ariaHiddenLabel() {
        return this._ariaHiddenLabel;
    }
    get ariaDescribedBy() {
        return this._ariaDescribedBy;
    }
    set ariaDescribedBy(ariaDescribedBy) {
        this._ariaDescribedBy = ariaDescribedBy;
    }
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocus() {
        this._isFocused = true;
    }
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocusout() {
        this._isFocused = false;
    }
    /**
     * @internal
     */
    get selectorType() {
        return 'selector-base';
    }
    /**
     * @internal
     */
    get icon() {
        return '';
    }
    /**
     * @internal
     */
    get iconClasses() {
        return '';
    }
    /**
     * @internal
     */
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    /**
     * @internal
     */
    get control() {
        var _a;
        return (_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control;
    }
    /**
     * @internal
     */
    handleDescribedBy(messageId) {
        const ariaDescribedBy = messageId.length > 0 ? (Array.isArray(messageId) ? messageId.join(' ') : messageId) : null;
        this.ariaDescribedBy = ariaDescribedBy;
    }
}
VoxelFormSelectionBase.ɵfac = function VoxelFormSelectionBase_Factory(t) { return new (t || VoxelFormSelectionBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelFormSelectionBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelFormSelectionBase, selectors: [["do-not-use-voxel-form-selection-base"]], hostVars: 3, hostBindings: function VoxelFormSelectionBase_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function VoxelFormSelectionBase_focus_HostBindingHandler() { return ctx.onFocus(); })("focusout", function VoxelFormSelectionBase_focusout_HostBindingHandler() { return ctx.onFocusout(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.controlId)("class", ctx.inputClasses)("aria-describedby", ctx.ariaDescribedBy);
    } }, inputs: { ariaDescribedBy: ["aria-describedby", "ariaDescribedBy"] } });
VoxelFormSelectionBase.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef }
];
VoxelFormSelectionBase.propDecorators = {
    controlId: [{ type: HostBinding, args: ['attr.id',] }],
    ariaDescribedBy: [{ type: HostBinding, args: ['attr.aria-describedby',] }, { type: Input, args: ['aria-describedby',] }],
    inputClasses: [{ type: HostBinding, args: ['attr.class',] }],
    onFocus: [{ type: HostListener, args: ['focus',] }],
    onFocusout: [{ type: HostListener, args: ['focusout',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionBase, [{
        type: Directive,
        args: [{
                // é uma diretiva que não pode ser usada, é apenas a base do checkbox, radio e switch
                // precisa ser declarada como diretiva por conta do ngControl, HostBinding e HostListener
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: 'do-not-use-voxel-form-selection-base'
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { controlId: [{
            type: HostBinding,
            args: ['attr.id']
        }], inputClasses: [{
            type: HostBinding,
            args: ['attr.class']
        }], ariaDescribedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }, {
            type: Input,
            args: ['aria-describedby']
        }], 
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocusout: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();

/**
 * Diretiva para utilização do Checkbox dentro do componente form-selection
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelCheckboxModule } from '@voxel/components';`
 *
 * * <example-url>../../demo/index.html#/portfolio/checkbox?componentOnly=true</example-url>
 *
 *  **Acessibilidade:**
 *
 *  A marcação de checkbox indeterminado não é lida pelo Android Talkback e no iOS VoiceOver
 *  é verbalizado como "marcado". No entanto, para o NVDA é bem suportado. Use esse caso apenas
 *  se estritamente necessário, até que ele haja melhor compatibilidade com as tecnologias assistivas citadas.
 *
 * @example Checkbox simples
 *  <voxel-form-selection>
 *             <input type="checkbox" formControlName="simple" voxelCheckbox />
 *             simples
 *  </voxel-form-selection>
 *
 * @example Checkbox selecionado
 *  <voxel-form-selection>
 *             <input type="checkbox" formControlName="selected" voxelCheckbox checked />
 *             selecionado
 *  </voxel-form-selection>
 *
 * @example Checkbox Group
 * <voxel-form-selection *ngFor="let item of checkboxItems.items; let i = index">
 *             <input type="checkbox" [value]="item.value" [name]="checkboxItems.name" voxelCheckbox />
 *             {{ item.label }}
 * </voxel-form-selection>
 */
class VoxelCheckboxDirective extends VoxelFormSelectionBase {
    /**
     * @internal
     */
    get selectorType() {
        return 'checkbox';
    }
    /**
     * @internal
     */
    get icon() {
        return this.nativeElement.indeterminate
            ? 'checkbox_indeterminado'
            : this.nativeElement.checked
                ? 'checkbox'
                : 'checkbox_vazio';
    }
    /**
     * @internal
     */
    get iconClasses() {
        return {
            'voxel-form-selection__checkbox': true,
            'voxel-form-selection__checkbox--checked': this.nativeElement.checked,
            'voxel-form-selection__checkbox--indeterminate': this.nativeElement.indeterminate,
            'voxel-form-selection__checkbox--empty': !this.nativeElement.indeterminate && !this.nativeElement.checked,
            'voxel-form-selection__checkbox--disabled': this.nativeElement.disabled,
            'voxel-form-selection__checkbox--focus': this._isFocused,
            'voxel-form-selection__checkbox--invalid': this.state === 'invalid',
        };
    }
}
VoxelCheckboxDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelCheckboxDirective_BaseFactory; return function VoxelCheckboxDirective_Factory(t) { return (ɵVoxelCheckboxDirective_BaseFactory || (ɵVoxelCheckboxDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelCheckboxDirective)))(t || VoxelCheckboxDirective); }; }();
VoxelCheckboxDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelCheckboxDirective, selectors: [["", "voxelCheckbox", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: VoxelFormSelectionBase, useExisting: VoxelCheckboxDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelCheckboxDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelCheckbox]',
                providers: [{ provide: VoxelFormSelectionBase, useExisting: VoxelCheckboxDirective }]
            }]
    }], null, null); })();

class VoxelCheckboxModule {
}
VoxelCheckboxModule.ɵfac = function VoxelCheckboxModule_Factory(t) { return new (t || VoxelCheckboxModule)(); };
VoxelCheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelCheckboxModule });
VoxelCheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelCheckboxDirective],
                exports: [VoxelCheckboxDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelCheckboxModule, { declarations: function () { return [VoxelCheckboxDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelCheckboxDirective]; } }); })();

/**
 * @internal
 */
let NEXT_ID$i = 0;
/**
 * @internal
 */
let NEXT_OPTION_ID = 0;
/**
 * Chips são elementos  que representam uma entrada, como uma escolha de categorias,
 * ou filtros dentre múltiplas opções
 *
 * *Chips are elements that represents an input, like a choice of categories,*
 * *or filters between multiple options*
 *
 * **Module:**
 *
 * `import { VoxelChipsModule } from '@voxel/components';`
 *
 *  <example-url>../../demo/#/portfolio/chips?componentOnly=true</example-url>
 *
 * @example filter
 * <voxel-chips
 *             label="Selecione um ou mais filtros"
 *             type="filter"
 *             [options]="[
 *                { label: 'opção 1', value: 'opt1', icon: favorito },
 *                { label: 'opção 2', value: 'opt2', disabled: true },
 *                { label: 'opção 3', value: 'opt3' },
 *             ]"
 * ></voxel-chips>
 *
 * @example choice
 * <voxel-chips
 *             label="Escolha uma opção"
 *             type="choice"
 *             [options]="[
 *               { label: 'opção 1', value: 'opt1' },
 *               { label: 'opção 2', value: 'opt2' },
 *               { label: 'opção 3', value: 'opt3' },
 *             ]"
 * ></voxel-chips>
 *
 */
class VoxelChipsComponent {
    constructor() {
        this.optionsView = [];
        this._options = [];
        this._disabled = false;
        /**
         * Id do componente
         *
         * *Chips id*
         */
        this.controlId = `voxel-chips-${NEXT_ID$i++}`;
        /**
         * Label do grupo de opções
         *
         * *Label (legend)*
         */
        this.label = '';
        /**
         * Evento disparado ao alterar o valor(es) selectionados
         *
         * Observação: para o filter, dispara todas as opções
         * com a propriedade selected de acordo com a seleção do usuário.
         * E para o choice, dispara apenas a opção selecionada
         *
         * *Fired event when change selected values*
         * *Note: for filter, it triggers all options with selected property checked as user's selection.*
         * *And for choice, it triggers only the selected option*
         *
         */
        this.changeChips = new EventEmitter();
    }
    /**
     * Tipo do componente
     *
     * *Type of the component*
     *
     * Variações:
     *
     * *Variations:*
     *
     * * choice;
     * * filter;
     *
     * Observação:
     * O choice é usado para selecionar apenas uma opção, enquanto no filter pode-se selecionar várias opções
     *
     * *Note:*
     * *Choice is used to select just one option whereas filter can be used to select multiple options*
     *
     */
    set type(value) {
        this._type = value;
    }
    get type() {
        return this._type;
    }
    /**
     * Opções que serão exibidas
     *
     * Nesta propriedade deve ser definido um array de objetos que implementam a interface VoxelChipsOption
     *
     * *Chips options*
     *
     * *In this property must be defined an object array that implements VoxelChipsOption interface*
     */
    set options(options) {
        this._options = options !== null && options !== void 0 ? options : [];
        this.removeDuplicatedOptions();
        this.handleOptions(this._options);
    }
    get options() {
        return this._options;
    }
    /**
     * Desabilita todos os itens do chips
     *
     * *Disable all chips items*
     *
     */
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * @internal
     */
    removeDuplicatedOptions() {
        this.options.forEach((option, index) => {
            const duplicatedIndex = this.options.findIndex((optionFind) => optionFind.value === option.value) === index;
            if (!duplicatedIndex) {
                this.options.splice(this.options.indexOf(option), 1);
            }
        });
    }
    /**
     * @internal
     */
    handleOptions(optionsList) {
        this.optionsView = optionsList.map((option) => (Object.assign(Object.assign({}, option), { id: `voxel-chips-option-${NEXT_OPTION_ID++}`, name: `${this.controlId}-${this.type}`, selected: Boolean(option.selected), disabled: Boolean(option.disabled), icon: this.type === 'choice' ? option.icon : option.selected ? 'check' : '' })));
    }
    /**
     * @internal
     * Dispara o evento com a opção/opções que foi/foram alteradas
     */
    changeOptions(_event) {
        const options = this.optionsView;
        const target = _event.target;
        const targetOption = options.find((option) => option.id === target.id);
        if (!targetOption) {
            return;
        }
        targetOption.selected = target.checked;
        if (this.type === 'filter') {
            targetOption.icon = targetOption.selected ? 'check' : '';
            this.changeChips.emit(options);
            return;
        }
        this.changeChips.emit(targetOption);
    }
}
VoxelChipsComponent.ɵfac = function VoxelChipsComponent_Factory(t) { return new (t || VoxelChipsComponent)(); };
VoxelChipsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelChipsComponent, selectors: [["voxel-chips"]], inputs: { controlId: "controlId", label: "label", type: "type", options: "options", disabled: "disabled" }, outputs: { changeChips: "changeChips" }, decls: 4, vars: 3, consts: [[1, "voxel-chips-group", 3, "id"], ["class", "voxel-chips-group__legend", 4, "ngIf"], [1, "voxel-chips-group__options"], ["class", "voxel-chips-group__item", 4, "ngFor", "ngForOf"], [1, "voxel-chips-group__legend"], [1, "voxel-chips-group__item"], [1, "voxel-chips"], [1, "voxel-chips__input", 3, "id", "type", "value", "disabled", "name", "checked", "change"], [1, "voxel-chips__content"], ["size", "S", 1, "voxel-chips__icon"], [1, "voxel-chips__label", 3, "for"]], template: function VoxelChipsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵtemplate(1, VoxelChipsComponent_legend_1_Template, 2, 1, "legend", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, VoxelChipsComponent_div_3_Template, 8, 13, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.controlId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.optionsView);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, VoxelIconComponent], styles: [".voxel-chips-group__legend[_ngcontent-%COMP%]{color:var(--ids_color_action_neutral_base);margin-bottom:var(--ids_size_general_8x)}.voxel-chips-group__options[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.voxel-chips-group__item[_ngcontent-%COMP%]{margin:0 var(--ids_size_general_8x) var(--ids_size_general_8x) 0}.voxel-chips[_ngcontent-%COMP%]{position:relative}.voxel-chips__icon[_ngcontent-%COMP%]{opacity:0;position:absolute;-webkit-transform:translate(var(--ids_size_general_16x),.375rem);transform:translate(var(--ids_size_general_16x),.375rem);-webkit-transition:opacity .1s linear;transition:opacity .1s linear}.voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_action_secondary_base);cursor:pointer;font-size:inherit;padding:var(--ids_size_general_2x) var(--ids_size_general_28x) var(--ids_size_general_4x);-webkit-transition:color .2s linear,-webkit-transform .1s ease;transition:color .2s linear,-webkit-transform .1s ease;transition:transform .1s ease,color .2s linear;transition:transform .1s ease,color .2s linear,-webkit-transform .1s ease}.voxel-chips--withIcon[_ngcontent-%COMP%]   .voxel-chips__icon[_ngcontent-%COMP%]{opacity:1;-webkit-transition:opacity .1s linear .1s;transition:opacity .1s linear .1s}.voxel-chips--withIcon[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{-webkit-transform:translateX(var(--ids_size_general_10x));transform:translate(var(--ids_size_general_10x));-webkit-transition:color .2s linear,-webkit-transform .1s ease .1s;transition:color .2s linear,-webkit-transform .1s ease .1s;transition:transform .1s ease .1s,color .2s linear;transition:transform .1s ease .1s,color .2s linear,-webkit-transform .1s ease .1s}.voxel-chips__content[_ngcontent-%COMP%]{border:var(--ids_size_general_1x) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_layout_01);-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--ids_color_action_secondary_base);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:.8125rem;position:relative;-webkit-transition:background-color .2s linear;transition:background-color .2s linear;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.voxel-chips__input[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;height:100%;position:absolute;width:100%}.voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]{background:var(--ids_color_action_secondary_base);color:var(--ids_color_contrast_onDark)}.voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]{background:var(--ids_color_bg_base);border:var(--ids_size_general_1x) solid var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_base);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.voxel-chips__input[_ngcontent-%COMP%]:hover:not(.voxel-chips__input:disabled, .voxel-chips__input[_ngcontent-%COMP%]:checked) + .voxel-chips__content[_ngcontent-%COMP%]{background:var(--ids_color_action_secondary_base_soft)}}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-chips__input[_ngcontent-%COMP%]{opacity:0}.voxel-chips__input[_ngcontent-%COMP%]:focus + .voxel-chips__content[_ngcontent-%COMP%]{outline:var(--ids_size_general_1x) dotted var(--ids_color_contrast_onLight)}}"] });
VoxelChipsComponent.propDecorators = {
    type: [{ type: Input }],
    controlId: [{ type: Input }],
    label: [{ type: Input }],
    options: [{ type: Input }],
    disabled: [{ type: Input }],
    changeChips: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelChipsComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-chips',
                template: "<fieldset [id]=\"controlId\" class=\"voxel-chips-group\">\n  <legend class=\"voxel-chips-group__legend\" *ngIf=\"label\">{{ label }}</legend>\n  <div class=\"voxel-chips-group__options\">\n    <div *ngFor=\"let option of optionsView\" class=\"voxel-chips-group__item\">\n      <div class=\"voxel-chips\" [class]=\"{ 'voxel-chips--withIcon': option.icon }\">\n        <input class=\"voxel-chips__input\"\n          [id]=\"option.id\"\n          [type]=\"type === 'filter' ? 'checkbox' : 'radio'\"\n          [value]=\"option.value\"\n          [disabled]=\"option.disabled || disabled\"\n          [name]=\"option.name\"\n          [checked]=\"option.selected\"\n          (change)=\"changeOptions($event)\"\n        />\n        <div class=\"voxel-chips__content\">\n          <voxel-icon class=\"voxel-chips__icon\" size=\"S\">{{ option.icon }}</voxel-icon>\n          <label class=\"voxel-chips__label\" [for]=\"option.id\">\n            {{ option.label }}\n          </label>\n        </div>\n      </div>\n    </div>\n  </div>\n</fieldset>\n",
                styles: [".voxel-chips-group__legend{color:var(--ids_color_action_neutral_base);margin-bottom:var(--ids_size_general_8x)}.voxel-chips-group__options{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.voxel-chips-group__item{margin:0 var(--ids_size_general_8x) var(--ids_size_general_8x) 0}.voxel-chips{position:relative}.voxel-chips__icon{opacity:0;position:absolute;-webkit-transform:translate(var(--ids_size_general_16x),.375rem);transform:translate(var(--ids_size_general_16x),.375rem);-webkit-transition:opacity .1s linear;transition:opacity .1s linear}.voxel-chips__label{color:var(--ids_color_action_secondary_base);cursor:pointer;font-size:inherit;padding:var(--ids_size_general_2x) var(--ids_size_general_28x) var(--ids_size_general_4x);-webkit-transition:color .2s linear,-webkit-transform .1s ease;transition:color .2s linear,-webkit-transform .1s ease;transition:transform .1s ease,color .2s linear;transition:transform .1s ease,color .2s linear,-webkit-transform .1s ease}.voxel-chips--withIcon .voxel-chips__icon{opacity:1;-webkit-transition:opacity .1s linear .1s;transition:opacity .1s linear .1s}.voxel-chips--withIcon .voxel-chips__label{-webkit-transform:translateX(var(--ids_size_general_10x));transform:translate(var(--ids_size_general_10x));-webkit-transition:color .2s linear,-webkit-transform .1s ease .1s;transition:color .2s linear,-webkit-transform .1s ease .1s;transition:transform .1s ease .1s,color .2s linear;transition:transform .1s ease .1s,color .2s linear,-webkit-transform .1s ease .1s}.voxel-chips__content{border:var(--ids_size_general_1x) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_layout_01);-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--ids_color_action_secondary_base);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:.8125rem;position:relative;-webkit-transition:background-color .2s linear;transition:background-color .2s linear;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.voxel-chips__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;height:100%;position:absolute;width:100%}.voxel-chips__input:checked+.voxel-chips__content{background:var(--ids_color_action_secondary_base);color:var(--ids_color_contrast_onDark)}.voxel-chips__input:checked+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onDark)}.voxel-chips__input:disabled+.voxel-chips__content{background:var(--ids_color_bg_base);border:var(--ids_size_general_1x) solid var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-chips__input:disabled+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_action_disabled_base);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.voxel-chips__input:hover:not(.voxel-chips__input:disabled,.voxel-chips__input:checked)+.voxel-chips__content{background:var(--ids_color_action_secondary_base_soft)}}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-chips__input{opacity:0}.voxel-chips__input:focus+.voxel-chips__content{outline:var(--ids_size_general_1x) dotted var(--ids_color_contrast_onLight)}}\n"]
            }]
    }], function () { return []; }, { controlId: [{
            type: Input
        }], label: [{
            type: Input
        }], changeChips: [{
            type: Output
        }], type: [{
            type: Input
        }], options: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();

class VoxelChipsModule {
}
VoxelChipsModule.ɵfac = function VoxelChipsModule_Factory(t) { return new (t || VoxelChipsModule)(); };
VoxelChipsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelChipsModule });
VoxelChipsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelChipsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelChipsComponent],
                exports: [VoxelChipsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelChipsModule, { declarations: function () { return [VoxelChipsComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelChipsComponent]; } }); })();

/**
 * @internal
 */
function VoxelCurrencyMaskMixin(base) {
    return class extends base {
        constructor(...args) {
            super(...args);
            /**
             * @internal
             */
            this.currencyTemplate = {
                allowNegative: false,
                decimal: ',',
                precision: 2,
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
            };
            /**
             * @internal
             */
            this.currencyMask = (rawValue, config) => {
                const { allowNegative, decimal, precision, thousands, prefix, suffix } = Object.assign(Object.assign({}, this.currencyTemplate), config);
                if (rawValue === '') {
                    return {
                        mask: this.regExpMask(prefix + suffix),
                        valueMask: '',
                        value: '',
                    };
                }
                const onlyNumbers = this.removeMask(rawValue, true);
                let newRawValue = onlyNumbers
                    .slice(0, onlyNumbers.length - precision)
                    .replace(/^0*/g, '')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
                if (newRawValue === '') {
                    newRawValue = '0';
                }
                newRawValue = newRawValue.replace(/\B(?=([0-9]{3})+(?![0-9]))/g, thousands);
                const decimalPart = onlyNumbers.slice(onlyNumbers.length - precision);
                const decimalValue = parseInt(decimalPart, 10) || 0;
                let newValue = parseInt(newRawValue, 10) + decimalValue / 100;
                newValue = rawValue.indexOf('-') > -1 ? -newValue : newValue;
                if (precision > 0) {
                    if (newRawValue === '0' && decimalPart.length < precision) {
                        newRawValue += decimal + '0'.repeat(precision - 1) + decimalPart;
                    }
                    else {
                        newRawValue += decimal + decimalPart;
                    }
                }
                const operator = rawValue.indexOf('-') > -1 && allowNegative && newValue !== 0 ? '-' : '';
                const cleanValue = parseFloat(newRawValue.split(thousands).join('').replace(decimal, '.')).toFixed(2);
                return {
                    mask: this.regExpMask(operator + prefix + newRawValue + suffix),
                    valueMask: newRawValue,
                    value: cleanValue,
                };
            };
            this.currencyTemplate = Object.assign(Object.assign({}, this.currencyTemplate), args[0]);
        }
    };
}

/**
 * @internal
 */
function VoxelDateMaskMixin(base) {
    return class DateMask extends base {
        constructor(...args) {
            super(...args);
            /** @internal */
            this.dateTemplate = {
                format: 'dd/mm/yyyy',
            };
            /** @internal */
            this.dateMask = (rawValue, config) => {
                const format = (config === null || config === void 0 ? void 0 : config.format) || this.dateTemplate.format;
                const formattedValue = [];
                let i = 0;
                format.split('').forEach((v) => {
                    if (/([^dmyHMS])/.test(v)) {
                        if (/[^0-9]/.test(rawValue.split('')[i])) {
                            i++;
                        }
                        formattedValue.push(v);
                        return;
                    }
                    formattedValue.push(/[^0-9]/.test(rawValue.split('')[i]) ? '' : rawValue.split('')[i]);
                    i++;
                });
                const formatArray = format.split(/([^dmyHMS])/);
                const yearIndex = format
                    .split(/([^dmyHMS])/)
                    .findIndex((year) => year.includes('yy'));
                const dayRegex = [/[0-9]/, /[0-9]/];
                const monthRegex = [/[0-9]/, /[0-9]/];
                const yearRegex = formatArray[yearIndex].length > 2
                    ? [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
                    : [/[0-9]/, /[0-9]/];
                formatArray.splice(formatArray.indexOf('dd'), 1, ...dayRegex);
                formatArray.splice(formatArray.indexOf('mm'), 1, ...monthRegex);
                formatArray.splice(formatArray.indexOf('yyyy' || 'yy'), 1, ...yearRegex);
                return formatArray;
            };
            this.dateTemplate = Object.assign(Object.assign({}, this.dateTemplate), args[1]);
        }
    };
}

/**
 * @internal
 */
const CURRENCY_CONFIG = new InjectionToken('currency.config');
/**
 * @internal
 */
const DATE_CONFIG = new InjectionToken('date.config');
/**
 * @internal
 */
class VoxelMaskdBase {
    constructor(iCurrencyConfig, iDateConfig) {
        this.iCurrencyConfig = iCurrencyConfig;
        this.iDateConfig = iDateConfig;
    }
}
/**
 * @internal
 */
class VoxelMaskService extends VoxelCurrencyMaskMixin(VoxelDateMaskMixin(VoxelMaskdBase)) {
    constructor(iCurrencyConfig, iDateConfig) {
        super(iCurrencyConfig, iDateConfig) /* istanbul ignore next */;
        this.iCurrencyConfig = iCurrencyConfig;
        this.iDateConfig = iDateConfig;
        /**
         * @internal
         */
        this.placeholderChar = '_';
    }
    /**
     * @internal
     */
    removeMask(value, keepOnlyDigits = false) {
        const regex = keepOnlyDigits ? /\D/g : /[^A-Za-z0-9]/g;
        return this.valueIsNotEmpty(value) ? value.replace(regex, '') : '';
    }
    /**
     * @internal
     */
    valueIsNotEmpty(value) {
        return value && value !== '';
    }
    /**
     * @internal
     */
    regExpMask(mask) {
        return mask
            .split('')
            .map((item) => (Number.isNaN(parseInt(item, 10)) ? item : new RegExp(/[0-9]/)));
    }
    /**
     * @internal
     */
    convertMaskToPlaceholder(mask) {
        return mask.map((char) => (char instanceof RegExp ? this.placeholderChar : char)).join('');
    }
    /**
     * @internal
     */
    valueWithMask(rawValue = '', mask, previousConformedValue = '', currentCaretPosition = 0, guide = false, keepCharPositions = false, allowLeadingZeros = false, config) {
        let cleanValue = '';
        if (typeof mask === 'function') {
            const newMask = mask(rawValue, config);
            // eslint-disable-next-line no-param-reassign
            mask = newMask.mask ? newMask.mask : newMask;
            // eslint-disable-next-line no-param-reassign
            rawValue = Object.prototype.hasOwnProperty.call(newMask, 'valueMask')
                ? newMask.valueMask
                : rawValue;
            cleanValue = Object.prototype.hasOwnProperty.call(newMask, 'value')
                ? newMask.value
                : cleanValue;
        }
        if (allowLeadingZeros) {
            const onlyNumbers = this.removeMask(rawValue, true);
            let length = 0;
            mask
                .map((char) => {
                length = char instanceof RegExp ? length + 1 : length;
            })
                .join('');
            let newRawValue = onlyNumbers.replace(/^0*/g, '');
            if (newRawValue.length > length) {
                newRawValue = onlyNumbers.slice(0, -1);
            }
            // eslint-disable-next-line no-param-reassign
            rawValue = ('0'.repeat(length - newRawValue.length) + newRawValue);
        }
        const suppressGuide = guide === false && previousConformedValue !== undefined;
        const maskString = this.convertMaskToPlaceholder(mask);
        const editDistance = rawValue.length - previousConformedValue.length;
        const isAddition = editDistance > 0;
        const indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0);
        const indexOfLastChange = indexOfFirstChange + Math.abs(editDistance);
        let conformedValue = '';
        if (!isAddition && keepCharPositions) {
            let compensatingPlaceholderChars = '';
            for (let i = indexOfFirstChange; i < indexOfLastChange; i++) {
                if (maskString[i] === this.placeholderChar) {
                    compensatingPlaceholderChars += this.placeholderChar;
                }
            }
            // eslint-disable-next-line no-param-reassign
            rawValue =
                rawValue.slice(0, indexOfFirstChange) +
                    compensatingPlaceholderChars +
                    rawValue.slice(indexOfFirstChange, rawValue.length);
        }
        const rawValueArr = rawValue.split('').map((char, i) => ({
            char,
            isNew: i >= indexOfFirstChange && i < indexOfLastChange,
        }));
        for (let i = rawValue.length - 1; i >= 0; i--) {
            if (rawValueArr[i].char !== this.placeholderChar) {
                const shouldOffset = i >= indexOfFirstChange && previousConformedValue.length === mask.length;
                if (rawValueArr[i].char === maskString[shouldOffset ? i - editDistance : i]) {
                    rawValueArr.splice(i, 1);
                }
            }
            break;
        }
        placeholderLoop: for (let i = 0; i < maskString.length; i++) {
            if (maskString[i] === this.placeholderChar) {
                if (rawValueArr.length > 0) {
                    while (rawValueArr.length > 0) {
                        const rawValueShift = rawValueArr.shift();
                        if (rawValueShift && this.placeholderChar === rawValueShift.char && !suppressGuide) {
                            conformedValue += this.placeholderChar;
                            continue placeholderLoop;
                        }
                        if (rawValueShift && mask[i].test(rawValueShift.char)) {
                            if (!keepCharPositions ||
                                !rawValueShift.isNew ||
                                previousConformedValue === '' ||
                                !guide ||
                                !isAddition) {
                                conformedValue += rawValueShift.char;
                            }
                            else {
                                let indexOfNextAvailablePlaceholderChar = null;
                                for (let index = 0; rawValueArr.length > index; index++) {
                                    const charData = rawValueArr[index];
                                    if (charData.char !== this.placeholderChar && !charData.isNew) {
                                        break;
                                    }
                                    if (charData.char === this.placeholderChar) {
                                        indexOfNextAvailablePlaceholderChar = index;
                                        break;
                                    }
                                }
                                if (indexOfNextAvailablePlaceholderChar !== null) {
                                    conformedValue += rawValueShift.char;
                                    rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1);
                                }
                                else {
                                    i--;
                                }
                            }
                            continue placeholderLoop;
                        }
                    }
                }
                if (!suppressGuide) {
                    conformedValue += maskString.substr(i, maskString.length);
                }
                break;
            }
            conformedValue += maskString[i];
        }
        if (suppressGuide && !isAddition) {
            let indexOfLastFilledPlaceholderChar = null;
            for (let i = 0; i < conformedValue.length; i++) {
                if (maskString[i] === this.placeholderChar) {
                    indexOfLastFilledPlaceholderChar = i;
                }
            }
            if (indexOfLastFilledPlaceholderChar !== null) {
                conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1);
            }
            else {
                conformedValue = '';
            }
        }
        cleanValue = this.valueIsNotEmpty(cleanValue) ? cleanValue : this.removeMask(conformedValue);
        return {
            valueMask: conformedValue,
            placeholder: maskString,
            value: cleanValue,
        };
    }
    /**
     * @internal
     */
    adjustCaretPosition(rawValue = '', conformedValue, placeholder, currentCaretPosition, previousConformedValue = '', isGuide = false, isAllowLeadingZeros = false, keepCharPositions = false, isDateMask = false, caretTrapIndexes = []) {
        if (currentCaretPosition === 0 || !rawValue.length) {
            return 0;
        }
        const rawValueLength = rawValue.length;
        const previousConformedValueLength = previousConformedValue.length;
        const placeholderLength = placeholder.length;
        const conformedValueLength = conformedValue.length;
        const editLength = rawValueLength - previousConformedValueLength;
        const isAddition = editLength > 0;
        const possiblyHasRejectedChar = isAddition && (previousConformedValue === conformedValue || conformedValue === placeholder);
        if ((!keepCharPositions || (keepCharPositions && isAddition) || isAllowLeadingZeros) &&
            (!isGuide || (isGuide && !isAddition)) &&
            (!isAllowLeadingZeros || (isAllowLeadingZeros && !isAddition)) &&
            conformedValueLength === previousConformedValueLength &&
            !possiblyHasRejectedChar &&
            conformedValue !== previousConformedValue) {
            return currentCaretPosition + 1;
        }
        let startingSearchIndex = 0;
        let targetChar = '';
        if (possiblyHasRejectedChar) {
            startingSearchIndex = currentCaretPosition - editLength;
        }
        else {
            const normalizedConformedValue = conformedValue.toLowerCase();
            const normalizedRawValue = rawValue.toLowerCase();
            const leftHalfChars = normalizedRawValue.substr(0, currentCaretPosition).split('');
            const intersection = leftHalfChars.filter((char) => normalizedConformedValue.indexOf(char) !== -1);
            targetChar = intersection[intersection.length - 1];
            const countTargetCharInIntersection = intersection.filter((char) => char === targetChar).length;
            const countTargetCharInPlaceholder = placeholder
                .substr(0, placeholder.indexOf(this.placeholderChar))
                .split('')
                .filter((char, index) => char === targetChar && rawValue[index] !== char).length;
            const requiredNumberOfMatches = countTargetCharInPlaceholder + countTargetCharInIntersection;
            let numberOfEncounteredMatches = 0;
            for (let i = 0; i < conformedValueLength; i++) {
                const conformedValueChar = normalizedConformedValue[i];
                startingSearchIndex = i + 1;
                if (conformedValueChar === targetChar) {
                    numberOfEncounteredMatches++;
                }
                if (numberOfEncounteredMatches >= requiredNumberOfMatches) {
                    break;
                }
            }
        }
        if (isAddition) {
            let lastPlaceholderChar = startingSearchIndex;
            for (let i = startingSearchIndex; i <= placeholderLength; i++) {
                if (placeholder[i] === this.placeholderChar) {
                    lastPlaceholderChar = i;
                }
                if (placeholder[i] === this.placeholderChar ||
                    (caretTrapIndexes && caretTrapIndexes.indexOf(i) !== -1) ||
                    i === placeholderLength) {
                    return lastPlaceholderChar;
                }
            }
        }
        for (let i = startingSearchIndex; i >= 0; i--) {
            const isDateMaskSeparator = isDateMask && placeholder[i - 1].search(/[\/-]/g) !== -1;
            if (placeholder[i - 1] === this.placeholderChar ||
                isDateMaskSeparator ||
                caretTrapIndexes.indexOf(i) !== -1 ||
                i === 0) {
                return i;
            }
        }
        return;
    }
}
VoxelMaskService.ɵfac = function VoxelMaskService_Factory(t) { return new (t || VoxelMaskService)(ɵngcc0.ɵɵinject(CURRENCY_CONFIG, 8), ɵngcc0.ɵɵinject(DATE_CONFIG, 8)); };
VoxelMaskService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: VoxelMaskService, factory: VoxelMaskService.ɵfac });
VoxelMaskService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [CURRENCY_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DATE_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelMaskService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [CURRENCY_CONFIG]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DATE_CONFIG]
            }] }]; }, null); })();

/**
 * Diretiva para utilização de mascaras personalizadas em inputs
 *
 * **Module:**
 *
 * `import { VoxelMaskModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/inputmask?componentOnly=true</example-url>
 *
 * @example <input voxelMask="(99) 99999-9999">
 * @example <input voxelMask="(99) 99999-9999" guide>
 * @example <input voxelMask="(99) 99999-9999" keepCharPositions>
 * @example <input voxelMask="currency">
 * @example <input voxelMask="currency" liveAnnouncer>
 * @example <input voxelMask="currency" [config]="minhaConfig">
 * @example <input [voxelMask]="minhaMascara">
 * @example <input [voxelMask]="minhaMascara" shouldKeepMask>
 * @example <voxel-form-field><input voxelInput voxelMask="(99) 99999-9999"></voxel-form-field>
 * @example <voxel-form-field><input voxelInput voxelMask="(99) 99999-9999" guide></voxel-form-field>
 * @example <voxel-form-field><input voxelInput voxelMask="(99) 99999-9999" keepCharPositions></voxel-form-field>
 * @example <voxel-form-field><input voxelInput voxelMask="currency"></voxel-form-field>
 * @example <voxel-form-field><input voxelInput voxelMask="currency" liveAnnouncer></voxel-form-field>
 * @example <voxel-form-field><input voxelInput voxelMask="currency" [config]="minhaConfig"></voxel-form-field>
 * @example <voxel-form-field><input voxelInput [voxelMask]="minhaMascara"></voxel-form-field>
 * @example <voxel-form-field><input voxelInput [voxelMask]="minhaMascara" shouldKeepMask></voxel-form-field>
 *
 */
class VoxelMaskDirective {
    constructor(ngControl, elementRef, voxelMaskService, renderer, la) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.voxelMaskService = voxelMaskService;
        this.renderer = renderer;
        this.la = la;
        /**
         * @internal
         */
        this._guide = false;
        /**
         * @internal
         */
        this._allowLeadingZeros = false;
        /**
         * @internal
         */
        this._shouldKeepMask = false;
        /**
         * @internal
         */
        this._keepCharPositions = false;
        /**
         * @internal
         */
        this._liveAnnouncer = false;
        /**
         *  Configuração da mascara de moeda.
         *
         * *currency mask configuration.*
         */
        this.config = {};
        /**
         * @internal
         */
        // eslint-disable-next-line
        this._onChange = (_) => { };
        /**
         * @internal
         */
        // eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
        this._onTouched = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    /**
     *  Valor do input.
     *
     * *Input value.*
     */
    set value(value) {
        if (value !== this._value) {
            this._value = value;
            this._onChange(value);
        }
    }
    get value() {
        return this._value;
    }
    /** @internal */
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    get disabled() {
        return (this._disabled ||
            (this.ngControl ? (this.ngControl.disabled && !this.controlValue) || null : null));
    }
    /** @internal */
    set readonly(value) {
        this._readonly = enforceBoolean(value);
    }
    get readonly() {
        return (this._readonly ||
            (this.ngControl ? (this.ngControl.disabled && !!this.controlValue) || null : null));
    }
    /**
     *  Máscara com guia.
     *
     * *Mask with guide.*
     */
    set guide(guide) {
        this._guide = enforceBoolean(guide);
    }
    get guide() {
        return this._guide;
    }
    /**
     *  Máscara com guia a esquerda.
     *
     * *Left-guided mask.*
     */
    set allowLeadingZeros(allowLeadingZeros) {
        this._allowLeadingZeros = enforceBoolean(allowLeadingZeros);
    }
    get allowLeadingZeros() {
        return this._allowLeadingZeros;
    }
    /**
     *  Deve manter a máscara.
     *
     * *should Keep Mask.*
     */
    set shouldKeepMask(keepMask) {
        this._shouldKeepMask = enforceBoolean(keepMask);
    }
    get shouldKeepMask() {
        return this._shouldKeepMask;
    }
    /**
     *  Anunciar o valor ao preencher.
     *
     * *Announce the amount when filling.*
     */
    set liveAnnouncer(liveAnnouncer) {
        this._liveAnnouncer = enforceBoolean(liveAnnouncer);
    }
    get liveAnnouncer() {
        return this._liveAnnouncer;
    }
    /**
     *  Quantidade máxima de caracteres.
     *
     * *Maximum amount of characters.*
     */
    set maxLength(maxLength) {
        this._maxLength = enforceNumber(maxLength);
    }
    get maxLength() {
        return this._maxLength;
    }
    /**
     *  manter a posições de valor.
     *
     * *maintain char positions.*
     */
    set keepCharPositions(keepCharPositions) {
        this._keepCharPositions = enforceBoolean(keepCharPositions);
    }
    get keepCharPositions() {
        return this._keepCharPositions;
    }
    /**
     *  Força o cursor para ficar sempre ao final do valor, útil para campos de moeda
     *
     * *Force the cursor to stay at the final of the input value, useful to money fields*
     */
    set forceEndCursor(forceEndCursor) {
        this._forceEndCursor = enforceBoolean(forceEndCursor);
    }
    get forceEndCursor() {
        return this._forceEndCursor;
    }
    /**
     * @internal
     */
    get controlValue() {
        return this._value;
    }
    /**
     * @internal
     */
    get controlDisabled() {
        return (this.disabled && !this.controlValue) || null;
    }
    /**
     * @internal
     */
    get controlMaxLength() {
        return this.maxLength || this.voxelMaskService.maxLength;
    }
    /**
     * @internal
     */
    onInput(target) {
        var _a, _b, _c;
        const value = this.valueMask(this.voxelMask === 'date' ? this._transformDateValue(target.value, false) : target.value, (_a = target.selectionEnd) !== null && _a !== void 0 ? _a : 0);
        if (typeof this._mask !== 'function' && !this.allowLeadingZeros) {
            this.maxLength =
                value.valueMask.replace(this.voxelMaskService.placeholderChar, '').length >=
                    this._mask.length
                    ? this._mask.length
                    : this._mask.length + 1;
        }
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', this.voxelMask === 'date' ? this._transformDateValue(value.valueMask) : value.valueMask);
        target.setSelectionRange((_b = value.position) !== null && _b !== void 0 ? _b : 0, (_c = value.position) !== null && _c !== void 0 ? _c : 0, 'none');
        this.value = this.shouldKeepMask ? value.valueMask : value.cleanValue;
        this._previousMaskValue = value.valueMask;
        if (this.liveAnnouncer) {
            this.la.announce(value.valueMask, 10000);
        }
    }
    onClick() {
        if (this.forceEndCursor) {
            this.setEndCursor();
        }
    }
    onKeyup() {
        if (this.forceEndCursor) {
            this.setEndCursor();
        }
    }
    /**
     * @internal
     */
    controlChange() {
        this._onChange(this.value);
    }
    /**
     * @internal
     */
    controlBlur() {
        this._onTouched();
    }
    /**
     * @internal
     */
    ngOnInit() {
        if (this.voxelMask === 'currency') {
            return (this._mask = this.voxelMaskService.currencyMask);
        }
        if (this.voxelMask === 'date') {
            this.guide = true;
            this.keepCharPositions = true;
            return (this._mask = this.voxelMaskService.dateMask);
        }
        if (typeof this.voxelMask === 'string') {
            return (this._mask = this.voxelMaskService.regExpMask(this.voxelMask));
        }
        return (this._mask = this.voxelMask);
    }
    ngAfterViewInit() {
        if (this._value) {
            this.setValueMask();
        }
    }
    _transformDateValue(value = '', removePlaceholder = true) {
        const placeholder = this.voxelMaskService.placeholderChar;
        const searchPattern = removePlaceholder ? RegExp(`${placeholder}`, 'g') : / /g;
        const stringToReplace = removePlaceholder ? ' ' : `${placeholder}`;
        let transformedValue;
        transformedValue = value.replace(searchPattern, stringToReplace);
        const valueWithoutMask = transformedValue.replace(/[ \/-]/g, '');
        if (removePlaceholder && valueWithoutMask.length === 0) {
            transformedValue = '';
        }
        return transformedValue;
    }
    setValueMask() {
        var _a;
        const value = this.valueMask((_a = this._value) === null || _a === void 0 ? void 0 : _a.toString(), this.elementRef.nativeElement.selectionEnd);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', value.valueMask);
        this._previousMaskValue = value.valueMask;
    }
    setEndCursor() {
        this.elementRef.nativeElement.selectionStart = this.elementRef.nativeElement.value.length;
    }
    /**
     * @internal
     */
    valueMask(value, selectionEnd) {
        const valueMask = this.voxelMaskService.valueWithMask(value, this._mask, this._previousMaskValue, selectionEnd, this.guide, this.keepCharPositions, this.allowLeadingZeros, this.config);
        const position = this.voxelMaskService.adjustCaretPosition(value, valueMask.valueMask, valueMask.placeholder, selectionEnd, this._previousMaskValue, this.guide, this.allowLeadingZeros, this.keepCharPositions, this.voxelMask === 'date');
        return {
            valueMask: valueMask.valueMask,
            cleanValue: valueMask.value,
            position,
        };
    }
    /**
     * @internal
     */
    writeValue(value) {
        this.value = value;
        if (this._mask) {
            this.setValueMask();
        }
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    /**
     * @internal
     */
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
    }
}
VoxelMaskDirective.ɵfac = function VoxelMaskDirective_Factory(t) { return new (t || VoxelMaskDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(VoxelMaskService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LiveAnnouncer)); };
VoxelMaskDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelMaskDirective, selectors: [["", "voxelMask", ""]], hostVars: 5, hostBindings: function VoxelMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function VoxelMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target); })("click", function VoxelMaskDirective_click_HostBindingHandler() { return ctx.onClick(); })("keyup", function VoxelMaskDirective_keyup_HostBindingHandler() { return ctx.onKeyup(); })("change", function VoxelMaskDirective_change_HostBindingHandler() { return ctx.controlChange(); })("blur", function VoxelMaskDirective_blur_HostBindingHandler() { return ctx.controlBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("disabled", ctx.disabled)("readonly", ctx.readonly);
        ɵngcc0.ɵɵattribute("value", ctx.controlValue)("disabled", ctx.controlDisabled)("maxLength", ctx.controlMaxLength);
    } }, inputs: { config: "config", value: "value", disabled: "disabled", readonly: "readonly", guide: "guide", allowLeadingZeros: "allowLeadingZeros", shouldKeepMask: "shouldKeepMask", liveAnnouncer: "liveAnnouncer", maxLength: "maxLength", keepCharPositions: "keepCharPositions", forceEndCursor: "forceEndCursor", voxelMask: "voxelMask" } });
VoxelMaskDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: VoxelMaskService },
    { type: Renderer2 },
    { type: LiveAnnouncer }
];
VoxelMaskDirective.propDecorators = {
    voxelMask: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input, args: ['disabled',] }, { type: HostBinding, args: ['disabled',] }],
    readonly: [{ type: Input, args: ['readonly',] }, { type: HostBinding, args: ['readonly',] }],
    guide: [{ type: Input }],
    allowLeadingZeros: [{ type: Input }],
    shouldKeepMask: [{ type: Input }],
    liveAnnouncer: [{ type: Input }],
    maxLength: [{ type: Input }],
    keepCharPositions: [{ type: Input }],
    config: [{ type: Input }],
    forceEndCursor: [{ type: Input }],
    controlValue: [{ type: HostBinding, args: ['attr.value',] }],
    controlDisabled: [{ type: HostBinding, args: ['attr.disabled',] }],
    controlMaxLength: [{ type: HostBinding, args: ['attr.maxLength',] }],
    onInput: [{ type: HostListener, args: ['input', ['$event.target'],] }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onKeyup: [{ type: HostListener, args: ['keyup',] }],
    controlChange: [{ type: HostListener, args: ['change',] }],
    controlBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelMask]'
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: VoxelMaskService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc5.LiveAnnouncer }]; }, { config: [{
            type: Input
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }, {
            type: HostBinding,
            args: ['disabled']
        }], readonly: [{
            type: Input,
            args: ['readonly']
        }, {
            type: HostBinding,
            args: ['readonly']
        }], guide: [{
            type: Input
        }], allowLeadingZeros: [{
            type: Input
        }], shouldKeepMask: [{
            type: Input
        }], liveAnnouncer: [{
            type: Input
        }], maxLength: [{
            type: Input
        }], keepCharPositions: [{
            type: Input
        }], forceEndCursor: [{
            type: Input
        }], controlValue: [{
            type: HostBinding,
            args: ['attr.value']
        }], controlDisabled: [{
            type: HostBinding,
            args: ['attr.disabled']
        }], controlMaxLength: [{
            type: HostBinding,
            args: ['attr.maxLength']
        }], 
    /**
     * @internal
     */
    onInput: [{
            type: HostListener,
            args: ['input', ['$event.target']]
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], onKeyup: [{
            type: HostListener,
            args: ['keyup']
        }], 
    /**
     * @internal
     */
    controlChange: [{
            type: HostListener,
            args: ['change']
        }], 
    /**
     * @internal
     */
    controlBlur: [{
            type: HostListener,
            args: ['blur']
        }], voxelMask: [{
            type: Input
        }] }); })();

class VoxelDatepickerDirective extends VoxelMaskDirective {
    constructor(ngControl, voxelInput, elementRef, voxelMaskService, la, renderer) {
        super(ngControl, elementRef, voxelMaskService, renderer, la) /* istanbul ignore next */;
        this.ngControl = ngControl;
        this.voxelInput = voxelInput;
        this.elementRef = elementRef;
        this.voxelMaskService = voxelMaskService;
        this.la = la;
        this.renderer = renderer;
        this._dateFormat = 'dd/mm/yyyy';
        this._minDate = '';
        this._maxDate = '';
        this._disableDefaultValidators = false;
        this.dateFilter = null;
        this.voxelMask = 'date';
    }
    /**
     *  Define o formato da data do datepicker.
     *
     * *Sets the date format of the datepicker.*
     */
    set dateFormat(dateFormat) {
        this._dateFormat = dateFormat;
    }
    get dateFormat() {
        return this._dateFormat;
    }
    /**
     *  Define a data mínima do datepicker.
     *
     * *Sets the minimum datepicker date.*
     */
    set minDate(minDate) {
        this._minDate = minDate;
    }
    get minDate() {
        return this._minDate;
    }
    /**
     *  Define a data máxima do datepicker.
     *
     * *Sets the maximum date of the datepicker.*
     */
    set maxDate(maxDate) {
        this._maxDate = maxDate;
    }
    get maxDate() {
        return this._maxDate;
    }
    /**
     * Desabilita os validadores padrão do datepicker.
     *
     * *Disable datepicker default validators*
     */
    set disableDefaultValidators(disableDefaultValidators) {
        this._disableDefaultValidators = enforceBoolean(disableDefaultValidators);
    }
    get disableDefaultValidators() {
        return this._disableDefaultValidators;
    }
    /** @internal */
    static formatDate(date, dateFormat = 'dd/mm/yyyy') {
        const formatArray = dateFormat.split(/[^dmyHMS]+/);
        const dateArray = date.split(/[^0-9]/);
        const dayIndex = formatArray.indexOf('dd');
        const monthIndex = formatArray.indexOf('mm');
        const yearIndex = formatArray.findIndex((year) => year.includes('yy'));
        return {
            date: new Date(parseInt(dateArray[yearIndex], 10), parseInt(dateArray[monthIndex], 10) - 1, parseInt(dateArray[dayIndex], 10)),
            day: parseInt(dateArray[dayIndex], 10),
            month: parseInt(dateArray[monthIndex], 10) - 1,
            year: parseInt(dateArray[yearIndex], 10),
        };
    }
    /** @internal */
    static isValidDate(dateValue, dateFormat = 'dd/mm/yyyy') {
        const valueDate = VoxelDatepickerDirective.formatDate(dateValue, dateFormat);
        return valueDate.date.getDate() === valueDate.day ? true : false;
    }
    ngOnInit() {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
            if (!this.disableDefaultValidators) {
                const control = this.ngControl.control;
                if (control) {
                    // Se o formControl já tiver validadores, define eles novamente e adiciona o validate daqui.
                    // Caso contrário, só define o validate.
                    const validators = control.validator
                        ? [control.validator, this.validate.bind(this)]
                        : [this.validate.bind(this)];
                    control.setValidators(validators);
                }
            }
        }
        return super.ngOnInit();
    }
    validate(control) {
        const typedDate = this.elementRef.nativeElement.value;
        return this.dateValidator(typedDate)(control);
    }
    /** @internal */
    dateValidator(value = '') {
        return () => {
            const valid = VoxelDatepickerDirective.isValidDate(value, this.dateFormat);
            const notEmpty = value.replace(/\D/g, '').length !== 0;
            if (notEmpty && !valid) {
                return { date: { value } };
            }
            const valueDate = VoxelDatepickerDirective.formatDate(value, this.dateFormat).date;
            if (this.minDate) {
                const minDateValue = VoxelDatepickerDirective.formatDate(this.minDate, this.dateFormat).date;
                const error = valueDate && valueDate < minDateValue;
                if (error) {
                    return { minDate: { value } };
                }
            }
            if (this.maxDate) {
                const maxDateValue = VoxelDatepickerDirective.formatDate(this.maxDate, this.dateFormat).date;
                const error = valueDate && valueDate > maxDateValue;
                if (error) {
                    return { maxDate: { value } };
                }
            }
            if (typeof this.dateFilter === 'function' && this.dateFilter(valueDate)) {
                return { dateFilter: { value } };
            }
            return null;
        };
    }
}
VoxelDatepickerDirective.ɵfac = function VoxelDatepickerDirective_Factory(t) { return new (t || VoxelDatepickerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(VoxelFieldMixinBase, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(VoxelMaskService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LiveAnnouncer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VoxelDatepickerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelDatepickerDirective, selectors: [["", "voxelDatepickerInput", ""]], inputs: { dateFormat: "dateFormat", minDate: "minDate", maxDate: "maxDate", disableDefaultValidators: "disableDefaultValidators" }, exportAs: ["voxelDatepickerInput"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelDatepickerDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: VoxelFieldMixinBase, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: VoxelMaskService },
    { type: LiveAnnouncer },
    { type: Renderer2 }
];
VoxelDatepickerDirective.propDecorators = {
    dateFormat: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    disableDefaultValidators: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDatepickerDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelDatepickerInput]',
                exportAs: 'voxelDatepickerInput'
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: VoxelFieldMixinBase, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: VoxelMaskService }, { type: ɵngcc5.LiveAnnouncer }, { type: ɵngcc0.Renderer2 }]; }, { dateFormat: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], disableDefaultValidators: [{
            type: Input
        }] }); })();

/**
 * Dados dos eventos do datepicker
 *
 * *Select event datepicker*
 */
class IVoxelDatepickerEvent {
    /** @internal */
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
/**
 * @internal
 */
let NEXT_ID$h = 0;
const MIN_DATEPICKER_HEIGHT = 416;
/**
 * Calendário que pode ser usado para selecionar datas
 *
 * *Calendar that can be used to select dates*
 *
 * **Module:**
 *
 * `import { VoxelDatepickerModule } from '@voxel/components';`
 *
 * <example-url>../../demo/#/portfolio/datepicker?componentOnly=true</example-url>
 *
 * @example Simples
 * <voxel-datepicker></voxel-datepicker>
 *
 * @example Simples com valor
 *   <voxel-datepicker value="10/10/2010"></voxel-datepicker>
 *
 * @example Simples com formfield
 *   <voxel-form-field
 *     label="Data de Pagamento"
 *     description="texto de apoio: dd/MM/aaaa"
 *   >
 *     <input
 *       voxelInput
 *       voxelDatepickerInput
 *       #input1="voxelDatepickerInput"
 *     />
 *     <voxel-datepicker [input]="input1"></voxel-datepicker>
 *   </voxel-form-field>
 */
class VoxelDatepickerComponent {
    /** @internal */
    constructor(liveAnnouncer, platform, renderer, overlay) {
        this.liveAnnouncer = liveAnnouncer;
        this.platform = platform;
        this.renderer = renderer;
        this.overlay = overlay;
        /** @internal */
        this._calendarOpen = false;
        this.offsetY = 0;
        this.screenWidth = window.innerWidth;
        /** @internal */
        this.currentDate = new Date(new Date().setHours(0, 0, 0, 0));
        /** @internal */
        this.day = this.currentDate.getDate();
        /** @internal */
        this.month = this.currentDate.getMonth();
        /** @internal */
        this.year = this.currentDate.getFullYear();
        /** @internal */
        this.inHundredYears = new Date(new Date().setFullYear(new Date().getFullYear() + 100));
        /** @internal */
        this.hundredYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
        /** @internal */
        this.calendar = [];
        /** @internal */
        this.isMobile = this.platform.ANDROID || this.platform.IOS;
        /** @internal */
        this.positions = [];
        /**
         * Variavel que define o id do datepicker
         *
         * *Variable that define the id of datepicker*
         */
        this.formFieldId = `voxel-datepicker-${NEXT_ID$h++}`;
        /**
         * Variavel que define o id da label input para a aria-describedby do datepicker
         *
         * *Variable that defines the label input id for the datepicker aria-describedby*
         */
        this.ariaDescribedby = `voxel-labelid-${NEXT_ID$h}`;
        /**
         *  Define o formato da data do datepicker.
         *
         * *Sets the date format of the datepicker.*
         */
        this.dateFormat = 'dd/mm/yyyy';
        /**
         *  Define a data máxima do datepicker.
         *
         * *Sets the maximum date of the datepicker.*
         */
        this.maxDate = this.convertToFormatDate(this.inHundredYears);
        /**
         *  Define a data mínima do datepicker.
         *
         * *Sets the minimum datepicker date.*
         */
        this.minDate = this.convertToFormatDate(this.hundredYearsAgo);
        /**
         *  Define uma função de callback para desativar datas específicas.
         *
         * *Sets a callback function to disable specific dates.*
         */
        this.dateFilter = null;
        /**
         *  Define a configuração de palavras usadas no datepicker.
         *
         * *Defines the configuration of words used in the datepicker.*
         */
        this.calendarConfig = {
            monthNames: [
                'janeiro',
                'fevereiro',
                'março',
                'abril',
                'maio',
                'junho',
                'julho',
                'agosto',
                'setembro',
                'outubro',
                'novembro',
                'dezembro',
            ],
            weekNames: [
                { name: 'Domingo', abbreviation: 'dom' },
                { name: 'Segunda', abbreviation: 'seg' },
                { name: 'Terça', abbreviation: 'ter' },
                { name: 'Quarta', abbreviation: 'qua' },
                { name: 'Quinta', abbreviation: 'qui' },
                { name: 'Sexta', abbreviation: 'sex' },
                { name: 'Sábado', abbreviation: 'sáb' },
            ],
            label: 'abrir calendário',
            close: 'fechar calendário',
            prevMonth: 'mês anterior',
            nextMonth: 'próximo mês',
            prevYear: 'ano anterior',
            nextYear: 'próximo ano',
        };
        /**
         * Define a posição de abertura do datepiker
         *
         * *Defines datepiker opening position*
         */
        this.position = 'auto';
        /**
         * Evento disparado com a mudança no valor do datepicker.
         *
         * *Event triggered with the change in the value of datepicker.*
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no datepicker.
         *
         * *Event triggered with focus on datepicker.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no datepicker.
         *
         * *Event triggered with blur on datepicker.*
         */
        this.blur = new EventEmitter();
        /**
         * Evento disparado ao abrir ou fechar o datepicker.
         *
         * *Event fired when opening or closing the datepicker.*
         */
        this.toggle = new EventEmitter();
        /** @internal */
        this.prevMonth = (element = null) => {
            if (this.disabledMonth(this.month, this.year)[0]) {
                return;
            }
            if (this.month === 0) {
                this.month = 11;
                this.year -= 1;
            }
            else {
                this.month -= 1;
            }
            this.updateCalendar();
            if (this.disabledMonth(this.month, this.year)[0] && element) {
                this.calendarChages(this.tableDays, () => {
                    var _a;
                    (_a = this.findNextTabStop(this.calendarFull.nativeElement, element)) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        };
        /** @internal */
        this.nextMonth = (element = null) => {
            if (this.disabledMonth(this.month, this.year)[1]) {
                return;
            }
            if (this.month === 11) {
                this.month = 0;
                this.year += 1;
            }
            else {
                this.month += 1;
            }
            this.updateCalendar();
            if (this.disabledMonth(this.month, this.year)[1] && element) {
                this.calendarChages(this.tableDays, () => {
                    var _a;
                    (_a = this.findNextTabStop(this.calendarFull.nativeElement, element)) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        };
        /** @internal */
        this.prevYear = (element = null) => {
            this.year -= 1;
            if (this.disabledMonth(this.month, this.year)[0]) {
                const dateMinMax = this.dateMinMax();
                this.month = dateMinMax.dateMin.getMonth();
            }
            this.updateCalendar();
            this.liveAnnouncer.announce(this.calendarConfig.monthNames[this.month], 10000);
            if (this.disabledYear(this.year)[0] && element) {
                this.calendarChages(this.tableDays, () => {
                    var _a;
                    (_a = this.findNextTabStop(this.calendarFull.nativeElement, element)) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        };
        /** @internal */
        this.nextYear = (element = null) => {
            this.year += 1;
            if (this.disabledMonth(this.month, this.year)[1]) {
                const dateMinMax = this.dateMinMax();
                this.month = dateMinMax.dateMax.getMonth();
            }
            this.updateCalendar();
            this.liveAnnouncer.announce(this.calendarConfig.monthNames[this.month], 10000);
            if (this.disabledYear(this.year)[1] && element) {
                this.calendarChages(this.tableDays, () => {
                    var _a;
                    (_a = this.findNextTabStop(this.calendarFull.nativeElement, element)) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        };
        /** @internal */
        this.tabIndexDay = (oldEl, newEl) => {
            if (oldEl && newEl) {
                return newEl === null || newEl === void 0 ? void 0 : newEl.focus();
            }
            return this.calendarChages(this.tableDays, () => {
                var _a;
                (_a = this.tableDays.nativeElement
                    .querySelectorAll('.voxel-datepicker__day--enable')[0]) === null || _a === void 0 ? void 0 : _a.removeAttribute('tabindex');
            });
        };
        /** @internal */
        this.calendarChages = (elementRef, event, config = { subtree: true, characterData: true }) => {
            const observer = new MutationObserver((mutations) => {
                observer.disconnect();
                if (mutations && event) {
                    return event(this.calendar);
                }
            });
            observer.observe(elementRef.nativeElement, config);
        };
    }
    /** @internal */
    get calendarOpen() {
        return this._calendarOpen;
    }
    /** @internal */
    get calendarWidth() {
        return this.input ? this.input.elementRef.nativeElement.offsetWidth : 'auto';
    }
    /**
     * Valor do datepicker
     *
     * *Value of the datepicker*
     */
    set value(value) {
        this._value = value;
    }
    get value() {
        return this._value;
    }
    /**
     * Desabilita o datepicker
     *
     * *Disables datepicker*
     */
    set disabled(disabled) {
        this._disabled = enforceBoolean(disabled);
    }
    get disabled() {
        return this._disabled;
    }
    ngOnInit() {
        this.defineOpeningPosition();
    }
    ngDoCheck() {
        if (this.input && this.input.disabled !== this.disabled) {
            this.disabled = this.input.disabled;
        }
    }
    ngAfterContentInit() {
        Promise.resolve().then(() => {
            if (this.input) {
                if (this.input.voxelInput) {
                    this.input.voxelInput.labelId = this.ariaDescribedby;
                    this.input.dateFormat = this.dateFormat;
                    this.input.minDate = this.minDate;
                    this.input.maxDate = this.maxDate;
                    this.input.dateFilter = this.dateFilter;
                }
                if (this.value) {
                    this.input.value = this.value;
                    this.renderer.setProperty(this.input.elementRef.nativeElement, 'value', this.value);
                }
                if (this.input.elementRef.nativeElement.value) {
                    this.value = this.input.elementRef.nativeElement.value;
                }
                this.overlayDir.origin = new CdkOverlayOrigin(this.input.elementRef);
                const yearIndex = this.dateFormat
                    .split(/[^dmyHMS]+/)
                    .findIndex((year) => year.includes('yy'));
                const maxDateArray = this.maxDate.split(/[^0-9]/);
                const minDateArray = this.minDate.split(/[^0-9]/);
                this.input.config = {
                    format: this.dateFormat,
                    minYear: minDateArray[yearIndex],
                    maxYear: maxDateArray[yearIndex],
                };
                return;
            }
            this.overlayDir.origin = this.datepickerOrigin;
        });
    }
    /** @internal */
    defineOpeningPosition() {
        const top = {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
        };
        const bottom = {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
        };
        const setPosition = {
            top: () => this.positions.push(top),
            bottom: () => this.positions.push(bottom),
            auto: () => this.positions.push(bottom, top),
        };
        return setPosition[this.position]();
    }
    /** @internal */
    calendarInitValue(value) {
        this.dateFocus = value ? value : this.convertToDate();
        const dateArray = this.dateFocus.split(/[^0-9]/);
        const formatArray = this.dateFormat.split(/[^dmyHMS]+/);
        const dateMinMax = this.dateMinMax();
        const dayIndex = formatArray.indexOf('dd');
        const monthIndex = formatArray.indexOf('mm');
        const yearIndex = formatArray.findIndex((year) => year.includes('yy'));
        let valueDate = new Date();
        valueDate = new Date(`${parseInt(dateArray[monthIndex], 10)}/
      ${parseInt(dateArray[dayIndex], 10)}/
      ${parseInt(dateArray[yearIndex], 10)}`);
        valueDate = isNaN(valueDate.getTime())
            ? new Date()
            : valueDate < dateMinMax.dateMin
                ? dateMinMax.dateMin
                : valueDate > dateMinMax.dateMax
                    ? dateMinMax.dateMax
                    : valueDate;
        this.day = valueDate.getDate();
        this.month = valueDate.getMonth();
        this.year = valueDate.getFullYear();
        this.dateFocus = this.convertToDate();
    }
    /** @internal */
    onFocus() {
        this.focus.emit(new IVoxelDatepickerEvent(this, this.value));
    }
    /** @internal */
    onBlur() {
        this.blur.emit(new IVoxelDatepickerEvent(this, this.value));
    }
    /** @internal */
    updateCalendar() {
        const firstDay = new Date(this.year, this.month, 1);
        const lastDay = new Date(this.year, this.month + 1, 0);
        let offset = firstDay.getDay();
        let dayCount = 1;
        const calendar = [];
        for (let i = 0; i < 6; i++) {
            const week = [];
            for (let j = 0; j < 7; j++) {
                if (offset === 0) {
                    if (dayCount > lastDay.getDate()) {
                        break;
                    }
                    week.push(dayCount);
                    dayCount++;
                }
                else {
                    week.push('');
                    offset--;
                }
            }
            calendar.push(week);
            if (dayCount > lastDay.getDate()) {
                break;
            }
        }
        this.lastDay = lastDay.getDate();
        this.calendar = calendar;
    }
    /** @internal */
    selectDate(day) {
        var _a, _b, _c;
        this.day = +day;
        this.value = this.convertToDate(this.day);
        if (this.input) {
            this.input.value = this.value;
            this.renderer.setProperty(this.input.elementRef.nativeElement, 'value', this.value);
            (_c = (_b = (_a = this.input) === null || _a === void 0 ? void 0 : _a.ngControl) === null || _b === void 0 ? void 0 : _b.control) === null || _c === void 0 ? void 0 : _c.updateValueAndValidity();
        }
        this._emitSelectChangeEvent();
        this.close();
    }
    /** @internal */
    isCurrentDate(day, month, year) {
        if (+day === this.currentDate.getDate() &&
            +month === this.currentDate.getMonth() &&
            +year === this.currentDate.getFullYear()) {
            return true;
        }
        return false;
    }
    /** @internal */
    convertToFormatDate(date) {
        return this.dateFormat
            .replace('dd', ('0' + date.getDate()).slice(-2).toString())
            .replace('mm', ('0' + (date.getMonth() + 1)).slice(-2).toString())
            .replace('yyyy', date.getFullYear().toString())
            .replace('yy', date.getFullYear().toString().slice(-2));
    }
    /** @internal */
    convertToDate(day = this.day) {
        return this.dateFormat
            .replace('dd', ('0' + day).slice(-2).toString())
            .replace('mm', ('0' + (this.month + 1)).slice(-2).toString())
            .replace('yyyy', this.year.toString())
            .replace('yy', this.year.toString().slice(-2));
    }
    /** @internal */
    isValidDate(dateValue) {
        const dateArray = dateValue.split(/[^0-9]/);
        const formatArray = this.dateFormat.split(/[^dmyHMS]+/);
        const dayIndex = formatArray.indexOf('dd');
        const monthIndex = formatArray.indexOf('mm');
        const yearIndex = formatArray.findIndex((year) => year.includes('yy'));
        const valueDate = new Date(parseInt(dateArray[yearIndex], 10), parseInt(dateArray[monthIndex], 10) - 1, parseInt(dateArray[dayIndex], 10));
        return valueDate.getDate() ? true : false;
    }
    /** @internal */
    ariaLabelDay(day, isSelected) {
        return (this.dateFormat
            .split('/')
            .join(' ')
            .replace('dd', ('0' + day).slice(-2).toString())
            .replace('mm', this.calendarConfig.monthNames[this.month])
            .replace('yyyy', this.year.toString())
            .replace('yy', this.year.toString().slice(-2)) + (isSelected ? ' selecionado' : ''));
    }
    /** @internal */
    findNextTabStop(el, lastFocus) {
        var _a;
        const allElements = 'a, button, input, [tabindex]';
        const universe = Array.prototype.slice.call(el.querySelectorAll(allElements));
        const index = universe.indexOf(lastFocus);
        for (let i = index; i < universe.length; i++) {
            if (!((_a = universe[i]) === null || _a === void 0 ? void 0 : _a.hasAttribute('disabled'))) {
                return universe[i];
            }
        }
    }
    /** @internal */
    dayFocus(oldEl, newEl) {
        if (oldEl && newEl && oldEl !== newEl && !this.isMobile) {
            newEl.removeAttribute('tabindex');
            oldEl.setAttribute('tabindex', '-1');
        }
        this.oudElementFocus = newEl;
    }
    /** @internal */
    dateMinMax() {
        const maxDateArray = this.maxDate.split(/[^0-9]/);
        const minDateArray = this.minDate.split(/[^0-9]/);
        const formatArray = this.dateFormat.split(/[^dmyHMS]+/);
        const dayIndex = formatArray.indexOf('dd');
        const monthIndex = formatArray.indexOf('mm');
        const yearIndex = formatArray.findIndex((year) => year.includes('yy'));
        const dateMax = new Date(parseInt(maxDateArray[yearIndex], 10), parseInt(maxDateArray[monthIndex], 10) - 1, parseInt(maxDateArray[dayIndex], 10));
        const dateMin = new Date(parseInt(minDateArray[yearIndex], 10), parseInt(minDateArray[monthIndex], 10) - 1, parseInt(minDateArray[dayIndex], 10));
        return { dateMin, dateMax };
    }
    /** @internal */
    disabledDay(day) {
        const dateMinMax = this.dateMinMax();
        const date = new Date(this.year, this.month, +day);
        if (date > dateMinMax.dateMax || date < dateMinMax.dateMin) {
            return true;
        }
        if (this.dateFilter) {
            return this.dateFilter(date);
        }
        return false;
    }
    /** @internal */
    disabledMonth(month, year) {
        const dateMinMax = this.dateMinMax();
        const disabledPrevNext = [false, false];
        if (month <= dateMinMax.dateMin.getMonth() && year <= dateMinMax.dateMin.getFullYear()) {
            disabledPrevNext[0] = true;
        }
        if (month >= dateMinMax.dateMax.getMonth() && year >= dateMinMax.dateMax.getFullYear()) {
            disabledPrevNext[1] = true;
        }
        return disabledPrevNext;
    }
    /** @internal */
    disabledYear(year) {
        const dateMinMax = this.dateMinMax();
        const disabledPrevNext = [false, false];
        if (year <= dateMinMax.dateMin.getFullYear()) {
            disabledPrevNext[0] = true;
        }
        if (year >= dateMinMax.dateMax.getFullYear()) {
            disabledPrevNext[1] = true;
        }
        return disabledPrevNext;
    }
    /** @internal */
    open() {
        this.defineOffsetY();
        if (this.input &&
            this.input.elementRef.nativeElement.value &&
            this.isValidDate(this.input.elementRef.nativeElement.value)) {
            this.value = this.input.elementRef.nativeElement.value;
        }
        if (!this.value) {
            this.month = this.currentDate.getMonth();
            this.year = this.currentDate.getFullYear();
        }
        this.calendarInitValue(this.value);
        this.updateCalendar();
        this.overlayDir.width =
            typeof this.calendarWidth === 'string' || Number(this.calendarWidth) < 340
                ? this.calendarWidth
                : 340;
        this._calendarOpen = true;
        this.toggle.emit(new IVoxelDatepickerEvent(this, this.value));
        if (!this.isMobile) {
            this.liveAnnouncer.announce('Se seu leitor de tela suporta modo de formulário, utilize-o para melhor experiência na navegação pelo calendário.', 10000);
        }
    }
    /** @internal */
    close() {
        var _a, _b;
        this._calendarOpen = false;
        this.toggle.emit(new IVoxelDatepickerEvent(this, this.value));
        if (this.isMobile) {
            toggleMobileFocusTrap({ add: false });
        }
        if (this.input) {
            (_a = this.input.elementRef.nativeElement) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        (_b = this.datepickerButton.nativeElement) === null || _b === void 0 ? void 0 : _b.focus();
    }
    /** @internal */
    attach() {
        const elementFocus = document.querySelectorAll('.voxel-datepicker__day--focus')[0];
        if (elementFocus === null || elementFocus === void 0 ? void 0 : elementFocus.hasAttribute('tabindex')) {
            this.renderer.removeAttribute(elementFocus, 'tabindex');
        }
        elementFocus === null || elementFocus === void 0 ? void 0 : elementFocus.focus();
        if (!this.isMobile) {
            return;
        }
        this.applyMobilePositionStrategy();
        toggleMobileFocusTrap({});
    }
    /** @internal */
    handleKeydown(_event) {
        const elFocus = document.activeElement;
        const col = elFocus ? elFocus.getAttribute('data-col') : '';
        const row = elFocus ? elFocus.getAttribute('data-row') : '';
        const getKeyValue = (obj, key) => obj[key];
        if (elFocus && getKeyValue(this.keydownEvents(elFocus), _event.code)) {
            _event.preventDefault();
            getKeyValue(this.keydownEvents(elFocus), _event.code)(col ? +col : 0, row ? +row : 0);
        }
    }
    /** @internal */
    keydownEvents(elFocus, table = this.tableDays) {
        const keysMap = {
            ArrowUp: (col, row) => {
                const el = table.nativeElement.querySelector(`button[data-row="${row - 1}"][data-col="${col}"]`);
                if (el) {
                    return this.tabIndexDay(elFocus, el);
                }
                this.prevMonth();
                this.calendarChages(table, (newCalendar) => {
                    var _a;
                    const nrow = newCalendar[newCalendar.length - 1][col]
                        ? newCalendar.length - 1
                        : newCalendar.length - 2;
                    (_a = table.nativeElement
                        .querySelector(`button[data-row="${nrow}"][data-col="${col}"]`)) === null || _a === void 0 ? void 0 : _a.focus();
                });
            },
            ArrowDown: (col, row) => {
                let el = table.nativeElement.querySelector(`button[data-row="${row + 1}"][data-col="${col}"]`);
                if (el) {
                    return this.tabIndexDay(elFocus, el);
                }
                this.nextMonth();
                this.calendarChages(table, (newCalendar) => {
                    const nrow = newCalendar[0][col] ? 0 : 1;
                    el = table.nativeElement.querySelector(`button[data-row="${nrow}"][data-col="${col}"]`);
                    this.tabIndexDay(elFocus, el);
                });
            },
            ArrowLeft: (col, row) => {
                const el = table.nativeElement.querySelector(`button[data-row="${col - 1 >= 0 ? row : row - 1}"][data-col="${col - 1 >= 0 ? col - 1 : 6}"]`);
                if (el) {
                    return this.tabIndexDay(elFocus, el);
                }
                this.prevMonth();
                this.calendarChages(table, keysMap.End);
            },
            ArrowRight: (col, row) => {
                const el = table.nativeElement.querySelector(`button[data-row="${col + 1 <= 6 ? row : row + 1}"][data-col="${col + 1 <= 6 ? col + 1 : 0}"]`);
                if (el) {
                    return this.tabIndexDay(elFocus, el);
                }
                this.nextMonth();
                this.calendarChages(table, keysMap.Home);
            },
            Home: () => {
                const el = table.nativeElement.querySelectorAll('.voxel-datepicker__day--enable')[0];
                this.tabIndexDay(elFocus, el);
            },
            End: () => {
                const el = table.nativeElement.querySelectorAll('.voxel-datepicker__day--enable');
                this.tabIndexDay(elFocus, el[el.length - 1]);
            },
        };
        return keysMap;
    }
    /** @internal */
    _emitSelectChangeEvent() {
        this.change.emit(new IVoxelDatepickerEvent(this, this.value));
    }
    applyMobilePositionStrategy() {
        const positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();
        this.overlayDir.overlayRef.updatePositionStrategy(positionStrategy);
        this.overlayDir.overlayRef.updatePosition();
    }
    defineOffsetY() {
        if (!this.input || this.position === 'auto') {
            this.offsetY = 0;
            return;
        }
        const top = this.input.elementRef.nativeElement.getBoundingClientRect().top - MIN_DATEPICKER_HEIGHT;
        const bottom = window.innerHeight -
            MIN_DATEPICKER_HEIGHT -
            this.input.elementRef.nativeElement.getBoundingClientRect().bottom;
        if (this.position === 'bottom' && bottom < 0) {
            this.offsetY = bottom;
            return;
        }
        if (this.position === 'top' && top < 0) {
            this.offsetY = -top;
            return;
        }
        this.offsetY = 0;
    }
}
VoxelDatepickerComponent.ɵfac = function VoxelDatepickerComponent_Factory(t) { return new (t || VoxelDatepickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LiveAnnouncer), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay)); };
VoxelDatepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelDatepickerComponent, selectors: [["voxel-datepicker"]], viewQuery: function VoxelDatepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
        ɵngcc0.ɵɵviewQuery(_c18, 7);
        ɵngcc0.ɵɵviewQuery(_c19, 7);
        ɵngcc0.ɵɵviewQuery(_c20, 5);
        ɵngcc0.ɵɵviewQuery(_c21, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayDir = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datepickerButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datepickerOrigin = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tableDays = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.calendarFull = _t.first);
    } }, inputs: { formFieldId: "formFieldId", ariaDescribedby: "ariaDescribedby", dateFormat: "dateFormat", maxDate: "maxDate", minDate: "minDate", dateFilter: "dateFilter", calendarConfig: "calendarConfig", position: "position", value: "value", disabled: "disabled", tabindex: "tabindex", input: "input" }, outputs: { change: "change", focus: "focus", blur: "blur", toggle: "toggle" }, decls: 7, vars: 11, consts: [["cdkOverlayOrigin", "", 1, "voxel-datepicker__open"], ["origin", "cdkOverlayOrigin"], ["type", "button", "aria-haspopup", "dialog", 1, "voxel-datepicker__button", 3, "disabled", "tabindex", "click", "focus", "blur"], ["datepickerButton", ""], ["cdkConnectedOverlay", "", "cdkConnectedOverlayHasBackdrop", "", 3, "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayOffsetX", "backdropClick", "detach", "attach"], ["aria-modal", "true", 1, "voxel-datepicker"], ["role", "application", "cdkTrapFocus", "", 1, "voxel-datepicker__container"], ["calendarFull", ""], [1, "voxel-datepicker__header"], [1, "voxel-datepicker__month-control"], ["type", "button", 1, "voxel-datepicker__button", "voxel-datepicker__prevMonth", 3, "disabled", "click"], ["btnPrevMonth", ""], ["aria-live", "polite", 1, "voxel-datepicker__month-name"], ["type", "button", 1, "voxel-datepicker__button", "voxel-datepicker__nextMonth", 3, "disabled", "click"], ["btnNextMonth", ""], [1, "voxel-datepicker__year-control"], ["type", "button", 1, "voxel-datepicker__button", "voxel-datepicker__prevYear", 3, "disabled", "click"], ["btnPrevYear", ""], ["aria-live", "polite", 1, "voxel-datepicker__year-number"], ["type", "button", 1, "voxel-datepicker__button", "voxel-datepicker__nextYear", 3, "disabled", "click"], ["btnNextYear", ""], [1, "voxel-datepicker__calendar"], ["role", "presentation", 1, "voxel-datepicker__table", 3, "keydown"], ["tableDays", ""], [1, "voxel-datepicker__week"], [4, "ngFor", "ngForOf"], [1, "voxel-datepicker__days"], ["type", "button", 1, "voxel-datepicker__button", "voxel-datepicker__close", 3, "click"], [3, "class", "voxel-datepicker__day--currentDate", "voxel-datepicker__day--selected", "voxel-datepicker__day--focus", "voxel-datepicker__day--enable", "disabled", "click", "focus", 4, "ngIf"], [3, "disabled", "click", "focus"]], template: function VoxelDatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2, 3);
        ɵngcc0.ɵɵlistener("click", function VoxelDatepickerComponent_Template_button_click_2_listener() { return ctx.open(); })("focus", function VoxelDatepickerComponent_Template_button_focus_2_listener() { return ctx.onFocus(); })("blur", function VoxelDatepickerComponent_Template_button_blur_2_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementStart(4, "voxel-icon");
        ɵngcc0.ɵɵtext(5, "calendario_outline");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VoxelDatepickerComponent_ng_template_6_Template, 36, 15, "ng-template", 4);
        ɵngcc0.ɵɵlistener("backdropClick", function VoxelDatepickerComponent_Template_ng_template_backdropClick_6_listener() { return ctx.close(); })("detach", function VoxelDatepickerComponent_Template_ng_template_detach_6_listener() { return ctx.close(); })("attach", function VoxelDatepickerComponent_Template_ng_template_attach_6_listener() { return ctx.attach(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵattribute("id", ctx.formFieldId)("aria-label", ctx.calendarConfig.label)("aria-describedby", ctx.ariaDescribedby);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayBackdropClass", !ctx.isMobile ? "cdk-overlay-transparent-backdrop" : "")("cdkConnectedOverlayOpen", ctx.calendarOpen)("cdkConnectedOverlayPositions", ctx.positions)("cdkConnectedOverlayMinWidth", ctx.screenWidth < 340 ? "320px" : "340px")("cdkConnectedOverlayOffsetY", ctx.offsetY)("cdkConnectedOverlayOffsetX", 30);
    } }, directives: [ɵngcc2.CdkOverlayOrigin, VoxelIconComponent, ɵngcc2.CdkConnectedOverlay, ɵngcc5.CdkTrapFocus, ɵngcc1.NgForOf, ɵngcc1.NgIf], styles: [".voxel-datepicker[_ngcontent-%COMP%]{background:var(--ids_color_bg_base);border:none;border-radius:var(--ids_size_cornerRadius_tooltip);-webkit-box-shadow:0 var(--ids_size_general_2x) var(--ids_size_general_8x) 0 rgba(86,80,76,.24);box-shadow:0 var(--ids_size_general_2x) var(--ids_size_general_8x) 0 rgba(86,80,76,.24);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);height:auto;left:auto;margin-top:var(--ids_size_general_7x);padding:var(--ids_spacing_4x);position:relative;right:auto;width:100%}.voxel-datepicker__open[_ngcontent-%COMP%]{display:inline}.voxel-datepicker__container[_ngcontent-%COMP%]{width:100%}.voxel-datepicker__header[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:var(--ids_spacing_3x);margin-top:-.25rem}.voxel-datepicker__table[_ngcontent-%COMP%]{border-collapse:collapse;min-height:18rem}.voxel-datepicker__button[_ngcontent-%COMP%]{background:var(--ids_color_bg_base);border:none;color:var(--ids_color_action_primary_base);cursor:pointer}.voxel-datepicker__button[_ngcontent-%COMP%]:disabled{color:var(--ids_color_action_disabled_base);cursor:auto;cursor:initial}.voxel-datepicker__close[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_border_medium);color:var(--ids_color_action_secondary_base);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_label_medium_bold);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:var(--ids_size_general_44x);position:relative;width:100%}.voxel-datepicker__close[_ngcontent-%COMP%]:disabled{border:none;cursor:not-allowed}.voxel-datepicker__close[_ngcontent-%COMP%]:hover{background:var(--ids_color_action_secondary_base_soft)}@media (min-width: 64rem){.voxel-datepicker__close[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_large_bold);padding:var(--ids_size_general_6x) var(--ids_size_general_24x)}}.voxel-datepicker__calendar-icon[_ngcontent-%COMP%]{background-color:var(--ids_color_bg_base);border:none;right:0;top:var(--ids_size_general_5x)}.voxel-datepicker__month-control[_ngcontent-%COMP%], .voxel-datepicker__year-control[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-left:-.375rem;margin-right:-.375rem}.voxel-datepicker__month-control[_ngcontent-%COMP%] > button[_ngcontent-%COMP%], .voxel-datepicker__year-control[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{min-height:var(--ids_size_general_44x);min-width:var(--ids_size_general_44x)}.voxel-datepicker__month-control[_ngcontent-%COMP%] > button[_ngcontent-%COMP%] + p[_ngcontent-%COMP%], .voxel-datepicker__year-control[_ngcontent-%COMP%] > button[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]{margin-bottom:var(--ids_size_general_3x)}.voxel-datepicker__month-name[_ngcontent-%COMP%]{min-width:4.75rem;text-align:center}.voxel-datepicker__month-name[_ngcontent-%COMP%], .voxel-datepicker__year-number[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_medium_bold);text-align:center}.voxel-datepicker__week[_ngcontent-%COMP%]{margin:var(--ids_size_general_8x) 0}.voxel-datepicker__week[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_medium_bold)}.voxel-datepicker__week[_ngcontent-%COMP%], .voxel-datepicker__days[_ngcontent-%COMP%]{text-align:center;width:100%}.voxel-datepicker__day[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:transparent;border:none;border-radius:var(--ids_size_cornerRadius_button);color:var(--ids_color_action_neutral_variant);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:var(--ids_size_general_24x);min-height:var(--ids_size_general_44x);min-width:var(--ids_size_general_44x);position:relative;text-align:center}.voxel-datepicker__day[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:block}.voxel-datepicker__day[_ngcontent-%COMP%]:disabled{color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-datepicker__day[_ngcontent-%COMP%]:hover:not(:disabled):not(.voxel-datepicker__day--selected){background-color:var(--ids_color_bg_variant_02)}.voxel-datepicker__day--currentDate[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_medium_bold)}.voxel-datepicker__day--currentDate[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-bottom:.1875rem solid var(--ids_color_action_neutral_variant)}.voxel-datepicker__day--selected[_ngcontent-%COMP%]{background:var(--ids_color_action_secondary_base);color:var(--ids_color_contrast_onDark)}@media (max-width: 340px){.voxel-datepicker[_ngcontent-%COMP%]{padding:var(--ids_spacing_4x) var(--ids_spacing_2x)}.voxel-datepicker__table[_ngcontent-%COMP%]{margin-left:-.125rem}}.voxel-datepicker__day--currentDate.voxel-datepicker__day--selected[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border-bottom-color:var(--ids_color_contrast_onDark)}"] });
VoxelDatepickerComponent.ctorParameters = () => [
    { type: LiveAnnouncer },
    { type: Platform },
    { type: Renderer2 },
    { type: Overlay }
];
VoxelDatepickerComponent.propDecorators = {
    formFieldId: [{ type: Input }],
    ariaDescribedby: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    tabindex: [{ type: Input }],
    dateFormat: [{ type: Input }],
    maxDate: [{ type: Input }],
    minDate: [{ type: Input }],
    dateFilter: [{ type: Input }],
    calendarConfig: [{ type: Input }],
    position: [{ type: Input }],
    input: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    toggle: [{ type: Output }],
    overlayDir: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }],
    datepickerButton: [{ type: ViewChild, args: ['datepickerButton', { static: true },] }],
    datepickerOrigin: [{ type: ViewChild, args: ['origin', { static: true },] }],
    tableDays: [{ type: ViewChild, args: ['tableDays', { static: false },] }],
    calendarFull: [{ type: ViewChild, args: ['calendarFull', { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDatepickerComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-datepicker',
                template: "<div\n  class=\"voxel-datepicker__open\"\n  cdkOverlayOrigin\n  #origin=\"cdkOverlayOrigin\"\n>\n<button\n  type=\"button\"\n  #datepickerButton\n  [attr.id]=\"formFieldId\"\n  class=\"voxel-datepicker__button\"\n  (click)=\"open()\"\n  (focus)=\"onFocus()\"\n  (blur)=\"onBlur()\"\n  [disabled]=\"disabled\"\n  [tabindex]=\"tabindex\"\n  aria-haspopup=\"dialog\"\n  [attr.aria-label]=\"calendarConfig.label\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n>\n  <voxel-icon>calendario_outline</voxel-icon>\n</button>\n</div>\n\n<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  [cdkConnectedOverlayBackdropClass]=\"!isMobile ? 'cdk-overlay-transparent-backdrop' : ''\"\n  [cdkConnectedOverlayOpen]=\"calendarOpen\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayMinWidth]=\"screenWidth < 340 ? '320px' : '340px'\"\n  [cdkConnectedOverlayOffsetY]=\"offsetY\"\n  [cdkConnectedOverlayOffsetX]=\"30\"\n  (backdropClick)=\"close()\"\n  (detach)=\"close()\"\n  (attach)=\"attach()\"\n>\n  <dialog class=\"voxel-datepicker\" aria-modal=\"true\">\n    <div #calendarFull class=\"voxel-datepicker__container\" role=\"application\" cdkTrapFocus>\n      <div class=\"voxel-datepicker__header\">\n        <div class=\"voxel-datepicker__month-control\">\n          <button\n            #btnPrevMonth\n            type=\"button\"\n            class=\"voxel-datepicker__button voxel-datepicker__prevMonth\"\n            [attr.aria-label]=\"calendarConfig.prevMonth\"\n            (click)=\"prevMonth(btnPrevMonth); tabIndexDay()\"\n            [disabled]=\"disabledMonth(month, year)[0]\"\n          >\n            <voxel-icon>seta_esquerda</voxel-icon>\n          </button>\n          <p\n            class=\"voxel-datepicker__month-name\"\n            [attr.aria-label]=\"isMobile ? calendarConfig.monthNames[month] : null\"\n            aria-live=\"polite\"\n          >\n            {{calendarConfig.monthNames[month]}}\n          </p>\n          <button\n            #btnNextMonth\n            type=\"button\"\n            class=\"voxel-datepicker__button voxel-datepicker__nextMonth\"\n            [attr.aria-label]=\"calendarConfig.nextMonth\"\n            (click)=\"nextMonth(btnNextMonth); tabIndexDay()\"\n            [disabled]=\"disabledMonth(month, year)[1]\"\n          >\n            <voxel-icon>seta_direita</voxel-icon>\n          </button>\n        </div>\n        <div class=\"voxel-datepicker__year-control\">\n          <button\n            #btnPrevYear\n            type=\"button\"\n            class=\"voxel-datepicker__button voxel-datepicker__prevYear\"\n            [attr.aria-label]=\"calendarConfig.prevYear\"\n            (click)=\"prevYear(btnPrevYear); tabIndexDay()\"\n            [disabled]=\"disabledYear(year)[0]\"\n          >\n            <voxel-icon>seta_esquerda</voxel-icon>\n          </button>\n          <p\n            class=\"voxel-datepicker__year-number\"\n            [attr.aria-label]=\"isMobile ? year : null\"\n            aria-live=\"polite\"\n          >\n            {{year}}\n          </p>\n          <button\n            #btnNextYear\n            type=\"button\"\n            class=\"voxel-datepicker__button voxel-datepicker__nextYear\"\n            [attr.aria-label]=\"calendarConfig.nextYear\"\n            (click)=\"nextYear(btnNextYear); tabIndexDay()\"\n            [disabled]=\"disabledYear(year)[1]\"\n          >\n            <voxel-icon>seta_direita</voxel-icon>\n          </button>\n        </div>\n      </div>\n      <div class=\"voxel-datepicker__calendar\">\n        <table\n          #tableDays\n          role=\"presentation\"\n          class=\"voxel-datepicker__table\"\n          (keydown)=\"handleKeydown($event)\"\n        >\n          <thead class=\"voxel-datepicker__week\">\n            <tr>\n              <th *ngFor=\"let week of calendarConfig.weekNames; index as i;\">\n                <span [attr.title]=\"week.name\">{{week.abbreviation}}</span>\n              </th>\n            </tr>\n          </thead>\n          <tbody\n            class=\"voxel-datepicker__days\"\n          >\n            <tr *ngFor=\"let week of calendar; index as row\">\n              <td *ngFor=\"let dayWeek of week; index as col\">\n                <button\n                  *ngIf=\"dayWeek\"\n                  class=\"voxel-datepicker__day voxel-datepicker__day-{{dayWeek}}\"\n                  [class.voxel-datepicker__day--currentDate]=\"isCurrentDate(dayWeek, month, year)\"\n                  [class.voxel-datepicker__day--selected]=\"value === convertToDate(dayWeek)\"\n                  [class.voxel-datepicker__day--focus]=\"dateFocus === convertToDate(dayWeek)\"\n                  [class.voxel-datepicker__day--enable]=\"!disabledDay(dayWeek)\"\n                  [disabled]=\"disabledDay(dayWeek)\"\n                  (click)=\"selectDate(dayWeek)\"\n                  [attr.aria-label]=\"ariaLabelDay(dayWeek, value === convertToDate(dayWeek))\"\n                  [attr.aria-current]=\"isCurrentDate(dayWeek, month, year) ? 'date' : null\"\n                  [attr.data-row]=\"row\"\n                  [attr.data-col]=\"col\"\n                  [attr.tabindex]=\"!isMobile ? '-1' : ''\"\n                  (focus)=\"dayFocus(oudElementFocus, $event.target)\"\n                >\n                  <span>{{dayWeek}}</span>\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n      <button\n        type=\"button\"\n        class=\"voxel-datepicker__button voxel-datepicker__close\"\n        [attr.aria-label]=\"calendarConfig.close\"\n        (click)=\"close()\"\n      >\n      fechar\n      </button>\n    </div>\n  </dialog>\n</ng-template>\n",
                styles: [".voxel-datepicker{background:var(--ids_color_bg_base);border:none;border-radius:var(--ids_size_cornerRadius_tooltip);-webkit-box-shadow:0 var(--ids_size_general_2x) var(--ids_size_general_8x) 0 rgba(86,80,76,.24);box-shadow:0 var(--ids_size_general_2x) var(--ids_size_general_8x) 0 rgba(86,80,76,.24);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);height:auto;left:auto;margin-top:var(--ids_size_general_7x);padding:var(--ids_spacing_4x);position:relative;right:auto;width:100%}.voxel-datepicker__open{display:inline}.voxel-datepicker__container{width:100%}.voxel-datepicker__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:var(--ids_spacing_3x);margin-top:-.25rem}.voxel-datepicker__table{border-collapse:collapse;min-height:18rem}.voxel-datepicker__button{background:var(--ids_color_bg_base);border:none;color:var(--ids_color_action_primary_base);cursor:pointer}.voxel-datepicker__button:disabled{color:var(--ids_color_action_disabled_base);cursor:auto;cursor:initial}.voxel-datepicker__close{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_border_medium);color:var(--ids_color_action_secondary_base);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_label_medium_bold);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:var(--ids_size_general_44x);position:relative;width:100%}.voxel-datepicker__close:disabled{border:none;cursor:not-allowed}.voxel-datepicker__close:hover{background:var(--ids_color_action_secondary_base_soft)}@media (min-width: 64rem){.voxel-datepicker__close{font:var(--ids_textStyle_label_large_bold);padding:var(--ids_size_general_6x) var(--ids_size_general_24x)}}.voxel-datepicker__calendar-icon{background-color:var(--ids_color_bg_base);border:none;right:0;top:var(--ids_size_general_5x)}.voxel-datepicker__month-control,.voxel-datepicker__year-control{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-left:-.375rem;margin-right:-.375rem}.voxel-datepicker__month-control>button,.voxel-datepicker__year-control>button{min-height:var(--ids_size_general_44x);min-width:var(--ids_size_general_44x)}.voxel-datepicker__month-control>button+p,.voxel-datepicker__year-control>button+p{margin-bottom:var(--ids_size_general_3x)}.voxel-datepicker__month-name{min-width:4.75rem;text-align:center}.voxel-datepicker__month-name,.voxel-datepicker__year-number{font:var(--ids_textStyle_label_medium_bold);text-align:center}.voxel-datepicker__week{margin:var(--ids_size_general_8x) 0}.voxel-datepicker__week th{font:var(--ids_textStyle_label_medium_bold)}.voxel-datepicker__week,.voxel-datepicker__days{text-align:center;width:100%}.voxel-datepicker__day{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:transparent;border:none;border-radius:var(--ids_size_cornerRadius_button);color:var(--ids_color_action_neutral_variant);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:var(--ids_size_general_24x);min-height:var(--ids_size_general_44x);min-width:var(--ids_size_general_44x);position:relative;text-align:center}.voxel-datepicker__day span{display:block}.voxel-datepicker__day:disabled{color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-datepicker__day:hover:not(:disabled):not(.voxel-datepicker__day--selected){background-color:var(--ids_color_bg_variant_02)}.voxel-datepicker__day--currentDate{font:var(--ids_textStyle_label_medium_bold)}.voxel-datepicker__day--currentDate span{border-bottom:.1875rem solid var(--ids_color_action_neutral_variant)}.voxel-datepicker__day--selected{background:var(--ids_color_action_secondary_base);color:var(--ids_color_contrast_onDark)}@media (max-width: 340px){.voxel-datepicker{padding:var(--ids_spacing_4x) var(--ids_spacing_2x)}.voxel-datepicker__table{margin-left:-.125rem}}.voxel-datepicker__day--currentDate.voxel-datepicker__day--selected span{border-bottom-color:var(--ids_color_contrast_onDark)}\n"]
            }]
    }], function () { return [{ type: ɵngcc5.LiveAnnouncer }, { type: ɵngcc6.Platform }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc2.Overlay }]; }, { formFieldId: [{
            type: Input
        }], ariaDescribedby: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], minDate: [{
            type: Input
        }], dateFilter: [{
            type: Input
        }], calendarConfig: [{
            type: Input
        }], position: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], toggle: [{
            type: Output
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], tabindex: [{
            type: Input
        }], input: [{
            type: Input
        }], overlayDir: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }], datepickerButton: [{
            type: ViewChild,
            args: ['datepickerButton', { static: true }]
        }], datepickerOrigin: [{
            type: ViewChild,
            args: ['origin', { static: true }]
        }], tableDays: [{
            type: ViewChild,
            args: ['tableDays', { static: false }]
        }], calendarFull: [{
            type: ViewChild,
            args: ['calendarFull', { static: false }]
        }] }); })();

class VoxelDatepickerModule {
}
VoxelDatepickerModule.ɵfac = function VoxelDatepickerModule_Factory(t) { return new (t || VoxelDatepickerModule)(); };
VoxelDatepickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelDatepickerModule });
VoxelDatepickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [VoxelMaskService], imports: [[CommonModule, OverlayModule, VoxelIconModule, A11yModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDatepickerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, OverlayModule, VoxelIconModule, A11yModule],
                declarations: [VoxelDatepickerComponent, VoxelDatepickerDirective],
                exports: [VoxelDatepickerComponent, VoxelDatepickerDirective],
                providers: [VoxelMaskService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelDatepickerModule, { declarations: function () { return [VoxelDatepickerComponent, VoxelDatepickerDirective]; }, imports: function () { return [CommonModule, OverlayModule, VoxelIconModule, A11yModule]; }, exports: function () { return [VoxelDatepickerComponent, VoxelDatepickerDirective]; } }); })();

/* eslint-disable @angular-eslint/no-output-rename */
let NEXT_ID$g = 0;
/**
 * Componente de Dialog
 *
 * **Module:**
 *
 * `import { VoxelDialogModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/dialog?componentOnly=true</example-url>
 */
class VoxelDialogComponent extends VoxelModalBaseComponent {
    constructor() {
        super(...arguments);
        /** @internal */
        this.className = 'voxel-dialog';
        this._dialogAriaLabelledby = 'voxel-fake-dialog-aria-labelledby';
        /**
         * Sufixo dos ids internos do dialog
         *
         * *Dialog internal id suffixes*
         */
        this.dialogId = `voxel-dialog-${NEXT_ID$g++}`;
        this._dialogIsOpen = false;
        /**
         * Evento para o dialog se auto fechar
         *
         * *Event for the dialog to close itself*
         */
        this.outputClose = new EventEmitter();
        /**
         * Evento que avisa quando o dialog abriu
         *
         * *Event that announces when the dialog has opened*
         */
        this.outputOpen = new EventEmitter();
    }
    /**
     * Id do título do dialog para ser lido por leitores de tela
     *
     * *Dialog title ID to be learned by screen readers*
     */
    set dialogAriaLabelledby(value) {
        this._dialogAriaLabelledby = value;
    }
    get dialogAriaLabelledby() {
        if (this.forceAriaLabelledby || platform.os !== 'Windows') {
            return this._dialogAriaLabelledby;
        }
        return 'voxel-fake-dialog-aria-labelledby';
    }
    /**
     * Define se o dialog está aberto
     *
     * *Defines if dialog is open*
     */
    set dialogIsOpen(open) {
        if (!open && this._dialogIsOpen) {
            this.detach();
        }
        this._dialogIsOpen = enforceBoolean(open);
    }
    get dialogIsOpen() {
        return this._dialogIsOpen;
    }
}
VoxelDialogComponent.ɵfac = /*@__PURE__*/ function () { let ɵVoxelDialogComponent_BaseFactory; return function VoxelDialogComponent_Factory(t) { return (ɵVoxelDialogComponent_BaseFactory || (ɵVoxelDialogComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelDialogComponent)))(t || VoxelDialogComponent); }; }();
VoxelDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelDialogComponent, selectors: [["voxel-dialog"]], inputs: { dialogId: "dialogId", dialogAriaLabelledby: "dialogAriaLabelledby", dialogIsOpen: "dialogIsOpen", dialogAriaDescribedby: "dialogAriaDescribedby", inputClass: ["dialogClass", "inputClass"], dialogLang: "dialogLang", inputOrigin: ["dialogOrigin", "inputOrigin"] }, outputs: { outputClose: "dialogClose", outputOpen: "dialogOpen" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c23, decls: 1, vars: 5, consts: [["cdkConnectedOverlay", "", "cdkConnectedOverlayHasBackdrop", "", 3, "cdkConnectedOverlayOpen", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayScrollStrategy", "backdropClick", "detach", "attach"], ["cdkTrapFocus", "", "role", "dialog", "tabindex", "-1", 1, "voxel-dialog__content", 3, "id"], ["contentRef", ""], ["cdkScrollable", "", 1, "voxel-dialog__body"], ["bodyRef", ""], ["id", "voxel-fake-dialog-aria-labelledby"]], template: function VoxelDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c22);
        ɵngcc0.ɵɵtemplate(0, VoxelDialogComponent_ng_template_0_Template, 7, 5, "ng-template", 0);
        ɵngcc0.ɵɵlistener("backdropClick", function VoxelDialogComponent_Template_ng_template_backdropClick_0_listener() { return ctx.canClose && (ctx.dialogIsOpen = false); })("detach", function VoxelDialogComponent_Template_ng_template_detach_0_listener() { return ctx.canClose && (ctx.dialogIsOpen = false); })("attach", function VoxelDialogComponent_Template_ng_template_attach_0_listener() { return ctx.attach(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayOpen", ctx.dialogIsOpen)("cdkConnectedOverlayOrigin", ctx.inputOrigin)("cdkConnectedOverlayDisableClose", !ctx.canClose)("cdkConnectedOverlayPanelClass", ctx.classes)("cdkConnectedOverlayScrollStrategy", ctx.overlay.scrollStrategies[ctx.scrollStrategy]());
    } }, directives: [ɵngcc2.CdkConnectedOverlay, ɵngcc5.CdkTrapFocus, ɵngcc7.CdkScrollable], styles: [".voxel-dialog{display:-webkit-box;display:-ms-flexbox;display:flex;height:auto;isolation:isolate;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;max-height:min(80vh,50rem);min-height:auto;width:22rem}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-dialog{height:100%;max-height:80vh}}.voxel-dialog__footer{background-color:var(--ids_color_bg_base);display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_12x);gap:var(--ids_size_general_12x);-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:var(--ids_size_general_22x) var(--ids_size_general_24x) var(--ids_size_general_24x);position:relative}.voxel-dialog__footer>*{white-space:nowrap}.voxel-dialog__footer--full>*{-webkit-box-flex:initial;-ms-flex:initial;flex:initial;width:100%}.voxel-dialog__content{background-color:var(--ids_color_bg_base);border:var(--ids_size_general_1x) solid var(--ids_color_border_soft);border-radius:var(--ids_size_general_4x);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:inherit;overflow:hidden;position:static;width:18rem}.voxel-dialog__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:auto;padding:var(--ids_size_general_24x) var(--ids_size_general_24x) var(--ids_size_general_2x);position:relative}@media (min-width: 48rem){.voxel-dialog .voxel-dialog__content{width:22rem}}\n"], encapsulation: 2 });
VoxelDialogComponent.propDecorators = {
    dialogAriaDescribedby: [{ type: Input }],
    dialogAriaLabelledby: [{ type: Input }],
    inputClass: [{ type: Input, args: ['dialogClass',] }],
    dialogId: [{ type: Input }],
    dialogIsOpen: [{ type: Input }],
    dialogLang: [{ type: Input }],
    inputOrigin: [{ type: Input, args: ['dialogOrigin',] }],
    outputClose: [{ type: Output, args: ['dialogClose',] }],
    outputOpen: [{ type: Output, args: ['dialogOpen',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDialogComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-dialog',
                template: "<ng-template\n  cdkConnectedOverlay\n  [cdkConnectedOverlayOpen]=\"dialogIsOpen\"\n  [cdkConnectedOverlayOrigin]=\"inputOrigin\"\n  cdkConnectedOverlayHasBackdrop\n  [cdkConnectedOverlayDisableClose]=\"!canClose\"\n  (backdropClick)=\"canClose && dialogIsOpen = false\"\n  (detach)=\"canClose && dialogIsOpen = false\"\n  (attach)=\"attach()\"\n  [cdkConnectedOverlayPanelClass]=\"classes\"\n  [cdkConnectedOverlayScrollStrategy]=\"overlay.scrollStrategies[scrollStrategy]()\"\n>\n  <section\n    cdkTrapFocus\n    class=\"voxel-dialog__content\"\n    role=\"dialog\"\n    [attr.aria-labelledby]=\"dialogAriaLabelledby\"\n    [attr.aria-describedby]=\"dialogAriaDescribedby\"\n    #contentRef\n    [attr.lang]=\"dialogLang\"\n    [id]=\"dialogId\"\n    tabindex=\"-1\"\n    [attr.aria-modal]=\"ariaModal\"\n  >\n    <div class=\"voxel-dialog__body\" cdkScrollable #bodyRef>\n      <ng-content></ng-content>\n    </div>\n\n    <ng-content select=\"[voxelDialogFooter]\"></ng-content>\n\n    <div id=\"voxel-fake-dialog-aria-labelledby\"></div>\n  </section>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-dialog{display:-webkit-box;display:-ms-flexbox;display:flex;height:auto;isolation:isolate;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;max-height:min(80vh,50rem);min-height:auto;width:22rem}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-dialog{height:100%;max-height:80vh}}.voxel-dialog__footer{background-color:var(--ids_color_bg_base);display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_12x);gap:var(--ids_size_general_12x);-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:var(--ids_size_general_22x) var(--ids_size_general_24x) var(--ids_size_general_24x);position:relative}.voxel-dialog__footer>*{white-space:nowrap}.voxel-dialog__footer--full>*{-webkit-box-flex:initial;-ms-flex:initial;flex:initial;width:100%}.voxel-dialog__content{background-color:var(--ids_color_bg_base);border:var(--ids_size_general_1x) solid var(--ids_color_border_soft);border-radius:var(--ids_size_general_4x);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:inherit;overflow:hidden;position:static;width:18rem}.voxel-dialog__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:auto;padding:var(--ids_size_general_24x) var(--ids_size_general_24x) var(--ids_size_general_2x);position:relative}@media (min-width: 48rem){.voxel-dialog .voxel-dialog__content{width:22rem}}\n"]
            }]
    }], null, { dialogId: [{
            type: Input
        }], outputClose: [{
            type: Output,
            args: ['dialogClose']
        }], outputOpen: [{
            type: Output,
            args: ['dialogOpen']
        }], dialogAriaLabelledby: [{
            type: Input
        }], dialogIsOpen: [{
            type: Input
        }], dialogAriaDescribedby: [{
            type: Input
        }], inputClass: [{
            type: Input,
            args: ['dialogClass']
        }], dialogLang: [{
            type: Input
        }], inputOrigin: [{
            type: Input,
            args: ['dialogOrigin']
        }] }); })();

class VoxelDialogFooterDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Define se o rodapé do dialog será com botões em linha ou um abaixo do outro
         *
         * *Sets wheter footer will be with button inline or one below the other*
         */
        this.voxelDialogFooter = '';
    }
    get classes() {
        return this.voxelDialogFooter === 'full'
            ? 'voxel-dialog__footer voxel-dialog__footer--full'
            : 'voxel-dialog__footer';
    }
}
VoxelDialogFooterDirective.ɵfac = function VoxelDialogFooterDirective_Factory(t) { return new (t || VoxelDialogFooterDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelDialogFooterDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelDialogFooterDirective, selectors: [["", "voxelDialogFooter", ""]], hostVars: 2, hostBindings: function VoxelDialogFooterDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.classes);
    } }, inputs: { voxelDialogFooter: "voxelDialogFooter" }, exportAs: ["voxelDialogFooter"] });
VoxelDialogFooterDirective.ctorParameters = () => [
    { type: ElementRef }
];
VoxelDialogFooterDirective.propDecorators = {
    voxelDialogFooter: [{ type: Input }],
    classes: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDialogFooterDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelDialogFooter]',
                exportAs: 'voxelDialogFooter'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { voxelDialogFooter: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class VoxelDialogModule {
}
VoxelDialogModule.ɵfac = function VoxelDialogModule_Factory(t) { return new (t || VoxelDialogModule)(); };
VoxelDialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelDialogModule });
VoxelDialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[A11yModule, CommonModule, OverlayModule, VoxelOverlayModalModule], VoxelOverlayModalModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDialogModule, [{
        type: NgModule,
        args: [{
                imports: [A11yModule, CommonModule, OverlayModule, VoxelOverlayModalModule],
                declarations: [VoxelDialogComponent, VoxelDialogFooterDirective],
                exports: [VoxelDialogComponent, VoxelDialogFooterDirective, VoxelOverlayModalModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelDialogModule, { declarations: function () { return [VoxelDialogComponent, VoxelDialogFooterDirective]; }, imports: function () { return [A11yModule, CommonModule, OverlayModule, VoxelOverlayModalModule]; }, exports: function () { return [VoxelDialogComponent, VoxelDialogFooterDirective, VoxelOverlayModalModule]; } }); })();

class VoxelMaskPipe {
    constructor(voxelMaskService) {
        this.voxelMaskService = voxelMaskService;
    }
    transform(value, mask, config) {
        this._mask = mask;
        if (typeof mask === 'string') {
            this._mask = this.voxelMaskService.regExpMask(mask);
        }
        if (mask === 'date') {
            const dateConfig = config ? ('format' in config ? config : undefined) : undefined;
            this._mask = this.voxelMaskService.dateMask(value, dateConfig);
        }
        if (mask === 'currency') {
            const currencyConfig = config ? ('prefix' in config ? config : undefined) : undefined;
            this._mask = this.voxelMaskService.currencyMask.bind(this, value, currencyConfig);
        }
        return this.valueMask(value);
    }
    /**
     * @internal
     */
    valueMask(value) {
        const valueMask = this.voxelMaskService.valueWithMask(value, this._mask);
        return valueMask.valueMask;
    }
}
VoxelMaskPipe.ɵfac = function VoxelMaskPipe_Factory(t) { return new (t || VoxelMaskPipe)(ɵngcc0.ɵɵdirectiveInject(VoxelMaskService, 16)); };
VoxelMaskPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "voxelMask", type: VoxelMaskPipe, pure: true });
VoxelMaskPipe.ctorParameters = () => [
    { type: VoxelMaskService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelMaskPipe, [{
        type: Pipe,
        args: [{
                name: 'voxelMask'
            }]
    }], function () { return [{ type: VoxelMaskService }]; }, null); })();

class VoxelMaskModule {
    static forRoot(maskConfig) {
        return {
            ngModule: VoxelMaskModule,
            providers: [
                {
                    provide: CURRENCY_CONFIG,
                    useValue: maskConfig.currencyConfig,
                },
                {
                    provide: DATE_CONFIG,
                    useValue: maskConfig.dateConfig,
                },
            ],
        };
    }
}
VoxelMaskModule.ɵfac = function VoxelMaskModule_Factory(t) { return new (t || VoxelMaskModule)(); };
VoxelMaskModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelMaskModule });
VoxelMaskModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [VoxelMaskService], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelMaskModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelMaskDirective, VoxelMaskPipe],
                exports: [VoxelMaskDirective, VoxelMaskPipe],
                providers: [VoxelMaskService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelMaskModule, { declarations: function () { return [VoxelMaskDirective, VoxelMaskPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelMaskDirective, VoxelMaskPipe]; } }); })();

/**
 * @internal
 */
const VoxelCrescentChart = trigger('crescentTrigger', [
    state('*', style({
        width: '0%',
    })),
    state('true', style({
        width: '{{chartPosition}}',
    }), { params: { chartPosition: '0' } }),
    transition('* => true', animate('2000ms ease-out')),
]);
/**
 * @internal
 */
const VoxelDecrescentChart = trigger('decrescentTrigger', [
    state('*', style({
        width: '100%',
    })),
    state('true', style({
        width: '{{chartPosition}}',
    }), { params: { chartPosition: '0' } }),
    transition('* => true', animate('2000ms ease-out')),
]);

/** @internal */
let NEXT_ID$f = 0;
/**
 *
 * Componente expense-chart
 *
 * **Module:**
 *
 * `import { VoxelExpenseChartModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/expense-chart?componentOnly=true</example-url>
 *
 */
class VoxelExpenseChartComponent {
    constructor() {
        /** @internal */
        this._chartPosition = '0%';
        /** @internal */
        this._currencyConfig = {
            allowNegative: false,
            decimal: ',',
            precision: 2,
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
        };
        /** @internal */
        this._currencyType = 'BRL';
        /** @internal */
        this._currentValue = 0;
        /** @internal */
        this._state = false;
        /** @internal */
        this._type = 'crescent';
        /** @internal */
        this._totalValue = 0;
        /**
         * define o texto que será exibido no chart atribuído ao valor atual
         *
         * *defines the text to be displayed about the current value*
         */
        this.currentLabel = 'utilizado';
        /**
         * Id do componente de expense chart
         *
         * *Expense Chart id*
         */
        this.expenseChartId = `voxel-expense-chart-${NEXT_ID$f++}`;
        /**
         * define o tema, valor opcional, se não passado o tema default será aplicado
         *
         * *defines the theme, is an optional value, if not passed the default value will be applied*
         */
        this.theme = 'dark';
        /**
         * define o texto que será exibido no chart atribuído ao valor atual
         *
         * *defines the text to be displayed about the current value*
         */
        this.totalLabel = 'total';
    }
    /**
     * define o texto acessível para o componente o valor aqui é opcional
     *
     * *defines the accessible text of the component, this value is optional*
     */
    set a11yLabel(arialabel) {
        this._a11yLabel = arialabel;
    }
    get a11yLabel() {
        if (!this._a11yLabel) {
            return `O ${this.currentLabel} é de ${this.currencyReading(this.currentValue)}, do ${this.totalLabel} de ${this.currencyReading(this.totalValue)}`;
        }
        return this._a11yLabel;
    }
    /**
     * define o tipo de moeda para ajudar na leitura acessível
     *
     * *defines the currency type to help in accessible reading*
     */
    set currencyType(value) {
        this._currencyType = value;
        this._currencyConfig.prefix = currencyPrefix(value);
    }
    get currencyType() {
        return this._currencyType;
    }
    /**
     * define o valor atual do chart e portanto a posição da barra, se decrescente não pode ser maior que o valor atual
     *
     * *defines the current value of the chart therefore the bar position, if decrescent cannot be greater than the total value*
     */
    set currentValue(value) {
        this._currentValue = enforceNumber(value);
        this.setOverflowChart();
        this._state = true;
    }
    get currentValue() {
        return this._currentValue;
    }
    /**
     * define o valor atual do chart e portanto a posição da barra, se decrescente não pode ser maior que o valor atual
     *
     * *defines the current value of the chart therefore the bar position, if decrescent cannot be greater than the total value*
     */
    set totalValue(value) {
        this._totalValue = enforceNumber(value);
        this.setOverflowChart();
    }
    get totalValue() {
        return this._totalValue;
    }
    /**
     * define o tipo de chart, se decrescente o valor atual não pode ser maior que o total
     *
     * *it defines the type of chart, if decrescent the current value cannot be greater than the total value*
     */
    set type(type) {
        this._type = type;
    }
    get type() {
        return this._type;
    }
    get chartPosition() {
        return this._chartPosition;
    }
    get currencyConfig() {
        return this._currencyConfig;
    }
    get state() {
        return this._state;
    }
    /** @internal */
    ngOnInit() {
        this._state = true;
    }
    /** @internal */
    currencyReading(value) {
        return accessibleCurrencyReading(value, this.currencyType);
    }
    /** @internal */
    setOverflowChart() {
        if (this._currentValue <= 0 && this._totalValue <= 0) {
            return;
        }
        if (this._currentValue >= this._totalValue) {
            this._chartPosition = 100 + '%';
            return;
        }
        this._chartPosition = (100 * this._currentValue) / this._totalValue + '%';
        return;
    }
}
VoxelExpenseChartComponent.ɵfac = function VoxelExpenseChartComponent_Factory(t) { return new (t || VoxelExpenseChartComponent)(); };
VoxelExpenseChartComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelExpenseChartComponent, selectors: [["voxel-expense-chart"]], inputs: { currentLabel: "currentLabel", expenseChartId: "expenseChartId", theme: "theme", totalLabel: "totalLabel", a11yLabel: "a11yLabel", currencyType: "currencyType", currentValue: "currentValue", totalValue: "totalValue", type: "type" }, decls: 15, vars: 31, consts: [["role", "img", 1, "voxel-expense-chart", 3, "ngClass"], ["aria-hidden", "true", 1, "voxel-expense-chart__title"], [1, "voxel-expense-chart__current-label"], [1, "voxel-expense-chart__total-label"], [1, "voxel-expense-chart__bar"], [1, "voxel-expense-chart__progress"], ["aria-hidden", "true", 1, "voxel-expense-chart__footer"], [1, "voxel-expense-chart__current-value"], [1, "voxel-expense-chart__total-value"]], template: function VoxelExpenseChartComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelement(7, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "span", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "voxelMask");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span", 8);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "voxelMask");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c24, ctx.theme === "light"));
        ɵngcc0.ɵɵattribute("id", ctx.expenseChartId)("aria-label", ctx.a11yLabel);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.currentLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.totalLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("width", ctx.chartPosition);
        ɵngcc0.ɵɵproperty("@crescentTrigger", ɵngcc0.ɵɵpureFunction2(23, _c26, ctx.state, ɵngcc0.ɵɵpureFunction1(21, _c25, ctx.chartPosition)))("@decrescentTrigger", ɵngcc0.ɵɵpureFunction2(28, _c26, ctx.type === "decrescent", ɵngcc0.ɵɵpureFunction1(26, _c25, ctx.chartPosition)));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(11, 11, ctx.currentValue.toFixed(2), "currency", ctx.currencyConfig), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(14, 15, ctx.totalValue.toFixed(2), "currency", ctx.currencyConfig), " ");
    } }, directives: [ɵngcc1.NgClass], pipes: [VoxelMaskPipe], styles: [".voxel-expense-chart__title[_ngcontent-%COMP%], .voxel-expense-chart__footer[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;line-height:1.375rem}.voxel-expense-chart__footer[_ngcontent-%COMP%]{font-weight:bold}.voxel-expense-chart__bar[_ngcontent-%COMP%]{background:var(--ids_color_bg_variant_02);border-radius:.3125rem;display:block;height:var(--ids_size_general_8x);margin:.5625rem 0;position:relative}.voxel-expense-chart__progress[_ngcontent-%COMP%]{background:var(--ids_color_action_secondary_base);border-radius:.3125rem;display:block;height:100%;overflow:hidden;position:relative}.voxel-expense-chart--light[_ngcontent-%COMP%]   .voxel-expense-chart__title[_ngcontent-%COMP%], .voxel-expense-chart--light[_ngcontent-%COMP%]   .voxel-expense-chart__footer[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-expense-chart--light[_ngcontent-%COMP%]   .voxel-expense-chart__bar[_ngcontent-%COMP%]{background:var(--ids_color_bg_base_medium)}.voxel-expense-chart--light[_ngcontent-%COMP%]   .voxel-expense-chart__progress[_ngcontent-%COMP%]{background:var(--ids_color_contrast_onDark)}"], data: { animation: [VoxelCrescentChart, VoxelDecrescentChart] }, changeDetection: 0 });
VoxelExpenseChartComponent.selector = 'voxel-expense-chart';
VoxelExpenseChartComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    currentLabel: [{ type: Input }],
    currencyType: [{ type: Input }],
    currentValue: [{ type: Input }],
    expenseChartId: [{ type: Input }],
    theme: [{ type: Input }],
    totalLabel: [{ type: Input }],
    totalValue: [{ type: Input }],
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelExpenseChartComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-expense-chart',
                template: "<div\n  [attr.id]=\"expenseChartId\"\n  class=\"voxel-expense-chart\"\n  [ngClass]=\"{'voxel-expense-chart--light' : theme === 'light'}\"\n  [attr.aria-label]=\"a11yLabel\"\n  role=\"img\">\n  <div class=\"voxel-expense-chart__title\" aria-hidden=\"true\">\n    <span class=\"voxel-expense-chart__current-label\">{{ currentLabel }}</span>\n    <span class=\"voxel-expense-chart__total-label\">{{ totalLabel }}</span>\n  </div>\n  <div class=\"voxel-expense-chart__bar\">\n    <span\n      class=\"voxel-expense-chart__progress\"\n      [style.width]=\"chartPosition\"\n      [@crescentTrigger]=\"{ value: state, params: { chartPosition: chartPosition } }\"\n      [@decrescentTrigger]=\"{\n        value: type === 'decrescent',\n        params: { chartPosition: chartPosition }\n      }\"\n    ></span>\n  </div>\n  <div class=\"voxel-expense-chart__footer\" aria-hidden=\"true\">\n    <span\n      class=\"voxel-expense-chart__current-value\"\n    >\n      {{ currentValue.toFixed(2) | voxelMask: 'currency':currencyConfig }}\n    </span>\n    <span\n      class=\"voxel-expense-chart__total-value\"\n    >\n      {{ totalValue.toFixed(2) | voxelMask: 'currency':currencyConfig }}\n    </span>\n  </div>\n</div>\n",
                animations: [VoxelCrescentChart, VoxelDecrescentChart],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".voxel-expense-chart__title,.voxel-expense-chart__footer{color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;line-height:1.375rem}.voxel-expense-chart__footer{font-weight:bold}.voxel-expense-chart__bar{background:var(--ids_color_bg_variant_02);border-radius:.3125rem;display:block;height:var(--ids_size_general_8x);margin:.5625rem 0;position:relative}.voxel-expense-chart__progress{background:var(--ids_color_action_secondary_base);border-radius:.3125rem;display:block;height:100%;overflow:hidden;position:relative}.voxel-expense-chart--light .voxel-expense-chart__title,.voxel-expense-chart--light .voxel-expense-chart__footer{color:var(--ids_color_contrast_onDark)}.voxel-expense-chart--light .voxel-expense-chart__bar{background:var(--ids_color_bg_base_medium)}.voxel-expense-chart--light .voxel-expense-chart__progress{background:var(--ids_color_contrast_onDark)}\n"]
            }]
    }], function () { return []; }, { currentLabel: [{
            type: Input
        }], expenseChartId: [{
            type: Input
        }], theme: [{
            type: Input
        }], totalLabel: [{
            type: Input
        }], a11yLabel: [{
            type: Input
        }], currencyType: [{
            type: Input
        }], currentValue: [{
            type: Input
        }], totalValue: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class VoxelExpenseChartModule {
}
VoxelExpenseChartModule.ɵfac = function VoxelExpenseChartModule_Factory(t) { return new (t || VoxelExpenseChartModule)(); };
VoxelExpenseChartModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelExpenseChartModule, bootstrap: function () { return [VoxelExpenseChartComponent]; } });
VoxelExpenseChartModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelMaskModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelExpenseChartModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelMaskModule],
                declarations: [VoxelExpenseChartComponent],
                exports: [VoxelExpenseChartComponent],
                bootstrap: [VoxelExpenseChartComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelExpenseChartModule, { declarations: function () { return [VoxelExpenseChartComponent]; }, imports: function () { return [CommonModule, VoxelMaskModule]; }, exports: function () { return [VoxelExpenseChartComponent]; } }); })();

/** @internal */
class VoxelHeaderBackButtonDirective {
    constructor() {
        this.class = 'voxel-header__back-button';
    }
}
VoxelHeaderBackButtonDirective.ɵfac = function VoxelHeaderBackButtonDirective_Factory(t) { return new (t || VoxelHeaderBackButtonDirective)(); };
VoxelHeaderBackButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHeaderBackButtonDirective, selectors: [["", "voxelHeaderBackButton", ""]], hostVars: 2, hostBindings: function VoxelHeaderBackButtonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelHeaderBackButtonDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderBackButtonDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelHeaderBackButton]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/** @internal */
class VoxelHeaderActionButtonDirective {
    constructor() {
        this.class = 'voxel-header__action-button';
    }
}
VoxelHeaderActionButtonDirective.ɵfac = function VoxelHeaderActionButtonDirective_Factory(t) { return new (t || VoxelHeaderActionButtonDirective)(); };
VoxelHeaderActionButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHeaderActionButtonDirective, selectors: [["", "voxelHeaderActionButton", ""]], hostVars: 2, hostBindings: function VoxelHeaderActionButtonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelHeaderActionButtonDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderActionButtonDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelHeaderActionButton]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/** @internal */
class VoxelHeaderTitleDirective {
    constructor() {
        this.class = 'voxel-header__title';
    }
}
VoxelHeaderTitleDirective.ɵfac = function VoxelHeaderTitleDirective_Factory(t) { return new (t || VoxelHeaderTitleDirective)(); };
VoxelHeaderTitleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHeaderTitleDirective, selectors: [["", "voxelHeaderTitle", ""]], hostVars: 2, hostBindings: function VoxelHeaderTitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelHeaderTitleDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelHeaderTitle]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/** @internal */
class VoxelHeaderStepperDirective {
    constructor() {
        this.class = 'voxel-header__stepper';
    }
}
VoxelHeaderStepperDirective.ɵfac = function VoxelHeaderStepperDirective_Factory(t) { return new (t || VoxelHeaderStepperDirective)(); };
VoxelHeaderStepperDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHeaderStepperDirective, selectors: [["", "voxelHeaderStepper", ""]], hostVars: 2, hostBindings: function VoxelHeaderStepperDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelHeaderStepperDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderStepperDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelHeaderStepper]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * O Header exibe informações e ações relacionadas à página atual. É usado para orientar qual página o
 * cliente está, permitindo a navegação e o filtro, no caso do tipo completo de Header.
 *
 * *The Header displays information and actions related to the current page. It is used to guide which*
 * *page the client is on, allowing navigation and filtering, in the case of the full Header type.*
 *
 * **Module:**
 *
 * `import { VoxelHeaderModule } from '@voxel/components';`
 *
 *  <example-url>../../demo/index.html#/portfolio/header?componentOnly=true</example-url>
 */
class VoxelHeaderComponent {
    /**
     * Adiciona uma classe auxiliar que fixa o componente no topo da página. De uso opcional, estilos adicionais
     * podem ser atribuídos diretamente.
     *
     * *Adds a helper class that fixes the component at the top of the page. Optional for use, additional*
     * *styles can be assigned directly.*
     */
    set fixed(fixed) {
        this._fixed = enforceBoolean(fixed);
    }
    get fixed() {
        return this._fixed;
    }
}
VoxelHeaderComponent.ɵfac = function VoxelHeaderComponent_Factory(t) { return new (t || VoxelHeaderComponent)(); };
VoxelHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelHeaderComponent, selectors: [["voxel-header"]], inputs: { fixed: "fixed" }, ngContentSelectors: _c28, decls: 9, vars: 2, consts: [[1, "voxel-header"], [1, "voxel-header__left-section"], [1, "voxel-header__middle-section"], [1, "voxel-header__right-section"], [1, "voxel-header__stepper-section"]], template: function VoxelHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c27);
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵprojection(8, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-header--fixed", ctx.fixed);
    } }, styles: ["voxel-header{display:block}.voxel-header{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_bg_base);-webkit-box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_1x) rgba(86,80,76,.24);box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_1x) rgba(86,80,76,.24);display:grid;grid-template-columns:minmax(var(--ids_size_general_48x),1fr) minmax(0,auto) minmax(var(--ids_size_general_48x),1fr);min-height:var(--ids_size_general_56x)}.voxel-header--fixed{left:0;position:fixed;top:0;width:100%;z-index:1000}.voxel-header__left-section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.voxel-header__right-section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.voxel-header__stepper-section{grid-column:span 3}.voxel-header__stepper-section:empty{display:none}.voxel-header__back-button,.voxel-header__action-button{background-color:transparent;border:none;color:var(--ids_color_action_primary_base);height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-header__title{color:var(--ids_color_text_heading_01);font:var(--ids_textStyle_subtitle_01);overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap}.voxel-header__stepper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:var(--ids_size_general_8x) var(--ids_size_general_36x)}.voxel-theme-empresas .voxel-header{background:var(--ids_color_bg_brand_gradient)}.voxel-theme-empresas .voxel-header__title,.voxel-theme-empresas .voxel-header__back-button,.voxel-theme-empresas .voxel-header__action-button{color:var(--ids_color_contrast_onDark)}\n"], encapsulation: 2 });
VoxelHeaderComponent.propDecorators = {
    fixed: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-header',
                template: "<header\n  class=\"voxel-header\"\n  [class.voxel-header--fixed]=\"fixed\"\n>\n  <div class=\"voxel-header__left-section\">\n    <ng-content select=\"[voxelHeaderBackButton]\"></ng-content>\n  </div>\n\n  <div class=\"voxel-header__middle-section\">\n    <ng-content select=\"[voxelHeaderTitle]\"></ng-content>\n  </div>\n\n  <div class=\"voxel-header__right-section\">\n    <ng-content select=\"[voxelHeaderActionButton]\"></ng-content>\n  </div>\n\n  <div class=\"voxel-header__stepper-section\">\n    <ng-content select=\"[voxelHeaderStepper]\"></ng-content>\n  </div>\n</header>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["voxel-header{display:block}.voxel-header{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_bg_base);-webkit-box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_1x) rgba(86,80,76,.24);box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_1x) rgba(86,80,76,.24);display:grid;grid-template-columns:minmax(var(--ids_size_general_48x),1fr) minmax(0,auto) minmax(var(--ids_size_general_48x),1fr);min-height:var(--ids_size_general_56x)}.voxel-header--fixed{left:0;position:fixed;top:0;width:100%;z-index:1000}.voxel-header__left-section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.voxel-header__right-section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.voxel-header__stepper-section{grid-column:span 3}.voxel-header__stepper-section:empty{display:none}.voxel-header__back-button,.voxel-header__action-button{background-color:transparent;border:none;color:var(--ids_color_action_primary_base);height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-header__title{color:var(--ids_color_text_heading_01);font:var(--ids_textStyle_subtitle_01);overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap}.voxel-header__stepper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:var(--ids_size_general_8x) var(--ids_size_general_36x)}.voxel-theme-empresas .voxel-header{background:var(--ids_color_bg_brand_gradient)}.voxel-theme-empresas .voxel-header__title,.voxel-theme-empresas .voxel-header__back-button,.voxel-theme-empresas .voxel-header__action-button{color:var(--ids_color_contrast_onDark)}\n"]
            }]
    }], null, { fixed: [{
            type: Input
        }] }); })();

class VoxelHeaderModule {
}
VoxelHeaderModule.ɵfac = function VoxelHeaderModule_Factory(t) { return new (t || VoxelHeaderModule)(); };
VoxelHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelHeaderModule });
VoxelHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    VoxelHeaderComponent,
                    VoxelHeaderActionButtonDirective,
                    VoxelHeaderBackButtonDirective,
                    VoxelHeaderTitleDirective,
                    VoxelHeaderStepperDirective,
                ],
                exports: [
                    VoxelHeaderComponent,
                    VoxelHeaderActionButtonDirective,
                    VoxelHeaderBackButtonDirective,
                    VoxelHeaderTitleDirective,
                    VoxelHeaderStepperDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelHeaderModule, { declarations: function () { return [VoxelHeaderComponent, VoxelHeaderActionButtonDirective, VoxelHeaderBackButtonDirective, VoxelHeaderTitleDirective, VoxelHeaderStepperDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelHeaderComponent, VoxelHeaderActionButtonDirective, VoxelHeaderBackButtonDirective, VoxelHeaderTitleDirective, VoxelHeaderStepperDirective]; } }); })();

/**
 * @internal
 */
let NEXT_ID_PREFIX = 0;
class VoxelPrefixDirective {
    constructor() {
        this.classes = true;
        this.id = `voxel-prefix-${NEXT_ID_PREFIX++}`;
    }
}
VoxelPrefixDirective.ɵfac = function VoxelPrefixDirective_Factory(t) { return new (t || VoxelPrefixDirective)(); };
VoxelPrefixDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelPrefixDirective, selectors: [["", "voxelPrefix", ""]], hostVars: 3, hostBindings: function VoxelPrefixDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.id);
        ɵngcc0.ɵɵclassProp("voxel-form-field__prefix", ctx.classes);
    } }, inputs: { id: "id" }, exportAs: ["voxelPrefix"] });
VoxelPrefixDirective.propDecorators = {
    classes: [{ type: HostBinding, args: ['class.voxel-form-field__prefix',] }],
    id: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelPrefixDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelPrefix]',
                exportAs: 'voxelPrefix'
            }]
    }], function () { return []; }, { classes: [{
            type: HostBinding,
            args: ['class.voxel-form-field__prefix']
        }], id: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }] }); })();
class VoxelSuffixDirective {
}
VoxelSuffixDirective.ɵfac = function VoxelSuffixDirective_Factory(t) { return new (t || VoxelSuffixDirective)(); };
VoxelSuffixDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelSuffixDirective, selectors: [["", "voxelSuffix", ""]], exportAs: ["voxelSuffix"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSuffixDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelSuffix]',
                exportAs: 'voxelSuffix'
            }]
    }], null, null); })();

/**
 * @internal
 */
let NEXT_ID$e = 0;
/**
 * Componente/diretiva de mensagem de erro. Deve ser utilizado em conjunto com inputs.
 *
 * *Component/Directive of error message. Must be used in conjunction with input elements*
 *
 * @example basico
 * <span *ngIf="isFormInvalid" voxel-error-msg>
 *  Campo Obrigatório!
 * </span>
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 */
class VoxelErrorMessageComponent {
    constructor() {
        this.errorMsgId = `voxel-error-msg-${NEXT_ID$e++}`;
        this.errorMsgClasses = 'voxel-error-message';
        this.errorMsgAriaLive = 'polite';
    }
}
VoxelErrorMessageComponent.ɵfac = function VoxelErrorMessageComponent_Factory(t) { return new (t || VoxelErrorMessageComponent)(); };
VoxelErrorMessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelErrorMessageComponent, selectors: [["voxel-error-msg"], ["", "voxel-error-msg", ""], ["", "voxelErrorMsg", ""]], hostVars: 3, hostBindings: function VoxelErrorMessageComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.errorMsgId)("class", ctx.errorMsgClasses)("aria-live", ctx.errorMsgAriaLive);
    } }, inputs: { errorMsgId: "errorMsgId", errorMsgClasses: "errorMsgClasses", errorMsgAriaLive: "errorMsgAriaLive" }, exportAs: ["voxelErrorMsg"], ngContentSelectors: _c0, decls: 4, vars: 0, consts: [[1, "voxel-error-message-icon"], ["size", "S"]], template: function VoxelErrorMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "voxel-icon", 1);
        ɵngcc0.ɵɵtext(2, "aviso_outline");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
    } }, directives: [VoxelIconComponent], styles: [".voxel-form-status{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-form-status voxel-icon{margin-left:var(--ids_size_general_4x);margin-right:var(--ids_size_general_12x)}.voxel-form-status-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}.voxel-error-message{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message voxel-icon{margin-right:var(--ids_size_general_8x)}.voxel-error-message-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}\n"], encapsulation: 2, changeDetection: 0 });
VoxelErrorMessageComponent.propDecorators = {
    errorMsgId: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    errorMsgClasses: [{ type: Input }, { type: HostBinding, args: ['attr.class',] }],
    errorMsgAriaLive: [{ type: Input }, { type: HostBinding, args: ['attr.aria-live',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelErrorMessageComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-error-msg, [voxel-error-msg], [voxelErrorMsg]',
                exportAs: 'voxelErrorMsg',
                template: `
    <div class="voxel-error-message-icon">
      <voxel-icon size="S">aviso_outline</voxel-icon>
    </div>
    <ng-content></ng-content>
  `,
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".voxel-form-status{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-form-status voxel-icon{margin-left:var(--ids_size_general_4x);margin-right:var(--ids_size_general_12x)}.voxel-form-status-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}.voxel-error-message{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message voxel-icon{margin-right:var(--ids_size_general_8x)}.voxel-error-message-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}\n"]
            }]
    }], function () { return []; }, { errorMsgId: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], errorMsgClasses: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.class']
        }], errorMsgAriaLive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-live']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$d = 0;
class VoxelHintFieldDirective {
    constructor() {
        this.hintFieldId = `voxel-hint-field-${NEXT_ID$d++}`;
        this.hintFieldClasses = 'voxel-hint-field';
        this.hintMsgAriaLive = 'off';
    }
}
VoxelHintFieldDirective.ɵfac = function VoxelHintFieldDirective_Factory(t) { return new (t || VoxelHintFieldDirective)(); };
VoxelHintFieldDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHintFieldDirective, selectors: [["voxel-hint-field"], ["", "voxel-hint-field", ""], ["", "voxelHintField", ""]], hostVars: 3, hostBindings: function VoxelHintFieldDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.hintFieldId)("class", ctx.hintFieldClasses)("aria-live", ctx.hintMsgAriaLive);
    } }, inputs: { hintFieldId: "hintFieldId", hintFieldClasses: "hintFieldClasses", hintMsgAriaLive: "hintMsgAriaLive" }, exportAs: ["voxelHintField"] });
VoxelHintFieldDirective.propDecorators = {
    hintFieldId: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    hintFieldClasses: [{ type: Input }, { type: HostBinding, args: ['attr.class',] }],
    hintMsgAriaLive: [{ type: Input }, { type: HostBinding, args: ['attr.aria-live',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHintFieldDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-hint-field, [voxel-hint-field], [voxelHintField]',
                exportAs: 'voxelHintField'
            }]
    }], function () { return []; }, { hintFieldId: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], hintFieldClasses: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.class']
        }], hintMsgAriaLive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-live']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$c = 0;
/**
 * Os formulários reativos fornecem uma abordagem orientada a modelo para lidar com entradas de formulário
 * cujo valores mudam ao longo do tempo. Este guia mostra como criar e atualizar um controle de formulário simples e
 * validar valores do formulário.
 *
 * **Module:**
 *
 * `import { VoxelInputModule, VoxelFormFieldModule, VoxelIconModule } from '@voxel/components';`
 *
 * Este modulo possui todas as diretivas de criação de formulários do tipo formulário reativo.
 *
 * `import { ReactiveFormsModule } from '@angular/forms';`
 *
 * **Component.ts:**
 *
 *  Este import disponibiliza os recursos Angular para criar o formulário reativo.
 *
 * `import { FormControl, Validators, FormGroup } from '@angular/forms';`
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 *
 * @example component.ts
 *  form = new FormGroup({
 *    simple: new FormControl(''),
 *    withErrornHelper: new FormControl('', [Validators.required]),
 *    disabled: new FormControl({ value: '', disabled: true }),
 *    disabledWithValue: new FormControl({ value: 'teste', disabled: true }),
 *  });
 *
 * @example component.html
 *  <form [formGroup]="form">
 *     <voxel-form-field label="nome">
 *        <input
 *          voxelInput
 *          formControlName="simple">
 *     </voxel-form-field>
 *     <voxel-form-field
 *       label="nome"
 *       description="informe o nome completo"
 *       msgErr="o preenchimento do nome é obrigatório"
 *     >
 *       <input
 *         voxelInput
 *         formControlName="withErrornHelper"
 *       >
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *         formControlName="disabled"
 *       >
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *         formControlName="disabledWithValue"
 *       >
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *       >
 *       <voxel-icon>editar</voxel-icon>
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *       >
 *       <voxel-icon>editar_outline</voxel-icon>
 *     </voxel-form-field>
 * </form>
 *
 * @example component.html
 *  <form [formGroup]="form">
 *    <voxel-form-field
 *       label="nome"
 *        >
 *        <textarea
 *            voxelInput
 *            rows="4"
 *            cols="30"
 *            formControlName="simple"
 *        ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *    >
 *      <textarea
 *        voxelInput
 *        maxlength="144"
 *        rows="4"
 *        cols="30"
 *        formControlName="withCounter"
 *      ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *      msgErr="o preenchimento do nome é obrigatório"
 *    >
 *      <textarea
 *        voxelInput
 *        rows="4"
 *        cols="30"
 *        formControlName="withError"
 *        required
 *      ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *      msgErr="o preenchimento do nome é obrigatório"
 *    >
 *      <textarea
 *        voxelInput
 *        maxlength="144"
 *        rows="4"
 *        cols="30"
 *        formControlName="withErrornCounter"
 *        required
 *      ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *    >
 *      <textarea
 *        voxelInput
 *        rows="4"
 *        cols="30"
 *        formControlName="disabled"
 *      ></textarea>
 *    </voxel-form-field>
 *  </form>
 */
class VoxelFormFieldComponent {
    constructor() {
        /**
         * @internal
         */
        this._showError = false;
        /**
         * @internal
         */
        this.COMPONENT_NOT_FOUND = 'VoxelComponents: Não foi possível encontrar a diretiva voxelInput, nem o componente <voxel-select> dentro de <voxel-form-field>.';
        /**
         * @internal
         */
        this.selector = 'VoxelFormFieldComponent';
        /**
         * @internal
         */
        this.describedById = `voxel-describedby-${NEXT_ID$c}`;
        /**
         * @internal
         */
        this._destroy = new Subject();
        /**
         * Variavel que define o id do form field
         *
         * *Variable that define the id of form field*
         */
        this.formFieldId = `voxel-form-field-${NEXT_ID$c++}`;
        /**
         * label do campo
         *
         * *field label*
         */
        this.label = 'default';
        /**
         * limite que determina quando o polite estará ativo
         *
         * *threshold that states when the polite will be active*
         */
        this.a11yPoliteThresold = 15;
        this._msgErr = 'o preenchimento do [rótulo do campo] é obrigatório';
        /**
         * Mensagem plural/singular para caracteres que faltam
         *
         * *Singular/Plural message for remaining characters*
         */
        this.charactersRemainingLabel = {
            singular: 'caracter restante',
            plural: 'caracteres restantes',
        };
    }
    get showError() {
        return this._showError;
    }
    set showError(value) {
        this._showError = value;
    }
    get formFielClasses() {
        var _a;
        const inputRef = (_a = this.field.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement;
        const emptySlider = (inputRef === null || inputRef === void 0 ? void 0 : inputRef.type) === 'range' && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.value) === '0';
        const cannotEdit = this.field.disabled || this.field.nativeElement.disabled;
        const isDisabled = cannotEdit && (!this.field.value || emptySlider);
        const isReadOnly = cannotEdit && this.field.value && !emptySlider;
        const sliderField = this.field;
        const onDark = sliderField.onDark;
        return this.field
            ? {
                'voxel-form-field__container': true,
                'voxel-form-field__container--single': this.field.nativeElement.type !== 'textarea',
                'voxel-form-field__container--no-border': this.field.nativeElement.type === 'range',
                'voxel-form-field__container--error': this.showError,
                'voxel-form-field__container--focus': this.isFocused,
                'voxel-form-field__container--disabled': isDisabled,
                'voxel-form-field__container--read-only': isReadOnly,
                'voxel-form-field__container--on-dark': onDark,
            }
            : '';
    }
    /** @internal */
    get isFocused() {
        return ((this.field.focused || document.activeElement === this.field.nativeElement) &&
            !(this.field.disabled || this.field.nativeElement.disabled));
    }
    /**
     * mensagem de erro para ser exibida quando o campo é inválido
     *
     * *error message to shown when the field to be invalid*
     */
    get msgErr() {
        return this._msgErr;
    }
    set msgErr(msg) {
        this._msgErr = msg;
    }
    /**
     * @internal
     */
    countCharacter() {
        const remainingCharacters = this.field.nativeElement.maxLength - this.field.value.toString().length;
        const pluralLabel = `${remainingCharacters} ${this.charactersRemainingLabel.plural} `;
        const singularLabel = `${remainingCharacters} ${this.charactersRemainingLabel.singular} `;
        this.description = remainingCharacters > 1 ? pluralLabel : singularLabel;
    }
    /**
     * @internal
     */
    describedHandler() {
        return (this.field.active || !this.field.focused) && !this.showError;
    }
    updateAriaLabelWithPrefix() {
        if (this.prefix) {
            this.field.ariaLabelledby = `${this.field.controlId} ${this.prefix.id}`;
        }
    }
    ngAfterContentInit() {
        if (!this.field) {
            throw new Error(this.COMPONENT_NOT_FOUND);
        }
        this.field.errorState.pipe(startWith(false), takeUntil(this._destroy)).subscribe((state) => {
            this.showError = state;
            if (this.field.nativeElement.type === 'textarea' && this.field.nativeElement.maxLength >= 0) {
                this.countCharacter();
                if (platform.os === 'Windows') {
                    this.field.onErrorStatusChange(!!this.description, this.describedById, state);
                    this.field.a11yHandler(this.describedHandler(), this.describedById);
                    return;
                }
            }
            this.field.onErrorStatusChange(!!this.description, this.describedById, state);
        });
        this.updateAriaLabelWithPrefix();
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        this._destroy.complete();
    }
}
VoxelFormFieldComponent.ɵfac = function VoxelFormFieldComponent_Factory(t) { return new (t || VoxelFormFieldComponent)(); };
VoxelFormFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormFieldComponent, selectors: [["voxel-form-field"]], contentQueries: function VoxelFormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFieldMixinBase, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelPrefixDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.field = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.prefix = _t.first);
    } }, inputs: { formFieldId: "formFieldId", label: "label", a11yPoliteThresold: "a11yPoliteThresold", charactersRemainingLabel: "charactersRemainingLabel", msgErr: "msgErr", description: "description" }, ngContentSelectors: _c30, decls: 14, vars: 11, consts: [[1, "voxel-form-field", 3, "id"], [3, "ngClass"], [1, "voxel-form-field__label", 3, "for"], [1, "voxel-form-field__content"], [1, "voxel-form-field__suffix"], ["suffix", ""], [1, "voxel-form-field__status-message"], ["voxelErrorMsg", "", 3, "errorMsgId", 4, "ngIf", "ngIfElse"], ["descTemplate", ""], ["voxelErrorMsg", "", 3, "errorMsgId"], ["voxelHintField", "", "hintMsgAriaLive", "polite", 3, "hintFieldId", 4, "ngIf", "ngIfElse"], ["descriptionTemplate", ""], ["voxelHintField", "", "hintMsgAriaLive", "polite", 3, "hintFieldId"], ["voxelHintField", "", 3, "hintFieldId", 4, "ngIf"], ["voxelHintField", "", 3, "hintFieldId"]], template: function VoxelFormFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c29);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementStart(7, "div", 4, 5);
        ɵngcc0.ɵɵprojection(9, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵtemplate(11, VoxelFormFieldComponent_span_11_Template, 2, 2, "span", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, VoxelFormFieldComponent_ng_template_12_Template, 3, 2, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(8);
        const _r2 = ɵngcc0.ɵɵreference(13);
        ɵngcc0.ɵɵproperty("id", ctx.formFieldId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.formFielClasses);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("for", ctx.field == null ? null : ctx.field.controlId);
        ɵngcc0.ɵɵattribute("id", (ctx.field == null ? null : ctx.field.labelId) ? ctx.field == null ? null : ctx.field.labelId : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("voxel-form-field__content--affix", _r0.innerHTML.trim().length > 0 || ctx.prefix);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("voxel-form-field__suffix--events-none", (ctx.field == null ? null : ctx.field.elementRef == null ? null : ctx.field.elementRef.nativeElement == null ? null : ctx.field.elementRef.nativeElement.tagName) === "SELECT" || (ctx.field == null ? null : ctx.field.elementRef == null ? null : ctx.field.elementRef.nativeElement == null ? null : ctx.field.elementRef.nativeElement.attributes == null ? null : ctx.field.elementRef.nativeElement.attributes.getNamedItem("voxelautocomplete")));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showError)("ngIfElse", _r2);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, VoxelErrorMessageComponent, VoxelHintFieldDirective], styles: ["voxel-form-field{display:block}voxel-form-field .voxel-input,voxel-form-field .voxel-native-select,voxel-form-field .voxel-select{outline:0}.voxel-form-field__prefix{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem;white-space:nowrap}.voxel-form-field__prefix .voxel-icon{font-size:inherit;line-height:1}.voxel-form-field__label{color:var(--ids_color_action_neutral_base);display:block;font:var(--ids_textStyle_label_small_regular);line-height:var(--ids_size_general_22x);width:100%}.voxel-form-field__content{position:relative}.voxel-form-field__content--affix{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-form-field__suffix{color:var(--ids_color_action_primary_base)}.voxel-form-field__suffix .voxel-icon{color:inherit}.voxel-form-field__status-message{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:var(--ids_size_general_22x);min-height:var(--ids_size_general_24x)}.voxel-form-field__container{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);-webkit-box-sizing:border-box;box-sizing:border-box;outline-offset:2px;padding-bottom:.3125rem;position:relative;width:100%}.voxel-form-field__container--error{border-bottom:var(--ids_size_border_medium) solid #781b8e}.voxel-form-field__container--error .voxel-form-field__label{color:#781b8e;font:var(--ids_textStyle_label_small_bold);line-height:var(--ids_size_general_22x)}.voxel-form-field__container--focus{border-width:var(--ids_size_border_medium);outline:5px auto Highlight;outline:5px auto -webkit-focus-ring-color}.voxel-form-field__container--focus .voxel-form-field__label{font:var(--ids_textStyle_label_small_bold);line-height:var(--ids_size_general_22x)}.voxel-form-field__container--focus:not(.voxel-form-field__container--error){border-color:var(--ids_color_action_primary_base)}.voxel-form-field__container--disabled,.voxel-form-field__container--read-only{border-color:var(--ids_color_action_disabled_base)}.voxel-form-field__container--disabled+.voxel-form-field__status-message,.voxel-form-field__container--disabled .voxel-form-field__label,.voxel-form-field__container--disabled .voxel-form-field__suffix{color:var(--ids_color_action_disabled_base)}.voxel-form-field__container--read-only+.voxel-form-field__status-message,.voxel-form-field__container--read-only .voxel-form-field__label,.voxel-form-field__container--read-only .voxel-form-field__suffix{color:var(--ids_color_action_disabled_variant)}.voxel-form-field__container--single{min-height:var(--ids_size_general_60x);padding-bottom:0}.voxel-form-field__container--no-border{border-bottom:0}.voxel-form-field__container--on-dark .voxel-form-field__label{color:var(--ids_color_contrast_onDark)}.voxel-input{background:transparent;border:none;color:var(--ids_color_text_body_01);display:block;padding-left:var(--ids_size_general_4x);padding-right:var(--ids_size_general_4x);resize:vertical;width:100%}.voxel-input.voxel-text-l{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem}.voxel-input:not(:-moz-read-write){color:#706a66}.voxel-input:not(:read-write){color:#706a66}.voxel-input:not(:read-write)::-webkit-input-placeholder{color:#706a66}.voxel-input:not(:read-write)::-moz-placeholder{color:#706a66}.voxel-input:not(:read-write):-ms-input-placeholder{color:#706a66}.voxel-input:not(:read-write)::-ms-input-placeholder{color:#706a66}.voxel-input:not(:-moz-read-write)::placeholder{color:#706a66}.voxel-input:not(:read-write)::placeholder{color:#706a66}.voxel-input:disabled{color:var(--ids_color_action_disabled_base);resize:none}.voxel-input:disabled::-webkit-input-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled::-moz-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled:-ms-input-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled::-ms-input-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled::placeholder{color:var(--ids_color_action_disabled_base)}.voxel-native-select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:none;color:var(--ids_color_text_body_01);cursor:pointer;font:var(--ids_textStyle_label_xsmall_regular);font-size:1.125rem;line-height:1.75rem;max-width:100%;overflow:hidden;padding-right:var(--ids_size_general_24x);position:relative;text-overflow:ellipsis;white-space:nowrap;width:100%}.voxel-native-select:disabled{color:var(--ids_color_action_disabled_base);opacity:1;pointer-events:none}.voxel-slider{--slider-color-primary: var(--ids_color_action_primary_base);--slider-color-secondary: var(--ids_color_bg_variant_02);-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border:0;color:transparent;height:var(--ids_size_general_48x);width:100%}.voxel-slider::-moz-range-track{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background-color:var(--slider-color-secondary)}.voxel-slider::-webkit-slider-runnable-track{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background:-webkit-gradient(linear,left top,right top,from(var(--slider-color-primary)),color-stop(var(--slider-color-primary)),color-stop(var(--slider-color-secondary)),to(var(--slider-color-secondary)));background:linear-gradient(to right,var(--slider-color-primary) 0%,var(--slider-color-primary) var(--slider-percent),var(--slider-color-secondary) var(--slider-percent),var(--slider-color-secondary) 100%)}.voxel-slider::-ms-track{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background:var(--ids_color_bg_variant_02);border:0;color:transparent}.voxel-slider::-ms-tooltip{display:none}.voxel-slider::-ms-fill-lower{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background-color:var(--ids_color_action_primary_base)}.voxel-slider::-moz-range-progress{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background-color:var(--slider-color-primary)}.voxel-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:var(--slider-color-primary);border:0;border-radius:50%;cursor:pointer;height:var(--ids_size_general_24x);-webkit-transition:-webkit-box-shadow .2s linear;transition:-webkit-box-shadow .2s linear;transition:box-shadow .2s linear;transition:box-shadow .2s linear,-webkit-box-shadow .2s linear;width:var(--ids_size_general_24x);-webkit-transform:translateY(calc(-50% + var(--ids_size_general_1x)));transform:translateY(calc(-50% + var(--ids_size_general_1x)))}.voxel-slider::-moz-range-thumb{-moz-appearance:none;appearance:none;background-color:var(--slider-color-primary);border:0;border-radius:50%;cursor:pointer;height:var(--ids_size_general_24x);-moz-transition:box-shadow .2s linear;transition:box-shadow .2s linear;width:var(--ids_size_general_24x)}.voxel-slider::-ms-thumb{appearance:none;background-color:var(--slider-color-primary);border:0;border-radius:50%;cursor:pointer;height:var(--ids_size_general_24x);-ms-transition:box-shadow .2s linear;transition:box-shadow .2s linear;width:var(--ids_size_general_24x);background-color:var(--ids_color_action_primary_base)}.voxel-slider:focus,.voxel-slider:hover,.voxel-slider:active{color:var(--ids_color_action_primary_base_medium)}.voxel-slider:active::-webkit-slider-thumb,.voxel-slider:focus::-webkit-slider-thumb,.voxel-slider:hover::-webkit-slider-thumb{-webkit-box-shadow:0 0 0 var(--ids_size_general_12x) currentColor;box-shadow:0 0 0 var(--ids_size_general_12x) currentColor;outline:0}.voxel-slider:active::-ms-thumb,.voxel-slider:focus::-ms-thumb,.voxel-slider:hover::-ms-thumb{box-shadow:0 0 0 var(--ids_size_general_12x) currentColor}.voxel-slider:active::-moz-range-thumb,.voxel-slider:focus::-moz-range-thumb,.voxel-slider:hover::-moz-range-thumb{box-shadow:0 0 0 var(--ids_size_general_12x) currentColor}.voxel-slider--light{--slider-color-primary: var(--ids_color_bg_base);--slider-color-secondary: var(--ids_color_bg_base_medium)}.voxel-slider--light:hover,.voxel-slider--light:focus,.voxel-slider--light:active{color:var(--ids_color_bg_base_soft)}.voxel-slider--light::-ms-thumb{background-color:var(--ids_color_bg_base)}.voxel-slider--light::-ms-fill-lower{background-color:var(--ids_color_bg_base)}.voxel-slider--light::-ms-track{background-color:var(--ids_color_bg_base_medium)}.voxel-slider:disabled{--slider-color-primary: var(--ids_color_bg_variant_02);pointer-events:none}.voxel-slider:disabled::-moz-range-thumb{box-shadow:none}.voxel-slider:disabled::-webkit-slider-thumb{-webkit-box-shadow:none;box-shadow:none}.voxel-slider:disabled::-ms-thumb{background:var(--ids_color_bg_variant_02)}.voxel-slider:disabled:focus,.voxel-slider:disabled:active,.voxel-slider:disabled:hover{color:transparent}.voxel-slider:disabled.voxel-slider--light{opacity:.6}\n"], encapsulation: 2 });
VoxelFormFieldComponent.propDecorators = {
    formFieldId: [{ type: Input }],
    label: [{ type: Input }],
    a11yPoliteThresold: [{ type: Input }],
    msgErr: [{ type: Input }],
    description: [{ type: Input }],
    field: [{ type: ContentChild, args: [VoxelFieldMixinBase, { static: true },] }],
    prefix: [{ type: ContentChild, args: [VoxelPrefixDirective, { static: true },] }],
    charactersRemainingLabel: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-field',
                template: "<div class=\"voxel-form-field\" [id]=\"formFieldId\">\n  <div [ngClass]=\"formFielClasses\">\n    <label\n      [for]=\"field?.controlId\"\n      class=\"voxel-form-field__label\"\n      [attr.id]=\"field?.labelId ? field?.labelId : null\"\n    >\n      {{ label }}\n    </label>\n    <div\n      class=\"voxel-form-field__content\"\n      [class.voxel-form-field__content--affix]=\"suffix.innerHTML.trim().length > 0 || prefix\"\n    >\n      <ng-content select=\"[voxelPrefix]\"></ng-content>\n\n      <ng-content></ng-content>\n      <div\n        #suffix\n        class=\"voxel-form-field__suffix\"\n        [class.voxel-form-field__suffix--events-none]=\"\n          field?.elementRef?.nativeElement?.tagName === 'SELECT' ||\n          field?.elementRef?.nativeElement?.attributes?.getNamedItem('voxelautocomplete')\n        \"\n      >\n        <ng-content select=\"voxel-icon, voxel-datepicker, [voxelSuffix]\"></ng-content>\n      </div>\n    </div>\n  </div>\n  <div class=\"voxel-form-field__status-message\">\n    <span\n      *ngIf=\"showError; else descTemplate\"\n      voxelErrorMsg\n      [errorMsgId]=\"describedById\"\n    >\n      {{ msgErr }}\n    </span>\n  </div>\n  <ng-template #descTemplate>\n    <span\n      *ngIf=\"field.nativeElement.type === 'textarea'\n        && description\n        && (field.nativeElement.maxLength - field.value.toString().length <= a11yPoliteThresold); else descriptionTemplate\"\n      voxelHintField\n      [hintFieldId]=\"describedById\"\n      hintMsgAriaLive=\"polite\"\n    >\n      {{ description }}\n    </span>\n    <ng-template #descriptionTemplate>\n      <span\n        *ngIf=\"description\"\n        voxelHintField\n        [hintFieldId]=\"describedById\"\n      >\n        {{ description }}\n      </span>\n    </ng-template>\n  </ng-template>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["voxel-form-field{display:block}voxel-form-field .voxel-input,voxel-form-field .voxel-native-select,voxel-form-field .voxel-select{outline:0}.voxel-form-field__prefix{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem;white-space:nowrap}.voxel-form-field__prefix .voxel-icon{font-size:inherit;line-height:1}.voxel-form-field__label{color:var(--ids_color_action_neutral_base);display:block;font:var(--ids_textStyle_label_small_regular);line-height:var(--ids_size_general_22x);width:100%}.voxel-form-field__content{position:relative}.voxel-form-field__content--affix{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-form-field__suffix{color:var(--ids_color_action_primary_base)}.voxel-form-field__suffix .voxel-icon{color:inherit}.voxel-form-field__status-message{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:var(--ids_size_general_22x);min-height:var(--ids_size_general_24x)}.voxel-form-field__container{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);-webkit-box-sizing:border-box;box-sizing:border-box;outline-offset:2px;padding-bottom:.3125rem;position:relative;width:100%}.voxel-form-field__container--error{border-bottom:var(--ids_size_border_medium) solid #781b8e}.voxel-form-field__container--error .voxel-form-field__label{color:#781b8e;font:var(--ids_textStyle_label_small_bold);line-height:var(--ids_size_general_22x)}.voxel-form-field__container--focus{border-width:var(--ids_size_border_medium);outline:5px auto Highlight;outline:5px auto -webkit-focus-ring-color}.voxel-form-field__container--focus .voxel-form-field__label{font:var(--ids_textStyle_label_small_bold);line-height:var(--ids_size_general_22x)}.voxel-form-field__container--focus:not(.voxel-form-field__container--error){border-color:var(--ids_color_action_primary_base)}.voxel-form-field__container--disabled,.voxel-form-field__container--read-only{border-color:var(--ids_color_action_disabled_base)}.voxel-form-field__container--disabled+.voxel-form-field__status-message,.voxel-form-field__container--disabled .voxel-form-field__label,.voxel-form-field__container--disabled .voxel-form-field__suffix{color:var(--ids_color_action_disabled_base)}.voxel-form-field__container--read-only+.voxel-form-field__status-message,.voxel-form-field__container--read-only .voxel-form-field__label,.voxel-form-field__container--read-only .voxel-form-field__suffix{color:var(--ids_color_action_disabled_variant)}.voxel-form-field__container--single{min-height:var(--ids_size_general_60x);padding-bottom:0}.voxel-form-field__container--no-border{border-bottom:0}.voxel-form-field__container--on-dark .voxel-form-field__label{color:var(--ids_color_contrast_onDark)}.voxel-input{background:transparent;border:none;color:var(--ids_color_text_body_01);display:block;padding-left:var(--ids_size_general_4x);padding-right:var(--ids_size_general_4x);resize:vertical;width:100%}.voxel-input.voxel-text-l{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem}.voxel-input:not(:-moz-read-write){color:#706a66}.voxel-input:not(:read-write){color:#706a66}.voxel-input:not(:read-write)::-webkit-input-placeholder{color:#706a66}.voxel-input:not(:read-write)::-moz-placeholder{color:#706a66}.voxel-input:not(:read-write):-ms-input-placeholder{color:#706a66}.voxel-input:not(:read-write)::-ms-input-placeholder{color:#706a66}.voxel-input:not(:-moz-read-write)::placeholder{color:#706a66}.voxel-input:not(:read-write)::placeholder{color:#706a66}.voxel-input:disabled{color:var(--ids_color_action_disabled_base);resize:none}.voxel-input:disabled::-webkit-input-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled::-moz-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled:-ms-input-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled::-ms-input-placeholder{color:var(--ids_color_action_disabled_base)}.voxel-input:disabled::placeholder{color:var(--ids_color_action_disabled_base)}.voxel-native-select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border:none;color:var(--ids_color_text_body_01);cursor:pointer;font:var(--ids_textStyle_label_xsmall_regular);font-size:1.125rem;line-height:1.75rem;max-width:100%;overflow:hidden;padding-right:var(--ids_size_general_24x);position:relative;text-overflow:ellipsis;white-space:nowrap;width:100%}.voxel-native-select:disabled{color:var(--ids_color_action_disabled_base);opacity:1;pointer-events:none}.voxel-slider{--slider-color-primary: var(--ids_color_action_primary_base);--slider-color-secondary: var(--ids_color_bg_variant_02);-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border:0;color:transparent;height:var(--ids_size_general_48x);width:100%}.voxel-slider::-moz-range-track{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background-color:var(--slider-color-secondary)}.voxel-slider::-webkit-slider-runnable-track{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background:-webkit-gradient(linear,left top,right top,from(var(--slider-color-primary)),color-stop(var(--slider-color-primary)),color-stop(var(--slider-color-secondary)),to(var(--slider-color-secondary)));background:linear-gradient(to right,var(--slider-color-primary) 0%,var(--slider-color-primary) var(--slider-percent),var(--slider-color-secondary) var(--slider-percent),var(--slider-color-secondary) 100%)}.voxel-slider::-ms-track{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background:var(--ids_color_bg_variant_02);border:0;color:transparent}.voxel-slider::-ms-tooltip{display:none}.voxel-slider::-ms-fill-lower{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background-color:var(--ids_color_action_primary_base)}.voxel-slider::-moz-range-progress{border-radius:var(--ids_size_general_1x);height:var(--ids_size_general_2x);background-color:var(--slider-color-primary)}.voxel-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:var(--slider-color-primary);border:0;border-radius:50%;cursor:pointer;height:var(--ids_size_general_24x);-webkit-transition:-webkit-box-shadow .2s linear;transition:-webkit-box-shadow .2s linear;transition:box-shadow .2s linear;transition:box-shadow .2s linear,-webkit-box-shadow .2s linear;width:var(--ids_size_general_24x);-webkit-transform:translateY(calc(-50% + var(--ids_size_general_1x)));transform:translateY(calc(-50% + var(--ids_size_general_1x)))}.voxel-slider::-moz-range-thumb{-moz-appearance:none;appearance:none;background-color:var(--slider-color-primary);border:0;border-radius:50%;cursor:pointer;height:var(--ids_size_general_24x);-moz-transition:box-shadow .2s linear;transition:box-shadow .2s linear;width:var(--ids_size_general_24x)}.voxel-slider::-ms-thumb{appearance:none;background-color:var(--slider-color-primary);border:0;border-radius:50%;cursor:pointer;height:var(--ids_size_general_24x);-ms-transition:box-shadow .2s linear;transition:box-shadow .2s linear;width:var(--ids_size_general_24x);background-color:var(--ids_color_action_primary_base)}.voxel-slider:focus,.voxel-slider:hover,.voxel-slider:active{color:var(--ids_color_action_primary_base_medium)}.voxel-slider:active::-webkit-slider-thumb,.voxel-slider:focus::-webkit-slider-thumb,.voxel-slider:hover::-webkit-slider-thumb{-webkit-box-shadow:0 0 0 var(--ids_size_general_12x) currentColor;box-shadow:0 0 0 var(--ids_size_general_12x) currentColor;outline:0}.voxel-slider:active::-ms-thumb,.voxel-slider:focus::-ms-thumb,.voxel-slider:hover::-ms-thumb{box-shadow:0 0 0 var(--ids_size_general_12x) currentColor}.voxel-slider:active::-moz-range-thumb,.voxel-slider:focus::-moz-range-thumb,.voxel-slider:hover::-moz-range-thumb{box-shadow:0 0 0 var(--ids_size_general_12x) currentColor}.voxel-slider--light{--slider-color-primary: var(--ids_color_bg_base);--slider-color-secondary: var(--ids_color_bg_base_medium)}.voxel-slider--light:hover,.voxel-slider--light:focus,.voxel-slider--light:active{color:var(--ids_color_bg_base_soft)}.voxel-slider--light::-ms-thumb{background-color:var(--ids_color_bg_base)}.voxel-slider--light::-ms-fill-lower{background-color:var(--ids_color_bg_base)}.voxel-slider--light::-ms-track{background-color:var(--ids_color_bg_base_medium)}.voxel-slider:disabled{--slider-color-primary: var(--ids_color_bg_variant_02);pointer-events:none}.voxel-slider:disabled::-moz-range-thumb{box-shadow:none}.voxel-slider:disabled::-webkit-slider-thumb{-webkit-box-shadow:none;box-shadow:none}.voxel-slider:disabled::-ms-thumb{background:var(--ids_color_bg_variant_02)}.voxel-slider:disabled:focus,.voxel-slider:disabled:active,.voxel-slider:disabled:hover{color:transparent}.voxel-slider:disabled.voxel-slider--light{opacity:.6}\n"]
            }]
    }], function () { return []; }, { formFieldId: [{
            type: Input
        }], label: [{
            type: Input
        }], a11yPoliteThresold: [{
            type: Input
        }], charactersRemainingLabel: [{
            type: Input
        }], msgErr: [{
            type: Input
        }], description: [{
            type: Input
        }], field: [{
            type: ContentChild,
            args: [VoxelFieldMixinBase, { static: true }]
        }], prefix: [{
            type: ContentChild,
            args: [VoxelPrefixDirective, { static: true }]
        }] }); })();

const formFieldComponents = [
    VoxelErrorMessageComponent,
    VoxelFormFieldComponent,
    VoxelHintFieldDirective,
    VoxelPrefixDirective,
    VoxelSuffixDirective,
    VoxelFieldMixinBase,
];
class VoxelFormFieldModule {
}
VoxelFormFieldModule.ɵfac = function VoxelFormFieldModule_Factory(t) { return new (t || VoxelFormFieldModule)(); };
VoxelFormFieldModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelFormFieldModule });
VoxelFormFieldModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormFieldModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: formFieldComponents,
                exports: formFieldComponents
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelFormFieldModule, { declarations: function () { return [VoxelErrorMessageComponent, VoxelFormFieldComponent, VoxelHintFieldDirective, VoxelPrefixDirective, VoxelSuffixDirective, VoxelFieldMixinBase]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelErrorMessageComponent, VoxelFormFieldComponent, VoxelHintFieldDirective, VoxelPrefixDirective, VoxelSuffixDirective, VoxelFieldMixinBase]; } }); })();

/**
 * @internal
 */
let NEXT_ID$b = 0;
/**
 * O voxelFormStatus foi desenvolvido para ser utilizado em conjunto com os componentes de seleção como checkbox,
 * radiobutton e switch (wip).
 *
 * **Module:**
 *
 * `import { VoxelFormStatusModule } from '@voxel/components';`
 *
 * Este modulo possui todas as declarações dos componentes citados acima.
 *
 * @example VoxelFormStatus
 * <voxel-form-status *ngIf="form.touched && form.invalid" errorMsgAriaLive="polite">
 *             seleciona uma opção para prosseguir
 * </voxel-form-status>
 *
 * @example Checkbox
 * <div>
 *             <voxel-form-selection>
 *               <input type="checkbox" formControlName="simple" voxelCheckbox />
 *               simples
 *             </voxel-form-selection>
 *             <voxel-form-status *ngIf="form.touched && form.invalid">
 *               seleciona uma opção para prosseguir
 *             </voxel-form-status>
 * </div>
 *
 * @example RadioButton
 * <div>
 *             <voxel-form-selection>
 *               <input type="radio" name="withError" formControlName="withError" voxelRadioButton />
 *                 Sim, aceito receber email :)
 *             </voxel-form-selection>
 *             <voxel-form-selection>
 *               <input type="radio" name="withError" formControlName="withError" voxelRadioButton />
 *                 Não aceito receber email.
 *             </voxel-form-selection>
 *             <voxel-form-status *ngIf="form.touched && form.invalid">
 *               seleciona uma opção para prosseguir
 *             </voxel-form-status>
 * </div>
 */
class VoxelFormStatusComponent {
    constructor() {
        /**
         * Variavel que define o id do form status
         *
         * *Variable that define the id of form status*
         */
        this.errorMsgId = `voxel-form-status-${++NEXT_ID$b}`;
        /**
         * Aria-live: indica em que momento a leitura da mensagem é feita.
         *
         * Por padrão usamos o polite, mas pode-se inserir:
         *
         * - off - não modifica a leitura da mensagem.
         * - polite - não interrompe a leitura atual da tela.
         * - assertive - lê a mensagem assim que a mesma aparece em tela.
         *
         * Ver mais em [accessibility-resources]{@link https://accessibilityresources.org/aria-live}
         *
         * *Aria-live: indicates at which point the message is read.*
         *
         * *By default we use a polite, but you can insert:*
         *
         * * - off - does not change the message reading  of message.*
         * * - polite - does not interrupt the current reading of the screen.*
         * * - assertive - not change the message reading.*
         *
         * *See more at [accessibility-resources]{@link https://accessibilityresources.org/aria-live}*
         */
        this.errorMsgAriaLive = 'polite';
    }
}
VoxelFormStatusComponent.ɵfac = function VoxelFormStatusComponent_Factory(t) { return new (t || VoxelFormStatusComponent)(); };
VoxelFormStatusComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormStatusComponent, selectors: [["voxel-form-status"]], inputs: { errorMsgId: "errorMsgId", errorMsgAriaLive: "errorMsgAriaLive" }, ngContentSelectors: _c0, decls: 5, vars: 2, consts: [[1, "voxel-form-status"], ["size", "S"], [3, "id"]], template: function VoxelFormStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "voxel-icon", 1);
        ɵngcc0.ɵɵtext(2, "aviso_outline");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("id", ctx.errorMsgId);
        ɵngcc0.ɵɵattribute("aria-live", ctx.errorMsgAriaLive);
    } }, directives: [VoxelIconComponent], styles: [".voxel-form-status[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-form-status[_ngcontent-%COMP%]   voxel-icon[_ngcontent-%COMP%]{margin-left:var(--ids_size_general_4x);margin-right:var(--ids_size_general_12x)}.voxel-form-status-icon[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}.voxel-error-message[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message[_ngcontent-%COMP%]   voxel-icon[_ngcontent-%COMP%]{margin-right:var(--ids_size_general_8x)}.voxel-error-message-icon[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}"] });
VoxelFormStatusComponent.propDecorators = {
    errorMsgId: [{ type: Input }],
    errorMsgAriaLive: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormStatusComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-status',
                template: "<div class=\"voxel-form-status\">\n  <voxel-icon size=\"S\">aviso_outline</voxel-icon>\n  <span [id]=\"errorMsgId\" [attr.aria-live]=\"errorMsgAriaLive\">\n    <ng-content></ng-content>\n  </span>\n</div>\n",
                styles: [".voxel-form-status{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-form-status voxel-icon{margin-left:var(--ids_size_general_4x);margin-right:var(--ids_size_general_12x)}.voxel-form-status-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}.voxel-error-message{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#781b8e;display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message voxel-icon{margin-right:var(--ids_size_general_8x)}.voxel-error-message-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}\n"]
            }]
    }], function () { return []; }, { errorMsgId: [{
            type: Input
        }], errorMsgAriaLive: [{
            type: Input
        }] }); })();

class VoxelFormStatusModule {
}
VoxelFormStatusModule.ɵfac = function VoxelFormStatusModule_Factory(t) { return new (t || VoxelFormStatusModule)(); };
VoxelFormStatusModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelFormStatusModule });
VoxelFormStatusModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormStatusModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelFormStatusComponent],
                exports: [VoxelFormStatusComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelFormStatusModule, { declarations: function () { return [VoxelFormStatusComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelFormStatusComponent]; } }); })();

/**
 * O Selector foi desenvolvido para ser utilizado em componentes de seleção como checkbox,
 * radiobutton e switch (wip).
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelCheckboxModule } from '@voxel/components';`
 *
 * Este modulo possui todas as declarações dos componentes citados acima.
 *
 * @example Checkbox
 *  <voxel-form-selection>
 *             <input type="checkbox" formControlName="simple" voxelCheckbox />
 *             simples
 *  </voxel-form-selection>
 *
 * @example Radio Button
 *  <voxel-form-selection>
 *             <input type="radio" value="1" name="simple" formControlName="simple" voxelRadioButton />
 *             simples
 *  </voxel-form-selection>
 *
 */
class VoxelFormSelectionComponent {
    constructor() {
        /**
         * @internal
         */
        this._destroy = new Subject();
        /**
         * @internal
         */
        this.COMPONENT_NOT_FOUND = 'VoxelComponents: Não foi possível encontrar a diretiva voxelCheckbox ou voxelRadioButton, nem o input type="checkbox" ou type="radio" dentro do voxel-form-selection.';
    }
    handleFormStatus() {
        let messageIds = [];
        this.status.changes.pipe(startWith(null), takeUntil(this._destroy)).subscribe(() => {
            messageIds = [];
            messageIds.push(...this.status.map((message) => message.errorMsgId));
            this.input.handleDescribedBy(messageIds);
            this.input.state = messageIds.length > 0 ? 'invalid' : '';
        });
    }
    ngAfterContentInit() {
        if (!this.input) {
            throw new Error(this.COMPONENT_NOT_FOUND);
        }
        this.handleFormStatus();
    }
    ngOnDestroy() {
        this._destroy.complete();
    }
}
VoxelFormSelectionComponent.ɵfac = function VoxelFormSelectionComponent_Factory(t) { return new (t || VoxelFormSelectionComponent)(); };
VoxelFormSelectionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormSelectionComponent, selectors: [["voxel-form-selection"]], contentQueries: function VoxelFormSelectionComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormSelectionBase, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormStatusComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.status = _t);
    } }, ngContentSelectors: _c32, decls: 6, vars: 8, consts: [[1, "voxel-form-selection"], [3, "ngClass", 4, "ngIf"], [3, "id", "for"], [3, "ngClass"]], template: function VoxelFormSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c31);
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, VoxelFormSelectionComponent_voxel_icon_1_Template, 2, 2, "voxel-icon", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "label", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(5, 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-form-selection--rtl", ctx.input.rtlDirection);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.input.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap("voxel-form-selection__label--" + ctx.input.selectorType);
        ɵngcc0.ɵɵproperty("id", ctx.input.labelId)("for", ctx.input.controlId);
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.input.ariaHiddenLabel ? ctx.input.ariaHiddenLabel : null);
    } }, directives: [ɵngcc1.NgIf, VoxelIconComponent, ɵngcc1.NgClass], styles: [".voxel-form-selection{display:-webkit-box;display:-ms-flexbox;display:flex;padding:var(--ids_size_general_8x) 0;position:relative}.voxel-form-selection__radio--checked:not(.voxel-form-selection__radio--disabled,.voxel-form-selection__radio--invalid),.voxel-form-selection__checkbox--checked:not(.voxel-form-selection__checkbox--disabled,.voxel-form-selection__checkbox--invalid){color:var(--ids_color_action_primary_base)}.voxel-form-selection input:disabled+label{color:var(--ids_color_action_disabled_base)}.voxel-form-selection--rtl{direction:rtl;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.voxel-form-selection__input--checkbox{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--checkbox:disabled+span{color:var(--ids_color_action_disabled_base)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__input--checkbox{opacity:0}}.voxel-form-selection__label--checkbox{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_neutral_variant);font:var(--ids_textStyle_label_medium_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox{color:var(--ids_color_action_neutral_variant);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox--checked{color:var(--ids_color_action_primary_base)}.voxel-form-selection__checkbox--disabled{color:var(--ids_color_action_disabled_base)}.voxel-form-selection__checkbox--invalid{color:#781b8e}.voxel-form-selection__checkbox--invalid+.voxel-form-selection__input--checkbox+.voxel-form-selection__label--checkbox{font:var(--ids_textStyle_label_medium_bold)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__checkbox--focus .voxel-icon{outline:auto -webkit-focus-ring-color}}.voxel-form-selection__input--radio{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--radio:disabled+span{color:var(--ids_color_action_disabled_base)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__input--radio{opacity:0}}.voxel-form-selection__label--radio{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);font:var(--ids_textStyle_body_01_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio{color:var(--ids_color_action_neutral_variant);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio--checked{color:var(--ids_color_action_primary_base)}.voxel-form-selection__radio--disabled{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-form-selection__radio--invalid{color:#781b8e}.voxel-form-selection__radio--invalid+.voxel-form-selection__input--radio+.voxel-form-selection__label--radio{font:var(--ids_textStyle_body_01_bold)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__radio--focus .voxel-icon{outline:auto -webkit-focus-ring-color}}.voxel-form-selection__switch{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:var(--ids_color_action_disabled_variant);border-radius:.875rem;cursor:pointer;height:var(--ids_size_general_24x);min-width:var(--ids_size_general_40x);position:relative;-webkit-transition:background-color .4s;transition:background-color .4s}.voxel-form-selection__switch:before{background-color:var(--ids_color_bg_base);border-radius:50%;-webkit-box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_2x) rgba(0,0,0,.25);box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_2x) rgba(0,0,0,.25);content:\"\";height:var(--ids_size_general_22x);left:var(--ids_size_general_1x);position:absolute;top:var(--ids_size_general_1x);-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s;width:var(--ids_size_general_22x)}.voxel-form-selection__switch--checked{background-color:var(--ids_color_action_primary_base)}.voxel-form-selection__switch--checked:before{-webkit-transform:translateX(var(--ids_size_general_16x));transform:translate(var(--ids_size_general_16x))}.voxel-form-selection__switch--disabled{background-color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-form-selection__label--switch{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-right:var(--ids_spacing_2x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__label--switch:empty{display:none}\n"], encapsulation: 2 });
VoxelFormSelectionComponent.propDecorators = {
    input: [{ type: ContentChild, args: [VoxelFormSelectionBase, { static: true },] }],
    status: [{ type: ContentChildren, args: [VoxelFormStatusComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-selection',
                template: "<span class=\"voxel-form-selection\" [class.voxel-form-selection--rtl]=\"input.rtlDirection\">\n  <voxel-icon *ngIf=\"input.icon\" [ngClass]=\"input.iconClasses\">\n    {{ input.icon }}\n  </voxel-icon>\n  <ng-content select=\"input\"></ng-content>\n  <label\n    [id]=\"input.labelId\"\n    [for]=\"input.controlId\"\n    [class]=\"'voxel-form-selection__label--' + input.selectorType\"\n    [attr.aria-hidden]=\"input.ariaHiddenLabel ? input.ariaHiddenLabel : null\"\n  >\n    <ng-content></ng-content>\n  </label>\n</span>\n<ng-content select=\"voxel-form-status\"></ng-content>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-form-selection{display:-webkit-box;display:-ms-flexbox;display:flex;padding:var(--ids_size_general_8x) 0;position:relative}.voxel-form-selection__radio--checked:not(.voxel-form-selection__radio--disabled,.voxel-form-selection__radio--invalid),.voxel-form-selection__checkbox--checked:not(.voxel-form-selection__checkbox--disabled,.voxel-form-selection__checkbox--invalid){color:var(--ids_color_action_primary_base)}.voxel-form-selection input:disabled+label{color:var(--ids_color_action_disabled_base)}.voxel-form-selection--rtl{direction:rtl;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.voxel-form-selection__input--checkbox{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--checkbox:disabled+span{color:var(--ids_color_action_disabled_base)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__input--checkbox{opacity:0}}.voxel-form-selection__label--checkbox{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_neutral_variant);font:var(--ids_textStyle_label_medium_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox{color:var(--ids_color_action_neutral_variant);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox--checked{color:var(--ids_color_action_primary_base)}.voxel-form-selection__checkbox--disabled{color:var(--ids_color_action_disabled_base)}.voxel-form-selection__checkbox--invalid{color:#781b8e}.voxel-form-selection__checkbox--invalid+.voxel-form-selection__input--checkbox+.voxel-form-selection__label--checkbox{font:var(--ids_textStyle_label_medium_bold)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__checkbox--focus .voxel-icon{outline:auto -webkit-focus-ring-color}}.voxel-form-selection__input--radio{-webkit-appearance:none;-moz-appearance:none;appearance:none;height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--radio:disabled+span{color:var(--ids_color_action_disabled_base)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__input--radio{opacity:0}}.voxel-form-selection__label--radio{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);font:var(--ids_textStyle_body_01_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio{color:var(--ids_color_action_neutral_variant);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio--checked{color:var(--ids_color_action_primary_base)}.voxel-form-selection__radio--disabled{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-form-selection__radio--invalid{color:#781b8e}.voxel-form-selection__radio--invalid+.voxel-form-selection__input--radio+.voxel-form-selection__label--radio{font:var(--ids_textStyle_body_01_bold)}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.voxel-form-selection__radio--focus .voxel-icon{outline:auto -webkit-focus-ring-color}}.voxel-form-selection__switch{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:var(--ids_color_action_disabled_variant);border-radius:.875rem;cursor:pointer;height:var(--ids_size_general_24x);min-width:var(--ids_size_general_40x);position:relative;-webkit-transition:background-color .4s;transition:background-color .4s}.voxel-form-selection__switch:before{background-color:var(--ids_color_bg_base);border-radius:50%;-webkit-box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_2x) rgba(0,0,0,.25);box-shadow:0 var(--ids_size_general_1x) var(--ids_size_general_2x) rgba(0,0,0,.25);content:\"\";height:var(--ids_size_general_22x);left:var(--ids_size_general_1x);position:absolute;top:var(--ids_size_general_1x);-webkit-transition:-webkit-transform .4s;transition:-webkit-transform .4s;transition:transform .4s;transition:transform .4s,-webkit-transform .4s;width:var(--ids_size_general_22x)}.voxel-form-selection__switch--checked{background-color:var(--ids_color_action_primary_base)}.voxel-form-selection__switch--checked:before{-webkit-transform:translateX(var(--ids_size_general_16x));transform:translate(var(--ids_size_general_16x))}.voxel-form-selection__switch--disabled{background-color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-form-selection__label--switch{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-right:var(--ids_spacing_2x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__label--switch:empty{display:none}\n"]
            }]
    }], function () { return []; }, { input: [{
            type: ContentChild,
            args: [VoxelFormSelectionBase, { static: true }]
        }], status: [{
            type: ContentChildren,
            args: [VoxelFormStatusComponent]
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$a = 0;
/**
 * O Form Selection Group foi desenvolvido para agrupar componentes de seleção como checkbox,
 * radiobutton e switch (wip).
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelCheckboxModule, VoxelRadioButtonModule } from '@voxel/components';`
 *
 * Este modulo possui todas as declarações dos componentes citados acima.
 *
 * @example Checkbox
 *  <voxel-form-selection-group>
 *             <legend>Aceito receber:</legend>
 *             <voxel-form-selection>
 *               <input type="checkbox" name="receiveSMS" formControlName="sms" voxelCheckbox required/>
 *               SMS
 *             </voxel-form-selection>
 *             <voxel-form-selection>
 *               <input type="checkbox" name="receiveWhatsapp" formControlName="whatsapp" voxelCheckbox required/>
 *               Whatsapp
 *             </voxel-form-selection>
 *  </voxel-form-selection-group>
 *
 * @example RadioButton
 *  <voxel-form-selection-group>
 *             <legend>Aceito receber:</legend>
 *             <voxel-form-selection>
 *               <input type="radio" value="11" name="receiveSMS" formControlName="receiveSMS" voxelRadioButton required/>
 *               Aceito receber SMS
 *             </voxel-form-selection>
 *             <voxel-form-selection>
 *               <input type="radio" value="12" name="receiveSMS" formControlName="receiveSMS" voxelRadioButton required/>
 *               Não aceito receber SMS
 *             </voxel-form-selection>
 *  </voxel-form-selection-group>
 *
 */
class VoxelFormSelectionGroupComponent {
    constructor() {
        /**
         * @internal
         */
        this.controlId = `voxel-form-selection-group-${++NEXT_ID$a}`;
        /**
         * @internal
         */
        this._inline = false;
        /**
         * @internal
         */
        this._destroy = new Subject();
    }
    /**
     * Indica se o grupo vai estar disposto em linha
     *
     * *Indicates if the group will be inline*
     */
    set inline(inline) {
        this._inline = enforceBoolean(inline);
    }
    get inline() {
        return this._inline;
    }
    ngAfterContentInit() {
        this.handleFormStatus();
    }
    ngOnDestroy() {
        this._destroy.complete();
    }
    /**
     * @internal
     */
    handleFormStatus() {
        let messageIds = [];
        this.status.changes.pipe(startWith(null), takeUntil(this._destroy)).subscribe(() => {
            messageIds = [];
            messageIds.push(...this.status.map((message) => message.errorMsgId));
            const state = messageIds.length > 0 ? 'invalid' : '';
            this.formSelectionList.forEach((formSelection) => {
                formSelection.input.handleDescribedBy(messageIds);
                formSelection.input.state = state;
            });
        });
    }
}
VoxelFormSelectionGroupComponent.ɵfac = function VoxelFormSelectionGroupComponent_Factory(t) { return new (t || VoxelFormSelectionGroupComponent)(); };
VoxelFormSelectionGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormSelectionGroupComponent, selectors: [["voxel-form-selection-group"]], contentQueries: function VoxelFormSelectionGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormSelectionComponent, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormStatusComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formSelectionList = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.status = _t);
    } }, inputs: { inline: "inline" }, ngContentSelectors: _c34, decls: 4, vars: 3, consts: [[1, "voxel-form-selection-group", 3, "id"]], template: function VoxelFormSelectionGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c33);
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵprojection(3, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-form-selection-group--inline", ctx.inline);
        ɵngcc0.ɵɵproperty("id", ctx.controlId);
    } }, styles: [".voxel-form-selection-group--inline[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_48x);gap:var(--ids_size_general_48x);width:100%}.voxel-form-selection-group--inline[_ngcontent-%COMP%]     .voxel-form-selection{margin-right:var(--ids_size_general_16x)}.voxel-form-selection-group[_ngcontent-%COMP%]     legend{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_small_regular)}"] });
VoxelFormSelectionGroupComponent.propDecorators = {
    formSelectionList: [{ type: ContentChildren, args: [VoxelFormSelectionComponent,] }],
    status: [{ type: ContentChildren, args: [VoxelFormStatusComponent,] }],
    inline: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionGroupComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-selection-group',
                template: "<fieldset [id]=\"controlId\" class=\"voxel-form-selection-group\"\n  [class.voxel-form-selection-group--inline]=\"inline\">\n  <ng-content select=\"legend\"></ng-content>\n  <ng-content select=\"voxel-form-selection\"></ng-content>\n  <ng-content select=\"voxel-form-status\"></ng-content>\n</fieldset>\n",
                styles: [".voxel-form-selection-group--inline{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_48x);gap:var(--ids_size_general_48x);width:100%}.voxel-form-selection-group--inline ::ng-deep .voxel-form-selection{margin-right:var(--ids_size_general_16x)}.voxel-form-selection-group ::ng-deep legend{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_small_regular)}\n"]
            }]
    }], function () { return []; }, { inline: [{
            type: Input
        }], formSelectionList: [{
            type: ContentChildren,
            args: [VoxelFormSelectionComponent]
        }], status: [{
            type: ContentChildren,
            args: [VoxelFormStatusComponent]
        }] }); })();

class VoxelFormSelectionModule {
}
VoxelFormSelectionModule.ɵfac = function VoxelFormSelectionModule_Factory(t) { return new (t || VoxelFormSelectionModule)(); };
VoxelFormSelectionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelFormSelectionModule });
VoxelFormSelectionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, VoxelIconModule, VoxelFormStatusModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule, VoxelFormStatusModule],
                declarations: [
                    VoxelFormSelectionBase,
                    VoxelFormSelectionComponent,
                    VoxelFormSelectionGroupComponent,
                ],
                exports: [VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelFormSelectionModule, { declarations: function () { return [VoxelFormSelectionBase, VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent]; }, imports: function () { return [CommonModule, VoxelIconModule, VoxelFormStatusModule]; }, exports: function () { return [VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID$9 = 0;
/**
 * Diretiva para customização de input
 *
 * *Directive for customizing input*
 *
 * **Module:**
 *
 * `import { VoxelInputModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 *
 * @example <input voxelInput>
 *
 * @example <textarea voxelInput rows="4" cols="30"></textarea>
 */
class VoxelInputDirective extends VoxelFieldMixinBase {
    constructor() {
        super(...arguments);
        /** @internal */
        this._readonly = null;
        /** @internal */
        this.inputClasses = 'voxel-input voxel-text-l';
        /** @internal */
        this.controlId = `voxel-input-${NEXT_ID$9++}`;
    }
    /**
     * Edição do campo só leitura
     *
     * *The field editing read only*
     */
    set readonly(readonly) {
        this._readonly = enforceBoolean(readonly);
    }
    get readonly() {
        return this._readonly;
    }
    /**
     * Define se a primeira atualização do campo será feita no blur. Ao entrar novamente, a atualização volta para a estratégia padrão
     *
     * *Defines if the first update of the field will be done on blur. Upon re-entering, update reverts to default strategy*
     */
    set controlUpdateFirstOnBlur(value) {
        this.updateFirstOnBlur = enforceBoolean(value);
    }
    /**
     * Desabilita a edição do campo
     *
     * *Disables the field editing*
     */
    set controlDisabled(disabled) {
        this.disabled = enforceBoolean(disabled);
    }
    get controlDisabled() {
        return (this.disabled && !this.controlValue) || null;
    }
    /** @internal */
    get controlReadOnly() {
        return (this.disabled && !!this.controlValue) || null || this.readonly;
    }
    /** @internal */
    get controlValue() {
        return this.value;
    }
    /** @internal */
    set type(type) {
        this._type = type;
    }
    get type() {
        if (platform.isMobile && this._type === 'number') {
            return 'text';
        }
        return this._type;
    }
    /** @internal */
    set inputmode(inputMode) {
        this._inputmode = inputMode;
    }
    get inputmode() {
        if (this._type === 'number') {
            return 'numeric';
        }
        return this._inputmode;
    }
    /** @internal */
    set pattern(pattern) {
        this._pattern = pattern;
    }
    get pattern() {
        if (this._type === 'number') {
            return '[0-9]*';
        }
        return this._pattern;
    }
    /** @internal */
    controlInput({ value, valueAsNumber }) {
        this.value = valueAsNumber || value;
    }
    /** @internal */
    controlChange(value) {
        this.value = value;
        this.formAcessorHandleChange();
    }
    /** @internal */
    controlFocus() {
        this.formAcessorHandleFocus();
    }
    /** @internal */
    controlBlur() {
        this.formAcessorHandleBlur();
    }
    /* implementado para verbalizar o texto da label + campo de edição o
    aria-labelledby tem o mesmo valor do atributo for da label. */
    /** @internal */
    handleArialabelledby() {
        if (platform.os === 'Windows') {
            this.ariaLabelledby = this.controlId;
        }
    }
    /** @internal */
    ngOnInit() {
        this.handleArialabelledby();
    }
    /** @internal */
    ngDoCheck() {
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
    }
}
VoxelInputDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelInputDirective_BaseFactory; return function VoxelInputDirective_Factory(t) { return (ɵVoxelInputDirective_BaseFactory || (ɵVoxelInputDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelInputDirective)))(t || VoxelInputDirective); }; }();
VoxelInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelInputDirective, selectors: [["", "voxelInput", ""]], hostVars: 8, hostBindings: function VoxelInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function VoxelInputDirective_input_HostBindingHandler($event) { return ctx.controlInput($event.target); })("ngModelChange", function VoxelInputDirective_ngModelChange_HostBindingHandler($event) { return ctx.controlChange($event); })("focus", function VoxelInputDirective_focus_HostBindingHandler() { return ctx.controlFocus(); })("blur", function VoxelInputDirective_blur_HostBindingHandler() { return ctx.controlBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.inputClasses)("id", ctx.controlId)("disabled", ctx.controlDisabled)("readonly", ctx.controlReadOnly)("value", ctx.controlValue)("type", ctx.type)("inputmode", ctx.inputmode)("pattern", ctx.pattern);
    } }, inputs: { readonly: "readonly", controlUpdateFirstOnBlur: ["updateFirstOnBlur", "controlUpdateFirstOnBlur"], controlDisabled: ["disabled", "controlDisabled"], type: "type", inputmode: "inputmode", pattern: "pattern" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: VoxelFieldMixinBase,
                useExisting: forwardRef(() => VoxelInputDirective)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelInputDirective.propDecorators = {
    readonly: [{ type: Input }],
    controlUpdateFirstOnBlur: [{ type: Input, args: ['updateFirstOnBlur',] }],
    controlDisabled: [{ type: Input, args: ['disabled',] }, { type: HostBinding, args: ['attr.disabled',] }],
    controlReadOnly: [{ type: HostBinding, args: ['attr.readonly',] }],
    controlValue: [{ type: HostBinding, args: ['attr.value',] }],
    inputClasses: [{ type: HostBinding, args: ['attr.class',] }],
    controlId: [{ type: HostBinding, args: ['attr.id',] }],
    type: [{ type: Input }, { type: HostBinding, args: ['attr.type',] }],
    inputmode: [{ type: Input }, { type: HostBinding, args: ['attr.inputmode',] }],
    pattern: [{ type: Input }, { type: HostBinding, args: ['attr.pattern',] }],
    controlInput: [{ type: HostListener, args: ['input', ['$event.target'],] }],
    controlChange: [{ type: HostListener, args: ['ngModelChange', ['$event'],] }],
    controlFocus: [{ type: HostListener, args: ['focus',] }],
    controlBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelInputDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelInput]',
                providers: [
                    {
                        provide: VoxelFieldMixinBase,
                        useExisting: forwardRef(() => VoxelInputDirective)
                    },
                ]
            }]
    }], null, { inputClasses: [{
            type: HostBinding,
            args: ['attr.class']
        }], controlId: [{
            type: HostBinding,
            args: ['attr.id']
        }], readonly: [{
            type: Input
        }], controlUpdateFirstOnBlur: [{
            type: Input,
            args: ['updateFirstOnBlur']
        }], controlDisabled: [{
            type: Input,
            args: ['disabled']
        }, {
            type: HostBinding,
            args: ['attr.disabled']
        }], controlReadOnly: [{
            type: HostBinding,
            args: ['attr.readonly']
        }], controlValue: [{
            type: HostBinding,
            args: ['attr.value']
        }], type: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.type']
        }], inputmode: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.inputmode']
        }], pattern: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.pattern']
        }], 
    /** @internal */
    controlInput: [{
            type: HostListener,
            args: ['input', ['$event.target']]
        }], 
    /** @internal */
    controlChange: [{
            type: HostListener,
            args: ['ngModelChange', ['$event']]
        }], 
    /** @internal */
    controlFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /** @internal */
    controlBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

class VoxelInputModule {
}
VoxelInputModule.ɵfac = function VoxelInputModule_Factory(t) { return new (t || VoxelInputModule)(); };
VoxelInputModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelInputModule });
VoxelInputModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelInputModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelInputDirective],
                exports: [VoxelInputDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelInputModule, { declarations: function () { return [VoxelInputDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelInputDirective]; } }); })();

/**
 * @internal
 */
let NEXT_ID$8 = 0;
/**
 * O componente Learn-more é usado para exibir extensas mensagens ou conteúdo sobre um produto ou serviço.
 *
 * *The learn more component is used to display extensive messages or content about a product or service.*
 *
 * **Module:**
 *
 * `import { VoxelLearnMoreComponent } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/learnmore?componentOnly=true</example-url>
 *
 * @example learn more fechado / Learn more closed
 *  <voxel-learn-more>
 *    <p>
 *      Far over the Misty Mountains cold, to dungeons deep and caverns old,
 *      we must away, ere break of day, to seek our pale enchanted gold.
 *      The dwarves of yore made mighty spells, while hammers fell like ringing bells,
 *      in places deep, where dark things sleep, in hollow halls beneath the fells.
 *    </p>
 *    <p>
 *      For ancient king and elvish lord, there many a gleaming golden hoard,
 *      they shaped and wrought, and light they caught, to hide in gems on hilt of sword.
 *    </p>
 *  </voxel-learn-more>
 *
 * @example learn more aberto e texto de botão diferente / learn more opened and diferent button text
 *  <voxel-learn-more
 *  [collapse]="false"
 *  readMoreLabel="Ver mais"
 *  readLessLabel="Ver menos"
 *  >
 *    <p>
 *      Far over the Misty Mountains cold, to dungeons deep and caverns old,
 *      we must away, ere break of day, to seek our pale enchanted gold.
 *      The dwarves of yore made mighty spells, while hammers fell like ringing bells,
 *      in places deep, where dark things sleep, in hollow halls beneath the fells.
 *    </p>
 *    <p>
 *      For ancient king and elvish lord, there many a gleaming golden hoard,
 *      they shaped and wrought, and light they caught, to hide in gems on hilt of sword.
 *    </p>
 *  </voxel-learn-more>
 */
class VoxelLearnMoreComponent {
    constructor(render) {
        this.render = render;
        /**
         * @internal
         */
        this.html = '';
        /**
         * @internal
         */
        this.firstAnimation = false;
        /**
         * @internal
         */
        this.minimalforBT = true;
        /**
         * @internal
         */
        this.cutOffContent = 0.39;
        /**
         * @internal
         */
        this.text = '';
        /**
         * @internal
         */
        this.contentId = `voxel-learnmore__content-${NEXT_ID$8++}`;
        /**
         * Booleano para recolher ou expandir o texto
         *
         * *Boolean to collapse or expand text*
         */
        this.collapse = true;
        /**
         * Texto para o botão quando o componente é recolhido
         *
         * *Text for the button when the component is collapsed*
         */
        this.readMoreLabel = 'ver mais';
        /**
         * Texto para o botão quando o componente não recolhido
         *
         * *Text for the button when the component is uncollapsed*
         */
        this.readLessLabel = 'ver menos';
        /**
         * Define Id para os elementos do componente
         *
         *
         * *Defines Id for the component elements*
         */
        this.learnMoreId = `voxel-learnmore-${NEXT_ID$8++}`;
        /**
         * @internal
         */
        this.focusOnChild = () => {
            if (!this.content.nativeElement.children[0]) {
                return;
            }
            this.render.setAttribute(this.content.nativeElement.children[0], 'Tabindex', '-1');
            this.render.setStyle(this.content.nativeElement.children[0], 'outline', 'none');
            this.content.nativeElement.children[0].focus();
        };
    }
    ngAfterContentInit() {
        this.html = this.content.nativeElement.innerHTML;
        this.text = this.content.nativeElement.textContent;
        this.onResize();
    }
    /**
     * @internal
     */
    onResize(fn) {
        if (!this.collapse) {
            this.content.nativeElement.innerHTML = this.html;
            if (fn) {
                fn();
            }
            return;
        }
        if (this.text.slice(this.content.nativeElement.offsetWidth * this.cutOffContent + 1, this.html.length - 1) === '') {
            this.content.nativeElement.innerHTML = this.text;
            this.minimalforBT = false;
            return;
        }
        this.minimalforBT = true;
        this.content.nativeElement.innerHTML = this.text
            .slice(0, this.content.nativeElement.offsetWidth * this.cutOffContent)
            .concat('...');
    }
    /**
     * @internal
     */
    toggleCollapse() {
        this.collapse = !this.collapse;
        if (!this.collapse) {
            this.firstAnimation = true;
            this.onResize();
        }
    }
    /**
     * @internal
     */
    animateEnd() {
        if (!this.firstAnimation) {
            this.onResize();
            return;
        }
        this.onResize(this.focusOnChild);
    }
}
VoxelLearnMoreComponent.ɵfac = function VoxelLearnMoreComponent_Factory(t) { return new (t || VoxelLearnMoreComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VoxelLearnMoreComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelLearnMoreComponent, selectors: [["voxel-learn-more"]], viewQuery: function VoxelLearnMoreComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c35, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, hostBindings: function VoxelLearnMoreComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VoxelLearnMoreComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { collapse: "collapse", readMoreLabel: "readMoreLabel", readLessLabel: "readLessLabel", learnMoreId: "learnMoreId" }, ngContentSelectors: _c0, decls: 5, vars: 6, consts: [[1, "voxel-learnmore"], [1, "voxel-learnmore__content"], ["content", ""], ["voxelButtonContextual", "", 3, "click", 4, "ngIf"], ["voxelButtonContextual", "", 3, "click"]], template: function VoxelLearnMoreComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵlistener("@expandContent.done", function VoxelLearnMoreComponent_Template_div_animation_expandContent_done_1_listener() { return ctx.animateEnd(); });
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, VoxelLearnMoreComponent_button_4_Template, 2, 3, "button", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-learnmore--expanded", !ctx.collapse || !ctx.minimalforBT);
        ɵngcc0.ɵɵattribute("id", ctx.learnMoreId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("@expandContent", ctx.collapse ? true : false);
        ɵngcc0.ɵɵattribute("id", ctx.contentId);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.minimalforBT);
    } }, directives: [ɵngcc1.NgIf, VoxelButtonComponent], styles: [".voxel-learnmore[_ngcontent-%COMP%]{margin-bottom:var(--ids_size_general_16x);position:relative;width:100%}.voxel-learnmore[_ngcontent-%COMP%]:after{background:-webkit-gradient(linear,left top,left bottom,color-stop(40%,transparent),to(var(--ids_color_bg_base)));background:linear-gradient(180deg,transparent 40%,var(--ids_color_bg_base) 100%);bottom:0;content:\"\";height:100%;pointer-events:none;position:absolute;width:100%}.voxel-learnmore--expanded[_ngcontent-%COMP%]:after{opacity:0;-webkit-transition:opacity 1.25s;transition:opacity 1.25s}.voxel-learnmore__content[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onLight);display:block;font:var(--ids_textStyle_body_01_regular);height:auto;overflow:hidden}"], data: { animation: [
            trigger('expandContent', [
                state('true', style({ height: '80px' })),
                state('false', style({ height: '*' })),
                transition('false <=> true', animate('0.4s')),
            ]),
        ] } });
VoxelLearnMoreComponent.ctorParameters = () => [
    { type: Renderer2 }
];
VoxelLearnMoreComponent.propDecorators = {
    collapse: [{ type: Input }],
    readMoreLabel: [{ type: Input }],
    readLessLabel: [{ type: Input }],
    learnMoreId: [{ type: Input }],
    content: [{ type: ViewChild, args: ['content', { static: true },] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLearnMoreComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-learn-more',
                template: "<div\n  class=\"voxel-learnmore\"\n  [attr.id]=\"learnMoreId\"\n  [class.voxel-learnmore--expanded]=\"!collapse || !minimalforBT\"\n>\n  <div\n    #content\n    class=\"voxel-learnmore__content\"\n    [attr.id]=\"contentId\"\n    [@expandContent]=\"collapse ? true : false\"\n    (@expandContent.done)=\"animateEnd()\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n\n<button *ngIf=\"minimalforBT\"\n  voxelButtonContextual\n  (click)=\"toggleCollapse()\"\n  [attr.aria-expanded]=\"!collapse\"\n  [attr.aria-controls]=\"contentId\"\n>\n  {{ collapse ? readMoreLabel : readLessLabel }}\n</button>",
                animations: [
                    trigger('expandContent', [
                        state('true', style({ height: '80px' })),
                        state('false', style({ height: '*' })),
                        transition('false <=> true', animate('0.4s')),
                    ]),
                ],
                styles: [".voxel-learnmore{margin-bottom:var(--ids_size_general_16x);position:relative;width:100%}.voxel-learnmore:after{background:-webkit-gradient(linear,left top,left bottom,color-stop(40%,transparent),to(var(--ids_color_bg_base)));background:linear-gradient(180deg,transparent 40%,var(--ids_color_bg_base) 100%);bottom:0;content:\"\";height:100%;pointer-events:none;position:absolute;width:100%}.voxel-learnmore--expanded:after{opacity:0;-webkit-transition:opacity 1.25s;transition:opacity 1.25s}.voxel-learnmore__content{color:var(--ids_color_contrast_onLight);display:block;font:var(--ids_textStyle_body_01_regular);height:auto;overflow:hidden}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { collapse: [{
            type: Input
        }], readMoreLabel: [{
            type: Input
        }], readLessLabel: [{
            type: Input
        }], learnMoreId: [{
            type: Input
        }], 
    /**
     * @internal
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], content: [{
            type: ViewChild,
            args: ['content', { static: true }]
        }] }); })();

class VoxelLearnMoreModule {
}
VoxelLearnMoreModule.ɵfac = function VoxelLearnMoreModule_Factory(t) { return new (t || VoxelLearnMoreModule)(); };
VoxelLearnMoreModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelLearnMoreModule });
VoxelLearnMoreModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelButtonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLearnMoreModule, [{
        type: NgModule,
        args: [{
                declarations: [VoxelLearnMoreComponent],
                imports: [CommonModule, VoxelButtonModule],
                exports: [VoxelLearnMoreComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelLearnMoreModule, { declarations: function () { return [VoxelLearnMoreComponent]; }, imports: function () { return [CommonModule, VoxelButtonModule]; }, exports: function () { return [VoxelLearnMoreComponent]; } }); })();

/**
 * @internal
 */
const LIKERT_OPTIONS_DEFAULT = [
    {
        key: 'bad',
        value: 'ruim',
        order: 1,
    },
    {
        key: 'dislike',
        value: 'não gostei',
        order: 2,
    },
    {
        key: 'neutral',
        value: 'neutro',
        order: 3,
    },
    {
        key: 'like',
        value: 'gostei',
        order: 4,
    },
    {
        key: 'love',
        value: 'adorei',
        order: 5,
    },
];
/**
 * @internal
 */
let NEXT_ID$7 = 1;
/**
 * Likert é um elemento baseado numa escala de pesquisa que combina estatística à psicologia,
 * para extrair insights qualitativos a partir de uma pergunta estruturada de forma quantitativa.
 * Utilizamos para avaliar a experiência do usuário referente a um fluxo.
 *
 * *Likert is an element based on a research scale that combines statistics with psychology*
 * *to extract qualitative insights from a quantitatively structured question.*
 * *We use it to assess the user experience for a flow.*
 *
 *  **Module:**
 *
 * `import { VoxelLikertModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/likert?componentOnly=true</example-url>
 *
 * @example componente simples
 * <voxel-likert
 *    (change)="responseLikert($event)">
 *    O que você achou dessa nova experiência?
 * </voxel-likert>
 *
 * @example enviando somente um nome para ser alterado.
 * <voxel-likert (change)="responseLikert($event)"
 *    [options]="[{ key:'love', value: 'amei' }]"
 * >
 *   O que você achou dessa nova experiência?
 * </voxel-likert>
 *
 * @example enviando lista completa.
 * <voxel-likert (change)="responseLikert($event)"
 *    [options]="[
 *    { key:'bad', value: 'péssimo' },
 *    { key:'dislike', value: 'ruim' },
 *    { key:'neutral', value: 'sei lá' },
 *    { key:'like', value: 'muito bom' },
 *    { key:'love', value: 'amei' }]"
 * >
 *
 *   O que achou dessa jornada?
 * </voxel-likert>
 */
class VoxelLikertComponent {
    constructor() {
        /**
         * @internal
         */
        this.optionsDefault = LIKERT_OPTIONS_DEFAULT;
        /**
         * lista com chave e valor (o nome da chave deve ser respeitado)
         *
         * *list with key and value (the key name must be respected)*
         *
         * [{key: "like", value: "gostei"}]
         */
        this.options = [];
        /**
         * Variavel que define o id do componente
         *
         * *Variable that defines the id of the component*
         */
        this.id = `voxel-likert-${NEXT_ID$7++}`;
        /**
         * Evento de resposta do likert
         *
         * *Likert response event*
         *
         * {key: "like", value: "gostei"}
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no likert.
         *
         * *Event triggered with focus on likert.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no likert.
         *
         * *Event triggered with blur on likert.*
         */
        this.blur = new EventEmitter();
        /**
         * @internal
         */
        // eslint-disable-next-line
        this._onChange = (_) => { };
        /**
         * @internal
         */
        // eslint-disable-next-line
        this._onTouched = () => { };
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.fillAndOrderOptions();
    }
    /**
     * @internal
     */
    fillAndOrderOptions() {
        if (this.options.length) {
            this.optionsDefault.forEach((option) => this.addOption(option));
            this.options.forEach((option) => this.addOrder(option));
            this.options.sort((a, b) => {
                if (a.order && b.order) {
                    return a.order - b.order;
                }
                /* istanbul ignore next */
                return 0;
            });
            return;
        }
        this.options = this.optionsDefault;
    }
    /**
     * @internal
     */
    onFocus() {
        this.focus.emit(this.value);
    }
    /**
     * @internal
     */
    onBlur() {
        this._onTouched();
        this.blur.emit(this.value);
    }
    /**
     * @internal
     */
    emitValue(option) {
        this.value = option;
        this._onChange(this.value);
        this.change.emit(this.value);
    }
    /**
     * @internal
     */
    addOption(option) {
        const hasOption = this.options.some((item) => item.key === option.key);
        if (!hasOption) {
            this.options.push(option);
        }
    }
    /**
     * @internal
     */
    addOrder(option) {
        const likert = {
            bad: () => {
                option.order = 1;
            },
            dislike: () => {
                option.order = 2;
            },
            neutral: () => {
                option.order = 3;
            },
            like: () => {
                option.order = 4;
            },
            love: () => {
                option.order = 5;
            },
        };
        likert[option.key]();
    }
    /**
     * @internal
     */
    writeValue(value) {
        this.value = value;
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
}
VoxelLikertComponent.ɵfac = function VoxelLikertComponent_Factory(t) { return new (t || VoxelLikertComponent)(); };
VoxelLikertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelLikertComponent, selectors: [["voxel-likert"]], inputs: { options: "options", id: "id", value: "value" }, outputs: { change: "change", focus: "focus", blur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: VoxelLikertComponent
            },
        ])], ngContentSelectors: _c0, decls: 15, vars: 2, consts: [[1, "voxel-likert", 3, "id"], [1, "voxel-likert__label"], [1, "voxel-likert__content"], ["type", "button", "class", "voxel-likert__button", "role", "radio", 3, "voxel-likert__button--selected", "id", "click", "focus", "blur", 4, "ngFor", "ngForOf"], ["bad", ""], ["dislike", ""], ["neutral", ""], ["like", ""], ["love", ""], ["type", "button", "role", "radio", 1, "voxel-likert__button", 3, "id", "click", "focus", "blur"], [3, "ngTemplateOutlet"], [1, "voxel-likert__button__text"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3ClinearGradient x1='50%25' y1='-20.7957192%25' x2='50%25' y2='75.0698753%25' id='linearGradient-1'%3E%3Cstop stop-color='%23EC7000' offset='0%25'%3E%3C/stop%3E%3Cstop stop-color='%23FFD735' offset='100%25'%3E%3C/stop%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-167.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(167.000000, 198.000000)'%3E%3Cpath d='M20,0 C8.95454424,0 0,8.95442431 0,20.0002679 L0,20.0002679 C0,31.0455757 8.95454424,40 20,40 L20,40 C31.0465272,40 40,31.0455757 40,20.0002679 L40,20.0002679 C40,8.95442431 31.0465272,0 20,0 Z' id='Fill-1' fill='url(%23linearGradient-1)'%3E%3C/path%3E%3Cpath d='M16,29 L16,29 C18.3925714,27.6666667 21.6074286,27.6666667 24,29' id='Stroke-4' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M28,22.9997596 C28,24.1047001 28.8952999,25 30.0002404,25 C31.1047001,25 32,24.1047001 32,22.9997596 C32,21.8952999 31.1047001,21 30.0002404,21 C28.8952999,21 28,21.8952999 28,22.9997596' id='Fill-10' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,19.3979764 C31.5385928,19.1470489 30.9795309,19 30.3773987,19 C29.3876333,19 28.5151386,19.3966273 28,20' id='Stroke-12' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-6' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M8,19.3979764 C8.46135806,19.1470489 9.0203603,19 9.62242831,19 C10.6120883,19 11.4844899,19.3966273 12,20' id='Stroke-8' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='41px' height='40px' viewBox='0 0 41 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-271.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(271.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-8' fill='%23FFD735' cx='21' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M17,30 L17,30 C19.3925714,28.6666667 22.6074286,28.6666667 25,30' id='Stroke-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M6.82823035,24.8650074 L4.14275994,22.0597038 C4.06655533,21.9800987 3.93146533,21.9800987 3.85476588,22.0597038 L1.16979031,24.8650074 C-0.389930105,26.4943268 -0.389930105,29.1455894 1.16979031,30.7759427 C1.92589844,31.5647567 2.93041381,32 3.99876291,32 C6.25026288,32 8,30.0920628 8,27.8202166 C8,26.7036779 7.5833488,25.6538213 6.82823035,24.8650074' id='Fill-5' fill='%23106EB0'%3E%3C/path%3E%3Cpath d='M29,22.9997596 C29,24.1047001 29.8952999,25 30.9997596,25 C32.1047001,25 33,24.1047001 33,22.9997596 C33,21.8952999 32.1047001,21 30.9997596,21 C29.8952999,21 29,21.8952999 29,22.9997596' id='Fill-8' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M33,18.1994573 C32.4594054,18.7042062 31.8043967,19 31.0989258,19 C30.3045216,19 29.5750687,18.6255088 29,18' id='Stroke-10' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M13,22.9997596 C13,24.1047001 12.1048077,25 11,25 C9.89567308,25 9,24.1047001 9,22.9997596 C9,21.8952999 9.89567308,21 11,21 C12.1048077,21 13,21.8952999 13,22.9997596' id='Fill-12' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M9,18.1994573 C9.54052704,18.7042062 10.195454,19 10.9013363,19 C11.6951418,19 12.4245036,18.6255088 13,18' id='Stroke-14' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-375.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(375.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-7' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-3-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,22.9997596 C32,24.1047001 31.1047001,25 30.0002404,25 C28.8952999,25 28,24.1047001 28,22.9997596 C28,21.8952999 28.8952999,21 30.0002404,21 C31.1047001,21 32,21.8952999 32,22.9997596' id='Fill-5-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpolyline id='Stroke-7-Copy-2' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' points='16 30 21.478863 30 24 30'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-479.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(479.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-6' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M7.49285834,19.0780347 C7.37839458,19.384594 7.03130511,19.5424284 6.71761232,19.4305675 C6.40391953,19.3187067 6.24241249,18.9795101 6.35687625,18.6729507 C6.59489533,18.0354827 7.01764654,17.4819177 7.58593436,17.082183 C8.22762031,16.6313596 8.9910809,16.4222903 9.75734384,16.4743229 C10.0904645,16.4969433 10.3417479,16.7791874 10.3186012,17.1047328 C10.2954545,17.4302783 10.0066427,17.6758475 9.67352211,17.6532272 C9.18702517,17.6201919 8.70316854,17.7526932 8.29207472,18.0415116 C7.92339224,18.3008436 7.64878839,18.6604193 7.49285834,19.0780347 Z' id='Stroke-3-Copy' fill='%23231D19' fill-rule='nonzero' transform='translate(8.320080, 17.966527) rotate(-345.000000) translate(-8.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M30.4928583,19.0780347 C30.3783946,19.384594 30.0313051,19.5424284 29.7176123,19.4305675 C29.4039195,19.3187067 29.2424125,18.9795101 29.3568763,18.6729507 C29.5948953,18.0354827 30.0176465,17.4819177 30.5859344,17.082183 C31.2276203,16.6313596 31.9910809,16.4222903 32.7573438,16.4743229 C33.0904645,16.4969433 33.3417479,16.7791874 33.3186012,17.1047328 C33.2954545,17.4302783 33.0066427,17.6758475 32.6735221,17.6532272 C32.1870252,17.6201919 31.7031685,17.7526932 31.2920747,18.0415116 C30.9233922,18.3008436 30.6487884,18.6604193 30.4928583,19.0780347 Z' id='Stroke-3-Copy-2' fill='%23231D19' fill-rule='nonzero' transform='translate(31.320080, 17.966527) scale(-1, 1) rotate(-345.000000) translate(-31.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M11.9313297,22.4824008 C12.217328,23.5490421 11.5838057,24.6454859 10.517681,24.9314938 C9.45107552,25.217021 8.35466858,24.5839581 8.06867027,23.5173168 C7.78267197,22.4511562 8.41619426,21.3542317 9.48231904,21.0687045 C10.5489245,20.7826966 11.6453314,21.4157595 11.9313297,22.4824008' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M28.0687016,23.5175791 C28.3546977,24.5846926 29.4506152,25.2172698 30.5176928,24.9312641 C31.5838091,24.6457392 32.2173263,23.5493041 31.9313303,22.4826713 C31.6453343,21.4160385 30.5489361,20.7829807 29.4823391,21.0685056 C28.4157422,21.3545113 27.7827056,22.4509463 28.0687016,23.5175791' id='Fill-9-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M16,30 L16,30 C18.3925714,28.6666667 21.6074286,28.6666667 24,30' id='Stroke-3-Copy-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' transform='translate(20.000000, 29.500000) rotate(-180.000000) translate(-20.000000, -29.500000) '%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3Cpath d='M7,7 C10.8659932,7 14,3.86599325 14,0 C14,0 0,0 0,0 C0,3.86599325 3.13400675,7 7,7 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-583.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(583.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-2' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cg id='Rectangle-Copy-4' transform='translate(26.667347, 27.192474) rotate(-15.000000) translate(-26.667347, -27.192474) translate(19.667347, 23.692474)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cuse id='Mask' fill='%23EC7000' xlink:href='%23path-1'%3E%3C/use%3E%3Crect id='Rectangle' fill='%23FFFFFF' mask='url(%23mask-2)' x='-0.774094079' y='-0.974744871' width='15' height='3'%3E%3C/rect%3E%3C/g%3E%3Cg id='Group-Copy-8' transform='translate(11.000000, 17.000000)'%3E%3Cpath d='M0,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3Cg id='Group-Copy-9' transform='translate(30.750173, 14.885095) scale(-1, 1) rotate(34.000000) translate(-30.750173, -14.885095) translate(28.250173, 11.885095)'%3E%3Cpath d='M-3.63797881e-12,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"]], template: function VoxelLikertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵelementStart(1, "legend", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, VoxelLikertComponent_button_4_Template, 4, 6, "button", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, VoxelLikertComponent_ng_template_5_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, VoxelLikertComponent_ng_template_7_Template, 1, 0, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(9, VoxelLikertComponent_ng_template_9_Template, 1, 0, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(11, VoxelLikertComponent_ng_template_11_Template, 1, 0, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(13, VoxelLikertComponent_ng_template_13_Template, 1, 0, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.options);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], styles: [".voxel-likert[_ngcontent-%COMP%]{display:block;overflow:hidden}.voxel-likert__label[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular)}.voxel-likert__content[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin:var(--ids_size_general_28x) 0}.voxel-likert__img[_ngcontent-%COMP%]{border:var(--ids_size_border_medium) solid transparent;border-radius:50%;margin-bottom:var(--ids_size_general_8x);-webkit-transition:border-color .3s,-webkit-transform .3s;transition:border-color .3s,-webkit-transform .3s;transition:transform .3s,border-color .3s;transition:transform .3s,border-color .3s,-webkit-transform .3s}@media (max-width: 47.99rem){.voxel-likert__img[_ngcontent-%COMP%]{height:var(--ids_size_general_28x);width:var(--ids_size_general_28x)}}.voxel-likert__button[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font:var(--ids_textStyle_label_small_regular);-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.voxel-likert__button__text[_ngcontent-%COMP%]{margin:0 var(--ids_size_general_6x)}.voxel-likert__button--selected[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_small_bold);-webkit-transform:scale(1.25);transform:scale(1.25)}.voxel-likert__button--selected[_ngcontent-%COMP%]   .voxel-likert__img[_ngcontent-%COMP%]{border-color:var(--ids_color_action_neutral_variant)}.voxel-likert__button[_ngcontent-%COMP%]:hover:not(.voxel-likert__button--selected){font:var(--ids_textStyle_label_small_bold)}.voxel-likert__button[_ngcontent-%COMP%]:hover:not(.voxel-likert__button--selected)   .voxel-likert__img[_ngcontent-%COMP%]{-webkit-transform:translateY(-.625rem);transform:translateY(-.625rem)}"] });
VoxelLikertComponent.propDecorators = {
    value: [{ type: Input }],
    options: [{ type: Input }],
    id: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLikertComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-likert',
                template: "<fieldset\n  class=\"voxel-likert\"\n  [id]=\"id\"\n>\n  <legend class=\"voxel-likert__label\">\n    <ng-content></ng-content>\n  </legend>\n\n  <div class=\"voxel-likert__content\">\n    <button\n      *ngFor=\"let option of options\"\n      type=\"button\"\n      class=\"voxel-likert__button\"\n      [class.voxel-likert__button--selected]=\"value?.key === option?.key\"\n      [id]=\"id + '-' + option.key\"\n      role=\"radio\"\n      [attr.aria-checked]=\"option === value\"\n      (click)=\"emitValue(option)\"\n      (focus)=\"onFocus()\"\n      (blur)=\"onBlur()\"\n    >\n      <ng-container\n        [ngTemplateOutlet]=\"\n          option.key === 'bad' ?\n            bad\n            : option.key === 'dislike' ?\n              dislike\n              : option.key === 'neutral' ?\n                neutral\n                : option.key === 'like' ?\n                  like\n                  : love\n        \"\n      >\n      </ng-container>\n      <span class=\"voxel-likert__button__text\">\n        {{option.value}}\n      </span>\n    </button>\n  </div>\n</fieldset>\n\n<ng-template #bad>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3ClinearGradient x1='50%25' y1='-20.7957192%25' x2='50%25' y2='75.0698753%25' id='linearGradient-1'%3E%3Cstop stop-color='%23EC7000' offset='0%25'%3E%3C/stop%3E%3Cstop stop-color='%23FFD735' offset='100%25'%3E%3C/stop%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-167.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(167.000000, 198.000000)'%3E%3Cpath d='M20,0 C8.95454424,0 0,8.95442431 0,20.0002679 L0,20.0002679 C0,31.0455757 8.95454424,40 20,40 L20,40 C31.0465272,40 40,31.0455757 40,20.0002679 L40,20.0002679 C40,8.95442431 31.0465272,0 20,0 Z' id='Fill-1' fill='url(%23linearGradient-1)'%3E%3C/path%3E%3Cpath d='M16,29 L16,29 C18.3925714,27.6666667 21.6074286,27.6666667 24,29' id='Stroke-4' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M28,22.9997596 C28,24.1047001 28.8952999,25 30.0002404,25 C31.1047001,25 32,24.1047001 32,22.9997596 C32,21.8952999 31.1047001,21 30.0002404,21 C28.8952999,21 28,21.8952999 28,22.9997596' id='Fill-10' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,19.3979764 C31.5385928,19.1470489 30.9795309,19 30.3773987,19 C29.3876333,19 28.5151386,19.3966273 28,20' id='Stroke-12' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-6' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M8,19.3979764 C8.46135806,19.1470489 9.0203603,19 9.62242831,19 C10.6120883,19 11.4844899,19.3966273 12,20' id='Stroke-8' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #dislike>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='41px' height='40px' viewBox='0 0 41 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-271.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(271.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-8' fill='%23FFD735' cx='21' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M17,30 L17,30 C19.3925714,28.6666667 22.6074286,28.6666667 25,30' id='Stroke-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M6.82823035,24.8650074 L4.14275994,22.0597038 C4.06655533,21.9800987 3.93146533,21.9800987 3.85476588,22.0597038 L1.16979031,24.8650074 C-0.389930105,26.4943268 -0.389930105,29.1455894 1.16979031,30.7759427 C1.92589844,31.5647567 2.93041381,32 3.99876291,32 C6.25026288,32 8,30.0920628 8,27.8202166 C8,26.7036779 7.5833488,25.6538213 6.82823035,24.8650074' id='Fill-5' fill='%23106EB0'%3E%3C/path%3E%3Cpath d='M29,22.9997596 C29,24.1047001 29.8952999,25 30.9997596,25 C32.1047001,25 33,24.1047001 33,22.9997596 C33,21.8952999 32.1047001,21 30.9997596,21 C29.8952999,21 29,21.8952999 29,22.9997596' id='Fill-8' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M33,18.1994573 C32.4594054,18.7042062 31.8043967,19 31.0989258,19 C30.3045216,19 29.5750687,18.6255088 29,18' id='Stroke-10' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M13,22.9997596 C13,24.1047001 12.1048077,25 11,25 C9.89567308,25 9,24.1047001 9,22.9997596 C9,21.8952999 9.89567308,21 11,21 C12.1048077,21 13,21.8952999 13,22.9997596' id='Fill-12' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M9,18.1994573 C9.54052704,18.7042062 10.195454,19 10.9013363,19 C11.6951418,19 12.4245036,18.6255088 13,18' id='Stroke-14' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #neutral>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-375.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(375.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-7' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-3-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,22.9997596 C32,24.1047001 31.1047001,25 30.0002404,25 C28.8952999,25 28,24.1047001 28,22.9997596 C28,21.8952999 28.8952999,21 30.0002404,21 C31.1047001,21 32,21.8952999 32,22.9997596' id='Fill-5-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpolyline id='Stroke-7-Copy-2' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' points='16 30 21.478863 30 24 30'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #like>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-479.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(479.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-6' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M7.49285834,19.0780347 C7.37839458,19.384594 7.03130511,19.5424284 6.71761232,19.4305675 C6.40391953,19.3187067 6.24241249,18.9795101 6.35687625,18.6729507 C6.59489533,18.0354827 7.01764654,17.4819177 7.58593436,17.082183 C8.22762031,16.6313596 8.9910809,16.4222903 9.75734384,16.4743229 C10.0904645,16.4969433 10.3417479,16.7791874 10.3186012,17.1047328 C10.2954545,17.4302783 10.0066427,17.6758475 9.67352211,17.6532272 C9.18702517,17.6201919 8.70316854,17.7526932 8.29207472,18.0415116 C7.92339224,18.3008436 7.64878839,18.6604193 7.49285834,19.0780347 Z' id='Stroke-3-Copy' fill='%23231D19' fill-rule='nonzero' transform='translate(8.320080, 17.966527) rotate(-345.000000) translate(-8.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M30.4928583,19.0780347 C30.3783946,19.384594 30.0313051,19.5424284 29.7176123,19.4305675 C29.4039195,19.3187067 29.2424125,18.9795101 29.3568763,18.6729507 C29.5948953,18.0354827 30.0176465,17.4819177 30.5859344,17.082183 C31.2276203,16.6313596 31.9910809,16.4222903 32.7573438,16.4743229 C33.0904645,16.4969433 33.3417479,16.7791874 33.3186012,17.1047328 C33.2954545,17.4302783 33.0066427,17.6758475 32.6735221,17.6532272 C32.1870252,17.6201919 31.7031685,17.7526932 31.2920747,18.0415116 C30.9233922,18.3008436 30.6487884,18.6604193 30.4928583,19.0780347 Z' id='Stroke-3-Copy-2' fill='%23231D19' fill-rule='nonzero' transform='translate(31.320080, 17.966527) scale(-1, 1) rotate(-345.000000) translate(-31.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M11.9313297,22.4824008 C12.217328,23.5490421 11.5838057,24.6454859 10.517681,24.9314938 C9.45107552,25.217021 8.35466858,24.5839581 8.06867027,23.5173168 C7.78267197,22.4511562 8.41619426,21.3542317 9.48231904,21.0687045 C10.5489245,20.7826966 11.6453314,21.4157595 11.9313297,22.4824008' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M28.0687016,23.5175791 C28.3546977,24.5846926 29.4506152,25.2172698 30.5176928,24.9312641 C31.5838091,24.6457392 32.2173263,23.5493041 31.9313303,22.4826713 C31.6453343,21.4160385 30.5489361,20.7829807 29.4823391,21.0685056 C28.4157422,21.3545113 27.7827056,22.4509463 28.0687016,23.5175791' id='Fill-9-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M16,30 L16,30 C18.3925714,28.6666667 21.6074286,28.6666667 24,30' id='Stroke-3-Copy-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' transform='translate(20.000000, 29.500000) rotate(-180.000000) translate(-20.000000, -29.500000) '%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #love>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3Cpath d='M7,7 C10.8659932,7 14,3.86599325 14,0 C14,0 0,0 0,0 C0,3.86599325 3.13400675,7 7,7 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-583.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(583.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-2' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cg id='Rectangle-Copy-4' transform='translate(26.667347, 27.192474) rotate(-15.000000) translate(-26.667347, -27.192474) translate(19.667347, 23.692474)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cuse id='Mask' fill='%23EC7000' xlink:href='%23path-1'%3E%3C/use%3E%3Crect id='Rectangle' fill='%23FFFFFF' mask='url(%23mask-2)' x='-0.774094079' y='-0.974744871' width='15' height='3'%3E%3C/rect%3E%3C/g%3E%3Cg id='Group-Copy-8' transform='translate(11.000000, 17.000000)'%3E%3Cpath d='M0,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3Cg id='Group-Copy-9' transform='translate(30.750173, 14.885095) scale(-1, 1) rotate(34.000000) translate(-30.750173, -14.885095) translate(28.250173, 11.885095)'%3E%3Cpath d='M-3.63797881e-12,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: VoxelLikertComponent
                    },
                ],
                styles: [".voxel-likert{display:block;overflow:hidden}.voxel-likert__label{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular)}.voxel-likert__content{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin:var(--ids_size_general_28x) 0}.voxel-likert__img{border:var(--ids_size_border_medium) solid transparent;border-radius:50%;margin-bottom:var(--ids_size_general_8x);-webkit-transition:border-color .3s,-webkit-transform .3s;transition:border-color .3s,-webkit-transform .3s;transition:transform .3s,border-color .3s;transition:transform .3s,border-color .3s,-webkit-transform .3s}@media (max-width: 47.99rem){.voxel-likert__img{height:var(--ids_size_general_28x);width:var(--ids_size_general_28x)}}.voxel-likert__button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font:var(--ids_textStyle_label_small_regular);-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.voxel-likert__button__text{margin:0 var(--ids_size_general_6x)}.voxel-likert__button--selected{font:var(--ids_textStyle_label_small_bold);-webkit-transform:scale(1.25);transform:scale(1.25)}.voxel-likert__button--selected .voxel-likert__img{border-color:var(--ids_color_action_neutral_variant)}.voxel-likert__button:hover:not(.voxel-likert__button--selected){font:var(--ids_textStyle_label_small_bold)}.voxel-likert__button:hover:not(.voxel-likert__button--selected) .voxel-likert__img{-webkit-transform:translateY(-.625rem);transform:translateY(-.625rem)}\n"]
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], id: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], value: [{
            type: Input
        }] }); })();

class VoxelLikertModule {
}
VoxelLikertModule.ɵfac = function VoxelLikertModule_Factory(t) { return new (t || VoxelLikertModule)(); };
VoxelLikertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelLikertModule });
VoxelLikertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ReactiveFormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLikertModule, [{
        type: NgModule,
        args: [{
                declarations: [VoxelLikertComponent],
                imports: [CommonModule, ReactiveFormsModule],
                exports: [VoxelLikertComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelLikertModule, { declarations: function () { return [VoxelLikertComponent]; }, imports: function () { return [CommonModule, ReactiveFormsModule]; }, exports: function () { return [VoxelLikertComponent]; } }); })();

/* eslint-disable @angular-eslint/directive-selector */
/**
 * @internal
 */
class VoxelListTextDirective {
    constructor() {
        this.class = 'voxel-list-text';
    }
}
VoxelListTextDirective.ɵfac = function VoxelListTextDirective_Factory(t) { return new (t || VoxelListTextDirective)(); };
VoxelListTextDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListTextDirective, selectors: [["voxel-list-text"]], hostVars: 2, hostBindings: function VoxelListTextDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListTextDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListTextDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-text'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListTextDetailDirective {
    constructor() {
        this.class = 'voxel-list-text-detail';
    }
}
VoxelListTextDetailDirective.ɵfac = function VoxelListTextDetailDirective_Factory(t) { return new (t || VoxelListTextDetailDirective)(); };
VoxelListTextDetailDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListTextDetailDirective, selectors: [["voxel-list-text-detail"]], hostVars: 2, hostBindings: function VoxelListTextDetailDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListTextDetailDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListTextDetailDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-text-detail'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListDescrDirective {
    constructor() {
        this.class = 'voxel-list-descr';
    }
}
VoxelListDescrDirective.ɵfac = function VoxelListDescrDirective_Factory(t) { return new (t || VoxelListDescrDirective)(); };
VoxelListDescrDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListDescrDirective, selectors: [["voxel-list-descr"]], hostVars: 2, hostBindings: function VoxelListDescrDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListDescrDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListDescrDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-descr'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListInformationDirective {
    constructor() {
        this.class = 'voxel-list-information';
    }
}
VoxelListInformationDirective.ɵfac = function VoxelListInformationDirective_Factory(t) { return new (t || VoxelListInformationDirective)(); };
VoxelListInformationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListInformationDirective, selectors: [["voxel-list-information"]], hostVars: 2, hostBindings: function VoxelListInformationDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListInformationDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListInformationDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-information'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListNumberDirective {
    constructor() {
        this.class = 'voxel-list-number';
    }
}
VoxelListNumberDirective.ɵfac = function VoxelListNumberDirective_Factory(t) { return new (t || VoxelListNumberDirective)(); };
VoxelListNumberDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListNumberDirective, selectors: [["voxel-list-number"]], hostVars: 2, hostBindings: function VoxelListNumberDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListNumberDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListNumberDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-number'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListDetailDirective {
    constructor() {
        this.class = 'voxel-list-detail';
    }
}
VoxelListDetailDirective.ɵfac = function VoxelListDetailDirective_Factory(t) { return new (t || VoxelListDetailDirective)(); };
VoxelListDetailDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListDetailDirective, selectors: [["voxel-list-detail"]], hostVars: 2, hostBindings: function VoxelListDetailDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListDetailDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListDetailDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-detail'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListSimpleComponent {
    constructor() {
        this.class = 'voxel-list-simple';
    }
}
VoxelListSimpleComponent.ɵfac = function VoxelListSimpleComponent_Factory(t) { return new (t || VoxelListSimpleComponent)(); };
VoxelListSimpleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListSimpleComponent, selectors: [["voxel-list-simple"], ["", "voxel-list-simple", ""], ["", "voxelListSimple", ""]], hostVars: 2, hostBindings: function VoxelListSimpleComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c37, decls: 7, vars: 1, consts: [[1, "voxel-list__content-simple"]], template: function VoxelListSimpleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c36);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListSimpleComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListSimpleComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-simple, [voxel-list-simple], [voxelListSimple]',
                template: ` <div class="voxel-list__content-simple" [attr.aria-label]="a11yLabel">
    <div>
      <ng-content select="voxel-icon, img"></ng-content>
    </div>
    <div>
      <ng-content></ng-content>
      <span>
        <ng-content select="voxel-list-descr"></ng-content>
      </span>
    </div>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
/**
 * @internal
 */
class VoxelListActionComponent {
    constructor() {
        this.class = 'voxel-list-action';
    }
}
VoxelListActionComponent.ɵfac = function VoxelListActionComponent_Factory(t) { return new (t || VoxelListActionComponent)(); };
VoxelListActionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListActionComponent, selectors: [["voxel-list-action"], ["", "voxel-list-action", ""], ["", "voxelListAction", ""]], hostVars: 2, hostBindings: function VoxelListActionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c39, decls: 8, vars: 3, consts: [[1, "voxel-list__content-action"], ["text", ""], [1, "voxel-list-action__description"]], template: function VoxelListActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c38);
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "button", 0);
        ɵngcc0.ɵɵelementStart(2, "div", null, 1);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementStart(5, "span", 2);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(7, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        let tmp_1_0;
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("voxel-list-action__description--with-icon", ((tmp_1_0 = _r0.children[0] == null ? null : _r0.children[0].firstChild) == null ? null : tmp_1_0.tagName) === "VOXEL-ICON");
    } }, encapsulation: 2 });
VoxelListActionComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListActionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-action, [voxel-list-action], [voxelListAction]',
                template: ` <div>
    <button class="voxel-list__content-action" [attr.aria-label]="a11yLabel">
      <div #text>
        <ng-content></ng-content>
        <span
          class="voxel-list-action__description"
          [class.voxel-list-action__description--with-icon]="
            $any(text.children[0]?.firstChild)?.tagName === 'VOXEL-ICON'
          "
        >
          <ng-content select="voxel-list-descr"></ng-content>
        </span>
      </div>
      <ng-content select="voxel-icon"></ng-content>
    </button>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
/**
 * @internal
 */
class VoxelListInfoComponent {
    constructor() {
        this.class = 'voxel-list-info';
    }
}
VoxelListInfoComponent.ɵfac = function VoxelListInfoComponent_Factory(t) { return new (t || VoxelListInfoComponent)(); };
VoxelListInfoComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListInfoComponent, selectors: [["voxel-list-info"], ["", "voxel-list-info", ""], ["", "voxelListInfo", ""]], hostVars: 2, hostBindings: function VoxelListInfoComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c0, decls: 2, vars: 1, consts: [[1, "voxel-list__content-info"]], template: function VoxelListInfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListInfoComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListInfoComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-info, [voxel-list-info], [voxelListInfo]',
                template: ` <div class="voxel-list__content-info" [attr.aria-label]="a11yLabel">
    <ng-content></ng-content>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
/**
 * @internal
 */
class VoxelListDefinitionComponent {
    constructor() {
        this.class = 'voxel-list-definition';
    }
}
VoxelListDefinitionComponent.ɵfac = function VoxelListDefinitionComponent_Factory(t) { return new (t || VoxelListDefinitionComponent)(); };
VoxelListDefinitionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListDefinitionComponent, selectors: [["voxel-list-definition"], ["", "voxel-list-definition", ""], ["", "voxelListDefinition", ""]], hostVars: 2, hostBindings: function VoxelListDefinitionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c41, decls: 4, vars: 1, consts: [[1, "voxel-list__content-definition"]], template: function VoxelListDefinitionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c40);
        ɵngcc0.ɵɵelementStart(0, "dt", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "dd");
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListDefinitionComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListDefinitionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-definition, [voxel-list-definition], [voxelListDefinition]',
                template: ` <dt class="voxel-list__content-definition" [attr.aria-label]="a11yLabel">
      <ng-content select="voxel-list-descr"></ng-content>
    </dt>
    <dd>
      <ng-content select="voxel-list-text"></ng-content>
    </dd>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
class VoxelListColumnComponent {
    constructor() {
        this.class = 'voxel-list-column';
    }
}
VoxelListColumnComponent.ɵfac = function VoxelListColumnComponent_Factory(t) { return new (t || VoxelListColumnComponent)(); };
VoxelListColumnComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListColumnComponent, selectors: [["voxel-list-column"], ["", "voxel-list-column", ""], ["", "voxelListColumn", ""]], hostVars: 2, hostBindings: function VoxelListColumnComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c43, decls: 9, vars: 1, consts: [[1, "voxel-list__content-column"]], template: function VoxelListColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c42);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵprojection(8, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListColumnComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListColumnComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-column, [voxel-list-column], [voxelListColumn]',
                template: ` <div class="voxel-list__content-column" [attr.aria-label]="a11yLabel">
    <div>
      <ng-content select="voxel-list-text"></ng-content>
      <span>
        <ng-content select="voxel-list-descr"></ng-content>
      </span>
    </div>
    <div>
      <ng-content select="voxel-list-text-detail, voxel-list-number"></ng-content>
      <span>
        <ng-content select="voxel-list-detail"></ng-content>
      </span>
    </div>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
class VoxelListRowComponent {
    constructor() {
        this.class = 'voxel-list-row';
    }
}
VoxelListRowComponent.ɵfac = function VoxelListRowComponent_Factory(t) { return new (t || VoxelListRowComponent)(); };
VoxelListRowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListRowComponent, selectors: [["voxel-list-row"], ["", "voxel-list-row", ""], ["", "voxelListRow", ""]], hostVars: 2, hostBindings: function VoxelListRowComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c45, decls: 9, vars: 1, consts: [[1, "voxel-list__content-row"]], template: function VoxelListRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c44);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div");
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span");
        ɵngcc0.ɵɵprojection(8, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListRowComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListRowComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-row, [voxel-list-row], [voxelListRow]',
                template: ` <div class="voxel-list__content-row" [attr.aria-label]="a11yLabel">
    <div>
      <ng-content select="voxel-list-text"></ng-content>
      <ng-content select="voxel-list-text-detail"></ng-content>
    </div>
    <div>
      <span>
        <ng-content select="voxel-list-descr"></ng-content>
      </span>
      <span>
        <ng-content select="voxel-list-detail"></ng-content>
      </span>
    </div>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
class VoxelListSwitchComponent {
    constructor() {
        this.class = 'voxel-list-switch';
    }
}
VoxelListSwitchComponent.ɵfac = function VoxelListSwitchComponent_Factory(t) { return new (t || VoxelListSwitchComponent)(); };
VoxelListSwitchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListSwitchComponent, selectors: [["voxel-list-switch"], ["", "voxel-list-switch", ""], ["", "voxelListSwitch", ""]], hostVars: 2, hostBindings: function VoxelListSwitchComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c47, decls: 2, vars: 1, consts: [[1, "voxel-list__content-switch"]], template: function VoxelListSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c46);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListSwitchComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-switch, [voxel-list-switch], [voxelListSwitch]',
                template: ` <div class="voxel-list__content-switch" [attr.aria-label]="a11yLabel">
    <ng-content select="voxel-form-selection, input[type='checkbox'][voxelSwitch]"></ng-content>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$6 = 0;
/**
 * Componente de List
 *
 * *List Component*
 *
 * **Module:**
 *
 * `import { VoxelListModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/list?componentOnly=true</example-url>
 *
 * A lista utiliza subcomponentes para especificar o tipo de item que será adicionado.
 * Também possui diretivas para a construção e customização desses itens.
 *
 * Sendo as diretivas:
 * * text: `<voxel-list-text></voxel-list-text>`*
 * * description: `<voxel-list-descr></voxel-list-descr>`*
 * * information: `<voxel-list-information></voxel-list-information>`*
 * * number: `<voxel-list-number></voxel-list-number>`*
 * * detail: `<voxel-list-detail></voxel-list-detail>`*
 * * * textdetail: `<voxel-list-text-detail></voxel-list-text-detail>`*
 *
 * E os subcomponentes:
 * * action: `voxel-list-action, voxelListAction`*
 * * simple: `voxel-list-simple, voxelListSimple`*
 * * info: `voxel-list-info, voxelListInfo`*
 * * definition: `voxel-list-definition, voxelListDefinition`*
 *
 * The list uses subcomponents to specify wich type of item will be added.*
 * It also has directives for the construction and customization of these items.*
 *
 * The directives are:*
 * * text: `<voxel-list-text></voxel-list-text>`*
 * * description: `<voxel-list-descr></voxel-list-descr>`*
 * * information: `<voxel-list-information></voxel-list-information>`*
 * * number: `<voxel-list-number></voxel-list-number>`*
 * * detail: `<voxel-list-detail></voxel-list-detail>`*
 * * textdetail: `<voxel-list-text-detail></voxel-list-text-detail>`*
 *
 * And the subcomponents:*
 * * action: `voxel-list-action, voxelListAction`*
 * * simple: `voxel-list-simple, voxelListSimple`*
 * * info: `voxel-list-info, voxelListInfo`*
 * * definition: `voxel-list-definition, voxelListDefinition`*
 *
 * @example Exemplo de lista vazia / Example of empty list
 * <voxel-list></voxel-list>
 *
 * @example Exemplo de lista com item simples / Example of list with simple item
 * <voxel-list>
 *  <li voxelListSimple>
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com aria-label customizável para / Example of list with customizable aria-label for accessibility
 * <voxel-list>
 *  <li voxelListSimple
 *  a11yLabel="texto customizado a ser lido pelo leitor de tela"
 * >
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com descrição / Example list with description
 * <voxel-list>
 *    <li voxelListSimple>
 *      <voxel-list-text>
 *        lorem ipsum dolor sit
 *      </voxel-list-text>
 *      <voxel-list-descr>
 *        description
 *      </voxel-list-descr>
 *    </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de definição / Definition list example
 * <voxel-list>
 *   <dl voxelListDefinition>
 *     <voxel-list-descr>
 *       definition
 *     </voxel-list-descr>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *   </dl>
 * </voxel-list>
 *
 * @example Exemplo de lista de definição horizontal / Example of horizontal definition list
 * <voxel-list voxelHorizontalList>
 *   <dl voxelListDefinition>
 *     <voxel-list-descr>
 *       definition
 *     </voxel-list-descr>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *   </dl>
 * </voxel-list>
 *
 * @example Exemplo de lista simples com ícone / Simple list example with icon
 * <voxel-list>
 *   <li voxelListSimple>
 *     <voxel-icon>
 *       inovacao_outline
 *     </voxel-icon>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista simples com ícone e descrição / Example of simple list with icon and description
 * <voxel-list>
 *   <li voxelListSimple>
 *     <voxel-icon>
 *       inovacao_outline
 *     </voxel-icon>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *     <voxel-list-descr>
 *       description
 *     </voxel-list-descr>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de informação complementar / Example of complementary information list
 * <voxel-list>
 *   <li voxelListInfo>
 *    <voxel-icon>
 *      inovacao_outline
 *    </voxel-icon>
 *    <voxel-list-information>
 *      lorem ipsum dolor sit
 *    </voxel-list-information>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de ação (button) / Action list example (button)
 * <voxel-list>
 *   <li voxelListAction
 *     (click)="onClick()"
 *   >
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *     <voxel-icon>
 *       seta_direita
 *     </voxel-icon>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de ação com descrição (button) / Example action list with description (button)
 * <voxel-list>
 *   <li voxelListAction
 *     (click)="onClick()"
 *   >
 *     <voxel-list-text>
 *       <voxel-icon>
 *        inovacao_outline
 *       </voxel-icon>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *     <voxel-icon>
 *       seta_direita
 *     </voxel-icon>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista em colunas / Column list example
 * <voxel-list>
 *  <li voxelListColumn>
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *    <voxel-list-descr>
 *      descrption
 *    </voxel-list-descr>
 *    <voxel-list-text>
 *      R$ 320,00
 *    </voxel-list-text>
 *    <voxel-list-detail>
 *      detail
 *    </voxel-list-detail>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com big numbers / List example with big number
 * <voxel-list>
 *  <li voxelListColumn>
 *    <voxel-list-text>
 *      lorem ipsum dolor sit
 *    </voxel-list-text>
 *    <voxel-list-number>
 *      100
 *    </voxel-list-number>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com avatar / example list with avatar
 * <voxel-list>
 *  <li voxelListSimple>
 *    <img src="image.png" alt="texto alternativo" />
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *    <voxel-list-descr>
 *      description
 *    </voxel-list-descr>
 *  </li>
 * </voxel-list>
 *
 *
 */
class VoxelListComponent {
    constructor() {
        this.listId = `voxel-list-${NEXT_ID$6++}`;
        /**
         * @internal
         */
        this._voxelHorizontalList = false;
    }
    /**
     * @internal
     */
    set voxelHorizontalList(value) {
        this._voxelHorizontalList = enforceBoolean(value);
    }
}
VoxelListComponent.ɵfac = function VoxelListComponent_Factory(t) { return new (t || VoxelListComponent)(); };
VoxelListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListComponent, selectors: [["voxel-list"]], contentQueries: function VoxelListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelListDefinitionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.definitionList = _t);
    } }, hostVars: 2, hostBindings: function VoxelListComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("horizontal-list", ctx._voxelHorizontalList);
    } }, inputs: { listId: "listId", voxelHorizontalList: "voxelHorizontalList" }, ngContentSelectors: _c49, decls: 2, vars: 2, consts: [["role", "list", "class", "voxel-list simple-list", 4, "ngIf"], ["class", "voxel-list defition-list", 4, "ngIf"], ["role", "list", 1, "voxel-list", "simple-list"], [1, "voxel-list", "defition-list"]], template: function VoxelListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c48);
        ɵngcc0.ɵɵtemplate(0, VoxelListComponent_ul_0_Template, 2, 1, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, VoxelListComponent_div_1_Template, 2, 1, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.definitionList.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.definitionList.length);
    } }, directives: [ɵngcc1.NgIf], styles: [":host{display:inline}.voxel-list{background:var(--ids_color_bg_base)}.voxel-list__content-simple,.voxel-list__content-action,.voxel-list__content-info,.voxel-list__content-column,.voxel-list__content-row,.voxel-list__content-switch{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);padding:var(--ids_size_general_8x);word-break:normal}.voxel-list__content-simple voxel-icon,.voxel-list__content-action voxel-icon,.voxel-list__content-info voxel-icon,.voxel-list__content-column voxel-icon,.voxel-list__content-row voxel-icon,.voxel-list__content-switch voxel-icon{display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-list__content-simple div{-ms-flex-item-align:center;align-self:center}.voxel-list__content-simple img{border-radius:100%;height:var(--ids_size_general_32x);margin:0 var(--ids_size_general_16x);vertical-align:middle;width:var(--ids_size_general_32x)}.voxel-list__content-action{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--ids_color_bg_base);border:none;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.voxel-list__content-info{border-bottom:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-list__content-info .voxel-icon{color:var(--ids_color_action_disabled_variant)}.voxel-list__content-column{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-column voxel-list-text-detail{-ms-flex-item-align:end;align-self:flex-end}.voxel-list__content-column div{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-list__content-row{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:.5rem}.voxel-list__content-row div{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-switch{display:list-item}.voxel-list__content-switch .voxel-form-selection .voxel-form-selection__label--switch{width:100%}.voxel-list-text,.voxel-list-text-detail{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);padding:var(--ids_size_general_6x) 0 var(--ids_size_general_6x) 0;text-align:left}.voxel-list-descr{color:var(--ids_color_text_body_02);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);padding-bottom:var(--ids_size_general_6x);text-align:left}.voxel-list-definition{color:var(--ids_color_text_body_02);display:block;font:var(--ids_textStyle_label_small_regular);padding:var(--ids_size_general_6x) 0 var(--ids_size_general_6x) 0}.voxel-list-information{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular)}.voxel-list-number{color:var(--ids_color_text_body_02);font:var(--ids_textStyle_insight_regular)}.voxel-list-detail{color:var(--ids_color_text_body_02);display:block;font:var(--ids_textStyle_label_small_regular);padding-bottom:var(--ids_size_general_6x)}.voxel-list voxel-icon{color:var(--ids_color_action_primary_base)}.horizontal-list div{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}.horizontal-list div .voxel-list-definition{text-align:left}.horizontal-list div div{border-bottom:none}@media (max-width: 32.5rem){.horizontal-list div{display:inline-block}}.voxel-list-action__description--with-icon voxel-list-descr{margin-left:var(--ids_size_general_48x);margin-top:-1rem}\n"], encapsulation: 2, changeDetection: 0 });
VoxelListComponent.propDecorators = {
    definitionList: [{ type: ContentChildren, args: [VoxelListDefinitionComponent,] }],
    listId: [{ type: Input }],
    _voxelHorizontalList: [{ type: HostBinding, args: ['class.horizontal-list',] }],
    voxelHorizontalList: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list',
                template: "<ul role=\"list\" [attr.id]=\"listId\" class=\"voxel-list simple-list\" *ngIf=\"!definitionList.length\">\n  <ng-content select=\"\n    li[voxelListSimple],\n    li[voxel-list-simple],\n    li[voxelListAction],\n    li[voxel-list-action],\n    li[voxelListInfo],\n    li[voxel-list-info],\n    li[voxelListColumn],\n    li[voxel-list-column],\n    li[voxelListRow],\n    li[voxel-list-row],\n    li[voxelListSwitch],\n    li[voxel-list-switch]\"\n  >\n  </ng-content>\n</ul>\n\n<div [attr.id]=\"listId\" class=\"voxel-list defition-list\" *ngIf=\"definitionList.length\">\n  <ng-content select=\"\n    dl[voxelListDefinition],\n    dl[voxel-list-definition]\"\n  >\n  </ng-content>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:inline}.voxel-list{background:var(--ids_color_bg_base)}.voxel-list__content-simple,.voxel-list__content-action,.voxel-list__content-info,.voxel-list__content-column,.voxel-list__content-row,.voxel-list__content-switch{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);padding:var(--ids_size_general_8x);word-break:normal}.voxel-list__content-simple voxel-icon,.voxel-list__content-action voxel-icon,.voxel-list__content-info voxel-icon,.voxel-list__content-column voxel-icon,.voxel-list__content-row voxel-icon,.voxel-list__content-switch voxel-icon{display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-list__content-simple div{-ms-flex-item-align:center;align-self:center}.voxel-list__content-simple img{border-radius:100%;height:var(--ids_size_general_32x);margin:0 var(--ids_size_general_16x);vertical-align:middle;width:var(--ids_size_general_32x)}.voxel-list__content-action{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--ids_color_bg_base);border:none;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.voxel-list__content-info{border-bottom:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-list__content-info .voxel-icon{color:var(--ids_color_action_disabled_variant)}.voxel-list__content-column{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-column voxel-list-text-detail{-ms-flex-item-align:end;align-self:flex-end}.voxel-list__content-column div{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-list__content-row{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:.5rem}.voxel-list__content-row div{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-switch{display:list-item}.voxel-list__content-switch .voxel-form-selection .voxel-form-selection__label--switch{width:100%}.voxel-list-text,.voxel-list-text-detail{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular);padding:var(--ids_size_general_6x) 0 var(--ids_size_general_6x) 0;text-align:left}.voxel-list-descr{color:var(--ids_color_text_body_02);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);padding-bottom:var(--ids_size_general_6x);text-align:left}.voxel-list-definition{color:var(--ids_color_text_body_02);display:block;font:var(--ids_textStyle_label_small_regular);padding:var(--ids_size_general_6x) 0 var(--ids_size_general_6x) 0}.voxel-list-information{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_medium_regular)}.voxel-list-number{color:var(--ids_color_text_body_02);font:var(--ids_textStyle_insight_regular)}.voxel-list-detail{color:var(--ids_color_text_body_02);display:block;font:var(--ids_textStyle_label_small_regular);padding-bottom:var(--ids_size_general_6x)}.voxel-list voxel-icon{color:var(--ids_color_action_primary_base)}.horizontal-list div{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}.horizontal-list div .voxel-list-definition{text-align:left}.horizontal-list div div{border-bottom:none}@media (max-width: 32.5rem){.horizontal-list div{display:inline-block}}.voxel-list-action__description--with-icon voxel-list-descr{margin-left:var(--ids_size_general_48x);margin-top:-1rem}\n"]
            }]
    }], function () { return []; }, { listId: [{
            type: Input
        }], _voxelHorizontalList: [{
            type: HostBinding,
            args: ['class.horizontal-list']
        }], voxelHorizontalList: [{
            type: Input
        }], definitionList: [{
            type: ContentChildren,
            args: [VoxelListDefinitionComponent]
        }] }); })();

const listUtils = [
    VoxelListActionComponent,
    VoxelListColumnComponent,
    VoxelListComponent,
    VoxelListDefinitionComponent,
    VoxelListDescrDirective,
    VoxelListDetailDirective,
    VoxelListInfoComponent,
    VoxelListInformationDirective,
    VoxelListNumberDirective,
    VoxelListRowComponent,
    VoxelListSimpleComponent,
    VoxelListSwitchComponent,
    VoxelListTextDetailDirective,
    VoxelListTextDirective,
];
class VoxelListModule {
}
VoxelListModule.ɵfac = function VoxelListModule_Factory(t) { return new (t || VoxelListModule)(); };
VoxelListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelListModule });
VoxelListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                declarations: [listUtils],
                exports: [listUtils]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelListModule, { declarations: function () { return [VoxelListActionComponent, VoxelListColumnComponent, VoxelListComponent, VoxelListDefinitionComponent, VoxelListDescrDirective, VoxelListDetailDirective, VoxelListInfoComponent, VoxelListInformationDirective, VoxelListNumberDirective, VoxelListRowComponent, VoxelListSimpleComponent, VoxelListSwitchComponent, VoxelListTextDetailDirective, VoxelListTextDirective]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [VoxelListActionComponent, VoxelListColumnComponent, VoxelListComponent, VoxelListDefinitionComponent, VoxelListDescrDirective, VoxelListDetailDirective, VoxelListInfoComponent, VoxelListInformationDirective, VoxelListNumberDirective, VoxelListRowComponent, VoxelListSimpleComponent, VoxelListSwitchComponent, VoxelListTextDetailDirective, VoxelListTextDirective]; } }); })();

/* eslint-disable @angular-eslint/no-output-rename */
let NEXT_ID$5 = 0;
/**
 * Componente de Modal
 *
 * **Module:**
 *
 * `import { VoxelModalModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/modal?componentOnly=true</example-url>
 */
class VoxelModalComponent extends VoxelModalBaseComponent {
    constructor() {
        super(...arguments);
        /** @internal */
        this.className = 'voxel-modal';
        this._modalAriaLabelledby = 'voxel-fake-modal-aria-labelledby';
        this._modalCloseLabel = 'fechar';
        /**
         * Sufixo dos ids internos do modal
         *
         * *Modal internal id suffixes*
         */
        this.modalId = `voxel-modal-${NEXT_ID$5++}`;
        this._modalIsOpen = false;
        /**
         * Evento para o modal se auto fechar
         *
         * *Event for the modal to close itself*
         */
        this.outputClose = new EventEmitter();
        /**
         * Evento que avisa quando o modal abriu
         *
         * *Event that announces when the modal has opened*
         */
        this.outputOpen = new EventEmitter();
    }
    /**
     * Id do título do modal para ser lido por leitores de tela
     *
     * *Modal title ID to be learned by screen readers*
     */
    set modalAriaLabelledby(value) {
        this._modalAriaLabelledby = value;
    }
    get modalAriaLabelledby() {
        if (this.forceAriaLabelledby || platform.os !== 'Windows') {
            return this._modalAriaLabelledby;
        }
        return 'voxel-fake-modal-aria-labelledby';
    }
    /**
     * Label do botão fechar para ser lido por leitores de tela
     *
     * *close button label to be read by screen readers*
     */
    set modalCloseLabel(value) {
        this._modalCloseLabel = value;
    }
    get modalCloseLabel() {
        return this._modalCloseLabel;
    }
    /**
     * Define se o modal está aberto
     *
     * *Defines if modal is open*
     */
    set modalIsOpen(open) {
        if (!open && this._modalIsOpen) {
            this.detach();
        }
        this._modalIsOpen = enforceBoolean(open);
    }
    get modalIsOpen() {
        return this._modalIsOpen;
    }
}
VoxelModalComponent.ɵfac = /*@__PURE__*/ function () { let ɵVoxelModalComponent_BaseFactory; return function VoxelModalComponent_Factory(t) { return (ɵVoxelModalComponent_BaseFactory || (ɵVoxelModalComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelModalComponent)))(t || VoxelModalComponent); }; }();
VoxelModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelModalComponent, selectors: [["voxel-modal"]], inputs: { modalId: "modalId", modalAriaLabelledby: "modalAriaLabelledby", modalCloseLabel: "modalCloseLabel", modalIsOpen: "modalIsOpen", modalAriaDescribedby: "modalAriaDescribedby", inputClass: ["modalClass", "inputClass"], modalLang: "modalLang", inputOrigin: ["modalOrigin", "inputOrigin"] }, outputs: { outputClose: "modalClose", outputOpen: "modalOpen" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c51, decls: 1, vars: 5, consts: [["cdkConnectedOverlay", "", "cdkConnectedOverlayHasBackdrop", "", 3, "cdkConnectedOverlayOpen", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayScrollStrategy", "backdropClick", "detach", "attach"], ["cdkTrapFocus", "", "role", "dialog", "tabindex", "-1", 1, "voxel-modal__content", 3, "id"], ["contentRef", ""], ["class", "voxel-modal__close", 3, "id", "click", 4, "ngIf"], ["cdkScrollable", "", 1, "voxel-modal__body"], ["bodyRef", ""], ["id", "voxel-fake-modal-aria-labelledby"], [1, "voxel-modal__close", 3, "id", "click"]], template: function VoxelModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c50);
        ɵngcc0.ɵɵtemplate(0, VoxelModalComponent_ng_template_0_Template, 8, 6, "ng-template", 0);
        ɵngcc0.ɵɵlistener("backdropClick", function VoxelModalComponent_Template_ng_template_backdropClick_0_listener() { return ctx.canClose && (ctx.modalIsOpen = false); })("detach", function VoxelModalComponent_Template_ng_template_detach_0_listener() { return ctx.canClose && (ctx.modalIsOpen = false); })("attach", function VoxelModalComponent_Template_ng_template_attach_0_listener() { return ctx.attach(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayOpen", ctx.modalIsOpen)("cdkConnectedOverlayOrigin", ctx.inputOrigin)("cdkConnectedOverlayDisableClose", !ctx.canClose)("cdkConnectedOverlayPanelClass", ctx.classes)("cdkConnectedOverlayScrollStrategy", ctx.overlay.scrollStrategies[ctx.scrollStrategy]());
    } }, directives: [ɵngcc2.CdkConnectedOverlay, ɵngcc5.CdkTrapFocus, ɵngcc1.NgIf, ɵngcc7.CdkScrollable, VoxelIconComponent], styles: [".voxel-modal{height:100%;isolation:isolate;width:100%}.voxel-modal__footer{background-color:var(--ids_color_bg_base);display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_16x);gap:var(--ids_size_general_16x);padding:var(--ids_size_general_16x);position:relative}.voxel-modal__footer>*{width:100%}.voxel-modal__footer--inline>*{-webkit-box-flex:1;-ms-flex:1;flex:1;white-space:nowrap}.voxel-modal__content{background-color:var(--ids_color_bg_base);border:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:inherit;overflow:hidden;position:static;width:100%}.voxel-modal__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:auto;padding:var(--ids_size_general_24x) var(--ids_size_general_24x) 0;position:relative}.voxel-modal__body:after{background:-webkit-gradient(linear,left bottom,left top,from(var(--ids_color_bg_base)),to(transparent));background:linear-gradient(to top,var(--ids_color_bg_base),transparent);bottom:0;content:\"\";display:block;height:var(--ids_size_general_48x);position:sticky}@supports (-webkit-touch-callout: none){.voxel-modal__body:after{background:transparent}}.voxel-modal__close{-ms-flex-item-align:end;align-self:flex-end;background-color:transparent;border:none;color:var(--ids_color_action_primary_base);cursor:pointer;display:block;margin:var(--ids_size_general_4x) var(--ids_size_general_4x) var(--ids_size_general_24x) 0;padding:var(--ids_size_general_12x)}.voxel-modal__close:hover{color:var(--ids_color_action_primary_variant)}.voxel-modal__close+.voxel-modal__body{padding:var(--ids_size_general_1x) var(--ids_size_general_16x) 0}@media (min-width: 48rem){.voxel-modal{height:auto;max-height:min(80vh,50rem);min-height:min(29.5rem,100vh);width:22rem}}@media screen and (min-width: 48rem) and (-ms-high-contrast: active),(min-width: 48rem) and (-ms-high-contrast: none){.voxel-modal{height:100%;max-height:80vh}}@media (min-width: 48rem){.voxel-modal__content{border:var(--ids_size_general_1x) solid var(--ids_color_border_soft);border-radius:var(--ids_size_general_4x)}}@media screen and (min-width: 48rem) and (-ms-high-contrast: active),(min-width: 48rem) and (-ms-high-contrast: none){.voxel-modal{min-height:80vh}}@media (min-width: 64rem){.voxel-modal{width:29.5rem}}@media (min-width: 80rem){.voxel-modal{width:36.875rem}}@media (min-width: 100rem){.voxel-modal{width:43rem}}\n"], encapsulation: 2 });
VoxelModalComponent.propDecorators = {
    modalAriaDescribedby: [{ type: Input }],
    modalAriaLabelledby: [{ type: Input }],
    inputClass: [{ type: Input, args: ['modalClass',] }],
    modalCloseLabel: [{ type: Input }],
    modalId: [{ type: Input }],
    modalIsOpen: [{ type: Input }],
    modalLang: [{ type: Input }],
    inputOrigin: [{ type: Input, args: ['modalOrigin',] }],
    outputClose: [{ type: Output, args: ['modalClose',] }],
    outputOpen: [{ type: Output, args: ['modalOpen',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelModalComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-modal',
                template: "<ng-template\n  cdkConnectedOverlay\n  [cdkConnectedOverlayOpen]=\"modalIsOpen\"\n  [cdkConnectedOverlayOrigin]=\"inputOrigin\"\n  cdkConnectedOverlayHasBackdrop\n  [cdkConnectedOverlayDisableClose]=\"!canClose\"\n  (backdropClick)=\"canClose && modalIsOpen = false\"\n  (detach)=\"canClose && modalIsOpen = false\"\n  (attach)=\"attach()\"\n  [cdkConnectedOverlayPanelClass]=\"classes\"\n  [cdkConnectedOverlayScrollStrategy]=\"overlay.scrollStrategies[scrollStrategy]()\"\n>\n  <section\n    cdkTrapFocus\n    class=\"voxel-modal__content\"\n    role=\"dialog\"\n    [attr.aria-labelledby]=\"modalAriaLabelledby\"\n    [attr.aria-describedby]=\"modalAriaDescribedby\"\n    #contentRef\n    [attr.lang]=\"modalLang\"\n    [id]=\"modalId\"\n    tabindex=\"-1\"\n    [attr.aria-modal]=\"ariaModal\"\n  >\n    <button\n      *ngIf=\"canClose\"\n      class=\"voxel-modal__close\"\n      (click)=\"modalIsOpen = false\"\n      [attr.aria-label]=\"modalCloseLabel\"\n      [id]=\"modalId + '-button-close'\"\n    >\n      <voxel-icon>fechar</voxel-icon>\n    </button>\n\n    <div class=\"voxel-modal__body\" cdkScrollable #bodyRef>\n      <ng-content></ng-content>\n    </div>\n\n    <ng-content select=\"[voxelModalFooter]\"></ng-content>\n\n    <div id=\"voxel-fake-modal-aria-labelledby\"></div>\n  </section>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-modal{height:100%;isolation:isolate;width:100%}.voxel-modal__footer{background-color:var(--ids_color_bg_base);display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_16x);gap:var(--ids_size_general_16x);padding:var(--ids_size_general_16x);position:relative}.voxel-modal__footer>*{width:100%}.voxel-modal__footer--inline>*{-webkit-box-flex:1;-ms-flex:1;flex:1;white-space:nowrap}.voxel-modal__content{background-color:var(--ids_color_bg_base);border:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:inherit;overflow:hidden;position:static;width:100%}.voxel-modal__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:auto;padding:var(--ids_size_general_24x) var(--ids_size_general_24x) 0;position:relative}.voxel-modal__body:after{background:-webkit-gradient(linear,left bottom,left top,from(var(--ids_color_bg_base)),to(transparent));background:linear-gradient(to top,var(--ids_color_bg_base),transparent);bottom:0;content:\"\";display:block;height:var(--ids_size_general_48x);position:sticky}@supports (-webkit-touch-callout: none){.voxel-modal__body:after{background:transparent}}.voxel-modal__close{-ms-flex-item-align:end;align-self:flex-end;background-color:transparent;border:none;color:var(--ids_color_action_primary_base);cursor:pointer;display:block;margin:var(--ids_size_general_4x) var(--ids_size_general_4x) var(--ids_size_general_24x) 0;padding:var(--ids_size_general_12x)}.voxel-modal__close:hover{color:var(--ids_color_action_primary_variant)}.voxel-modal__close+.voxel-modal__body{padding:var(--ids_size_general_1x) var(--ids_size_general_16x) 0}@media (min-width: 48rem){.voxel-modal{height:auto;max-height:min(80vh,50rem);min-height:min(29.5rem,100vh);width:22rem}}@media screen and (min-width: 48rem) and (-ms-high-contrast: active),(min-width: 48rem) and (-ms-high-contrast: none){.voxel-modal{height:100%;max-height:80vh}}@media (min-width: 48rem){.voxel-modal__content{border:var(--ids_size_general_1x) solid var(--ids_color_border_soft);border-radius:var(--ids_size_general_4x)}}@media screen and (min-width: 48rem) and (-ms-high-contrast: active),(min-width: 48rem) and (-ms-high-contrast: none){.voxel-modal{min-height:80vh}}@media (min-width: 64rem){.voxel-modal{width:29.5rem}}@media (min-width: 80rem){.voxel-modal{width:36.875rem}}@media (min-width: 100rem){.voxel-modal{width:43rem}}\n"]
            }]
    }], null, { modalId: [{
            type: Input
        }], outputClose: [{
            type: Output,
            args: ['modalClose']
        }], outputOpen: [{
            type: Output,
            args: ['modalOpen']
        }], modalAriaLabelledby: [{
            type: Input
        }], modalCloseLabel: [{
            type: Input
        }], modalIsOpen: [{
            type: Input
        }], modalAriaDescribedby: [{
            type: Input
        }], inputClass: [{
            type: Input,
            args: ['modalClass']
        }], modalLang: [{
            type: Input
        }], inputOrigin: [{
            type: Input,
            args: ['modalOrigin']
        }] }); })();

class VoxelModalFooterDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Define se o rodapé do modal será com botões em linha ou um abaixo do outro
         *
         * *Sets wheter footer will be with button inline or one below the other*
         */
        this.voxelModalFooter = '';
    }
    get classes() {
        return this.voxelModalFooter === 'inline'
            ? 'voxel-modal__footer voxel-modal__footer--inline'
            : 'voxel-modal__footer';
    }
}
VoxelModalFooterDirective.ɵfac = function VoxelModalFooterDirective_Factory(t) { return new (t || VoxelModalFooterDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelModalFooterDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelModalFooterDirective, selectors: [["", "voxelModalFooter", ""]], hostVars: 2, hostBindings: function VoxelModalFooterDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.classes);
    } }, inputs: { voxelModalFooter: "voxelModalFooter" }, exportAs: ["voxelModalFooter"] });
VoxelModalFooterDirective.ctorParameters = () => [
    { type: ElementRef }
];
VoxelModalFooterDirective.propDecorators = {
    voxelModalFooter: [{ type: Input }],
    classes: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelModalFooterDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelModalFooter]',
                exportAs: 'voxelModalFooter'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { voxelModalFooter: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

class VoxelModalModule {
}
VoxelModalModule.ɵfac = function VoxelModalModule_Factory(t) { return new (t || VoxelModalModule)(); };
VoxelModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelModalModule });
VoxelModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[A11yModule, CommonModule, OverlayModule, VoxelIconModule, VoxelOverlayModalModule], VoxelOverlayModalModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelModalModule, [{
        type: NgModule,
        args: [{
                imports: [A11yModule, CommonModule, OverlayModule, VoxelIconModule, VoxelOverlayModalModule],
                declarations: [VoxelModalComponent, VoxelModalFooterDirective],
                exports: [VoxelModalComponent, VoxelModalFooterDirective, VoxelOverlayModalModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelModalModule, { declarations: function () { return [VoxelModalComponent, VoxelModalFooterDirective]; }, imports: function () { return [A11yModule, CommonModule, OverlayModule, VoxelIconModule, VoxelOverlayModalModule]; }, exports: function () { return [VoxelModalComponent, VoxelModalFooterDirective, VoxelOverlayModalModule]; } }); })();

const buildValueString = (id, value) => {
    let newVal;
    if (id === null) {
        return `${value}`;
    }
    if (value && typeof value === 'object') {
        newVal = 'Object';
    }
    return `${id}: ${newVal}`.slice(0, 50);
};
/**
 * @internal
 */
let NEXT_ID$4 = 0;
class VoxelNativeSelectDirective extends VoxelFieldMixinBase {
    /** @internal */
    constructor(ngControl, elementRef, renderer) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.renderer = renderer;
        /** @internal */
        this._compareWith = objectIs;
        /** @internal */
        this.optionMap = new Map();
        /** @internal */
        this.idCounter = 0;
        /** @internal */
        this.controlId = `voxel-native-select-${NEXT_ID$4++}`;
        /** @internal */
        this.inputClasses = 'voxel-native-select';
    }
    /** @internal */
    get controlDisabled() {
        return this.disabled || null;
    }
    /** @internal */
    get controlValue() {
        return this.value;
    }
    /** @internal */
    get id() {
        return this.controlId;
    }
    /** @internal */
    controlSelect({ value }) {
        this.value = this.getOptionValue(value);
    }
    /** @internal */
    controlChange() {
        this.formAcessorHandleChange();
    }
    /** @internal */
    controlFocus() {
        this.formAcessorHandleFocus();
    }
    /** @internal */
    controlBlur() {
        this.formAcessorHandleBlur();
    }
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * *Function to compare the option values with the selected values.*
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: any, c2: any): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectControlValueAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    set compareWith(fn) {
        this._compareWith = fn;
    }
    /** @internal */
    ngDoCheck() {
        /* istanbul ignore next */
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
    }
    /** @internal */
    writeValue(value) {
        this.value = value;
        const id = this.getOptionId(value);
        if (id === null) {
            this.renderer.setProperty(this.elementRef.nativeElement, 'selectedIndex', -1);
        }
        const valueString = buildValueString(id, value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', valueString);
    }
    /** @internal */
    registerOption() {
        return (this.idCounter++).toString();
    }
    /** @internal */
    getOptionId(value) {
        for (const id of Array.from(this.optionMap.keys())) {
            if (this.compareWith(this.optionMap.get(id), value)) {
                return id;
            }
        }
        return null;
    }
    /** @internal */
    getOptionValue(valueString) {
        const id = this.extractId(valueString);
        return this.optionMap.has(id) ? this.optionMap.get(id) : valueString;
    }
    /** @internal */
    extractId(valueString) {
        return valueString.split(':')[0];
    }
}
VoxelNativeSelectDirective.ɵfac = function VoxelNativeSelectDirective_Factory(t) { return new (t || VoxelNativeSelectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VoxelNativeSelectDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelNativeSelectDirective, selectors: [["", "voxelNativeSelect", ""]], hostVars: 4, hostBindings: function VoxelNativeSelectDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function VoxelNativeSelectDirective_change_HostBindingHandler($event) { return ctx.controlSelect($event.target); })("ngModelChange", function VoxelNativeSelectDirective_ngModelChange_HostBindingHandler() { return ctx.controlChange(); })("focus", function VoxelNativeSelectDirective_focus_HostBindingHandler() { return ctx.controlFocus(); })("blur", function VoxelNativeSelectDirective_blur_HostBindingHandler() { return ctx.controlBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.inputClasses)("disabled", ctx.controlDisabled)("value", ctx.controlValue)("id", ctx.id);
    } }, inputs: { compareWith: "compareWith" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: VoxelFieldMixinBase,
                useExisting: forwardRef(/* istanbul ignore next */ () => VoxelNativeSelectDirective)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelNativeSelectDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: Renderer2 }
];
VoxelNativeSelectDirective.propDecorators = {
    controlDisabled: [{ type: HostBinding, args: ['attr.disabled',] }],
    controlValue: [{ type: HostBinding, args: ['attr.value',] }],
    id: [{ type: HostBinding, args: ['attr.id',] }],
    inputClasses: [{ type: HostBinding, args: ['attr.class',] }],
    controlSelect: [{ type: HostListener, args: ['change', ['$event.target'],] }],
    controlChange: [{ type: HostListener, args: ['ngModelChange',] }],
    controlFocus: [{ type: HostListener, args: ['focus',] }],
    controlBlur: [{ type: HostListener, args: ['blur',] }],
    compareWith: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelNativeSelectDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelNativeSelect]',
                providers: [
                    {
                        provide: VoxelFieldMixinBase,
                        useExisting: forwardRef(/* istanbul ignore next */ () => VoxelNativeSelectDirective)
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { inputClasses: [{
            type: HostBinding,
            args: ['attr.class']
        }], controlDisabled: [{
            type: HostBinding,
            args: ['attr.disabled']
        }], controlValue: [{
            type: HostBinding,
            args: ['attr.value']
        }], id: [{
            type: HostBinding,
            args: ['attr.id']
        }], 
    /** @internal */
    controlSelect: [{
            type: HostListener,
            args: ['change', ['$event.target']]
        }], 
    /** @internal */
    controlChange: [{
            type: HostListener,
            args: ['ngModelChange']
        }], 
    /** @internal */
    controlFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /** @internal */
    controlBlur: [{
            type: HostListener,
            args: ['blur']
        }], compareWith: [{
            type: Input
        }] }); })();

class VoxelNativeSelectOptionDirective {
    /** @internal */
    constructor(element, renderer, select) {
        this.element = element;
        this.renderer = renderer;
        this.select = select;
        if (this.select) {
            this.id = this.select.registerOption();
        }
    }
    /**
     * Rastreia o valor vinculado ao elemento de opção. Ao contrário da associação de valor(string),
     * `ngValue` oferece suporte à associação de objetos.
     *
     * *Tracks the value bound to the option element. Unlike the value binding,*
     * *`ngValue` supports binding to objects.*
     */
    set ngValue(value) {
        if (this.select === null) {
            return;
        }
        this.select.optionMap.set(this.id, value);
        this.setElementValue(buildValueString(this.id, value));
        this.select.writeValue(this.select.value);
    }
    /**
     * Rastreia valores de string simples vinculados ao elemento de opção.
     * Para objetos, use o parâmetro de entrada `ngValue`.
     *
     * *Tracks simple string values bound to the option element.*
     * *For objects, use the `ngValue` input binding.*
     */
    set value(value) {
        this.setElementValue(value);
        if (this.select) {
            this.select.writeValue(this.select.value);
        }
    }
    /** @internal */
    setElementValue(value) {
        this.renderer.setProperty(this.element.nativeElement, 'value', value);
    }
}
VoxelNativeSelectOptionDirective.ɵfac = function VoxelNativeSelectOptionDirective_Factory(t) { return new (t || VoxelNativeSelectOptionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(VoxelNativeSelectDirective, 9)); };
VoxelNativeSelectOptionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelNativeSelectOptionDirective, selectors: [["", "voxelNativeOption", ""]], inputs: { ngValue: "ngValue", value: "value" } });
VoxelNativeSelectOptionDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: VoxelNativeSelectDirective, decorators: [{ type: Optional }, { type: Host }] }
];
VoxelNativeSelectOptionDirective.propDecorators = {
    ngValue: [{ type: Input }],
    value: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelNativeSelectOptionDirective, [{
        type: Directive,
        args: [{ selector: '[voxelNativeOption]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: VoxelNativeSelectDirective, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }]; }, { ngValue: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

/**
 * Dados dos eventos do select
 *
 * *Select event data*
 */
class IVoxelSelectEvent {
    /** @internal */
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
/**
 * @internal
 */
let NEXT_ID$3 = 0;
/**
 * Select é um tipo de input utilizado em formulários, no qual o usuário tem a possibilidade de fazer uma escolha dentre
 * uma lista de opções, que são exibidas após o click no componente.
 *
 * *Select is a type of input used in forms, in which the user has the possibility to make a choice from a list of*
 * *options, which are displayed after clicking on the component.*
 *
 * **Module:**
 *
 * `import { VoxelSelectModule, VoxelFormFieldModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/select?componentOnly=true</example-url>
 *
 */
class VoxelSelectComponent extends VoxelFieldMixinBase {
    constructor(liveAnnouncer, ngControl, elementRef, platform, overlay) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.liveAnnouncer = liveAnnouncer;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.platform = platform;
        this.overlay = overlay;
        /** @internal */
        this._compareWith = objectIs;
        /** @internal */
        this._panelOpen = false;
        /** @internal */
        this._destroy = new Subject();
        /** @internal */
        this._clearSearchString = new Subject();
        /** @internal */
        this._optionSelectionChanges = defer(() => {
            const options = this.options;
            return options === null || options === void 0 ? void 0 : options.changes.pipe(startWith(options), switchMap(() => merge(...options.map((option) => option.change))));
        });
        /** @internal */
        this.panelId = `voxel-select__panel-options-${NEXT_ID$3}`;
        /** @internal */
        this.labelId = `voxel-select-label-${NEXT_ID$3}`;
        /** @internal */
        this.valueId = `voxel-select-value-${NEXT_ID$3}`;
        /** @internal */
        this.searchString = '';
        /** @internal */
        this.positions = [];
        /** @internal */
        this.isMobile = this.platform.ANDROID || this.platform.IOS;
        /**
         *  Identificação única do select.
         *
         *  *Unique select identification.*
         */
        this.controlId = `voxel-select-${NEXT_ID$3++}`;
        /**
         * Placeholder do select.
         *
         * *Select placeholder.*
         */
        this.placeholder = '';
        /**
         *  Define a quantidade de option no visível scroll.
         *  visibleOptions = 8; (default)
         *
         * *Sets the amount of option in the visible scroll.*
         * *visibleOptions = 8; (default)*
         */
        this.visibleOptions = 8;
        /**
         * Define a posição de abertura da lista de opções
         *
         * *Defines the opening position of the options list*
         */
        this.position = 'auto';
        /**
         * Evento disparado com a mudança no select.
         *
         * *Event triggered with the change in the select.*
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no select.
         *
         * *Event triggered with focus on select.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no select.
         *
         * *Event triggered with blur on select.*
         */
        this.blur = new EventEmitter();
        /**
         * Evento disparado quando select é aberto.
         *
         * *Event fired when select is opened.*
         */
        this.selectOpen = new EventEmitter();
        /**
         * Evento disparado quando o select é fechado.
         *
         * *Event fired when the select is closed.*
         */
        this.selectClose = new EventEmitter();
    }
    /** @internal */
    get panelOpen() {
        return this._panelOpen;
    }
    /** @internal */
    get selectWidth() {
        return this._selectWidth;
    }
    /** @internal */
    get optionSelected() {
        return this._lastOptionSelected;
    }
    /** @internal */
    get arrayOption() {
        return this.options.toArray();
    }
    /** @internal */
    get enableOption() {
        return this.arrayOption.filter((item) => !item.disabled);
    }
    /** @internal */
    get optionTextValue() {
        return this.optionSelected ? this.optionSelected.optionLabel : this.placeholder;
    }
    /** @internal */
    get tabindex() {
        return this.disabled ? '-1' : '0';
    }
    /** @internal */
    get ariaActiveDescendant() {
        if (this.panelOpen && this.optionSelected) {
            return this.optionSelected.optionId;
        }
        return null;
    }
    /** @internal */
    get ariaLabelledBy() {
        return this.isMobile ? `${this.labelId} ${this.valueId}` : this.labelId;
    }
    /**
     * Indica se o select é obrigatório.
     *
     * *Indicates whether select is mandatory.*
     */
    set required(value) {
        this._required = enforceBoolean(value);
    }
    get required() {
        return this._required;
    }
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * *Function to compare the option values with the selected values.*
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: any, c2: any): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectControlValueAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    set compareWith(fn) {
        this._compareWith = fn;
    }
    /** @internal */
    controlChange() {
        this.formAcessorHandleChange();
    }
    /** @internal */
    ngOnInit() {
        this.defineOpeningPosition();
    }
    /** @internal */
    defineOpeningPosition() {
        const bottom = {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        };
        const top = {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
        };
        const setPosition = {
            top: () => this.positions.push(top),
            bottom: () => this.positions.push(bottom),
            auto: () => this.positions.push(bottom, top),
        };
        return setPosition[this.position]();
    }
    /** @internal */
    ngAfterContentInit() {
        this.options.changes.pipe(startWith(null), takeUntil(this._destroy)).subscribe(() => {
            this.resetOptions();
        });
        this.initializeSelection();
    }
    /** @internal */
    resetOptions() {
        const changedOrDestroyed = merge(this.options.changes, this._destroy);
        this._optionSelectionChanges.pipe(skip(1), takeUntil(changedOrDestroyed)).subscribe((event) => {
            this.selectOption(event.option, true, event.close);
        });
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
    /** @internal */
    ngDoCheck() {
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
        if ((this.value === '' && !this.optionSelected) ||
            (this.optionSelected && this.value === this.optionSelected.value)) {
            return;
        }
        this.resetSelect();
    }
    /** @internal */
    initializeSelection() {
        Promise.resolve().then(() => {
            const value = this.ngControl ? this.ngControl.value : this.value;
            const optionSelected = this.enableOption.find((opt) => this.compareWith(opt.value, value));
            const initialSelect = this.arrayOption.filter((opt) => opt.selected);
            if (initialSelect.length > 0 && (!optionSelected || value === '')) {
                this.selectOption(initialSelect[initialSelect.length - 1]);
                return;
            }
            if (!optionSelected) {
                return;
            }
            optionSelected.select();
            this.selectOption(optionSelected);
        });
    }
    /** @internal */
    resetSelect() {
        if (!this.options || this.options.length < 0) {
            return;
        }
        /* istanbul ignore next */
        Promise.resolve().then(() => {
            const value = this.ngControl ? this.ngControl.value : this.value;
            const optionSelected = this.enableOption.find((opt) => this.compareWith(opt.value, value));
            if (optionSelected) {
                optionSelected.select();
                return;
            }
            if (this.optionSelected) {
                this.optionSelected.deselect(true);
            }
            this.value = '';
            this._lastOptionSelected = null;
        });
    }
    /** @internal */
    onFocus() {
        this.formAcessorHandleFocus();
        this.focus.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    onBlur() {
        this.formAcessorHandleBlur();
        this.blur.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    toggle() {
        if (this.disabled) {
            return;
        }
        if (this.panelOpen) {
            this.dettach();
            return;
        }
        this.open();
    }
    /** @internal */
    open() {
        this._panelOpen = true;
        this._selectWidth = this.select.nativeElement.offsetWidth;
        if (this.arrayOption.length > 0 && !this.optionSelected) {
            this.enableOption[0].select();
        }
        this.selectOpen.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    attach() {
        if (this.isMobile) {
            const positionStrategy = this.overlay
                .position()
                .global()
                .centerHorizontally()
                .centerVertically();
            const sizeConfig = { maxHeight: '80%' };
            this.overlayDir.overlayRef.updateScrollStrategy(this.overlay.scrollStrategies.block());
            this.overlayDir.overlayRef.updateSize(sizeConfig);
            this.overlayDir.overlayRef.updatePositionStrategy(positionStrategy);
            this.overlayDir.overlayRef.updatePosition();
            toggleMobileFocusTrap({});
            this.panel.changes.pipe(take(1)).subscribe(() => {
                if (!this.optionSelected) {
                    return;
                }
                if (this.platform.IOS) {
                    // Had to do this to make VO focus on the selected option
                    setTimeout(() => {
                        if (this.optionSelected && this.optionSelected.element) {
                            setVoiceOverFocus(this.optionSelected.element.nativeElement);
                        }
                    });
                }
                this.setScrollPosition(this.optionSelected);
            });
            return;
        }
        this.overlayDir.positionChange.pipe(take(1)).subscribe(() => {
            if (this.optionSelected) {
                this.setScrollPosition(this.optionSelected);
            }
        });
    }
    /** @internal */
    dettach() {
        this._panelOpen = false;
        if (this.isMobile) {
            toggleMobileFocusTrap({ add: false });
        }
        this.select.nativeElement.focus();
        this.selectClose.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    selectOption(selectOption, emitChangeEvent = false, close = false) {
        if (this.optionSelected && !(this.optionSelected.value === selectOption.value)) {
            this.optionSelected.deselect();
        }
        this.updateValueSelect(selectOption, emitChangeEvent);
        this.setScrollPosition(selectOption);
        if (close) {
            this.dettach();
        }
    }
    /** @internal */
    updateValueSelect(selectOption, emitChangeEvent = true) {
        const notSameValueSelected = !this._lastOptionSelected || this._lastOptionSelected !== selectOption;
        if (!this._lastOptionSelected || !(this._lastOptionSelected.value === selectOption.value)) {
            this.value = selectOption.value;
        }
        this._lastOptionSelected = selectOption;
        if (emitChangeEvent && notSameValueSelected) {
            this.emitSelectChangeEvent();
        }
    }
    /** @internal */
    setSelectOptionByIndex(index = 1) {
        const optionSelected = this._lastOptionSelected
            ? this.enableOption.findIndex((opt) => opt.selected)
            : 0;
        if (this.enableOption[optionSelected + index]) {
            this.enableOption[optionSelected + index].select();
        }
    }
    /** @internal */
    handleKeydown(event) {
        if (this.disabled) {
            return;
        }
        if (this.panelOpen) {
            this.handleOpenKeydown(event);
            return;
        }
        this.handleClosedKeydown(event);
    }
    /** @internal */
    handleClosedKeydown(_event) {
        const isOpenKey = _event.code === 'Enter' || _event.code === 'NumpadEnter' || _event.code === 'Space';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown';
        if (isOpenKey || (_event.altKey && isArrowKey)) {
            _event.preventDefault();
            this.open();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.enableOption[0].select();
            this.announceValue(this.optionTextValue);
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.enableOption[this.enableOption.length - 1].select();
            this.announceValue(this.optionTextValue);
        }
        if ((_event.code === 'ArrowUp' || _event.code === 'ArrowLeft') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
            this.announceValue(this.optionTextValue);
        }
        if ((_event.code === 'ArrowDown' || _event.code === 'ArrowRight') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
            this.announceValue(this.optionTextValue);
        }
        return;
    }
    /** @internal */
    announceValue(text) {
        this.liveAnnouncer.announce(text, 'assertive', 1000);
    }
    /** @internal */
    handleOpenKeydown(_event) {
        const isEnterKey = _event.code === 'Enter' || _event.code === 'NumpadEnter';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown';
        const announceValue = this.platform.SAFARI; // VO on SAFARI does not announce the new value selected when navigating through keyboard
        /* istanbul ignore next */
        if (_event.shiftKey && !this.focused) {
            this.select.nativeElement.focus();
        }
        if (isEnterKey ||
            _event.code === 'Tab' ||
            _event.code === 'Escape' ||
            (isArrowKey && _event.altKey) ||
            (_event.code === 'Space' && this.searchString === '')) {
            _event.preventDefault();
            this.dettach();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.enableOption[0].select();
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.enableOption[this.enableOption.length - 1].select();
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        if (_event.code === 'ArrowUp' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        if (_event.code === 'ArrowDown' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        this.filterAndSelectOption(_event);
        return;
    }
    /**
     *
     * @internal
     */
    filterAndSelectOption(_event) {
        var _a;
        const startsWithSpace = this.searchString === '' && _event.code === 'Space';
        if (!/[a-zA-Z0-9-_ ]/.test(_event.key) || _event.key.length > 1 || startsWithSpace) {
            return;
        }
        _event.preventDefault();
        this.searchString += _event.key;
        (_a = this.arrayOption
            .find((o) => { var _a; return normalizeText((_a = o.optionLabel) !== null && _a !== void 0 ? _a : '').includes(this.searchString) && !o.disabled; })) === null || _a === void 0 ? void 0 : _a.select();
        if (this._clearSearchString.observers.length === 0) {
            this.initializeSearchStringObserver();
        }
        this._clearSearchString.next();
    }
    /** @internal */
    initializeSearchStringObserver() {
        this._clearSearchString.pipe(debounceTime(1000), takeUntil(this._destroy)).subscribe(() => {
            this.searchString = '';
        });
    }
    /** @internal */
    setScrollPosition(option) {
        /* istanbul ignore next */
        if (option && this.panel.first) {
            const positionScroll = option.element.nativeElement.offsetTop - this.panel.first.nativeElement.scrollTop;
            if (positionScroll >= this.panel.first.nativeElement.offsetHeight - 9) {
                option.element.nativeElement.scrollIntoView(false);
            }
            if (positionScroll < 0) {
                option.element.nativeElement.scrollIntoView(true);
            }
        }
        return;
    }
    /** @internal */
    emitSelectChangeEvent() {
        this.change.emit(new IVoxelSelectEvent(this, this.value));
    }
}
VoxelSelectComponent.ɵfac = function VoxelSelectComponent_Factory(t) { return new (t || VoxelSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LiveAnnouncer), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay)); };
VoxelSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelSelectComponent, selectors: [["voxel-select"]], contentQueries: function VoxelSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelOptionComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, viewQuery: function VoxelSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c52, 7);
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
        ɵngcc0.ɵɵviewQuery(_c8, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.select = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayDir = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panel = _t);
    } }, hostBindings: function VoxelSelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("ngModelChange", function VoxelSelectComponent_ngModelChange_HostBindingHandler() { return ctx.controlChange(); });
    } }, inputs: { controlId: "controlId", placeholder: "placeholder", visibleOptions: "visibleOptions", position: "position", required: "required", compareWith: "compareWith" }, outputs: { change: "change", focus: "focus", blur: "blur", selectOpen: "selectOpen", selectClose: "selectClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: VoxelFieldMixinBase,
                useExisting: forwardRef(/* istanbul ignore next */ () => VoxelSelectComponent)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c10, decls: 8, vars: 24, consts: [["cdkOverlayOrigin", "", "role", "combobox", "aria-haspopup", "listbox", 1, "voxel-select", 3, "id", "ngClass", "tabindex", "click", "keydown", "focus", "blur"], ["select", "", "origin", "cdkOverlayOrigin"], [1, "voxel-select__text", 3, "id"], [3, "ngClass"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayLockPosition", "", "cdkConnectedOverlayHasBackdrop", "", 3, "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayWidth", "backdropClick", "attach"], ["role", "listbox", "tabindex", "-1", 1, "voxel-select__panel-options", 3, "id", "keydown"], ["panel", ""]], template: function VoxelSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c9);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("click", function VoxelSelectComponent_Template_div_click_0_listener() { return ctx.toggle(); })("keydown", function VoxelSelectComponent_Template_div_keydown_0_listener($event) { return ctx.handleKeydown($event); })("focus", function VoxelSelectComponent_Template_div_focus_0_listener() { return ctx.onFocus(); })("blur", function VoxelSelectComponent_Template_div_blur_0_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "voxel-icon", 3);
        ɵngcc0.ɵɵtext(6, " seta_baixo\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, VoxelSelectComponent_ng_template_7_Template, 3, 5, "ng-template", 4);
        ɵngcc0.ɵɵlistener("backdropClick", function VoxelSelectComponent_Template_ng_template_backdropClick_7_listener() { return ctx.dettach(); })("attach", function VoxelSelectComponent_Template_ng_template_attach_7_listener() { return ctx.attach(); });
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("id", ctx.controlId)("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c53, ctx.disabled))("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵattribute("aria-disabled", ctx.disabled)("aria-expanded", ctx.panelOpen)("aria-describedby", ctx.controlDescribedBy)("aria-labelledby", ctx.ariaLabelledBy)("aria-invalid", ctx.controlAriaInvalid)("aria-activedescendant", ctx.ariaActiveDescendant)("aria-controls", ctx.panelId)("aria-required", ctx.required);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("id", ctx.valueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.optionTextValue, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(21, _c54, ctx.disabled, ctx.panelOpen));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayBackdropClass", !ctx.isMobile ? "cdk-overlay-transparent-backdrop" : "")("cdkConnectedOverlayOrigin", _r1)("cdkConnectedOverlayOpen", ctx.panelOpen)("cdkConnectedOverlayPositions", ctx.positions)("cdkConnectedOverlayWidth", ctx.selectWidth);
    } }, directives: [ɵngcc2.CdkOverlayOrigin, ɵngcc1.NgClass, VoxelIconComponent, ɵngcc2.CdkConnectedOverlay], styles: ["[_nghost-%COMP%]{display:block;width:100%}.voxel-select[_ngcontent-%COMP%]{cursor:pointer;padding-bottom:var(--ids_size_general_8x);position:relative}.voxel-select--disabled[_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-select__text[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem;min-height:var(--ids_size_general_28x);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.voxel-select__icon[_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_base);padding-top:var(--ids_size_general_5x);pointer-events:none;position:absolute;right:0;top:0;-webkit-transition:-webkit-transform .2s linear;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear}.voxel-select__icon--open[_ngcontent-%COMP%]{-webkit-transform:rotateX(180deg);transform:rotateX(180deg)}.voxel-select__icon[_ngcontent-%COMP%]:not(.voxel-select__icon--disabled){color:var(--ids_color_action_primary_base)}.voxel-select__panel-options[_ngcontent-%COMP%]{background-color:var(--ids_color_bg_base);border-radius:0 0 var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01);-webkit-box-shadow:0 0 .125rem 0 rgba(86,80,76,.16),0 .125rem .5rem 0 rgba(86,80,76,.16);box-shadow:0 0 .125rem rgba(86,80,76,.16),0 .125rem .5rem rgba(86,80,76,.16);margin:var(--ids_size_general_2x) 0;overflow-y:auto;width:100%}"] });
VoxelSelectComponent.ctorParameters = () => [
    { type: LiveAnnouncer },
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: Platform },
    { type: Overlay }
];
VoxelSelectComponent.propDecorators = {
    controlId: [{ type: Input }],
    placeholder: [{ type: Input }],
    visibleOptions: [{ type: Input }],
    position: [{ type: Input }],
    required: [{ type: Input }],
    compareWith: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    selectOpen: [{ type: Output }],
    selectClose: [{ type: Output }],
    options: [{ type: ContentChildren, args: [VoxelOptionComponent, { descendants: true },] }],
    select: [{ type: ViewChild, args: ['select', { static: true },] }],
    overlayDir: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }],
    panel: [{ type: ViewChildren, args: ['panel',] }],
    controlChange: [{ type: HostListener, args: ['ngModelChange',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSelectComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-select',
                template: "<div\n  #select\n  cdkOverlayOrigin\n  #origin=\"cdkOverlayOrigin\"\n  role=\"combobox\"\n  [id]=\"controlId\"\n  class=\"voxel-select\"\n  [ngClass]=\"{\n    'voxel-select--disabled': disabled\n  }\"\n  (click)=\"toggle()\"\n  (keydown)=\"handleKeydown($event)\"\n  [attr.aria-disabled]=\"disabled\"\n  [attr.aria-expanded]=\"panelOpen\"\n  [attr.aria-describedby]=\"controlDescribedBy\"\n  [attr.aria-labelledby]=\"ariaLabelledBy\"\n  [attr.aria-invalid]=\"controlAriaInvalid\"\n  [attr.aria-activedescendant]=\"ariaActiveDescendant\"\n  [attr.aria-controls]=\"panelId\"\n  [attr.aria-required]=\"required\"\n  aria-haspopup=\"listbox\"\n  [tabindex]=\"tabindex\"\n  (focus)=\"onFocus()\"\n  (blur)=\"onBlur()\"\n>\n  <div\n    [id]=\"valueId\"\n    class=\"voxel-select__text\">\n    {{ optionTextValue }}\n  </div>\n</div>\n\n<voxel-icon\n  [ngClass]=\"{\n    'voxel-select__icon': true,\n    'voxel-select__icon--disabled': disabled,\n    'voxel-select__icon--open': panelOpen\n  }\"\n>\n  seta_baixo\n</voxel-icon>\n\n<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayLockPosition\n  cdkConnectedOverlayHasBackdrop\n  [cdkConnectedOverlayBackdropClass]=\"!isMobile ? 'cdk-overlay-transparent-backdrop' : ''\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayWidth]=\"selectWidth\"\n  (backdropClick)=\"dettach()\"\n  (attach)=\"attach()\"\n>\n  <div\n    #panel\n    role=\"listbox\"\n    tabindex=\"-1\"\n    [id]=\"panelId\"\n    class=\"voxel-select__panel-options\"\n    (keydown)=\"handleKeydown($event)\"\n    [attr.aria-labelledby]=\"labelId\"\n    [attr.aria-hidden]=\"!panelOpen\"\n    [style.maxHeight.rem]=\"!isMobile ? visibleOptions * 3 : ''\"\n  >\n    <ng-content select=\"voxel-option\"></ng-content>\n  </div>\n</ng-template>\n",
                providers: [
                    {
                        provide: VoxelFieldMixinBase,
                        useExisting: forwardRef(/* istanbul ignore next */ () => VoxelSelectComponent)
                    },
                ],
                styles: [":host{display:block;width:100%}.voxel-select{cursor:pointer;padding-bottom:var(--ids_size_general_8x);position:relative}.voxel-select--disabled{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-select__text{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem;min-height:var(--ids_size_general_28x);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.voxel-select__icon{color:var(--ids_color_action_disabled_base);padding-top:var(--ids_size_general_5x);pointer-events:none;position:absolute;right:0;top:0;-webkit-transition:-webkit-transform .2s linear;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear}.voxel-select__icon--open{-webkit-transform:rotateX(180deg);transform:rotateX(180deg)}.voxel-select__icon:not(.voxel-select__icon--disabled){color:var(--ids_color_action_primary_base)}.voxel-select__panel-options{background-color:var(--ids_color_bg_base);border-radius:0 0 var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01);-webkit-box-shadow:0 0 .125rem 0 rgba(86,80,76,.16),0 .125rem .5rem 0 rgba(86,80,76,.16);box-shadow:0 0 .125rem rgba(86,80,76,.16),0 .125rem .5rem rgba(86,80,76,.16);margin:var(--ids_size_general_2x) 0;overflow-y:auto;width:100%}\n"]
            }]
    }], function () { return [{ type: ɵngcc5.LiveAnnouncer }, { type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc6.Platform }, { type: ɵngcc2.Overlay }]; }, { controlId: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], visibleOptions: [{
            type: Input
        }], position: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], selectOpen: [{
            type: Output
        }], selectClose: [{
            type: Output
        }], required: [{
            type: Input
        }], compareWith: [{
            type: Input
        }], 
    /** @internal */
    controlChange: [{
            type: HostListener,
            args: ['ngModelChange']
        }], options: [{
            type: ContentChildren,
            args: [VoxelOptionComponent, { descendants: true }]
        }], select: [{
            type: ViewChild,
            args: ['select', { static: true }]
        }], overlayDir: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }], panel: [{
            type: ViewChildren,
            args: ['panel']
        }] }); })();

class VoxelSelectModule {
}
VoxelSelectModule.ɵfac = function VoxelSelectModule_Factory(t) { return new (t || VoxelSelectModule)(); };
VoxelSelectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelSelectModule });
VoxelSelectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, OverlayModule, FormsModule, VoxelIconModule, VoxelOptionModule], VoxelOptionModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSelectModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, OverlayModule, FormsModule, VoxelIconModule, VoxelOptionModule],
                declarations: [
                    VoxelSelectComponent,
                    VoxelNativeSelectDirective,
                    VoxelNativeSelectOptionDirective,
                ],
                exports: [
                    VoxelSelectComponent,
                    VoxelNativeSelectDirective,
                    VoxelNativeSelectOptionDirective,
                    VoxelOptionModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelSelectModule, { declarations: function () { return [VoxelSelectComponent, VoxelNativeSelectDirective, VoxelNativeSelectOptionDirective]; }, imports: function () { return [CommonModule, OverlayModule, FormsModule, VoxelIconModule, VoxelOptionModule]; }, exports: function () { return [VoxelSelectComponent, VoxelNativeSelectDirective, VoxelNativeSelectOptionDirective, VoxelOptionModule]; } }); })();

class VoxelSliderControlsComponent {
    constructor() {
        this._voxelSliderControls = true;
    }
    /** @internal */
    get formattedMin() {
        if (!this.input.mask) {
            return this.input.min;
        }
        return this.input.maskService.valueWithMask(this.input.min, this.input.maskService.currencyMask, undefined, undefined, undefined, undefined, true, Object.assign({ allowNegative: true, decimal: ',', precision: 0, thousands: '.', prefix: 'R$ ', suffix: '' }, this.input.maskConfig)).valueMask;
    }
    /** @internal */
    get formattedMax() {
        if (!this.input.mask) {
            return this.input.max;
        }
        return this.input.maskService.valueWithMask(this.input.max, this.input.maskService.currencyMask, undefined, undefined, undefined, undefined, true, Object.assign({ allowNegative: true, decimal: ',', precision: 0, thousands: '.', prefix: 'R$ ', suffix: '' }, this.input.maskConfig)).valueMask;
    }
    get showValue() {
        return this.input.touched || this.input.value !== this.input.min;
    }
}
VoxelSliderControlsComponent.ɵfac = function VoxelSliderControlsComponent_Factory(t) { return new (t || VoxelSliderControlsComponent)(); };
VoxelSliderControlsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelSliderControlsComponent, selectors: [["voxel-slider-controls"]], hostVars: 4, hostBindings: function VoxelSliderControlsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-slider-controls", ctx._voxelSliderControls)("voxel-slider-controls--with-tooltip", ctx.showValue);
    } }, inputs: { input: "input" }, decls: 9, vars: 13, consts: [[1, "voxel-slider-controls__tracking"], [1, "voxel-slider-controls__cursor"], [1, "voxel-slider-controls__tooltip"], [1, "voxel-slider-controls__footer"], ["role", "text"]], template: function VoxelSliderControlsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 4);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("width", ctx.input.percentageString);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("voxel-slider-controls__tooltip--center", ctx.input.percentage >= 15 && ctx.input.percentage < 85)("voxel-slider-controls__tooltip--right", ctx.input.percentage >= 85);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.input.formattedCurrent, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.input.minId)("aria-label", ctx.input.labelMin + " " + ctx.formattedMin);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.formattedMin, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", ctx.input.maxId)("aria-label", ctx.input.labelMax + " " + ctx.formattedMax);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.formattedMax, " ");
    } }, styles: [".voxel-slider-controls{font:var(--ids_textStyle_body_02_regular);position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-slider-controls__tooltip{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_action_primary_base);border-radius:var(--ids_size_cornerRadius_tooltip);bottom:0;color:var(--ids_color_bg_base);display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_24x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1;min-width:var(--ids_size_general_32x);padding:0 var(--ids_size_general_6x);position:absolute;right:0;text-align:center;-webkit-transform:translateX(calc(100% - 1.25rem));transform:translate(calc(100% - 1.25rem));-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;white-space:nowrap}.voxel-slider-controls__tooltip--center{-webkit-transform:translateX(50%);transform:translate(50%)}.voxel-slider-controls__tooltip--right{-webkit-transform:translateX(var(--ids_size_general_20x));transform:translate(var(--ids_size_general_20x))}.voxel-slider-controls__tracking{padding:0 var(--ids_size_general_12x);pointer-events:none}.voxel-slider-controls__cursor{opacity:0;position:relative;-webkit-transition:opacity .1s linear .1s;transition:opacity .1s linear .1s}.voxel-slider-controls__cursor:before{border-left:var(--ids_size_border_large) solid transparent;border-right:var(--ids_size_border_large) solid transparent;border-top:var(--ids_size_border_large) solid var(--ids_color_action_primary_base);bottom:0;content:\"\";height:0;position:absolute;right:-.25rem;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;width:0}.voxel-slider-controls__footer{color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-slider-controls--with-tooltip .voxel-slider-controls__cursor{opacity:1}.voxel-slider-controls--with-tooltip .voxel-slider-controls__cursor:before{-webkit-transform:translateY(-3rem);transform:translateY(-3rem)}.voxel-slider-controls--with-tooltip .voxel-slider-controls__tooltip{-webkit-transform:translate(calc(100% - .625rem),-3.25rem);transform:translate(calc(100% - .625rem),-3.25rem)}.voxel-slider-controls--with-tooltip .voxel-slider-controls__tooltip--center{-webkit-transform:translate(50%,-3.25rem);transform:translate(50%,-3.25rem)}.voxel-slider-controls--with-tooltip .voxel-slider-controls__tooltip--right{-webkit-transform:translate(var(--ids_size_general_10x),-3.25rem);transform:translate(var(--ids_size_general_10x),-3.25rem)}.voxel-slider--light+.voxel-slider-controls .voxel-slider-controls__footer{color:var(--ids_color_bg_base)}.voxel-slider--light+.voxel-slider-controls .voxel-slider-controls__cursor:before{border-top-color:var(--ids_color_bg_base)}.voxel-slider--light+.voxel-slider-controls .voxel-slider-controls__tooltip{background-color:var(--ids_color_bg_base);color:var(--ids_color_text_body_01)}.voxel-slider:disabled+.voxel-slider-controls .voxel-slider-controls__tracking{display:none}.voxel-slider:disabled+.voxel-slider-controls .voxel-slider-controls__footer{color:var(--ids_color_action_disabled_base)}\n"], encapsulation: 2 });
VoxelSliderControlsComponent.propDecorators = {
    input: [{ type: Input }],
    _voxelSliderControls: [{ type: HostBinding, args: ['class.voxel-slider-controls',] }],
    showValue: [{ type: HostBinding, args: ['class.voxel-slider-controls--with-tooltip',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSliderControlsComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-slider-controls',
                template: "<div class=\"voxel-slider-controls__tracking\">\n  <div class=\"voxel-slider-controls__cursor\" [style.width]=\"input.percentageString\">\n    <span\n      class=\"voxel-slider-controls__tooltip\"\n      [class.voxel-slider-controls__tooltip--center]=\"this.input.percentage >= 15 && this.input.percentage < 85\"\n      [class.voxel-slider-controls__tooltip--right]=\"this.input.percentage >= 85\"\n    >\n      {{ input.formattedCurrent }}\n    </span>\n  </div>\n</div>\n\n<div class=\"voxel-slider-controls__footer\">\n  <span\n    [attr.id]=\"input.minId\"\n    role=\"text\"\n    [attr.aria-label]=\"input.labelMin + ' ' + formattedMin\"\n  >\n    {{ formattedMin }}\n  </span>\n\n  <span\n    [attr.id]=\"input.maxId\"\n    role=\"text\"\n    [attr.aria-label]=\"input.labelMax + ' ' + formattedMax\"\n  >\n    {{ formattedMax }}\n  </span>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-slider-controls{font:var(--ids_textStyle_body_02_regular);position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-slider-controls__tooltip{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_action_primary_base);border-radius:var(--ids_size_cornerRadius_tooltip);bottom:0;color:var(--ids_color_bg_base);display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_24x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1;min-width:var(--ids_size_general_32x);padding:0 var(--ids_size_general_6x);position:absolute;right:0;text-align:center;-webkit-transform:translateX(calc(100% - 1.25rem));transform:translate(calc(100% - 1.25rem));-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;white-space:nowrap}.voxel-slider-controls__tooltip--center{-webkit-transform:translateX(50%);transform:translate(50%)}.voxel-slider-controls__tooltip--right{-webkit-transform:translateX(var(--ids_size_general_20x));transform:translate(var(--ids_size_general_20x))}.voxel-slider-controls__tracking{padding:0 var(--ids_size_general_12x);pointer-events:none}.voxel-slider-controls__cursor{opacity:0;position:relative;-webkit-transition:opacity .1s linear .1s;transition:opacity .1s linear .1s}.voxel-slider-controls__cursor:before{border-left:var(--ids_size_border_large) solid transparent;border-right:var(--ids_size_border_large) solid transparent;border-top:var(--ids_size_border_large) solid var(--ids_color_action_primary_base);bottom:0;content:\"\";height:0;position:absolute;right:-.25rem;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;width:0}.voxel-slider-controls__footer{color:var(--ids_color_text_body_01);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-slider-controls--with-tooltip .voxel-slider-controls__cursor{opacity:1}.voxel-slider-controls--with-tooltip .voxel-slider-controls__cursor:before{-webkit-transform:translateY(-3rem);transform:translateY(-3rem)}.voxel-slider-controls--with-tooltip .voxel-slider-controls__tooltip{-webkit-transform:translate(calc(100% - .625rem),-3.25rem);transform:translate(calc(100% - .625rem),-3.25rem)}.voxel-slider-controls--with-tooltip .voxel-slider-controls__tooltip--center{-webkit-transform:translate(50%,-3.25rem);transform:translate(50%,-3.25rem)}.voxel-slider-controls--with-tooltip .voxel-slider-controls__tooltip--right{-webkit-transform:translate(var(--ids_size_general_10x),-3.25rem);transform:translate(var(--ids_size_general_10x),-3.25rem)}.voxel-slider--light+.voxel-slider-controls .voxel-slider-controls__footer{color:var(--ids_color_bg_base)}.voxel-slider--light+.voxel-slider-controls .voxel-slider-controls__cursor:before{border-top-color:var(--ids_color_bg_base)}.voxel-slider--light+.voxel-slider-controls .voxel-slider-controls__tooltip{background-color:var(--ids_color_bg_base);color:var(--ids_color_text_body_01)}.voxel-slider:disabled+.voxel-slider-controls .voxel-slider-controls__tracking{display:none}.voxel-slider:disabled+.voxel-slider-controls .voxel-slider-controls__footer{color:var(--ids_color_action_disabled_base)}\n"]
            }]
    }], function () { return []; }, { _voxelSliderControls: [{
            type: HostBinding,
            args: ['class.voxel-slider-controls']
        }], showValue: [{
            type: HostBinding,
            args: ['class.voxel-slider-controls--with-tooltip']
        }], input: [{
            type: Input
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$2 = 0;
/**
 * Slider é um elemento que permite que o usuário selecione um número dentro de um alcance pré-definido.
 * Ele pode deslizar o cursor do ponto inicial ao ponto final e encontrar a opção desejada através
 * da indicação imediata do elemento.
 *
 * *Slider is an element that allows the user to select a number within a predefined range.*
 * *It can slide the cursor from the start point to the end point and find the desired option*
 * *by immediately indicating the element.*
 *
 * **Module:**
 *
 * `import { VoxelSliderModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/slider?componentOnly=true</example-url>
 */
class VoxelSliderDirective extends VoxelFieldMixinBase {
    /** @internal */
    constructor(_componentFactoryResolver, _viewContainerRef, maskService, elementRef, ngControl, renderer) {
        /* istanbul ignore */
        super(ngControl, elementRef);
        this._componentFactoryResolver = _componentFactoryResolver;
        this._viewContainerRef = _viewContainerRef;
        this.maskService = maskService;
        this.elementRef = elementRef;
        this.ngControl = ngControl;
        this.renderer = renderer;
        /** @internal */
        this._destroy = new Subject();
        /** @internal */
        this._disabled = false;
        /** @internal */
        this._onDark = false;
        /** @internal */
        this.touched = false;
        /**
         * valor máximo da label de acessibilidade
         *
         * *maximum value accessibility label*
         */
        this.labelMax = ' valor máximo';
        /**
         * valor mínimo da label de acessibilidade
         *
         * *minimum value accessibility label*
         */
        this.labelMin = ' valor mínimo';
        /** @internal */
        this.type = 'range';
        /** @internal */
        this._voxelSlider = true;
        this.controlId = `voxel-slider-${NEXT_ID$2++}`;
        /**
         * define o valor máximo que pode ser selecionado
         *
         * *defines the maximum value to be selected*
         */
        this.max = '100';
        /**
         * define o valor mínimo que pode ser selecionado
         *
         * *defines the minimum value to be selected*
         */
        this.min = '0';
    }
    /** @internal */
    get maxId() {
        return `${this.controlId}-${this.max}`;
    }
    /** @internal */
    get minId() {
        return `${this.controlId}-${this.min}`;
    }
    /** @internal */
    get percentage() {
        const inputEl = this.elementRef.nativeElement;
        const numberValue = Number(this.value);
        const numberMin = Number(inputEl.min) || 0;
        const numberMax = Number(inputEl.max) || 100;
        return ((numberValue - numberMin) * 100) / (numberMax - numberMin);
    }
    /** @internal */
    get ariaDescribedby() {
        return `${this.minId} ${this.maxId}`;
    }
    set controlDisabled(disabled) {
        this._disabled = enforceBoolean(disabled);
    }
    get controlDisabled() {
        return this._disabled || null;
    }
    /** @internal */
    get formattedCurrent() {
        if (!this.mask) {
            return this.value;
        }
        return this.maskService.valueWithMask(this.value, this.maskService.currencyMask, undefined, undefined, undefined, undefined, true, Object.assign({ allowNegative: true, decimal: ',', precision: 0, thousands: '.', prefix: 'R$ ', suffix: '' }, this.maskConfig)).valueMask;
    }
    /**
     * torna o componente claro para ser usado em fundos escuros
     *
     * *become it light to be using in dark backgrounds*
     */
    get onDark() {
        return this._onDark;
    }
    set onDark(value) {
        this._onDark = enforceBoolean(value);
    }
    /** @internal */
    onChange(target) {
        this.touched = true;
        this.value = String(parseFloat(target.value));
        if (this._onChange) {
            this._onChange(this.value);
        }
    }
    /** @internal */
    get percentageString() {
        return `${this.percentage}%`;
    }
    /**
     * Valor deve ser definido a partir MDC do min e do max; ou será zerado caso o valor informado seja zero
     *
     * *Value must be set from MDC of min and max; or it'll be zero if the value passed is zero*
     */
    set value(value) {
        this._value = value;
    }
    get value() {
        const inputEl = this.elementRef.nativeElement;
        const numberValue = Number(this._value) || 0;
        const numberMin = Number(inputEl.min) || 0;
        const numberMax = Number(inputEl.max) || 100;
        if (typeof this._value === 'undefined' || numberValue <= numberMin) {
            return String(numberMin);
        }
        if (numberValue >= numberMax) {
            return String(numberMax);
        }
        return String(numberValue);
    }
    /** @internal */
    ngOnInit() {
        const controlsFactory = this._componentFactoryResolver.resolveComponentFactory(VoxelSliderControlsComponent);
        const controlsRef = this._viewContainerRef.createComponent(controlsFactory);
        controlsRef.instance.input = this;
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
    /** @internal */
    onTouched() {
        this.touched = true;
    }
    /** @internal */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /** @internal */
    setDisabledState(isDisabled) {
        this._disabled = isDisabled;
    }
}
VoxelSliderDirective.ɵfac = function VoxelSliderDirective_Factory(t) { return new (t || VoxelSliderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(VoxelMaskService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VoxelSliderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelSliderDirective, selectors: [["", "voxelSlider", ""]], hostVars: 15, hostBindings: function VoxelSliderDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function VoxelSliderDirective_change_HostBindingHandler($event) { return ctx.onChange($event.target); })("input", function VoxelSliderDirective_input_HostBindingHandler($event) { return ctx.onChange($event.target); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("type", ctx.type)("max", ctx.max)("min", ctx.min)("value", ctx.value);
        ɵngcc0.ɵɵattribute("id", ctx.controlId)("aria-describedby", ctx.ariaDescribedby)("disabled", ctx.controlDisabled)("aria-valuetext", ctx.formattedCurrent)("aria-valuenow", ctx.value);
        ɵngcc0.ɵɵstyleProp("--slider-percent", ctx.percentageString);
        ɵngcc0.ɵɵclassProp("voxel-slider", ctx._voxelSlider)("voxel-slider--light", ctx.onDark);
    } }, inputs: { labelMax: "labelMax", labelMin: "labelMin", controlId: ["id", "controlId"], max: "max", min: "min", controlDisabled: ["disabled", "controlDisabled"], onDark: "onDark", value: "value", mask: "mask", maskConfig: "maskConfig" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: VoxelFieldMixinBase,
                useExisting: forwardRef(
                /* istanbul ignore next */
                () => VoxelSliderDirective)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelSliderDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef },
    { type: VoxelMaskService },
    { type: ElementRef },
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: Renderer2 }
];
VoxelSliderDirective.propDecorators = {
    labelMax: [{ type: Input }],
    labelMin: [{ type: Input }],
    mask: [{ type: Input }],
    maskConfig: [{ type: Input }],
    type: [{ type: HostBinding }],
    _voxelSlider: [{ type: HostBinding, args: ['class.voxel-slider',] }],
    ariaDescribedby: [{ type: HostBinding, args: ['attr.aria-describedby',] }],
    controlDisabled: [{ type: Input, args: ['disabled',] }, { type: HostBinding, args: ['attr.disabled',] }],
    controlId: [{ type: Input, args: ['id',] }, { type: HostBinding, args: ['attr.id',] }],
    formattedCurrent: [{ type: HostBinding, args: ['attr.aria-valuetext',] }],
    onDark: [{ type: Input }, { type: HostBinding, args: ['class.voxel-slider--light',] }],
    max: [{ type: Input }, { type: HostBinding }],
    min: [{ type: Input }, { type: HostBinding }],
    onChange: [{ type: HostListener, args: ['change', ['$event.target'],] }, { type: HostListener, args: ['input', ['$event.target'],] }],
    percentageString: [{ type: HostBinding, args: ['style.--slider-percent',] }],
    value: [{ type: Input }, { type: HostBinding }, { type: HostBinding, args: ['attr.aria-valuenow',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSliderDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelSlider]',
                providers: [
                    {
                        provide: VoxelFieldMixinBase,
                        useExisting: forwardRef(
                        /* istanbul ignore next */
                        () => VoxelSliderDirective)
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }, { type: VoxelMaskService }, { type: ɵngcc0.ElementRef }, { type: ɵngcc3.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.Renderer2 }]; }, { labelMax: [{
            type: Input
        }], labelMin: [{
            type: Input
        }], type: [{
            type: HostBinding
        }], _voxelSlider: [{
            type: HostBinding,
            args: ['class.voxel-slider']
        }], controlId: [{
            type: Input,
            args: ['id']
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], max: [{
            type: Input
        }, {
            type: HostBinding
        }], min: [{
            type: Input
        }, {
            type: HostBinding
        }], ariaDescribedby: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }], controlDisabled: [{
            type: Input,
            args: ['disabled']
        }, {
            type: HostBinding,
            args: ['attr.disabled']
        }], formattedCurrent: [{
            type: HostBinding,
            args: ['attr.aria-valuetext']
        }], onDark: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.voxel-slider--light']
        }], 
    /** @internal */
    onChange: [{
            type: HostListener,
            args: ['change', ['$event.target']]
        }, {
            type: HostListener,
            args: ['input', ['$event.target']]
        }], value: [{
            type: Input
        }, {
            type: HostBinding
        }, {
            type: HostBinding,
            args: ['attr.aria-valuenow']
        }], percentageString: [{
            type: HostBinding,
            args: ['style.--slider-percent']
        }], mask: [{
            type: Input
        }], maskConfig: [{
            type: Input
        }] }); })();

class VoxelSliderModule {
}
VoxelSliderModule.ɵfac = function VoxelSliderModule_Factory(t) { return new (t || VoxelSliderModule)(); };
VoxelSliderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelSliderModule });
VoxelSliderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [VoxelMaskService], imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSliderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                declarations: [VoxelSliderDirective, VoxelSliderControlsComponent],
                providers: [VoxelMaskService],
                exports: [VoxelSliderDirective, VoxelSliderControlsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelSliderModule, { declarations: function () { return [VoxelSliderDirective, VoxelSliderControlsComponent]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [VoxelSliderDirective, VoxelSliderControlsComponent]; } }); })();

/**
 * Diretiva para utilização do Checkbox dentro do componente form selection
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelSwitchModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/switch?componentOnly=true</example-url>
 *
 * @example Switch simples
 * <voxel-form-selection>
 *            <input type="checkbox" formControlName="simple" voxelSwitch />
 *            simples
 * </voxel-form-selection>
 *
 * @example Switch pré selecionado
 *  <voxel-form-selection>
 *             <input type="checkbox" formControlName="selected" voxelSwitch checked />
 *             selecionado
 *  </voxel-form-selection>
 *
 */
class VoxelSwitchDirective extends VoxelFormSelectionBase {
    constructor() {
        super(...arguments);
        // Essa configuração é necessária para que não ocorra foco duplo no ambiente iOS/VO
        // Decidimos fazer a mesma configuração para todos os ambientes
        this._rtlDirection = true;
        this._ariaHiddenLabel = true;
        this.role = 'button';
    }
    /**
     * @internal
     */
    get selectorType() {
        return 'switch';
    }
    get classes() {
        return {
            'voxel-form-selection__switch': true,
            'voxel-form-selection__switch--checked': this.nativeElement.checked,
            'voxel-form-selection__switch--disabled': this.nativeElement.disabled,
        };
    }
    get ariaLabelledBy() {
        return this.labelId;
    }
    get ariaSelected() {
        return this.nativeElement.checked;
    }
}
VoxelSwitchDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelSwitchDirective_BaseFactory; return function VoxelSwitchDirective_Factory(t) { return (ɵVoxelSwitchDirective_BaseFactory || (ɵVoxelSwitchDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelSwitchDirective)))(t || VoxelSwitchDirective); }; }();
VoxelSwitchDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelSwitchDirective, selectors: [["", "voxelSwitch", ""]], hostVars: 5, hostBindings: function VoxelSwitchDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role)("aria-labelledby", ctx.ariaLabelledBy)("aria-pressed", ctx.ariaSelected);
        ɵngcc0.ɵɵclassMap(ctx.classes);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: VoxelFormSelectionBase, useExisting: VoxelSwitchDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelSwitchDirective.propDecorators = {
    classes: [{ type: HostBinding, args: ['class',] }],
    ariaLabelledBy: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    ariaSelected: [{ type: HostBinding, args: ['attr.aria-pressed',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSwitchDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelSwitch]',
                providers: [{ provide: VoxelFormSelectionBase, useExisting: VoxelSwitchDirective }]
            }]
    }], null, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }], ariaLabelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], ariaSelected: [{
            type: HostBinding,
            args: ['attr.aria-pressed']
        }] }); })();

class VoxelSwitchModule {
}
VoxelSwitchModule.ɵfac = function VoxelSwitchModule_Factory(t) { return new (t || VoxelSwitchModule)(); };
VoxelSwitchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelSwitchModule });
VoxelSwitchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSwitchModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelSwitchDirective],
                exports: [VoxelSwitchDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelSwitchModule, { declarations: function () { return [VoxelSwitchDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelSwitchDirective]; } }); })();

/**
 * Diretiva para utilização do RadioButton dentro do componente selector
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelRadioButtonModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/radiobutton?componentOnly=true</example-url>
 *
 * @example RadioButton sem seleção
 * <voxel-form-selection-group>
 *           <voxel-form-selection>
 *             <input type="radio" name="noSelection" formControlName="noSelection" voxelRadioButton />
 *             simples
 *           </voxel-form-selection>
 * </voxel-form-selection-group>
 *
 * @example RadioButton pré selecionado
 * <voxel-form-selection-group>
 *            <voxel-form-selection>
 *              <input type="radio" name="selected" formControlName="selected" voxelRadioButton />
 *              pré selecionado
 *            </voxel-form-selection>
 * </voxel-form-selection-group>
 *
 * @example RadioButton com error, utilizando <voxel-form-status>
 * <voxel-form-selection-group aria-live="polite">
 *             <voxel-form-selection>
 *               <input type="radio" value="15" name="withError" formControlName="withError" voxelRadioButton required />
 *               aceito receber SMS
 *             </voxel-form-selection>
 *             <voxel-form-selection>
 *               <input type="radio" value="16" name="withError" formControlName="withError" voxelRadioButton required />
 *               não aceito SMS
 *             </voxel-form-selection>
 *             <voxel-form-status *ngIf="withError()" [attr.aria-invalid]="withError()">
 *               seleciona uma opção para prosseguir
 *             </voxel-form-status>
 * </voxel-form-selection-group>
 */
class VoxelRadioButtonDirective extends VoxelFormSelectionBase {
    /**
     * @internal
     */
    get selectorType() {
        return 'radio';
    }
    /**
     * @internal
     */
    get icon() {
        return this.nativeElement.checked ? 'radio_button_full' : 'radio_button_outline';
    }
    /**
     * @internal
     */
    get iconClasses() {
        return {
            'voxel-form-selection__radio': true,
            'voxel-form-selection__radio--checked': this.nativeElement.checked,
            'voxel-form-selection__radio--empty': !this.nativeElement.checked,
            'voxel-form-selection__radio--disabled': this.nativeElement.disabled,
            'voxel-form-selection__radio--focus': this._isFocused,
            'voxel-form-selection__radio--invalid': this.state === 'invalid',
        };
    }
}
VoxelRadioButtonDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelRadioButtonDirective_BaseFactory; return function VoxelRadioButtonDirective_Factory(t) { return (ɵVoxelRadioButtonDirective_BaseFactory || (ɵVoxelRadioButtonDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelRadioButtonDirective)))(t || VoxelRadioButtonDirective); }; }();
VoxelRadioButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelRadioButtonDirective, selectors: [["", "voxelRadioButton", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: VoxelFormSelectionBase, useExisting: VoxelRadioButtonDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelRadioButtonDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelRadioButton]',
                providers: [{ provide: VoxelFormSelectionBase, useExisting: VoxelRadioButtonDirective }]
            }]
    }], null, null); })();

class VoxelRadioButtonModule {
}
VoxelRadioButtonModule.ɵfac = function VoxelRadioButtonModule_Factory(t) { return new (t || VoxelRadioButtonModule)(); };
VoxelRadioButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelRadioButtonModule });
VoxelRadioButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelRadioButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelRadioButtonDirective],
                exports: [VoxelRadioButtonDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelRadioButtonModule, { declarations: function () { return [VoxelRadioButtonDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelRadioButtonDirective]; } }); })();

let NEXT_ID$1 = 0;
/**
 * As abas são uma maneira fácil de organizar o conteúdo, agrupando informações semelhantes na mesma página.
 *
 * *Tabs are an easy way to organize content, grouping similar information on the same page.*
 *
 * **Module:**
 *
 * `import { VoxelTabsModule } from '@voxel/components';`
 */
class VoxelTabsComponent {
    /**
     * @internal
     */
    constructor(_renderer, _platform) {
        this._renderer = _renderer;
        this._platform = _platform;
        /** @internal */
        this.scrollPosition = 0;
        /** @internal */
        this.tabIndexScroll = 0;
        /** @internal */
        this.scrolless = false;
        /**
         * Identificação do componente
         *
         * *Identification of the component*
         */
        this.tabId = `voxel-tabs-${NEXT_ID$1++}`;
        /**
         * Número da aba/passo atual
         *
         * *Number of the current tab/step*
         */
        this.current = 1;
        this._onDark = false;
        /**
         * Evento disparado sempre que selecionar uma aba.
         *
         * **Na opção de steps esse evento não é acionado devido a regra de uso**
         *
         * *Event triggered when selecting a tab.*
         *
         * ***In the steps option this event isn't triggered because of the usage rules***
         */
        this.tabChange = new EventEmitter();
    }
    /**
     * Define se a cor do tab seguirá a cor de fundo
     *
     * *Defines whether the tab color will follow the background color*
     */
    set onDark(value) {
        this._onDark = enforceBoolean(value);
    }
    get dark() {
        return this._onDark;
    }
    /**
     * @internal
     */
    onResize() {
        this.controlPosition();
    }
    ngAfterViewInit() {
        Promise.resolve().then(() => {
            this.controlPosition();
            this.setGradient();
        });
    }
    ngOnDestroy() {
        var _a;
        (_a = this.scrollObservable) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    setGradient() {
        const bgInterval = 200;
        const focusTotalRepetitions = 10;
        let focusRepetitions = 0;
        const interval = setInterval(() => {
            const getBgColor = getBackgroundColor(this.tabsBg.nativeElement);
            this.bgColor = `linear-gradient(
        to right,
        ${getBgColor} 20px,
        ${getBgColor.replace(')', ', 0)').replace('rgb', 'rgba')} 50px,
        ${getBgColor.replace(')', ', 0)').replace('rgb', 'rgba')} calc(100% - 50px),
        ${getBgColor} calc(100% - 25px)
      )`;
            this._renderer.setStyle(this.tabsBg.nativeElement, 'background', this.bgColor);
            focusRepetitions++;
            if (focusRepetitions >= focusTotalRepetitions) {
                clearInterval(interval);
            }
        }, bgInterval);
    }
    /**
     * @internal
     */
    clickTab(_event, tabItem, navIndex) {
        this.tabSelected = tabItem;
        this.current = navIndex + 1;
        this.tabChange.emit({
            event: _event,
            tabs: tabItem.name,
            selected: tabItem,
            current: this.current,
            disabled: tabItem.disabled,
        });
        if (this._platform.IOS) {
            setVoiceOverFocus(_event.target);
        }
    }
    /**
     * @internal
     */
    controlPosition() {
        const element = this.tabListContent.nativeElement;
        const hasScroll = element.scrollWidth > element.clientWidth;
        if (hasScroll) {
            this.scrollObservable = fromEvent(element, 'scroll').subscribe((_event) => {
                const target = _event.target;
                const scrollLeft = target.scrollWidth - target.clientWidth;
                this.scrollPosition = (100 * target.scrollLeft) / scrollLeft;
            });
            this.scrolless = true;
            return;
        }
        // this.scrollObservable?.unsubscribe();
        this.ngOnDestroy();
        this.scrolless = false;
    }
    changeTab(toTheRight) {
        this.tabIndexScroll += toTheRight ? 1 : -1;
        const element = this.tabListContent.nativeElement;
        const quantityScroll = element.clientWidth * 0.5;
        const scroll = (toTheRight ? +1 : -1) * quantityScroll;
        element.scrollTo({
            left: element.scrollLeft + scroll,
            behavior: 'smooth',
        });
    }
    /**
     * @internal
     */
    onKeyDown(_event) {
        const element = _event.currentTarget;
        const nextElement = element.nextElementSibling;
        const previousElement = element.previousElementSibling;
        if (_event.key === 'ArrowRight' || _event.key === 'ArrowDown') {
            _event.preventDefault();
            if (nextElement) {
                nextElement.focus();
                return;
            }
            element.focus();
        }
        if (_event.key === 'ArrowLeft' || _event.key === 'ArrowUp') {
            _event.preventDefault();
            if (previousElement) {
                previousElement.focus();
                return;
            }
            element.focus();
        }
    }
    /**
     * @internal
     */
    scrollIntoView(_element) {
        const containerElement = this.tabListContent.nativeElement;
        const scroll = _element.offsetLeft - (containerElement.clientWidth - _element.offsetWidth) / 2;
        containerElement.scrollTo({
            left: scroll,
            behavior: 'smooth',
        });
    }
}
VoxelTabsComponent.ɵfac = function VoxelTabsComponent_Factory(t) { return new (t || VoxelTabsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Platform)); };
VoxelTabsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelTabsComponent, selectors: [["voxel-tabs"]], viewQuery: function VoxelTabsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c55, 5);
        ɵngcc0.ɵɵviewQuery(_c56, 5);
        ɵngcc0.ɵɵviewQuery(_c57, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabsBg = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabListContent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.buttonTabs = _t);
    } }, hostBindings: function VoxelTabsComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VoxelTabsComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { tabId: "tabId", current: "current", onDark: "onDark", tabSelected: "tabSelected", tabs: "tabs" }, outputs: { tabChange: "tabChange" }, decls: 8, vars: 7, consts: [[1, "voxel-tab-list"], [1, "voxel-tab-list__bg"], ["tabsBg", ""], ["tabindex", "-1", "aria-hidden", "true", "class", "voxel-tab-list__navigation", 3, "ngClass", "click", 4, "ngIf"], ["role", "tablist", 1, "voxel-tab-list__items"], ["tabListContent", ""], ["class", "voxel-tab", "role", "tab", 3, "voxel-tab--checked", "voxel-tab--on-dark", "id", "focus", "keydown", "click", 4, "ngFor", "ngForOf"], ["tabindex", "-1", "aria-hidden", "true", "class", "voxel-tab-list__navigation voxel-tab-list__navigation--right", 3, "ngClass", "click", 4, "ngIf"], ["tabindex", "-1", "aria-hidden", "true", 1, "voxel-tab-list__navigation", 3, "ngClass", "click"], ["size", "S"], ["role", "tab", 1, "voxel-tab", 3, "id", "focus", "keydown", "click"], ["buttonTabs", ""], ["class", "voxel-tab__icon", 4, "ngIf"], [1, "voxel-tab__icon"], ["tabindex", "-1", "aria-hidden", "true", 1, "voxel-tab-list__navigation", "voxel-tab-list__navigation--right", 3, "ngClass", "click"]], template: function VoxelTabsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1, 2);
        ɵngcc0.ɵɵtemplate(3, VoxelTabsComponent_button_3_Template, 3, 3, "button", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4, 5);
        ɵngcc0.ɵɵtemplate(6, VoxelTabsComponent_button_6_Template, 4, 10, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, VoxelTabsComponent_button_7_Template, 3, 3, "button", 7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-tab-list--on-dark", ctx.dark)("voxel-tab-list--scalable", ctx.scrolless);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.scrolless === true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.scrolless === true);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass, VoxelIconComponent], styles: [".voxel-tab{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;border-bottom:var(--ids_size_border_small) solid transparent;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_label_small_regular);min-height:var(--ids_size_general_48x);padding:var(--ids_size_general_1x) var(--ids_size_general_7x)}.voxel-tab__icon{padding-right:var(--ids_size_general_4x)}.voxel-tab:disabled{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-tab--checked{border-color:currentColor;font-weight:700}.voxel-tab--on-dark{color:var(--ids_color_contrast_onDark)}.voxel-tab:hover:not(:disabled):not(.voxel-tab--checked){background-color:var(--ids_color_bg_variant_02)}.voxel-tab--checked:not(:disabled):not(.voxel-tab--on-dark){color:var(--ids_color_text_highlight)}.voxel-tab--on-dark:disabled{color:var(--ids_color_action_disabled_variant)}.voxel-tab--on-dark:hover:not(:disabled):not(.voxel-tab--checked){background-color:rgba(255,255,255,.1)}.voxel-tab:not(:disabled):not(.voxel-tab--checked):not(.voxel-tab--on-dark){color:var(--ids_color_action_neutral_variant)}.voxel-tab-list{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:.03125rem solid var(--ids_color_action_disabled_base);display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;z-index:0}.voxel-tab-list--scalable .voxel-tab-list__bg{background:linear-gradient(to right,white 20px,rgba(255,255,255,.1) 50px,rgba(255,255,255,.1) calc(100% - 50px),white calc(100% - 25px));height:100%;pointer-events:none;position:absolute;width:100%}.voxel-tab-list__items{display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 -.9375rem;overflow-x:scroll;padding:var(--ids_size_general_2x) var(--ids_size_general_16x) 0 var(--ids_size_general_16x);-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory;scrollbar-width:none;white-space:nowrap}.voxel-tab-list__items>*{scroll-snap-align:center}@media not all and (min-resolution: .001dpcm){.voxel-tab-list__items{margin:0 0 0 -.9375rem}}.voxel-tab-list__items::-webkit-scrollbar{display:none}.voxel-tab-list__navigation{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:stretch;align-self:stretch;background:transparent;border:none;color:var(--ids_color_text_highlight);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 var(--ids_size_general_16x) 0 var(--ids_size_general_8x);z-index:1}.voxel-tab-list__navigation--right{padding:0 var(--ids_size_general_8x) 0 var(--ids_size_general_16x)}.voxel-tab-list__navigation--disabled{color:var(--ids_color_action_disabled_variant);pointer-events:none}.voxel-tab-list--on-dark .voxel-tab-list__navigation{color:var(--ids_color_contrast_onDark)}.voxel-tab-list--on-dark .voxel-tab-list__navigation--disabled{color:var(--ids_color_action_disabled_variant);pointer-events:none}\n"], encapsulation: 2 });
VoxelTabsComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: Platform }
];
VoxelTabsComponent.propDecorators = {
    tabId: [{ type: Input }],
    current: [{ type: Input }],
    tabSelected: [{ type: Input }],
    tabs: [{ type: Input }],
    onDark: [{ type: Input }],
    tabChange: [{ type: Output }],
    tabsBg: [{ type: ViewChild, args: ['tabsBg',] }],
    tabListContent: [{ type: ViewChild, args: ['tabListContent',] }],
    buttonTabs: [{ type: ViewChildren, args: ['buttonTabs',] }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTabsComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-tabs',
                template: "<div\n  class=\"voxel-tab-list\"\n  [class.voxel-tab-list--on-dark]=\"dark\"\n  [class.voxel-tab-list--scalable]=\"scrolless\"\n>\n  <span #tabsBg class=\"voxel-tab-list__bg\"></span>\n  <button\n    *ngIf=\"scrolless === true\"\n    tabindex=\"-1\"\n    aria-hidden=\"true\"\n    [ngClass]=\"{'voxel-tab-list__navigation--disabled' : scrollPosition === 0}\"\n    class=\"voxel-tab-list__navigation\"\n    (click)=\"changeTab(false)\"\n  >\n    <voxel-icon size=\"S\">seta_esquerda</voxel-icon>\n  </button>\n\n  <div #tabListContent class=\"voxel-tab-list__items\" role=\"tablist\">\n    <button\n      *ngFor=\"let tab of tabs; let index = index;\"\n      #buttonTabs\n      class=\"voxel-tab\"\n      [class.voxel-tab--checked]=\"current === index + 1\"\n      [class.voxel-tab--on-dark]=\"dark\"\n      [attr.aria-selected]=\"current === (index + 1)\"\n      [attr.aria-controls]=\"current === (index + 1) ? tab.panelId : '' \"\n      [attr.disabled]=\"tab.disabled || null\"\n      [id]=\"tabId + '-' + (index + 1)\"\n      role=\"tab\"\n      (focus)=\"scrollIntoView(buttonTabs)\"\n      (keydown)=\"onKeyDown($event)\"\n      (click)=\"clickTab($event, tab, index)\"\n    >\n      <voxel-icon *ngIf=\"tab.icon\" class=\"voxel-tab__icon\">{{ tab.icon }}</voxel-icon>\n      {{ tab.name }}\n    </button>\n  </div>\n\n  <button\n    *ngIf=\"scrolless === true\"\n    tabindex=\"-1\"\n    aria-hidden=\"true\"\n    [ngClass]=\"{'voxel-tab-list__navigation--disabled' : scrollPosition >= 100}\"\n    class=\"voxel-tab-list__navigation voxel-tab-list__navigation--right\"\n    (click)=\"changeTab(true)\"\n  >\n    <voxel-icon size=\"S\">seta_direita</voxel-icon>\n  </button>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-tab{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;border-bottom:var(--ids_size_border_small) solid transparent;cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_label_small_regular);min-height:var(--ids_size_general_48x);padding:var(--ids_size_general_1x) var(--ids_size_general_7x)}.voxel-tab__icon{padding-right:var(--ids_size_general_4x)}.voxel-tab:disabled{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-tab--checked{border-color:currentColor;font-weight:700}.voxel-tab--on-dark{color:var(--ids_color_contrast_onDark)}.voxel-tab:hover:not(:disabled):not(.voxel-tab--checked){background-color:var(--ids_color_bg_variant_02)}.voxel-tab--checked:not(:disabled):not(.voxel-tab--on-dark){color:var(--ids_color_text_highlight)}.voxel-tab--on-dark:disabled{color:var(--ids_color_action_disabled_variant)}.voxel-tab--on-dark:hover:not(:disabled):not(.voxel-tab--checked){background-color:rgba(255,255,255,.1)}.voxel-tab:not(:disabled):not(.voxel-tab--checked):not(.voxel-tab--on-dark){color:var(--ids_color_action_neutral_variant)}.voxel-tab-list{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:.03125rem solid var(--ids_color_action_disabled_base);display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;z-index:0}.voxel-tab-list--scalable .voxel-tab-list__bg{background:linear-gradient(to right,white 20px,rgba(255,255,255,.1) 50px,rgba(255,255,255,.1) calc(100% - 50px),white calc(100% - 25px));height:100%;pointer-events:none;position:absolute;width:100%}.voxel-tab-list__items{display:-webkit-box;display:-ms-flexbox;display:flex;margin:0 -.9375rem;overflow-x:scroll;padding:var(--ids_size_general_2x) var(--ids_size_general_16x) 0 var(--ids_size_general_16x);-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory;scrollbar-width:none;white-space:nowrap}.voxel-tab-list__items>*{scroll-snap-align:center}@media not all and (min-resolution: .001dpcm){.voxel-tab-list__items{margin:0 0 0 -.9375rem}}.voxel-tab-list__items::-webkit-scrollbar{display:none}.voxel-tab-list__navigation{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:stretch;align-self:stretch;background:transparent;border:none;color:var(--ids_color_text_highlight);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 var(--ids_size_general_16x) 0 var(--ids_size_general_8x);z-index:1}.voxel-tab-list__navigation--right{padding:0 var(--ids_size_general_8x) 0 var(--ids_size_general_16x)}.voxel-tab-list__navigation--disabled{color:var(--ids_color_action_disabled_variant);pointer-events:none}.voxel-tab-list--on-dark .voxel-tab-list__navigation{color:var(--ids_color_contrast_onDark)}.voxel-tab-list--on-dark .voxel-tab-list__navigation--disabled{color:var(--ids_color_action_disabled_variant);pointer-events:none}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc6.Platform }]; }, { tabId: [{
            type: Input
        }], current: [{
            type: Input
        }], tabChange: [{
            type: Output
        }], onDark: [{
            type: Input
        }], 
    /**
     * @internal
     */
    onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], tabSelected: [{
            type: Input
        }], tabs: [{
            type: Input
        }], tabsBg: [{
            type: ViewChild,
            args: ['tabsBg']
        }], tabListContent: [{
            type: ViewChild,
            args: ['tabListContent']
        }], buttonTabs: [{
            type: ViewChildren,
            args: ['buttonTabs']
        }] }); })();

class VoxelTabsModule {
}
VoxelTabsModule.ɵfac = function VoxelTabsModule_Factory(t) { return new (t || VoxelTabsModule)(); };
VoxelTabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelTabsModule });
VoxelTabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTabsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelTabsComponent],
                exports: [VoxelTabsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelTabsModule, { declarations: function () { return [VoxelTabsComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelTabsComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID = 0;
/**
 * Tooltip é um componente de interface que permite ao usuário expandir um pop-up com pequenas informações complementares
 *
 * Tooltip is an interface component that allows the user to expand a pop-up with small supplementary information
 *
 * **Module:**
 *
 * `import { VoxelTooltipModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/tooltip?componentOnly=true</example-url>
 *
 */
class VoxelTooltipComponent {
    constructor() {
        this.verticalMargin = 0;
        /**
         * @internal
         */
        this.tooltipId = `voxel-tooltip-${NEXT_ID++}`;
        /**
         * Input que recebe o texto que vai aparecer dentro do tooltip
         *
         * *Input that receives the text that will appear inside the tooltip*
         */
        this.text = '';
    }
    onResize() {
        this.resizeControl();
    }
    ngOnInit() {
        this.resizeControl();
    }
    resizeControl() {
        if (this.tooltipPosition === 'bottom') {
            return;
        }
        if ((this.tooltipPosition === 'left' || this.tooltipPosition === 'right') &&
            this.tooltipArrow !== 'end') {
            return;
        }
        this.verticalMargin = window.innerHeight - document.documentElement.clientHeight;
    }
}
VoxelTooltipComponent.ɵfac = function VoxelTooltipComponent_Factory(t) { return new (t || VoxelTooltipComponent)(); };
VoxelTooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelTooltipComponent, selectors: [["voxel-tooltip"]], hostBindings: function VoxelTooltipComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VoxelTooltipComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { text: "text", tooltipType: "tooltipType", tooltipIcon: "tooltipIcon", tooltipPosition: "tooltipPosition", tooltipArrow: "tooltipArrow", hideArrow: "hideArrow" }, decls: 5, vars: 26, consts: [["role", "tooltip", 1, "voxel-tooltip", 3, "id", "ngStyle"], [1, "voxel-tooltip__arrow"], [1, "voxel-tooltip__text"], ["class", "voxel-tooltip__icon", 4, "ngIf"], [1, "voxel-tooltip__icon"]], template: function VoxelTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, VoxelTooltipComponent_voxel_icon_3_Template, 2, 1, "voxel-icon", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-tooltip--tip", ctx.tooltipType === "tip")("voxel-tooltip--info", ctx.tooltipType === "info")("voxel-tooltip--top", ctx.tooltipPosition === "top")("voxel-tooltip--right", ctx.tooltipPosition === "right")("voxel-tooltip--bottom", ctx.tooltipPosition === "bottom")("voxel-tooltip--left", ctx.tooltipPosition === "left")("voxel-tooltip--start", ctx.tooltipArrow === "start")("voxel-tooltip--middle", ctx.tooltipArrow === "middle")("voxel-tooltip--end", ctx.tooltipArrow === "end");
        ɵngcc0.ɵɵproperty("id", ctx.tooltipId)("ngStyle", ɵngcc0.ɵɵpureFunction1(24, _c59, "translateY(-" + ctx.verticalMargin + "px)"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("voxel-tooltip__arrow--hide", ctx.hideArrow);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tooltipIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.text, " ");
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgIf, VoxelIconComponent], styles: [".voxel-tooltip{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-tooltip__text{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_feedback_information);border-radius:var(--ids_size_cornerRadius_tooltip);color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:1.09375rem;max-width:13.25rem;padding:var(--ids_size_general_12x)}@media (min-width: 64rem){.voxel-tooltip__text{max-width:19rem}}.voxel-tooltip__icon{margin-right:.9375rem;margin-top:var(--ids_size_general_8x)}.voxel-tooltip__icon .voxel-icon{color:var(--ids_color_contrast_onDark)}.voxel-tooltip__arrow{border:.3125rem solid transparent;border-top-color:var(--ids_color_feedback_information);margin:0 var(--ids_size_general_5x)}.voxel-tooltip__arrow--hide{border-width:var(--ids_size_general_4x);opacity:var(--ids_opacity_empty)}.voxel-tooltip--info .voxel-tooltip__text{background-color:var(--ids_color_feedback_neutral);color:var(--ids_color_contrast_onDark)}.voxel-tooltip--info .voxel-tooltip__arrow{border-top-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.voxel-tooltip--bottom .voxel-tooltip__arrow{border-color:transparent;border-bottom-color:var(--ids_color_feedback_information)}.voxel-tooltip--left{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.voxel-tooltip--left .voxel-tooltip__arrow{border-color:transparent;border-left-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.voxel-tooltip--right .voxel-tooltip__arrow{border-color:transparent;border-right-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right.voxel-tooltip--info .voxel-tooltip__arrow{border-right-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom.voxel-tooltip--info .voxel-tooltip__arrow{border-bottom-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--left.voxel-tooltip--info .voxel-tooltip__arrow{border-left-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--start{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.voxel-tooltip--end{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}\n"], encapsulation: 2 });
VoxelTooltipComponent.propDecorators = {
    tooltipType: [{ type: Input }],
    text: [{ type: Input }],
    tooltipIcon: [{ type: Input }],
    tooltipPosition: [{ type: Input }],
    tooltipArrow: [{ type: Input }],
    hideArrow: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTooltipComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-tooltip',
                template: "<div\n  role=\"tooltip\"\n  class=\"voxel-tooltip\"\n  [class.voxel-tooltip--tip] = \"tooltipType === 'tip'\"\n  [class.voxel-tooltip--info] = \"tooltipType === 'info'\"\n  [class.voxel-tooltip--top] = \"tooltipPosition === 'top'\"\n  [class.voxel-tooltip--right] = \"tooltipPosition === 'right'\"\n  [class.voxel-tooltip--bottom] = \"tooltipPosition === 'bottom'\"\n  [class.voxel-tooltip--left] = \"tooltipPosition === 'left'\"\n  [class.voxel-tooltip--start] = \"tooltipArrow === 'start'\"\n  [class.voxel-tooltip--middle] = \"tooltipArrow === 'middle'\"\n  [class.voxel-tooltip--end] = \"tooltipArrow === 'end'\"\n  [id]=\"tooltipId\"\n  [ngStyle]=\"{ 'transform': 'translateY(-' + verticalMargin + 'px)' }\"\n>\n  <div\n    class=\"voxel-tooltip__arrow\"\n    [class.voxel-tooltip__arrow--hide]=\"hideArrow\"\n  ></div>\n  <div class=\"voxel-tooltip__text\">\n    <voxel-icon class=\"voxel-tooltip__icon\" *ngIf=\"tooltipIcon\">\n      {{ tooltipIcon }}\n    </voxel-icon>\n    {{ text }}\n  </div>\n</div>\n\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-tooltip{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-tooltip__text{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_feedback_information);border-radius:var(--ids_size_cornerRadius_tooltip);color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:1.09375rem;max-width:13.25rem;padding:var(--ids_size_general_12x)}@media (min-width: 64rem){.voxel-tooltip__text{max-width:19rem}}.voxel-tooltip__icon{margin-right:.9375rem;margin-top:var(--ids_size_general_8x)}.voxel-tooltip__icon .voxel-icon{color:var(--ids_color_contrast_onDark)}.voxel-tooltip__arrow{border:.3125rem solid transparent;border-top-color:var(--ids_color_feedback_information);margin:0 var(--ids_size_general_5x)}.voxel-tooltip__arrow--hide{border-width:var(--ids_size_general_4x);opacity:var(--ids_opacity_empty)}.voxel-tooltip--info .voxel-tooltip__text{background-color:var(--ids_color_feedback_neutral);color:var(--ids_color_contrast_onDark)}.voxel-tooltip--info .voxel-tooltip__arrow{border-top-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.voxel-tooltip--bottom .voxel-tooltip__arrow{border-color:transparent;border-bottom-color:var(--ids_color_feedback_information)}.voxel-tooltip--left{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.voxel-tooltip--left .voxel-tooltip__arrow{border-color:transparent;border-left-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.voxel-tooltip--right .voxel-tooltip__arrow{border-color:transparent;border-right-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right.voxel-tooltip--info .voxel-tooltip__arrow{border-right-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom.voxel-tooltip--info .voxel-tooltip__arrow{border-bottom-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--left.voxel-tooltip--info .voxel-tooltip__arrow{border-left-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--start{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.voxel-tooltip--end{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}\n"]
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], tooltipType: [{
            type: Input
        }], tooltipIcon: [{
            type: Input
        }], tooltipPosition: [{
            type: Input
        }], tooltipArrow: [{
            type: Input
        }], hideArrow: [{
            type: Input
        }] }); })();

class VoxelTooltipDirective {
    constructor(overlayPositionBuilder, _scrollDispatcher, _overlayContainer, elementRef, renderer, overlay, la) {
        this.overlayPositionBuilder = overlayPositionBuilder;
        this._scrollDispatcher = _scrollDispatcher;
        this._overlayContainer = _overlayContainer;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.overlay = overlay;
        this.la = la;
        /** @internal */
        this._hideArrow = false;
        /** @internal */
        this.toolTipShowing = false;
        /** @internal */
        this.positionsToolTip = {
            top: {
                originY: 'top',
                overlayY: 'bottom',
            },
            bottom: {
                originY: 'bottom',
                overlayY: 'top',
            },
            left: {
                originX: 'start',
                overlayX: 'end',
            },
            right: {
                originX: 'end',
                overlayX: 'start',
            },
        };
        /** @internal */
        this.positionsArrow = {
            start: {
                originX: 'start',
                overlayX: 'start',
                originY: 'top',
                overlayY: 'top',
            },
            middle: {
                originX: 'center',
                overlayX: 'center',
                originY: 'center',
                overlayY: 'center',
            },
            end: {
                originX: 'end',
                overlayX: 'end',
                originY: 'bottom',
                overlayY: 'bottom',
            },
        };
        /**
         * Input que recebe o texto que irá aparecer dentro do tooltip
         *
         * *Input that receives the text that will appear inside the tooltip*
         */
        this.tooltipText = '';
        /**
         * input que recebe a maneira como o tooltip vai funcionar, 'hover'
         * para exibir ao receber foco e 'click', para exibir ao clicar
         *
         * *input that gets the way the tooltip will work, 'hover'*
         * *to display on focus and 'click' to display on click*
         */
        this.voxelTooltip = 'hover';
        /**
         * recebe a posição que o tooltip irá aparecer
         * em relação ao elemento que ele se relaciona, com os valores 'top','bottom','left' e 'right'
         *
         * *receives the position that the tooltip will appear*
         * *in relation to the element it relates to, with the values 'top','bottom','left' e 'right'*
         */
        this.tooltipPosition = 'top';
        /**
         * recebe a posição que a seta vai ficar no tooltip sendo os valores 'start', 'middle' e 'end'
         *
         * *gets the position that the arrow will be in the tooltip being the values 'start', 'middle' and 'end'*
         */
        this.tooltipArrow = 'middle';
        /**
         * começa a leitura do component quando criado
         *
         * *starts reading the component when created*
         */
        this.tooltipAriaLive = 'polite';
        /**
         * recebe o texto personalizado para aria label
         *
         * *receive custom text for aria label*
         */
        this.tooltipAriaLabel = 'informações adicionais';
        /**
         * define como o tooltip se comporta com rolagem
         *
         * *set the behavior of the tooltip on scroll*
         */
        this.tooltipScrollStrategy = 'reposition';
        /**
         * define novo valor para a propriedade z-index. Importante: o valor é definido apenas quando o tooltip
         * não é utilizado dentro do Modal ou Dialog. Nesses casos, ele recebe o z-index padrão de 1000 definido pelo
         * CDK Overlay
         *
         * *sets new value for z-index property. Important: the value is defined only when the tooltip*
         * *is not used within Modal or Dialog. In such cases it gets the default z-index*
         * *of 1000 set by CDK Overlay*
         */
        this.zIndex = 999;
        /** @internal */
        this.click = () => (this.toolTipShowing ? this.hide() : this.show());
    }
    /**
     * Define se a seta (tooltipArrow) está visível
     *
     * *hideArrow = true*
     *
     * *Defines if the arrow (Arrow tooltip) is visible*
     *
     * *hideArrow = true*
     */
    set hideArrow(value) {
        this._hideArrow = enforceBoolean(value);
    }
    get hideArrow() {
        return this._hideArrow;
    }
    /**
     * adiciona um rótulo acessível ao elemento
     *
     * *add an accessible label to the element*
     */
    get controlAriaLabel() {
        return this.voxelTooltip === 'hover' ? this.tooltipText : this.tooltipAriaLabel;
    }
    /** @internal */
    get tooltipType() {
        return this.voxelTooltip === 'hover' ? 'info' : 'tip';
    }
    /** @internal */
    mouseenter() {
        if (this.voxelTooltip === 'hover') {
            this.show();
        }
    }
    /** @internal */
    focus() {
        if (this.voxelTooltip === 'hover') {
            this.show();
        }
    }
    bindTooltipMouseLeave() {
        this.mouseLeaveSubscription = fromEvent(this.overlayRef.overlayElement, 'mouseleave').subscribe(this.hide.bind(this));
    }
    /** @internal */
    mouseleave(event) {
        var _a;
        if (this.voxelTooltip !== 'hover') {
            return;
        }
        if ((_a = event.relatedTarget) === null || _a === void 0 ? void 0 : _a.className.includes('voxel-tooltip')) {
            this.bindTooltipMouseLeave();
            return;
        }
        this.hide();
    }
    /** @internal */
    blur() {
        if (this.voxelTooltip === 'hover') {
            this.hide();
        }
    }
    ngOnInit() {
        if (this.voxelTooltip === 'click') {
            this.controlAriaExpanded = false;
        }
    }
    /** @internal */
    subscribeDomClick() {
        this.documentClickSubscription = fromEvent(document, 'click').subscribe((event) => {
            var _a, _b;
            const target = event.target;
            const clickedOnTooltip = (_b = (_a = target.className) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, 'voxel-tooltip');
            const clickedOnOpenButton = event.composedPath().includes(this.elementRef.nativeElement);
            /* istanbul ignore next */
            if (clickedOnTooltip || clickedOnOpenButton) {
                return;
            }
            this.hide();
        });
    }
    /** @internal */
    subscribeKeyPress() {
        this.keyPressSubscription = fromEvent(document, 'keydown').subscribe((event) => {
            const keyClick = event;
            const escPressed = keyClick.code === 'Escape';
            if (this.toolTipShowing && escPressed) {
                this.hide();
            }
        });
    }
    /** @internal */
    announce() {
        if (this.voxelTooltip !== 'click') {
            return;
        }
        this.controlAriaExpanded = true;
        this.la.announce(this.tooltipText, 1000);
        this.createA11yToolTip();
    }
    /**
     * nessa função é criada uma instância do componente tooltip e passada para o componente
     * os valores que são recebidos nessa diretiva
     *
     * In this function an instance of the tooltip component is created and passed to the component
     * the values that are received in this directive
     */
    show() {
        if (this.toolTipShowing) {
            return;
        }
        this.createToolTip();
        this.toolTipShowing = true;
        this.subscribeKeyPress();
        this.subscribeDomClick();
        this.announce();
    }
    /** @internal */
    unsubscribeAll() {
        if (this.mouseLeaveSubscription) {
            this.mouseLeaveSubscription.unsubscribe();
        }
        if (this.keyPressSubscription) {
            this.keyPressSubscription.unsubscribe();
        }
        if (this.documentClickSubscription) {
            this.documentClickSubscription.unsubscribe();
        }
    }
    /** @internal */
    removeClickTooltip() {
        if (this.voxelTooltip === 'click') {
            this.controlAriaExpanded = false;
            this.removeA11Y();
        }
    }
    /** @internal */
    hide() {
        var _a;
        if (!this.toolTipShowing) {
            return;
        }
        if ((_a = this === null || this === void 0 ? void 0 : this.overlayRef) === null || _a === void 0 ? void 0 : _a.detach) {
            this.overlayRef.detach();
        }
        this.toolTipShowing = false;
        this.unsubscribeAll();
        this.removeClickTooltip();
    }
    removeA11Y() {
        var _a, _b, _c, _d, _e;
        (_b = (_a = this.a11yToolTip) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_e = (_d = (_c = this.a11yToolTip) === null || _c === void 0 ? void 0 : _c.parentNode) === null || _d === void 0 ? void 0 : _d.removeChild) === null || _e === void 0 ? void 0 : _e.call(_d, this.a11yToolTip);
    }
    /** @internal */
    createToolTip() {
        const scrollStrategy = this.overlay.scrollStrategies[this.tooltipScrollStrategy]();
        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([this.positions]);
        const setLowerZIndex = document.querySelectorAll('.cdk-overlay-pane').length === 0;
        this.overlayRef = this.overlay.create({ positionStrategy, scrollStrategy });
        const tooltipRef = this.overlayRef.attach(new ComponentPortal(VoxelTooltipComponent));
        tooltipRef.instance.text = this.tooltipText;
        tooltipRef.instance.tooltipType = this.tooltipType;
        tooltipRef.instance.tooltipPosition = this.tooltipPosition;
        tooltipRef.instance.tooltipArrow = this.tooltipArrow;
        tooltipRef.instance.hideArrow = this.hideArrow;
        tooltipRef.instance.tooltipIcon = this.tooltipIcon;
        const panel = this._overlayContainer.getContainerElement();
        if (setLowerZIndex) {
            this.renderer.setStyle(panel, 'z-index', this.zIndex);
        }
        panel.setAttribute('aria-hidden', 'true');
        this.overlayRef.detachments().subscribe(() => {
            if (setLowerZIndex) {
                this.renderer.removeStyle(panel, 'z-index');
            }
            this.hide();
        });
    }
    /**
     * recebe a posição passada pelo usuário e passa os valores necessários para colocar o tooltip na posição desejada
     *
     * receives the position passed by the user and passes the necessary values to place the tooltip in the desired position
     */
    get positions() {
        return Object.assign(Object.assign({}, this.positionsArrow[this.tooltipArrow]), this.positionsToolTip[this.tooltipPosition]);
    }
    /** @internal */
    createA11yToolTip() {
        this.a11yToolTip = document.createElement('div');
        this.a11yToolTip.classList.add('voxel-sr-only-a11y', 'voxel-tooltip__text');
        this.a11yToolTip.setAttribute('role', 'tooltip');
        this.a11yToolTip.textContent = this.tooltipText;
        const tooltipA11y = this.elementRef.nativeElement.insertAdjacentElement('afterend', this.a11yToolTip);
        setTimeout(() => this.setPositionTooltipA11y(tooltipA11y));
        this._scrollDispatcher.scrolled(0).subscribe(() => this.setPositionTooltipA11y(tooltipA11y));
    }
    setPositionTooltipA11y(tooltip) {
        Promise.resolve().then(() => {
            const positionOverlay = this.overlayRef.overlayElement.getBoundingClientRect();
            const difference = {
                x: this.tooltipPosition === 'right' ? 10 : 0,
                y: this.tooltipPosition === 'bottom' ? 10 : 0,
                width: this.tooltipPosition === 'left' || this.tooltipPosition === 'right' ? -10 : 0,
                height: this.tooltipPosition === 'top' || this.tooltipPosition === 'bottom' ? -10 : 0,
            };
            if (this.tooltipIcon) {
                difference.x += 24;
                difference.width -= 24;
            }
            this.renderer.setStyle(tooltip, 'top', positionOverlay.top + difference.y + 'px');
            this.renderer.setStyle(tooltip, 'right', positionOverlay.right + difference.x + 'px');
            this.renderer.setStyle(tooltip, 'bottom', positionOverlay.bottom + difference.y + 'px');
            this.renderer.setStyle(tooltip, 'left', positionOverlay.left + difference.x + 'px');
            this.renderer.setStyle(tooltip, 'height', positionOverlay.height + difference.height + 'px');
            this.renderer.setStyle(tooltip, 'width', positionOverlay.width + difference.width + 'px');
        });
    }
}
VoxelTooltipDirective.ɵfac = function VoxelTooltipDirective_Factory(t) { return new (t || VoxelTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.OverlayPositionBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ScrollDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.OverlayContainer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LiveAnnouncer)); };
VoxelTooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelTooltipDirective, selectors: [["", "voxelTooltip", ""]], hostVars: 2, hostBindings: function VoxelTooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function VoxelTooltipDirective_click_HostBindingHandler() { return ctx.click(); })("mouseenter", function VoxelTooltipDirective_mouseenter_HostBindingHandler() { return ctx.mouseenter(); })("focus", function VoxelTooltipDirective_focus_HostBindingHandler() { return ctx.focus(); })("mouseleave", function VoxelTooltipDirective_mouseleave_HostBindingHandler($event) { return ctx.mouseleave($event); })("blur", function VoxelTooltipDirective_blur_HostBindingHandler() { return ctx.blur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.controlAriaLabel)("aria-expanded", ctx.controlAriaExpanded);
    } }, inputs: { tooltipText: "tooltipText", voxelTooltip: "voxelTooltip", tooltipPosition: "tooltipPosition", tooltipArrow: "tooltipArrow", tooltipAriaLive: "tooltipAriaLive", tooltipAriaLabel: "tooltipAriaLabel", tooltipScrollStrategy: "tooltipScrollStrategy", zIndex: "zIndex", hideArrow: "hideArrow", tooltipIcon: "tooltipIcon" } });
VoxelTooltipDirective.ctorParameters = () => [
    { type: OverlayPositionBuilder },
    { type: ScrollDispatcher },
    { type: OverlayContainer },
    { type: ElementRef },
    { type: Renderer2 },
    { type: Overlay },
    { type: LiveAnnouncer }
];
VoxelTooltipDirective.propDecorators = {
    tooltipText: [{ type: Input }],
    voxelTooltip: [{ type: Input }],
    tooltipIcon: [{ type: Input }],
    tooltipPosition: [{ type: Input }],
    tooltipArrow: [{ type: Input }],
    hideArrow: [{ type: Input }],
    tooltipAriaLive: [{ type: Input }],
    tooltipAriaLabel: [{ type: Input }],
    tooltipScrollStrategy: [{ type: Input }],
    zIndex: [{ type: Input }],
    controlAriaLabel: [{ type: HostBinding, args: ['attr.aria-label',] }],
    controlAriaExpanded: [{ type: HostBinding, args: ['attr.aria-expanded',] }],
    mouseenter: [{ type: HostListener, args: ['mouseenter',] }],
    focus: [{ type: HostListener, args: ['focus',] }],
    click: [{ type: HostListener, args: ['click',] }],
    mouseleave: [{ type: HostListener, args: ['mouseleave', ['$event'],] }],
    blur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelTooltip]'
            }]
    }], function () { return [{ type: ɵngcc2.OverlayPositionBuilder }, { type: ɵngcc2.ScrollDispatcher }, { type: ɵngcc2.OverlayContainer }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc2.Overlay }, { type: ɵngcc5.LiveAnnouncer }]; }, { tooltipText: [{
            type: Input
        }], voxelTooltip: [{
            type: Input
        }], tooltipPosition: [{
            type: Input
        }], tooltipArrow: [{
            type: Input
        }], tooltipAriaLive: [{
            type: Input
        }], tooltipAriaLabel: [{
            type: Input
        }], tooltipScrollStrategy: [{
            type: Input
        }], zIndex: [{
            type: Input
        }], click: [{
            type: HostListener,
            args: ['click']
        }], hideArrow: [{
            type: Input
        }], controlAriaLabel: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], 
    /** @internal */
    mouseenter: [{
            type: HostListener,
            args: ['mouseenter']
        }], 
    /** @internal */
    focus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /** @internal */
    mouseleave: [{
            type: HostListener,
            args: ['mouseleave', ['$event']]
        }], 
    /** @internal */
    blur: [{
            type: HostListener,
            args: ['blur']
        }], controlAriaExpanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], tooltipIcon: [{
            type: Input
        }] }); })();

class VoxelTooltipModule {
}
VoxelTooltipModule.ɵfac = function VoxelTooltipModule_Factory(t) { return new (t || VoxelTooltipModule)(); };
VoxelTooltipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelTooltipModule });
VoxelTooltipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, OverlayModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTooltipModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, OverlayModule, VoxelIconModule],
                declarations: [VoxelTooltipDirective, VoxelTooltipComponent],
                exports: [VoxelTooltipDirective, VoxelTooltipComponent],
                entryComponents: [VoxelTooltipComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelTooltipModule, { declarations: function () { return [VoxelTooltipDirective, VoxelTooltipComponent]; }, imports: function () { return [CommonModule, FormsModule, OverlayModule, VoxelIconModule]; }, exports: function () { return [VoxelTooltipDirective, VoxelTooltipComponent]; } }); })();

/**
 * Transaction status são espaços no topo da tela que trazem mensagens de feedback do app sobre ações tomadas no mesmo fluxo.
 * Esse feedback não deve interromper o usuário.
 *
 * *Transaction status are spaces on top of the screen that bring feedback messages of the app about actions to be taken in the same flow.
 * *This feedback should not stop the user.*
 *
 * **Module:**
 *
 * `import { VoxelTransactionStatusModule } from '@voxel/components';`
 *
 * <example-url>../../demo/index.html#/portfolio/transactionstatus?componentOnly=true</example-url>
 *
 */
class VoxelTransactionStatusComponent {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        /** @internal */
        this.icon = 'check';
        /** @internal */
        this.typeClass = '';
    }
    /** @internal */
    generateIconByType() {
        const isAnAlert = this.type === 'critical' || this.type === 'error';
        if (isAnAlert) {
            this.icon = 'aviso_outline';
            return;
        }
        const isOkAlert = this.type === 'schedule';
        if (isOkAlert) {
            this.icon = 'relogio_outline';
            return;
        }
    }
    /** @internal */
    ngOnInit() {
        this.generateIconByType();
        this.typeClass = this.type ? `voxel-transaction-status--${this.type}` : '';
    }
    ngOnDestroy() {
        this.liveAnnouncer.clear();
    }
    ngAfterViewInit() {
        if (!this.ariaLive) {
            return;
        }
        this.liveAnnouncer.announce(this.messageRef.nativeElement.innerText, this.ariaLive);
    }
}
VoxelTransactionStatusComponent.ɵfac = function VoxelTransactionStatusComponent_Factory(t) { return new (t || VoxelTransactionStatusComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.LiveAnnouncer)); };
VoxelTransactionStatusComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelTransactionStatusComponent, selectors: [["voxel-transaction-status"]], viewQuery: function VoxelTransactionStatusComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c60, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.messageRef = _t.first);
    } }, inputs: { type: "type", ariaLive: "ariaLive" }, ngContentSelectors: _c0, decls: 8, vars: 5, consts: [["data-voxel-animation", "wrapper", 1, "voxel-transaction-status__wrapper"], ["data-voxel-animation", "content", 1, "voxel-transaction-status__content"], [1, "voxel-transaction-status__icon"], [1, "voxel-transaction-status__message", "voxel-text-m"], ["messageRef", ""]], template: function VoxelTransactionStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "voxel-icon", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 3, 4);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("voxel-transaction-status ", ctx.typeClass, "");
        ɵngcc0.ɵɵproperty("@inOut", undefined);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.icon);
    } }, directives: [VoxelIconComponent], styles: [".voxel-transaction-status[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark);overflow:hidden}.voxel-transaction-status__wrapper[_ngcontent-%COMP%]{background:var(--ids_color_feedback_success);min-height:var(--ids_size_general_64x);padding:var(--ids_size_general_20x)}.voxel-transaction-status__content[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-transaction-status__icon[_ngcontent-%COMP%]{margin-right:var(--ids_size_general_16x)}.voxel-transaction-status__message[_ngcontent-%COMP%]{-webkit-box-flex:1;-ms-flex:1;flex:1;font:var(--ids_textStyle_body_01_regular)}.voxel-transaction-status--error[_ngcontent-%COMP%]   .voxel-transaction-status__wrapper[_ngcontent-%COMP%]{background:#781b8e}.voxel-transaction-status--critical[_ngcontent-%COMP%]   .voxel-transaction-status__wrapper[_ngcontent-%COMP%]{background:var(--ids_color_feedback_error)}.voxel-transaction-status--schedule[_ngcontent-%COMP%]{color:var(--ids_color_action_neutral_variant)}.voxel-transaction-status--schedule[_ngcontent-%COMP%]   .voxel-transaction-status__wrapper[_ngcontent-%COMP%]{background:var(--ids_color_feedback_alert)}"], data: { animation: [IN_OUT_ANIMATION_FROM_TOP] } });
VoxelTransactionStatusComponent.ctorParameters = () => [
    { type: LiveAnnouncer }
];
VoxelTransactionStatusComponent.propDecorators = {
    type: [{ type: Input }],
    ariaLive: [{ type: Input }],
    messageRef: [{ type: ViewChild, args: ['messageRef',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTransactionStatusComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-transaction-status',
                template: "<div @inOut class=\"voxel-transaction-status {{ typeClass }}\">\n  <div class=\"voxel-transaction-status__wrapper\" data-voxel-animation=\"wrapper\">\n    <div class=\"voxel-transaction-status__content\" data-voxel-animation=\"content\">\n      <voxel-icon class=\"voxel-transaction-status__icon\">{{ icon }}</voxel-icon>\n      <span #messageRef class=\"voxel-transaction-status__message voxel-text-m\">\n        <ng-content></ng-content>\n      </span>\n    </div>\n  </div>\n</div>\n",
                animations: [IN_OUT_ANIMATION_FROM_TOP],
                styles: [".voxel-transaction-status{color:var(--ids_color_contrast_onDark);overflow:hidden}.voxel-transaction-status__wrapper{background:var(--ids_color_feedback_success);min-height:var(--ids_size_general_64x);padding:var(--ids_size_general_20x)}.voxel-transaction-status__content{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-transaction-status__icon{margin-right:var(--ids_size_general_16x)}.voxel-transaction-status__message{-webkit-box-flex:1;-ms-flex:1;flex:1;font:var(--ids_textStyle_body_01_regular)}.voxel-transaction-status--error .voxel-transaction-status__wrapper{background:#781b8e}.voxel-transaction-status--critical .voxel-transaction-status__wrapper{background:var(--ids_color_feedback_error)}.voxel-transaction-status--schedule{color:var(--ids_color_action_neutral_variant)}.voxel-transaction-status--schedule .voxel-transaction-status__wrapper{background:var(--ids_color_feedback_alert)}\n"]
            }]
    }], function () { return [{ type: ɵngcc5.LiveAnnouncer }]; }, { type: [{
            type: Input
        }], ariaLive: [{
            type: Input
        }], messageRef: [{
            type: ViewChild,
            args: ['messageRef']
        }] }); })();

class VoxelTransactionStatusModule {
}
VoxelTransactionStatusModule.ɵfac = function VoxelTransactionStatusModule_Factory(t) { return new (t || VoxelTransactionStatusModule)(); };
VoxelTransactionStatusModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelTransactionStatusModule });
VoxelTransactionStatusModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTransactionStatusModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelTransactionStatusComponent],
                exports: [VoxelTransactionStatusComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelTransactionStatusModule, { declarations: function () { return [VoxelTransactionStatusComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelTransactionStatusComponent]; } }); })();

/*
 * Public API Surface of voxel
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CURRENCY_CONFIG, DATE_CONFIG, FormAcessorMixin, IN_OUT_ANIMATION_FROM_BOTTOM, IN_OUT_ANIMATION_FROM_LEFT, IN_OUT_ANIMATION_FROM_RIGHT, IN_OUT_ANIMATION_FROM_TOP, IVoxelDatepickerEvent, IVoxelOptionEvent, IVoxelSelectEvent, LIKERT_OPTIONS_DEFAULT, LegacySegmentTypes, MIN_DATEPICKER_HEIGHT, SegmentTypes, TRANSFORM_FROM_BOTTOM, TRANSFORM_FROM_LEFT, TRANSFORM_FROM_RIGHT, TRANSFORM_FROM_TOP, VoxelAccordionComponent, VoxelAccordionGroupComponent, VoxelAccordionModule, VoxelAlertComponent, VoxelAlertModule, VoxelAutocompleteComponent, VoxelAutocompleteDirective, VoxelAutocompleteModule, VoxelBadgeComponent, VoxelBadgeModule, VoxelBreadcrumbComponent, VoxelBreadcrumbModule, VoxelButtonComponent, VoxelButtonModule, VoxelCheckboxDirective, VoxelCheckboxModule, VoxelChipsComponent, VoxelChipsModule, VoxelConfigModule, VoxelDatepickerComponent, VoxelDatepickerModule, VoxelDialogComponent, VoxelDialogFooterDirective, VoxelDialogModule, VoxelErrorMessageComponent, VoxelExpenseChartComponent, VoxelExpenseChartModule, VoxelFieldMixinBase, VoxelFormFieldComponent, VoxelFormFieldModule, VoxelFormSelectionBase, VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent, VoxelFormSelectionModule, VoxelFormStatusComponent, VoxelFormStatusModule, VoxelHeaderActionButtonDirective, VoxelHeaderBackButtonDirective, VoxelHeaderComponent, VoxelHeaderModule, VoxelHeaderStepperDirective, VoxelHeaderTitleDirective, VoxelHintFieldDirective, VoxelIconComponent, VoxelIconModule, VoxelInputDirective, VoxelInputModule, VoxelLearnMoreComponent, VoxelLearnMoreModule, VoxelLikertComponent, VoxelLikertModule, VoxelListActionComponent, VoxelListColumnComponent, VoxelListComponent, VoxelListDefinitionComponent, VoxelListDescrDirective, VoxelListDetailDirective, VoxelListInfoComponent, VoxelListInformationDirective, VoxelListModule, VoxelListNumberDirective, VoxelListRowComponent, VoxelListSimpleComponent, VoxelListSwitchComponent, VoxelListTextDetailDirective, VoxelListTextDirective, VoxelLoadingCircleComponent, VoxelLoadingCircleModule, VoxelMaskDirective, VoxelMaskModule, VoxelMaskPipe, VoxelMaskService, VoxelModalComponent, VoxelModalFooterDirective, VoxelModalModule, VoxelOptionComponent, VoxelOptionModule, VoxelOverlayModalModule, VoxelOverlayOriginDirective, VoxelPrefixDirective, VoxelRadioButtonDirective, VoxelRadioButtonModule, VoxelSegmentModule, VoxelSegmentService, VoxelSelectComponent, VoxelSelectModule, VoxelSliderControlsComponent, VoxelSliderDirective, VoxelSliderModule, VoxelSuffixDirective, VoxelSwitchDirective, VoxelSwitchModule, VoxelTabsComponent, VoxelTabsModule, VoxelTooltipComponent, VoxelTooltipModule, VoxelTransactionStatusComponent, VoxelTransactionStatusModule, accessibleCurrencyReading, currencies, currencyPrefix, enforceBoolean, enforceNumber, focus, focusSafely, focusWithoutScrolling, getBackgroundColor, isNumber, normalizeText, objectIs, setVoiceOverFocus, startDialogFocus, toggleMobileFocusTrap, ɵ0, ɵ1$2 as ɵ1, ɵ2$2 as ɵ2, SegmentTypeDefault as ɵa, SegmentTypeConfig as ɵb, segmentTypeDefaultFactory as ɵc, SegmentTypeDefaultProvider as ɵd, VoxelDatepickerDirective as ɵe, VoxelOverlayModalModule as ɵh, VoxelOverlayOriginDirective as ɵi, VoxelModalBaseComponent as ɵj, VoxelCrescentChart as ɵk, VoxelDecrescentChart as ɵl, VoxelNativeSelectDirective as ɵm, VoxelNativeSelectOptionDirective as ɵn, VoxelTooltipDirective as ɵo, IN_OUT_ANIMATION_FROM_TOP as ɵp };

